// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Host Variables */
:host {
  --grid-auto-row-height: 0;
  --grid-fill-color: var(--ids-layout-grid-color-background);
  --grid-text-color: var(--ids-layout-grid-color-text);
  --min-col-width: 0;
  --max-col-width: 1fr;
  --min-row-height: 0;
  --max-row-height: 1fr;
  --min-row-width: 1fr;
  --sticky-position: 0;
}

/* Grid Variables */
/* Host and ids-layout-grid Base */
:host,
.ids-layout-grid {
  display: grid;
  /* stylelint-disable-next-line property-no-deprecated */
  grid-gap: 16px;
  justify-content: start;
  box-sizing: border-box;
}

:host([hidden]) {
  display: none;
}

/* Grid Columms - Base */
:host([cols="1"]),
.ids-layout-grid-cols-1 {
  width: 100%;
  grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="1"]),
.ids-layout-grid > .ids-layout-grid-col-span-1 {
  grid-column: span 1/span 1;
}

:host(.ids-layout-grid) > ::slotted([col-start="1"]),
.ids-layout-grid > .ids-layout-grid-col-start-1 {
  grid-column-start: 1;
}

:host(.ids-layout-grid) > ::slotted([col-end="1"]),
.ids-layout-grid > .ids-layout-grid-col-end-1 {
  grid-column-end: 1;
}

:host([cols="2"]),
.ids-layout-grid-cols-2 {
  width: 100%;
  grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="2"]),
.ids-layout-grid > .ids-layout-grid-col-span-2 {
  grid-column: span 2/span 2;
}

:host(.ids-layout-grid) > ::slotted([col-start="2"]),
.ids-layout-grid > .ids-layout-grid-col-start-2 {
  grid-column-start: 2;
}

:host(.ids-layout-grid) > ::slotted([col-end="2"]),
.ids-layout-grid > .ids-layout-grid-col-end-2 {
  grid-column-end: 2;
}

:host([cols="3"]),
.ids-layout-grid-cols-3 {
  width: 100%;
  grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="3"]),
.ids-layout-grid > .ids-layout-grid-col-span-3 {
  grid-column: span 3/span 3;
}

:host(.ids-layout-grid) > ::slotted([col-start="3"]),
.ids-layout-grid > .ids-layout-grid-col-start-3 {
  grid-column-start: 3;
}

:host(.ids-layout-grid) > ::slotted([col-end="3"]),
.ids-layout-grid > .ids-layout-grid-col-end-3 {
  grid-column-end: 3;
}

:host([cols="4"]),
.ids-layout-grid-cols-4 {
  width: 100%;
  grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="4"]),
.ids-layout-grid > .ids-layout-grid-col-span-4 {
  grid-column: span 4/span 4;
}

:host(.ids-layout-grid) > ::slotted([col-start="4"]),
.ids-layout-grid > .ids-layout-grid-col-start-4 {
  grid-column-start: 4;
}

:host(.ids-layout-grid) > ::slotted([col-end="4"]),
.ids-layout-grid > .ids-layout-grid-col-end-4 {
  grid-column-end: 4;
}

:host([cols="5"]),
.ids-layout-grid-cols-5 {
  width: 100%;
  grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="5"]),
.ids-layout-grid > .ids-layout-grid-col-span-5 {
  grid-column: span 5/span 5;
}

:host(.ids-layout-grid) > ::slotted([col-start="5"]),
.ids-layout-grid > .ids-layout-grid-col-start-5 {
  grid-column-start: 5;
}

:host(.ids-layout-grid) > ::slotted([col-end="5"]),
.ids-layout-grid > .ids-layout-grid-col-end-5 {
  grid-column-end: 5;
}

:host([cols="6"]),
.ids-layout-grid-cols-6 {
  width: 100%;
  grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="6"]),
.ids-layout-grid > .ids-layout-grid-col-span-6 {
  grid-column: span 6/span 6;
}

:host(.ids-layout-grid) > ::slotted([col-start="6"]),
.ids-layout-grid > .ids-layout-grid-col-start-6 {
  grid-column-start: 6;
}

:host(.ids-layout-grid) > ::slotted([col-end="6"]),
.ids-layout-grid > .ids-layout-grid-col-end-6 {
  grid-column-end: 6;
}

:host([cols="7"]),
.ids-layout-grid-cols-7 {
  width: 100%;
  grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="7"]),
.ids-layout-grid > .ids-layout-grid-col-span-7 {
  grid-column: span 7/span 7;
}

:host(.ids-layout-grid) > ::slotted([col-start="7"]),
.ids-layout-grid > .ids-layout-grid-col-start-7 {
  grid-column-start: 7;
}

:host(.ids-layout-grid) > ::slotted([col-end="7"]),
.ids-layout-grid > .ids-layout-grid-col-end-7 {
  grid-column-end: 7;
}

:host([cols="8"]),
.ids-layout-grid-cols-8 {
  width: 100%;
  grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="8"]),
.ids-layout-grid > .ids-layout-grid-col-span-8 {
  grid-column: span 8/span 8;
}

:host(.ids-layout-grid) > ::slotted([col-start="8"]),
.ids-layout-grid > .ids-layout-grid-col-start-8 {
  grid-column-start: 8;
}

:host(.ids-layout-grid) > ::slotted([col-end="8"]),
.ids-layout-grid > .ids-layout-grid-col-end-8 {
  grid-column-end: 8;
}

:host([cols="9"]),
.ids-layout-grid-cols-9 {
  width: 100%;
  grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="9"]),
.ids-layout-grid > .ids-layout-grid-col-span-9 {
  grid-column: span 9/span 9;
}

:host(.ids-layout-grid) > ::slotted([col-start="9"]),
.ids-layout-grid > .ids-layout-grid-col-start-9 {
  grid-column-start: 9;
}

:host(.ids-layout-grid) > ::slotted([col-end="9"]),
.ids-layout-grid > .ids-layout-grid-col-end-9 {
  grid-column-end: 9;
}

:host([cols="10"]),
.ids-layout-grid-cols-10 {
  width: 100%;
  grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="10"]),
.ids-layout-grid > .ids-layout-grid-col-span-10 {
  grid-column: span 10/span 10;
}

:host(.ids-layout-grid) > ::slotted([col-start="10"]),
.ids-layout-grid > .ids-layout-grid-col-start-10 {
  grid-column-start: 10;
}

:host(.ids-layout-grid) > ::slotted([col-end="10"]),
.ids-layout-grid > .ids-layout-grid-col-end-10 {
  grid-column-end: 10;
}

:host([cols="11"]),
.ids-layout-grid-cols-11 {
  width: 100%;
  grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="11"]),
.ids-layout-grid > .ids-layout-grid-col-span-11 {
  grid-column: span 11/span 11;
}

:host(.ids-layout-grid) > ::slotted([col-start="11"]),
.ids-layout-grid > .ids-layout-grid-col-start-11 {
  grid-column-start: 11;
}

:host(.ids-layout-grid) > ::slotted([col-end="11"]),
.ids-layout-grid > .ids-layout-grid-col-end-11 {
  grid-column-end: 11;
}

:host([cols="12"]),
.ids-layout-grid-cols-12 {
  width: 100%;
  grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="12"]),
.ids-layout-grid > .ids-layout-grid-col-span-12 {
  grid-column: span 12/span 12;
}

:host(.ids-layout-grid) > ::slotted([col-start="12"]),
.ids-layout-grid > .ids-layout-grid-col-start-12 {
  grid-column-start: 12;
}

:host(.ids-layout-grid) > ::slotted([col-end="12"]),
.ids-layout-grid > .ids-layout-grid-col-end-12 {
  grid-column-end: 12;
}

:host([cols="13"]),
.ids-layout-grid-cols-13 {
  width: 100%;
  grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="13"]),
.ids-layout-grid > .ids-layout-grid-col-span-13 {
  grid-column: span 13/span 13;
}

:host(.ids-layout-grid) > ::slotted([col-start="13"]),
.ids-layout-grid > .ids-layout-grid-col-start-13 {
  grid-column-start: 13;
}

:host(.ids-layout-grid) > ::slotted([col-end="13"]),
.ids-layout-grid > .ids-layout-grid-col-end-13 {
  grid-column-end: 13;
}

:host([cols="14"]),
.ids-layout-grid-cols-14 {
  width: 100%;
  grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="14"]),
.ids-layout-grid > .ids-layout-grid-col-span-14 {
  grid-column: span 14/span 14;
}

:host(.ids-layout-grid) > ::slotted([col-start="14"]),
.ids-layout-grid > .ids-layout-grid-col-start-14 {
  grid-column-start: 14;
}

:host(.ids-layout-grid) > ::slotted([col-end="14"]),
.ids-layout-grid > .ids-layout-grid-col-end-14 {
  grid-column-end: 14;
}

:host([cols="15"]),
.ids-layout-grid-cols-15 {
  width: 100%;
  grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="15"]),
.ids-layout-grid > .ids-layout-grid-col-span-15 {
  grid-column: span 15/span 15;
}

:host(.ids-layout-grid) > ::slotted([col-start="15"]),
.ids-layout-grid > .ids-layout-grid-col-start-15 {
  grid-column-start: 15;
}

:host(.ids-layout-grid) > ::slotted([col-end="15"]),
.ids-layout-grid > .ids-layout-grid-col-end-15 {
  grid-column-end: 15;
}

:host([cols="16"]),
.ids-layout-grid-cols-16 {
  width: 100%;
  grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="16"]),
.ids-layout-grid > .ids-layout-grid-col-span-16 {
  grid-column: span 16/span 16;
}

:host(.ids-layout-grid) > ::slotted([col-start="16"]),
.ids-layout-grid > .ids-layout-grid-col-start-16 {
  grid-column-start: 16;
}

:host(.ids-layout-grid) > ::slotted([col-end="16"]),
.ids-layout-grid > .ids-layout-grid-col-end-16 {
  grid-column-end: 16;
}

:host([cols="17"]),
.ids-layout-grid-cols-17 {
  width: 100%;
  grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="17"]),
.ids-layout-grid > .ids-layout-grid-col-span-17 {
  grid-column: span 17/span 17;
}

:host(.ids-layout-grid) > ::slotted([col-start="17"]),
.ids-layout-grid > .ids-layout-grid-col-start-17 {
  grid-column-start: 17;
}

:host(.ids-layout-grid) > ::slotted([col-end="17"]),
.ids-layout-grid > .ids-layout-grid-col-end-17 {
  grid-column-end: 17;
}

:host([cols="18"]),
.ids-layout-grid-cols-18 {
  width: 100%;
  grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="18"]),
.ids-layout-grid > .ids-layout-grid-col-span-18 {
  grid-column: span 18/span 18;
}

:host(.ids-layout-grid) > ::slotted([col-start="18"]),
.ids-layout-grid > .ids-layout-grid-col-start-18 {
  grid-column-start: 18;
}

:host(.ids-layout-grid) > ::slotted([col-end="18"]),
.ids-layout-grid > .ids-layout-grid-col-end-18 {
  grid-column-end: 18;
}

:host([cols="19"]),
.ids-layout-grid-cols-19 {
  width: 100%;
  grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="19"]),
.ids-layout-grid > .ids-layout-grid-col-span-19 {
  grid-column: span 19/span 19;
}

:host(.ids-layout-grid) > ::slotted([col-start="19"]),
.ids-layout-grid > .ids-layout-grid-col-start-19 {
  grid-column-start: 19;
}

:host(.ids-layout-grid) > ::slotted([col-end="19"]),
.ids-layout-grid > .ids-layout-grid-col-end-19 {
  grid-column-end: 19;
}

:host([cols="20"]),
.ids-layout-grid-cols-20 {
  width: 100%;
  grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="20"]),
.ids-layout-grid > .ids-layout-grid-col-span-20 {
  grid-column: span 20/span 20;
}

:host(.ids-layout-grid) > ::slotted([col-start="20"]),
.ids-layout-grid > .ids-layout-grid-col-start-20 {
  grid-column-start: 20;
}

:host(.ids-layout-grid) > ::slotted([col-end="20"]),
.ids-layout-grid > .ids-layout-grid-col-end-20 {
  grid-column-end: 20;
}

:host([cols="21"]),
.ids-layout-grid-cols-21 {
  width: 100%;
  grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="21"]),
.ids-layout-grid > .ids-layout-grid-col-span-21 {
  grid-column: span 21/span 21;
}

:host(.ids-layout-grid) > ::slotted([col-start="21"]),
.ids-layout-grid > .ids-layout-grid-col-start-21 {
  grid-column-start: 21;
}

:host(.ids-layout-grid) > ::slotted([col-end="21"]),
.ids-layout-grid > .ids-layout-grid-col-end-21 {
  grid-column-end: 21;
}

:host([cols="22"]),
.ids-layout-grid-cols-22 {
  width: 100%;
  grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="22"]),
.ids-layout-grid > .ids-layout-grid-col-span-22 {
  grid-column: span 22/span 22;
}

:host(.ids-layout-grid) > ::slotted([col-start="22"]),
.ids-layout-grid > .ids-layout-grid-col-start-22 {
  grid-column-start: 22;
}

:host(.ids-layout-grid) > ::slotted([col-end="22"]),
.ids-layout-grid > .ids-layout-grid-col-end-22 {
  grid-column-end: 22;
}

:host([cols="23"]),
.ids-layout-grid-cols-23 {
  width: 100%;
  grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="23"]),
.ids-layout-grid > .ids-layout-grid-col-span-23 {
  grid-column: span 23/span 23;
}

:host(.ids-layout-grid) > ::slotted([col-start="23"]),
.ids-layout-grid > .ids-layout-grid-col-start-23 {
  grid-column-start: 23;
}

:host(.ids-layout-grid) > ::slotted([col-end="23"]),
.ids-layout-grid > .ids-layout-grid-col-end-23 {
  grid-column-end: 23;
}

:host([cols="24"]),
.ids-layout-grid-cols-24 {
  width: 100%;
  grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
}

:host(.ids-layout-grid) > ::slotted([col-span="24"]),
.ids-layout-grid > .ids-layout-grid-col-span-24 {
  grid-column: span 24/span 24;
}

:host(.ids-layout-grid) > ::slotted([col-start="24"]),
.ids-layout-grid > .ids-layout-grid-col-start-24 {
  grid-column-start: 24;
}

:host(.ids-layout-grid) > ::slotted([col-end="24"]),
.ids-layout-grid > .ids-layout-grid-col-end-24 {
  grid-column-end: 24;
}

/* Grid Rows - Base */
:host([rows="1"]),
.ids-layout-grid-rows-1 {
  grid-template-rows: repeat(1, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="1"]),
.ids-layout-grid > .ids-layout-grid-row-span-1 {
  grid-row: span 1/span 1;
}

:host(.ids-layout-grid) > ::slotted([order="1"]),
.ids-layout-grid > .ids-layout-grid-order-1 {
  order: 1;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="2"]),
.ids-layout-grid-rows-2 {
  grid-template-rows: repeat(2, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="2"]),
.ids-layout-grid > .ids-layout-grid-row-span-2 {
  grid-row: span 2/span 2;
}

:host(.ids-layout-grid) > ::slotted([order="2"]),
.ids-layout-grid > .ids-layout-grid-order-2 {
  order: 2;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="3"]),
.ids-layout-grid-rows-3 {
  grid-template-rows: repeat(3, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="3"]),
.ids-layout-grid > .ids-layout-grid-row-span-3 {
  grid-row: span 3/span 3;
}

:host(.ids-layout-grid) > ::slotted([order="3"]),
.ids-layout-grid > .ids-layout-grid-order-3 {
  order: 3;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="4"]),
.ids-layout-grid-rows-4 {
  grid-template-rows: repeat(4, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="4"]),
.ids-layout-grid > .ids-layout-grid-row-span-4 {
  grid-row: span 4/span 4;
}

:host(.ids-layout-grid) > ::slotted([order="4"]),
.ids-layout-grid > .ids-layout-grid-order-4 {
  order: 4;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="5"]),
.ids-layout-grid-rows-5 {
  grid-template-rows: repeat(5, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="5"]),
.ids-layout-grid > .ids-layout-grid-row-span-5 {
  grid-row: span 5/span 5;
}

:host(.ids-layout-grid) > ::slotted([order="5"]),
.ids-layout-grid > .ids-layout-grid-order-5 {
  order: 5;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="6"]),
.ids-layout-grid-rows-6 {
  grid-template-rows: repeat(6, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="6"]),
.ids-layout-grid > .ids-layout-grid-row-span-6 {
  grid-row: span 6/span 6;
}

:host(.ids-layout-grid) > ::slotted([order="6"]),
.ids-layout-grid > .ids-layout-grid-order-6 {
  order: 6;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="7"]),
.ids-layout-grid-rows-7 {
  grid-template-rows: repeat(7, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="7"]),
.ids-layout-grid > .ids-layout-grid-row-span-7 {
  grid-row: span 7/span 7;
}

:host(.ids-layout-grid) > ::slotted([order="7"]),
.ids-layout-grid > .ids-layout-grid-order-7 {
  order: 7;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="8"]),
.ids-layout-grid-rows-8 {
  grid-template-rows: repeat(8, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="8"]),
.ids-layout-grid > .ids-layout-grid-row-span-8 {
  grid-row: span 8/span 8;
}

:host(.ids-layout-grid) > ::slotted([order="8"]),
.ids-layout-grid > .ids-layout-grid-order-8 {
  order: 8;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="9"]),
.ids-layout-grid-rows-9 {
  grid-template-rows: repeat(9, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="9"]),
.ids-layout-grid > .ids-layout-grid-row-span-9 {
  grid-row: span 9/span 9;
}

:host(.ids-layout-grid) > ::slotted([order="9"]),
.ids-layout-grid > .ids-layout-grid-order-9 {
  order: 9;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="10"]),
.ids-layout-grid-rows-10 {
  grid-template-rows: repeat(10, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="10"]),
.ids-layout-grid > .ids-layout-grid-row-span-10 {
  grid-row: span 10/span 10;
}

:host(.ids-layout-grid) > ::slotted([order="10"]),
.ids-layout-grid > .ids-layout-grid-order-10 {
  order: 10;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="11"]),
.ids-layout-grid-rows-11 {
  grid-template-rows: repeat(11, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="11"]),
.ids-layout-grid > .ids-layout-grid-row-span-11 {
  grid-row: span 11/span 11;
}

:host(.ids-layout-grid) > ::slotted([order="11"]),
.ids-layout-grid > .ids-layout-grid-order-11 {
  order: 11;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="12"]),
.ids-layout-grid-rows-12 {
  grid-template-rows: repeat(12, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="12"]),
.ids-layout-grid > .ids-layout-grid-row-span-12 {
  grid-row: span 12/span 12;
}

:host(.ids-layout-grid) > ::slotted([order="12"]),
.ids-layout-grid > .ids-layout-grid-order-12 {
  order: 12;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="13"]),
.ids-layout-grid-rows-13 {
  grid-template-rows: repeat(13, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="13"]),
.ids-layout-grid > .ids-layout-grid-row-span-13 {
  grid-row: span 13/span 13;
}

:host(.ids-layout-grid) > ::slotted([order="13"]),
.ids-layout-grid > .ids-layout-grid-order-13 {
  order: 13;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="14"]),
.ids-layout-grid-rows-14 {
  grid-template-rows: repeat(14, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="14"]),
.ids-layout-grid > .ids-layout-grid-row-span-14 {
  grid-row: span 14/span 14;
}

:host(.ids-layout-grid) > ::slotted([order="14"]),
.ids-layout-grid > .ids-layout-grid-order-14 {
  order: 14;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="15"]),
.ids-layout-grid-rows-15 {
  grid-template-rows: repeat(15, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="15"]),
.ids-layout-grid > .ids-layout-grid-row-span-15 {
  grid-row: span 15/span 15;
}

:host(.ids-layout-grid) > ::slotted([order="15"]),
.ids-layout-grid > .ids-layout-grid-order-15 {
  order: 15;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="16"]),
.ids-layout-grid-rows-16 {
  grid-template-rows: repeat(16, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="16"]),
.ids-layout-grid > .ids-layout-grid-row-span-16 {
  grid-row: span 16/span 16;
}

:host(.ids-layout-grid) > ::slotted([order="16"]),
.ids-layout-grid > .ids-layout-grid-order-16 {
  order: 16;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="17"]),
.ids-layout-grid-rows-17 {
  grid-template-rows: repeat(17, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="17"]),
.ids-layout-grid > .ids-layout-grid-row-span-17 {
  grid-row: span 17/span 17;
}

:host(.ids-layout-grid) > ::slotted([order="17"]),
.ids-layout-grid > .ids-layout-grid-order-17 {
  order: 17;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="18"]),
.ids-layout-grid-rows-18 {
  grid-template-rows: repeat(18, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="18"]),
.ids-layout-grid > .ids-layout-grid-row-span-18 {
  grid-row: span 18/span 18;
}

:host(.ids-layout-grid) > ::slotted([order="18"]),
.ids-layout-grid > .ids-layout-grid-order-18 {
  order: 18;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="19"]),
.ids-layout-grid-rows-19 {
  grid-template-rows: repeat(19, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="19"]),
.ids-layout-grid > .ids-layout-grid-row-span-19 {
  grid-row: span 19/span 19;
}

:host(.ids-layout-grid) > ::slotted([order="19"]),
.ids-layout-grid > .ids-layout-grid-order-19 {
  order: 19;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="20"]),
.ids-layout-grid-rows-20 {
  grid-template-rows: repeat(20, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="20"]),
.ids-layout-grid > .ids-layout-grid-row-span-20 {
  grid-row: span 20/span 20;
}

:host(.ids-layout-grid) > ::slotted([order="20"]),
.ids-layout-grid > .ids-layout-grid-order-20 {
  order: 20;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="21"]),
.ids-layout-grid-rows-21 {
  grid-template-rows: repeat(21, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="21"]),
.ids-layout-grid > .ids-layout-grid-row-span-21 {
  grid-row: span 21/span 21;
}

:host(.ids-layout-grid) > ::slotted([order="21"]),
.ids-layout-grid > .ids-layout-grid-order-21 {
  order: 21;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="22"]),
.ids-layout-grid-rows-22 {
  grid-template-rows: repeat(22, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="22"]),
.ids-layout-grid > .ids-layout-grid-row-span-22 {
  grid-row: span 22/span 22;
}

:host(.ids-layout-grid) > ::slotted([order="22"]),
.ids-layout-grid > .ids-layout-grid-order-22 {
  order: 22;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="23"]),
.ids-layout-grid-rows-23 {
  grid-template-rows: repeat(23, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="23"]),
.ids-layout-grid > .ids-layout-grid-row-span-23 {
  grid-row: span 23/span 23;
}

:host(.ids-layout-grid) > ::slotted([order="23"]),
.ids-layout-grid > .ids-layout-grid-order-23 {
  order: 23;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="24"]),
.ids-layout-grid-rows-24 {
  grid-template-rows: repeat(24, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="24"]),
.ids-layout-grid > .ids-layout-grid-row-span-24 {
  grid-row: span 24/span 24;
}

:host(.ids-layout-grid) > ::slotted([order="24"]),
.ids-layout-grid > .ids-layout-grid-order-24 {
  order: 24;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="25"]),
.ids-layout-grid-rows-25 {
  grid-template-rows: repeat(25, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="25"]),
.ids-layout-grid > .ids-layout-grid-row-span-25 {
  grid-row: span 25/span 25;
}

:host(.ids-layout-grid) > ::slotted([order="25"]),
.ids-layout-grid > .ids-layout-grid-order-25 {
  order: 25;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="26"]),
.ids-layout-grid-rows-26 {
  grid-template-rows: repeat(26, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="26"]),
.ids-layout-grid > .ids-layout-grid-row-span-26 {
  grid-row: span 26/span 26;
}

:host(.ids-layout-grid) > ::slotted([order="26"]),
.ids-layout-grid > .ids-layout-grid-order-26 {
  order: 26;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="27"]),
.ids-layout-grid-rows-27 {
  grid-template-rows: repeat(27, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="27"]),
.ids-layout-grid > .ids-layout-grid-row-span-27 {
  grid-row: span 27/span 27;
}

:host(.ids-layout-grid) > ::slotted([order="27"]),
.ids-layout-grid > .ids-layout-grid-order-27 {
  order: 27;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="28"]),
.ids-layout-grid-rows-28 {
  grid-template-rows: repeat(28, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="28"]),
.ids-layout-grid > .ids-layout-grid-row-span-28 {
  grid-row: span 28/span 28;
}

:host(.ids-layout-grid) > ::slotted([order="28"]),
.ids-layout-grid > .ids-layout-grid-order-28 {
  order: 28;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="29"]),
.ids-layout-grid-rows-29 {
  grid-template-rows: repeat(29, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="29"]),
.ids-layout-grid > .ids-layout-grid-row-span-29 {
  grid-row: span 29/span 29;
}

:host(.ids-layout-grid) > ::slotted([order="29"]),
.ids-layout-grid > .ids-layout-grid-order-29 {
  order: 29;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="30"]),
.ids-layout-grid-rows-30 {
  grid-template-rows: repeat(30, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="30"]),
.ids-layout-grid > .ids-layout-grid-row-span-30 {
  grid-row: span 30/span 30;
}

:host(.ids-layout-grid) > ::slotted([order="30"]),
.ids-layout-grid > .ids-layout-grid-order-30 {
  order: 30;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="31"]),
.ids-layout-grid-rows-31 {
  grid-template-rows: repeat(31, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="31"]),
.ids-layout-grid > .ids-layout-grid-row-span-31 {
  grid-row: span 31/span 31;
}

:host(.ids-layout-grid) > ::slotted([order="31"]),
.ids-layout-grid > .ids-layout-grid-order-31 {
  order: 31;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="32"]),
.ids-layout-grid-rows-32 {
  grid-template-rows: repeat(32, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="32"]),
.ids-layout-grid > .ids-layout-grid-row-span-32 {
  grid-row: span 32/span 32;
}

:host(.ids-layout-grid) > ::slotted([order="32"]),
.ids-layout-grid > .ids-layout-grid-order-32 {
  order: 32;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="33"]),
.ids-layout-grid-rows-33 {
  grid-template-rows: repeat(33, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="33"]),
.ids-layout-grid > .ids-layout-grid-row-span-33 {
  grid-row: span 33/span 33;
}

:host(.ids-layout-grid) > ::slotted([order="33"]),
.ids-layout-grid > .ids-layout-grid-order-33 {
  order: 33;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="34"]),
.ids-layout-grid-rows-34 {
  grid-template-rows: repeat(34, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="34"]),
.ids-layout-grid > .ids-layout-grid-row-span-34 {
  grid-row: span 34/span 34;
}

:host(.ids-layout-grid) > ::slotted([order="34"]),
.ids-layout-grid > .ids-layout-grid-order-34 {
  order: 34;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="35"]),
.ids-layout-grid-rows-35 {
  grid-template-rows: repeat(35, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="35"]),
.ids-layout-grid > .ids-layout-grid-row-span-35 {
  grid-row: span 35/span 35;
}

:host(.ids-layout-grid) > ::slotted([order="35"]),
.ids-layout-grid > .ids-layout-grid-order-35 {
  order: 35;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="36"]),
.ids-layout-grid-rows-36 {
  grid-template-rows: repeat(36, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="36"]),
.ids-layout-grid > .ids-layout-grid-row-span-36 {
  grid-row: span 36/span 36;
}

:host(.ids-layout-grid) > ::slotted([order="36"]),
.ids-layout-grid > .ids-layout-grid-order-36 {
  order: 36;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="37"]),
.ids-layout-grid-rows-37 {
  grid-template-rows: repeat(37, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="37"]),
.ids-layout-grid > .ids-layout-grid-row-span-37 {
  grid-row: span 37/span 37;
}

:host(.ids-layout-grid) > ::slotted([order="37"]),
.ids-layout-grid > .ids-layout-grid-order-37 {
  order: 37;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="38"]),
.ids-layout-grid-rows-38 {
  grid-template-rows: repeat(38, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="38"]),
.ids-layout-grid > .ids-layout-grid-row-span-38 {
  grid-row: span 38/span 38;
}

:host(.ids-layout-grid) > ::slotted([order="38"]),
.ids-layout-grid > .ids-layout-grid-order-38 {
  order: 38;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="39"]),
.ids-layout-grid-rows-39 {
  grid-template-rows: repeat(39, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="39"]),
.ids-layout-grid > .ids-layout-grid-row-span-39 {
  grid-row: span 39/span 39;
}

:host(.ids-layout-grid) > ::slotted([order="39"]),
.ids-layout-grid > .ids-layout-grid-order-39 {
  order: 39;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="40"]),
.ids-layout-grid-rows-40 {
  grid-template-rows: repeat(40, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="40"]),
.ids-layout-grid > .ids-layout-grid-row-span-40 {
  grid-row: span 40/span 40;
}

:host(.ids-layout-grid) > ::slotted([order="40"]),
.ids-layout-grid > .ids-layout-grid-order-40 {
  order: 40;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="41"]),
.ids-layout-grid-rows-41 {
  grid-template-rows: repeat(41, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="41"]),
.ids-layout-grid > .ids-layout-grid-row-span-41 {
  grid-row: span 41/span 41;
}

:host(.ids-layout-grid) > ::slotted([order="41"]),
.ids-layout-grid > .ids-layout-grid-order-41 {
  order: 41;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="42"]),
.ids-layout-grid-rows-42 {
  grid-template-rows: repeat(42, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="42"]),
.ids-layout-grid > .ids-layout-grid-row-span-42 {
  grid-row: span 42/span 42;
}

:host(.ids-layout-grid) > ::slotted([order="42"]),
.ids-layout-grid > .ids-layout-grid-order-42 {
  order: 42;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="43"]),
.ids-layout-grid-rows-43 {
  grid-template-rows: repeat(43, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="43"]),
.ids-layout-grid > .ids-layout-grid-row-span-43 {
  grid-row: span 43/span 43;
}

:host(.ids-layout-grid) > ::slotted([order="43"]),
.ids-layout-grid > .ids-layout-grid-order-43 {
  order: 43;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="44"]),
.ids-layout-grid-rows-44 {
  grid-template-rows: repeat(44, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="44"]),
.ids-layout-grid > .ids-layout-grid-row-span-44 {
  grid-row: span 44/span 44;
}

:host(.ids-layout-grid) > ::slotted([order="44"]),
.ids-layout-grid > .ids-layout-grid-order-44 {
  order: 44;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="45"]),
.ids-layout-grid-rows-45 {
  grid-template-rows: repeat(45, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="45"]),
.ids-layout-grid > .ids-layout-grid-row-span-45 {
  grid-row: span 45/span 45;
}

:host(.ids-layout-grid) > ::slotted([order="45"]),
.ids-layout-grid > .ids-layout-grid-order-45 {
  order: 45;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="46"]),
.ids-layout-grid-rows-46 {
  grid-template-rows: repeat(46, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="46"]),
.ids-layout-grid > .ids-layout-grid-row-span-46 {
  grid-row: span 46/span 46;
}

:host(.ids-layout-grid) > ::slotted([order="46"]),
.ids-layout-grid > .ids-layout-grid-order-46 {
  order: 46;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="47"]),
.ids-layout-grid-rows-47 {
  grid-template-rows: repeat(47, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="47"]),
.ids-layout-grid > .ids-layout-grid-row-span-47 {
  grid-row: span 47/span 47;
}

:host(.ids-layout-grid) > ::slotted([order="47"]),
.ids-layout-grid > .ids-layout-grid-order-47 {
  order: 47;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="48"]),
.ids-layout-grid-rows-48 {
  grid-template-rows: repeat(48, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="48"]),
.ids-layout-grid > .ids-layout-grid-row-span-48 {
  grid-row: span 48/span 48;
}

:host(.ids-layout-grid) > ::slotted([order="48"]),
.ids-layout-grid > .ids-layout-grid-order-48 {
  order: 48;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="49"]),
.ids-layout-grid-rows-49 {
  grid-template-rows: repeat(49, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="49"]),
.ids-layout-grid > .ids-layout-grid-row-span-49 {
  grid-row: span 49/span 49;
}

:host(.ids-layout-grid) > ::slotted([order="49"]),
.ids-layout-grid > .ids-layout-grid-order-49 {
  order: 49;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

:host([rows="50"]),
.ids-layout-grid-rows-50 {
  grid-template-rows: repeat(50, minmax(var(--min-row-height), var(--max-row-height)));
}

:host(.ids-layout-grid) > ::slotted([row-span="50"]),
.ids-layout-grid > .ids-layout-grid-row-span-50 {
  grid-row: span 50/span 50;
}

:host(.ids-layout-grid) > ::slotted([order="50"]),
.ids-layout-grid > .ids-layout-grid-order-50 {
  order: 50;
}

:host(.ids-layout-grid) > ::slotted([order="-1"]),
.ids-layout-grid > .ids-layout-grid-order--1 {
  order: -1;
}

@media (width >= 0) {
  :host(:not([enable-container])[cols-xs="1"]),
  .ids-layout-grid-cols-xs-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="2"]),
  .ids-layout-grid-cols-xs-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="3"]),
  .ids-layout-grid-cols-xs-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="4"]),
  .ids-layout-grid-cols-xs-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="5"]),
  .ids-layout-grid-cols-xs-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="6"]),
  .ids-layout-grid-cols-xs-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="7"]),
  .ids-layout-grid-cols-xs-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="8"]),
  .ids-layout-grid-cols-xs-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="9"]),
  .ids-layout-grid-cols-xs-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="10"]),
  .ids-layout-grid-cols-xs-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="11"]),
  .ids-layout-grid-cols-xs-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="12"]),
  .ids-layout-grid-cols-xs-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="13"]),
  .ids-layout-grid-cols-xs-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="14"]),
  .ids-layout-grid-cols-xs-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="15"]),
  .ids-layout-grid-cols-xs-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="16"]),
  .ids-layout-grid-cols-xs-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="17"]),
  .ids-layout-grid-cols-xs-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="18"]),
  .ids-layout-grid-cols-xs-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="19"]),
  .ids-layout-grid-cols-xs-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="20"]),
  .ids-layout-grid-cols-xs-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="21"]),
  .ids-layout-grid-cols-xs-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="22"]),
  .ids-layout-grid-cols-xs-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="23"]),
  .ids-layout-grid-cols-xs-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xs="24"]),
  .ids-layout-grid-cols-xs-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([rows-xs="1"]),
  .ids-layout-grid-rows-xs-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([rows-xs="2"]),
  .ids-layout-grid-rows-xs-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([rows-xs="3"]),
  .ids-layout-grid-rows-xs-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([rows-xs="4"]),
  .ids-layout-grid-rows-xs-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([rows-xs="5"]),
  .ids-layout-grid-rows-xs-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([rows-xs="6"]),
  .ids-layout-grid-rows-xs-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([rows-xs="7"]),
  .ids-layout-grid-rows-xs-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([rows-xs="8"]),
  .ids-layout-grid-rows-xs-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([rows-xs="9"]),
  .ids-layout-grid-rows-xs-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([rows-xs="10"]),
  .ids-layout-grid-rows-xs-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([rows-xs="11"]),
  .ids-layout-grid-rows-xs-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([rows-xs="12"]),
  .ids-layout-grid-rows-xs-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([rows-xs="13"]),
  .ids-layout-grid-rows-xs-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([rows-xs="14"]),
  .ids-layout-grid-rows-xs-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([rows-xs="15"]),
  .ids-layout-grid-rows-xs-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([rows-xs="16"]),
  .ids-layout-grid-rows-xs-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([rows-xs="17"]),
  .ids-layout-grid-rows-xs-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([rows-xs="18"]),
  .ids-layout-grid-rows-xs-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([rows-xs="19"]),
  .ids-layout-grid-rows-xs-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([rows-xs="20"]),
  .ids-layout-grid-rows-xs-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([rows-xs="21"]),
  .ids-layout-grid-rows-xs-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([rows-xs="22"]),
  .ids-layout-grid-rows-xs-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([rows-xs="23"]),
  .ids-layout-grid-rows-xs-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([rows-xs="24"]),
  .ids-layout-grid-rows-xs-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([rows-xs="25"]),
  .ids-layout-grid-rows-xs-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([rows-xs="26"]),
  .ids-layout-grid-rows-xs-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([rows-xs="27"]),
  .ids-layout-grid-rows-xs-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([rows-xs="28"]),
  .ids-layout-grid-rows-xs-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([rows-xs="29"]),
  .ids-layout-grid-rows-xs-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([rows-xs="30"]),
  .ids-layout-grid-rows-xs-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([rows-xs="31"]),
  .ids-layout-grid-rows-xs-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([rows-xs="32"]),
  .ids-layout-grid-rows-xs-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([rows-xs="33"]),
  .ids-layout-grid-rows-xs-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([rows-xs="34"]),
  .ids-layout-grid-rows-xs-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([rows-xs="35"]),
  .ids-layout-grid-rows-xs-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([rows-xs="36"]),
  .ids-layout-grid-rows-xs-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([rows-xs="37"]),
  .ids-layout-grid-rows-xs-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([rows-xs="38"]),
  .ids-layout-grid-rows-xs-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([rows-xs="39"]),
  .ids-layout-grid-rows-xs-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([rows-xs="40"]),
  .ids-layout-grid-rows-xs-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([rows-xs="41"]),
  .ids-layout-grid-rows-xs-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([rows-xs="42"]),
  .ids-layout-grid-rows-xs-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([rows-xs="43"]),
  .ids-layout-grid-rows-xs-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([rows-xs="44"]),
  .ids-layout-grid-rows-xs-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([rows-xs="45"]),
  .ids-layout-grid-rows-xs-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([rows-xs="46"]),
  .ids-layout-grid-rows-xs-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([rows-xs="47"]),
  .ids-layout-grid-rows-xs-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([rows-xs="48"]),
  .ids-layout-grid-rows-xs-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([rows-xs="49"]),
  .ids-layout-grid-rows-xs-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([rows-xs="50"]),
  .ids-layout-grid-rows-xs-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([flow-xs=row]), .ids-layout-grid-flow-xs-row {
    grid-auto-flow: row;
  }
  :host([flow-xs=column]), .ids-layout-grid-flow-xs-col {
    grid-auto-flow: column;
  }
  :host([flow-xs=dense]), .ids-layout-grid-flow-xs-dense {
    grid-auto-flow: dense;
  }
  :host([flow-xs=row-dense]), .ids-layout-grid-flow-xs-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-xs=column-dense]), .ids-layout-grid-flow-xs-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (width >= 767px) {
  :host(:not([enable-container])[cols-sm="1"]),
  .ids-layout-grid-cols-sm-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="2"]),
  .ids-layout-grid-cols-sm-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="3"]),
  .ids-layout-grid-cols-sm-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="4"]),
  .ids-layout-grid-cols-sm-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="5"]),
  .ids-layout-grid-cols-sm-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="6"]),
  .ids-layout-grid-cols-sm-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="7"]),
  .ids-layout-grid-cols-sm-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="8"]),
  .ids-layout-grid-cols-sm-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="9"]),
  .ids-layout-grid-cols-sm-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="10"]),
  .ids-layout-grid-cols-sm-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="11"]),
  .ids-layout-grid-cols-sm-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="12"]),
  .ids-layout-grid-cols-sm-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="13"]),
  .ids-layout-grid-cols-sm-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="14"]),
  .ids-layout-grid-cols-sm-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="15"]),
  .ids-layout-grid-cols-sm-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="16"]),
  .ids-layout-grid-cols-sm-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="17"]),
  .ids-layout-grid-cols-sm-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="18"]),
  .ids-layout-grid-cols-sm-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="19"]),
  .ids-layout-grid-cols-sm-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="20"]),
  .ids-layout-grid-cols-sm-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="21"]),
  .ids-layout-grid-cols-sm-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="22"]),
  .ids-layout-grid-cols-sm-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="23"]),
  .ids-layout-grid-cols-sm-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-sm="24"]),
  .ids-layout-grid-cols-sm-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([rows-sm="1"]),
  .ids-layout-grid-rows-sm-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([rows-sm="2"]),
  .ids-layout-grid-rows-sm-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([rows-sm="3"]),
  .ids-layout-grid-rows-sm-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([rows-sm="4"]),
  .ids-layout-grid-rows-sm-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([rows-sm="5"]),
  .ids-layout-grid-rows-sm-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([rows-sm="6"]),
  .ids-layout-grid-rows-sm-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([rows-sm="7"]),
  .ids-layout-grid-rows-sm-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([rows-sm="8"]),
  .ids-layout-grid-rows-sm-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([rows-sm="9"]),
  .ids-layout-grid-rows-sm-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([rows-sm="10"]),
  .ids-layout-grid-rows-sm-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([rows-sm="11"]),
  .ids-layout-grid-rows-sm-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([rows-sm="12"]),
  .ids-layout-grid-rows-sm-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([rows-sm="13"]),
  .ids-layout-grid-rows-sm-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([rows-sm="14"]),
  .ids-layout-grid-rows-sm-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([rows-sm="15"]),
  .ids-layout-grid-rows-sm-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([rows-sm="16"]),
  .ids-layout-grid-rows-sm-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([rows-sm="17"]),
  .ids-layout-grid-rows-sm-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([rows-sm="18"]),
  .ids-layout-grid-rows-sm-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([rows-sm="19"]),
  .ids-layout-grid-rows-sm-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([rows-sm="20"]),
  .ids-layout-grid-rows-sm-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([rows-sm="21"]),
  .ids-layout-grid-rows-sm-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([rows-sm="22"]),
  .ids-layout-grid-rows-sm-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([rows-sm="23"]),
  .ids-layout-grid-rows-sm-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([rows-sm="24"]),
  .ids-layout-grid-rows-sm-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([rows-sm="25"]),
  .ids-layout-grid-rows-sm-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([rows-sm="26"]),
  .ids-layout-grid-rows-sm-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([rows-sm="27"]),
  .ids-layout-grid-rows-sm-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([rows-sm="28"]),
  .ids-layout-grid-rows-sm-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([rows-sm="29"]),
  .ids-layout-grid-rows-sm-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([rows-sm="30"]),
  .ids-layout-grid-rows-sm-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([rows-sm="31"]),
  .ids-layout-grid-rows-sm-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([rows-sm="32"]),
  .ids-layout-grid-rows-sm-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([rows-sm="33"]),
  .ids-layout-grid-rows-sm-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([rows-sm="34"]),
  .ids-layout-grid-rows-sm-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([rows-sm="35"]),
  .ids-layout-grid-rows-sm-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([rows-sm="36"]),
  .ids-layout-grid-rows-sm-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([rows-sm="37"]),
  .ids-layout-grid-rows-sm-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([rows-sm="38"]),
  .ids-layout-grid-rows-sm-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([rows-sm="39"]),
  .ids-layout-grid-rows-sm-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([rows-sm="40"]),
  .ids-layout-grid-rows-sm-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([rows-sm="41"]),
  .ids-layout-grid-rows-sm-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([rows-sm="42"]),
  .ids-layout-grid-rows-sm-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([rows-sm="43"]),
  .ids-layout-grid-rows-sm-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([rows-sm="44"]),
  .ids-layout-grid-rows-sm-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([rows-sm="45"]),
  .ids-layout-grid-rows-sm-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([rows-sm="46"]),
  .ids-layout-grid-rows-sm-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([rows-sm="47"]),
  .ids-layout-grid-rows-sm-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([rows-sm="48"]),
  .ids-layout-grid-rows-sm-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([rows-sm="49"]),
  .ids-layout-grid-rows-sm-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([rows-sm="50"]),
  .ids-layout-grid-rows-sm-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([flow-sm=row]), .ids-layout-grid-flow-sm-row {
    grid-auto-flow: row;
  }
  :host([flow-sm=column]), .ids-layout-grid-flow-sm-col {
    grid-auto-flow: column;
  }
  :host([flow-sm=dense]), .ids-layout-grid-flow-sm-dense {
    grid-auto-flow: dense;
  }
  :host([flow-sm=row-dense]), .ids-layout-grid-flow-sm-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-sm=column-dense]), .ids-layout-grid-flow-sm-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (width >= 927px) {
  :host(:not([enable-container])[cols-md="1"]),
  .ids-layout-grid-cols-md-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="2"]),
  .ids-layout-grid-cols-md-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="3"]),
  .ids-layout-grid-cols-md-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="4"]),
  .ids-layout-grid-cols-md-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="5"]),
  .ids-layout-grid-cols-md-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="6"]),
  .ids-layout-grid-cols-md-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="7"]),
  .ids-layout-grid-cols-md-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="8"]),
  .ids-layout-grid-cols-md-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="9"]),
  .ids-layout-grid-cols-md-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="10"]),
  .ids-layout-grid-cols-md-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="11"]),
  .ids-layout-grid-cols-md-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="12"]),
  .ids-layout-grid-cols-md-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="13"]),
  .ids-layout-grid-cols-md-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="14"]),
  .ids-layout-grid-cols-md-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="15"]),
  .ids-layout-grid-cols-md-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="16"]),
  .ids-layout-grid-cols-md-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="17"]),
  .ids-layout-grid-cols-md-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="18"]),
  .ids-layout-grid-cols-md-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="19"]),
  .ids-layout-grid-cols-md-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="20"]),
  .ids-layout-grid-cols-md-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="21"]),
  .ids-layout-grid-cols-md-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="22"]),
  .ids-layout-grid-cols-md-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="23"]),
  .ids-layout-grid-cols-md-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-md="24"]),
  .ids-layout-grid-cols-md-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([rows-md="1"]),
  .ids-layout-grid-rows-md-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([rows-md="2"]),
  .ids-layout-grid-rows-md-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([rows-md="3"]),
  .ids-layout-grid-rows-md-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([rows-md="4"]),
  .ids-layout-grid-rows-md-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([rows-md="5"]),
  .ids-layout-grid-rows-md-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([rows-md="6"]),
  .ids-layout-grid-rows-md-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([rows-md="7"]),
  .ids-layout-grid-rows-md-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([rows-md="8"]),
  .ids-layout-grid-rows-md-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([rows-md="9"]),
  .ids-layout-grid-rows-md-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([rows-md="10"]),
  .ids-layout-grid-rows-md-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([rows-md="11"]),
  .ids-layout-grid-rows-md-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([rows-md="12"]),
  .ids-layout-grid-rows-md-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([rows-md="13"]),
  .ids-layout-grid-rows-md-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([rows-md="14"]),
  .ids-layout-grid-rows-md-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([rows-md="15"]),
  .ids-layout-grid-rows-md-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([rows-md="16"]),
  .ids-layout-grid-rows-md-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([rows-md="17"]),
  .ids-layout-grid-rows-md-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([rows-md="18"]),
  .ids-layout-grid-rows-md-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([rows-md="19"]),
  .ids-layout-grid-rows-md-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([rows-md="20"]),
  .ids-layout-grid-rows-md-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([rows-md="21"]),
  .ids-layout-grid-rows-md-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([rows-md="22"]),
  .ids-layout-grid-rows-md-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([rows-md="23"]),
  .ids-layout-grid-rows-md-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([rows-md="24"]),
  .ids-layout-grid-rows-md-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([rows-md="25"]),
  .ids-layout-grid-rows-md-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([rows-md="26"]),
  .ids-layout-grid-rows-md-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([rows-md="27"]),
  .ids-layout-grid-rows-md-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([rows-md="28"]),
  .ids-layout-grid-rows-md-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([rows-md="29"]),
  .ids-layout-grid-rows-md-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([rows-md="30"]),
  .ids-layout-grid-rows-md-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([rows-md="31"]),
  .ids-layout-grid-rows-md-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([rows-md="32"]),
  .ids-layout-grid-rows-md-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([rows-md="33"]),
  .ids-layout-grid-rows-md-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([rows-md="34"]),
  .ids-layout-grid-rows-md-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([rows-md="35"]),
  .ids-layout-grid-rows-md-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([rows-md="36"]),
  .ids-layout-grid-rows-md-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([rows-md="37"]),
  .ids-layout-grid-rows-md-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([rows-md="38"]),
  .ids-layout-grid-rows-md-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([rows-md="39"]),
  .ids-layout-grid-rows-md-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([rows-md="40"]),
  .ids-layout-grid-rows-md-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([rows-md="41"]),
  .ids-layout-grid-rows-md-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([rows-md="42"]),
  .ids-layout-grid-rows-md-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([rows-md="43"]),
  .ids-layout-grid-rows-md-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([rows-md="44"]),
  .ids-layout-grid-rows-md-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([rows-md="45"]),
  .ids-layout-grid-rows-md-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([rows-md="46"]),
  .ids-layout-grid-rows-md-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([rows-md="47"]),
  .ids-layout-grid-rows-md-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([rows-md="48"]),
  .ids-layout-grid-rows-md-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([rows-md="49"]),
  .ids-layout-grid-rows-md-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([rows-md="50"]),
  .ids-layout-grid-rows-md-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([flow-md=row]), .ids-layout-grid-flow-md-row {
    grid-auto-flow: row;
  }
  :host([flow-md=column]), .ids-layout-grid-flow-md-col {
    grid-auto-flow: column;
  }
  :host([flow-md=dense]), .ids-layout-grid-flow-md-dense {
    grid-auto-flow: dense;
  }
  :host([flow-md=row-dense]), .ids-layout-grid-flow-md-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-md=column-dense]), .ids-layout-grid-flow-md-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (width >= 928px) {
  :host(:not([enable-container])[cols-lg="1"]),
  .ids-layout-grid-cols-lg-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="2"]),
  .ids-layout-grid-cols-lg-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="3"]),
  .ids-layout-grid-cols-lg-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="4"]),
  .ids-layout-grid-cols-lg-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="5"]),
  .ids-layout-grid-cols-lg-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="6"]),
  .ids-layout-grid-cols-lg-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="7"]),
  .ids-layout-grid-cols-lg-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="8"]),
  .ids-layout-grid-cols-lg-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="9"]),
  .ids-layout-grid-cols-lg-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="10"]),
  .ids-layout-grid-cols-lg-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="11"]),
  .ids-layout-grid-cols-lg-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="12"]),
  .ids-layout-grid-cols-lg-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="13"]),
  .ids-layout-grid-cols-lg-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="14"]),
  .ids-layout-grid-cols-lg-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="15"]),
  .ids-layout-grid-cols-lg-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="16"]),
  .ids-layout-grid-cols-lg-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="17"]),
  .ids-layout-grid-cols-lg-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="18"]),
  .ids-layout-grid-cols-lg-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="19"]),
  .ids-layout-grid-cols-lg-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="20"]),
  .ids-layout-grid-cols-lg-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="21"]),
  .ids-layout-grid-cols-lg-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="22"]),
  .ids-layout-grid-cols-lg-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="23"]),
  .ids-layout-grid-cols-lg-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-lg="24"]),
  .ids-layout-grid-cols-lg-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([rows-lg="1"]),
  .ids-layout-grid-rows-lg-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([rows-lg="2"]),
  .ids-layout-grid-rows-lg-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([rows-lg="3"]),
  .ids-layout-grid-rows-lg-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([rows-lg="4"]),
  .ids-layout-grid-rows-lg-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([rows-lg="5"]),
  .ids-layout-grid-rows-lg-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([rows-lg="6"]),
  .ids-layout-grid-rows-lg-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([rows-lg="7"]),
  .ids-layout-grid-rows-lg-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([rows-lg="8"]),
  .ids-layout-grid-rows-lg-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([rows-lg="9"]),
  .ids-layout-grid-rows-lg-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([rows-lg="10"]),
  .ids-layout-grid-rows-lg-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([rows-lg="11"]),
  .ids-layout-grid-rows-lg-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([rows-lg="12"]),
  .ids-layout-grid-rows-lg-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([rows-lg="13"]),
  .ids-layout-grid-rows-lg-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([rows-lg="14"]),
  .ids-layout-grid-rows-lg-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([rows-lg="15"]),
  .ids-layout-grid-rows-lg-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([rows-lg="16"]),
  .ids-layout-grid-rows-lg-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([rows-lg="17"]),
  .ids-layout-grid-rows-lg-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([rows-lg="18"]),
  .ids-layout-grid-rows-lg-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([rows-lg="19"]),
  .ids-layout-grid-rows-lg-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([rows-lg="20"]),
  .ids-layout-grid-rows-lg-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([rows-lg="21"]),
  .ids-layout-grid-rows-lg-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([rows-lg="22"]),
  .ids-layout-grid-rows-lg-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([rows-lg="23"]),
  .ids-layout-grid-rows-lg-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([rows-lg="24"]),
  .ids-layout-grid-rows-lg-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([rows-lg="25"]),
  .ids-layout-grid-rows-lg-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([rows-lg="26"]),
  .ids-layout-grid-rows-lg-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([rows-lg="27"]),
  .ids-layout-grid-rows-lg-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([rows-lg="28"]),
  .ids-layout-grid-rows-lg-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([rows-lg="29"]),
  .ids-layout-grid-rows-lg-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([rows-lg="30"]),
  .ids-layout-grid-rows-lg-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([rows-lg="31"]),
  .ids-layout-grid-rows-lg-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([rows-lg="32"]),
  .ids-layout-grid-rows-lg-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([rows-lg="33"]),
  .ids-layout-grid-rows-lg-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([rows-lg="34"]),
  .ids-layout-grid-rows-lg-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([rows-lg="35"]),
  .ids-layout-grid-rows-lg-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([rows-lg="36"]),
  .ids-layout-grid-rows-lg-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([rows-lg="37"]),
  .ids-layout-grid-rows-lg-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([rows-lg="38"]),
  .ids-layout-grid-rows-lg-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([rows-lg="39"]),
  .ids-layout-grid-rows-lg-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([rows-lg="40"]),
  .ids-layout-grid-rows-lg-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([rows-lg="41"]),
  .ids-layout-grid-rows-lg-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([rows-lg="42"]),
  .ids-layout-grid-rows-lg-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([rows-lg="43"]),
  .ids-layout-grid-rows-lg-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([rows-lg="44"]),
  .ids-layout-grid-rows-lg-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([rows-lg="45"]),
  .ids-layout-grid-rows-lg-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([rows-lg="46"]),
  .ids-layout-grid-rows-lg-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([rows-lg="47"]),
  .ids-layout-grid-rows-lg-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([rows-lg="48"]),
  .ids-layout-grid-rows-lg-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([rows-lg="49"]),
  .ids-layout-grid-rows-lg-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([rows-lg="50"]),
  .ids-layout-grid-rows-lg-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([flow-lg=row]), .ids-layout-grid-flow-lg-row {
    grid-auto-flow: row;
  }
  :host([flow-lg=column]), .ids-layout-grid-flow-lg-col {
    grid-auto-flow: column;
  }
  :host([flow-lg=dense]), .ids-layout-grid-flow-lg-dense {
    grid-auto-flow: dense;
  }
  :host([flow-lg=row-dense]), .ids-layout-grid-flow-lg-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-lg=column-dense]), .ids-layout-grid-flow-lg-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (width >= 1183px) {
  :host(:not([enable-container])[cols-xl="1"]),
  .ids-layout-grid-cols-xl-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="2"]),
  .ids-layout-grid-cols-xl-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="3"]),
  .ids-layout-grid-cols-xl-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="4"]),
  .ids-layout-grid-cols-xl-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="5"]),
  .ids-layout-grid-cols-xl-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="6"]),
  .ids-layout-grid-cols-xl-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="7"]),
  .ids-layout-grid-cols-xl-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="8"]),
  .ids-layout-grid-cols-xl-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="9"]),
  .ids-layout-grid-cols-xl-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="10"]),
  .ids-layout-grid-cols-xl-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="11"]),
  .ids-layout-grid-cols-xl-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="12"]),
  .ids-layout-grid-cols-xl-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="13"]),
  .ids-layout-grid-cols-xl-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="14"]),
  .ids-layout-grid-cols-xl-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="15"]),
  .ids-layout-grid-cols-xl-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="16"]),
  .ids-layout-grid-cols-xl-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="17"]),
  .ids-layout-grid-cols-xl-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="18"]),
  .ids-layout-grid-cols-xl-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="19"]),
  .ids-layout-grid-cols-xl-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="20"]),
  .ids-layout-grid-cols-xl-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="21"]),
  .ids-layout-grid-cols-xl-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="22"]),
  .ids-layout-grid-cols-xl-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="23"]),
  .ids-layout-grid-cols-xl-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xl="24"]),
  .ids-layout-grid-cols-xl-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([rows-xl="1"]),
  .ids-layout-grid-rows-xl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([rows-xl="2"]),
  .ids-layout-grid-rows-xl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([rows-xl="3"]),
  .ids-layout-grid-rows-xl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([rows-xl="4"]),
  .ids-layout-grid-rows-xl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([rows-xl="5"]),
  .ids-layout-grid-rows-xl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([rows-xl="6"]),
  .ids-layout-grid-rows-xl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([rows-xl="7"]),
  .ids-layout-grid-rows-xl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([rows-xl="8"]),
  .ids-layout-grid-rows-xl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([rows-xl="9"]),
  .ids-layout-grid-rows-xl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([rows-xl="10"]),
  .ids-layout-grid-rows-xl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([rows-xl="11"]),
  .ids-layout-grid-rows-xl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([rows-xl="12"]),
  .ids-layout-grid-rows-xl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([rows-xl="13"]),
  .ids-layout-grid-rows-xl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([rows-xl="14"]),
  .ids-layout-grid-rows-xl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([rows-xl="15"]),
  .ids-layout-grid-rows-xl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([rows-xl="16"]),
  .ids-layout-grid-rows-xl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([rows-xl="17"]),
  .ids-layout-grid-rows-xl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([rows-xl="18"]),
  .ids-layout-grid-rows-xl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([rows-xl="19"]),
  .ids-layout-grid-rows-xl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([rows-xl="20"]),
  .ids-layout-grid-rows-xl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([rows-xl="21"]),
  .ids-layout-grid-rows-xl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([rows-xl="22"]),
  .ids-layout-grid-rows-xl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([rows-xl="23"]),
  .ids-layout-grid-rows-xl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([rows-xl="24"]),
  .ids-layout-grid-rows-xl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([rows-xl="25"]),
  .ids-layout-grid-rows-xl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([rows-xl="26"]),
  .ids-layout-grid-rows-xl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([rows-xl="27"]),
  .ids-layout-grid-rows-xl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([rows-xl="28"]),
  .ids-layout-grid-rows-xl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([rows-xl="29"]),
  .ids-layout-grid-rows-xl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([rows-xl="30"]),
  .ids-layout-grid-rows-xl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([rows-xl="31"]),
  .ids-layout-grid-rows-xl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([rows-xl="32"]),
  .ids-layout-grid-rows-xl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([rows-xl="33"]),
  .ids-layout-grid-rows-xl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([rows-xl="34"]),
  .ids-layout-grid-rows-xl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([rows-xl="35"]),
  .ids-layout-grid-rows-xl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([rows-xl="36"]),
  .ids-layout-grid-rows-xl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([rows-xl="37"]),
  .ids-layout-grid-rows-xl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([rows-xl="38"]),
  .ids-layout-grid-rows-xl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([rows-xl="39"]),
  .ids-layout-grid-rows-xl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([rows-xl="40"]),
  .ids-layout-grid-rows-xl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([rows-xl="41"]),
  .ids-layout-grid-rows-xl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([rows-xl="42"]),
  .ids-layout-grid-rows-xl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([rows-xl="43"]),
  .ids-layout-grid-rows-xl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([rows-xl="44"]),
  .ids-layout-grid-rows-xl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([rows-xl="45"]),
  .ids-layout-grid-rows-xl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([rows-xl="46"]),
  .ids-layout-grid-rows-xl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([rows-xl="47"]),
  .ids-layout-grid-rows-xl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([rows-xl="48"]),
  .ids-layout-grid-rows-xl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([rows-xl="49"]),
  .ids-layout-grid-rows-xl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([rows-xl="50"]),
  .ids-layout-grid-rows-xl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([flow-xl=row]), .ids-layout-grid-flow-xl-row {
    grid-auto-flow: row;
  }
  :host([flow-xl=column]), .ids-layout-grid-flow-xl-col {
    grid-auto-flow: column;
  }
  :host([flow-xl=dense]), .ids-layout-grid-flow-xl-dense {
    grid-auto-flow: dense;
  }
  :host([flow-xl=row-dense]), .ids-layout-grid-flow-xl-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-xl=column-dense]), .ids-layout-grid-flow-xl-col-dense {
    grid-auto-flow: column dense;
  }
}
@media (width >= 2463px) {
  :host(:not([enable-container])[cols-xxl="1"]),
  .ids-layout-grid-cols-xxl-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="2"]),
  .ids-layout-grid-cols-xxl-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="3"]),
  .ids-layout-grid-cols-xxl-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="4"]),
  .ids-layout-grid-cols-xxl-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="5"]),
  .ids-layout-grid-cols-xxl-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="6"]),
  .ids-layout-grid-cols-xxl-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="7"]),
  .ids-layout-grid-cols-xxl-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="8"]),
  .ids-layout-grid-cols-xxl-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="9"]),
  .ids-layout-grid-cols-xxl-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="10"]),
  .ids-layout-grid-cols-xxl-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="11"]),
  .ids-layout-grid-cols-xxl-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="12"]),
  .ids-layout-grid-cols-xxl-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="13"]),
  .ids-layout-grid-cols-xxl-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="14"]),
  .ids-layout-grid-cols-xxl-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="15"]),
  .ids-layout-grid-cols-xxl-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="16"]),
  .ids-layout-grid-cols-xxl-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="17"]),
  .ids-layout-grid-cols-xxl-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="18"]),
  .ids-layout-grid-cols-xxl-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="19"]),
  .ids-layout-grid-cols-xxl-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="20"]),
  .ids-layout-grid-cols-xxl-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="21"]),
  .ids-layout-grid-cols-xxl-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="22"]),
  .ids-layout-grid-cols-xxl-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="23"]),
  .ids-layout-grid-cols-xxl-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host(:not([enable-container])[cols-xxl="24"]),
  .ids-layout-grid-cols-xxl-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([rows-xxl="1"]),
  .ids-layout-grid-rows-xxl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([rows-xxl="2"]),
  .ids-layout-grid-rows-xxl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([rows-xxl="3"]),
  .ids-layout-grid-rows-xxl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([rows-xxl="4"]),
  .ids-layout-grid-rows-xxl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([rows-xxl="5"]),
  .ids-layout-grid-rows-xxl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([rows-xxl="6"]),
  .ids-layout-grid-rows-xxl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([rows-xxl="7"]),
  .ids-layout-grid-rows-xxl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([rows-xxl="8"]),
  .ids-layout-grid-rows-xxl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([rows-xxl="9"]),
  .ids-layout-grid-rows-xxl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([rows-xxl="10"]),
  .ids-layout-grid-rows-xxl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([rows-xxl="11"]),
  .ids-layout-grid-rows-xxl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([rows-xxl="12"]),
  .ids-layout-grid-rows-xxl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([rows-xxl="13"]),
  .ids-layout-grid-rows-xxl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([rows-xxl="14"]),
  .ids-layout-grid-rows-xxl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([rows-xxl="15"]),
  .ids-layout-grid-rows-xxl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([rows-xxl="16"]),
  .ids-layout-grid-rows-xxl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([rows-xxl="17"]),
  .ids-layout-grid-rows-xxl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([rows-xxl="18"]),
  .ids-layout-grid-rows-xxl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([rows-xxl="19"]),
  .ids-layout-grid-rows-xxl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([rows-xxl="20"]),
  .ids-layout-grid-rows-xxl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([rows-xxl="21"]),
  .ids-layout-grid-rows-xxl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([rows-xxl="22"]),
  .ids-layout-grid-rows-xxl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([rows-xxl="23"]),
  .ids-layout-grid-rows-xxl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([rows-xxl="24"]),
  .ids-layout-grid-rows-xxl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([rows-xxl="25"]),
  .ids-layout-grid-rows-xxl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([rows-xxl="26"]),
  .ids-layout-grid-rows-xxl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([rows-xxl="27"]),
  .ids-layout-grid-rows-xxl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([rows-xxl="28"]),
  .ids-layout-grid-rows-xxl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([rows-xxl="29"]),
  .ids-layout-grid-rows-xxl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([rows-xxl="30"]),
  .ids-layout-grid-rows-xxl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([rows-xxl="31"]),
  .ids-layout-grid-rows-xxl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([rows-xxl="32"]),
  .ids-layout-grid-rows-xxl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([rows-xxl="33"]),
  .ids-layout-grid-rows-xxl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([rows-xxl="34"]),
  .ids-layout-grid-rows-xxl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([rows-xxl="35"]),
  .ids-layout-grid-rows-xxl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([rows-xxl="36"]),
  .ids-layout-grid-rows-xxl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([rows-xxl="37"]),
  .ids-layout-grid-rows-xxl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([rows-xxl="38"]),
  .ids-layout-grid-rows-xxl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([rows-xxl="39"]),
  .ids-layout-grid-rows-xxl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([rows-xxl="40"]),
  .ids-layout-grid-rows-xxl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([rows-xxl="41"]),
  .ids-layout-grid-rows-xxl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([rows-xxl="42"]),
  .ids-layout-grid-rows-xxl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([rows-xxl="43"]),
  .ids-layout-grid-rows-xxl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([rows-xxl="44"]),
  .ids-layout-grid-rows-xxl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([rows-xxl="45"]),
  .ids-layout-grid-rows-xxl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([rows-xxl="46"]),
  .ids-layout-grid-rows-xxl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([rows-xxl="47"]),
  .ids-layout-grid-rows-xxl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([rows-xxl="48"]),
  .ids-layout-grid-rows-xxl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([rows-xxl="49"]),
  .ids-layout-grid-rows-xxl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([rows-xxl="50"]),
  .ids-layout-grid-rows-xxl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([flow-xxl=row]), .ids-layout-grid-flow-xxl-row {
    grid-auto-flow: row;
  }
  :host([flow-xxl=column]), .ids-layout-grid-flow-xxl-col {
    grid-auto-flow: column;
  }
  :host([flow-xxl=dense]), .ids-layout-grid-flow-xxl-dense {
    grid-auto-flow: dense;
  }
  :host([flow-xxl=row-dense]), .ids-layout-grid-flow-xxl-row-dense {
    grid-auto-flow: row dense;
  }
  :host([flow-xxl=column-dense]), .ids-layout-grid-flow-xxl-col-dense {
    grid-auto-flow: column dense;
  }
}
@container (width >= 0) {
  :host([cols-xs="1"]), .ids-layout-grid-cols-xs-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="2"]), .ids-layout-grid-cols-xs-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="3"]), .ids-layout-grid-cols-xs-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="4"]), .ids-layout-grid-cols-xs-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="5"]), .ids-layout-grid-cols-xs-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="6"]), .ids-layout-grid-cols-xs-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="7"]), .ids-layout-grid-cols-xs-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="8"]), .ids-layout-grid-cols-xs-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="9"]), .ids-layout-grid-cols-xs-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="10"]), .ids-layout-grid-cols-xs-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="11"]), .ids-layout-grid-cols-xs-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="12"]), .ids-layout-grid-cols-xs-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="13"]), .ids-layout-grid-cols-xs-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="14"]), .ids-layout-grid-cols-xs-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="15"]), .ids-layout-grid-cols-xs-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="16"]), .ids-layout-grid-cols-xs-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="17"]), .ids-layout-grid-cols-xs-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="18"]), .ids-layout-grid-cols-xs-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="19"]), .ids-layout-grid-cols-xs-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="20"]), .ids-layout-grid-cols-xs-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="21"]), .ids-layout-grid-cols-xs-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="22"]), .ids-layout-grid-cols-xs-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="23"]), .ids-layout-grid-cols-xs-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xs="24"]), .ids-layout-grid-cols-xs-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
}
@container (width >= 767px) {
  :host([cols-sm="1"]), .ids-layout-grid-cols-sm-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="2"]), .ids-layout-grid-cols-sm-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="3"]), .ids-layout-grid-cols-sm-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="4"]), .ids-layout-grid-cols-sm-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="5"]), .ids-layout-grid-cols-sm-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="6"]), .ids-layout-grid-cols-sm-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="7"]), .ids-layout-grid-cols-sm-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="8"]), .ids-layout-grid-cols-sm-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="9"]), .ids-layout-grid-cols-sm-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="10"]), .ids-layout-grid-cols-sm-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="11"]), .ids-layout-grid-cols-sm-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="12"]), .ids-layout-grid-cols-sm-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="13"]), .ids-layout-grid-cols-sm-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="14"]), .ids-layout-grid-cols-sm-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="15"]), .ids-layout-grid-cols-sm-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="16"]), .ids-layout-grid-cols-sm-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="17"]), .ids-layout-grid-cols-sm-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="18"]), .ids-layout-grid-cols-sm-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="19"]), .ids-layout-grid-cols-sm-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="20"]), .ids-layout-grid-cols-sm-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="21"]), .ids-layout-grid-cols-sm-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="22"]), .ids-layout-grid-cols-sm-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="23"]), .ids-layout-grid-cols-sm-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-sm="24"]), .ids-layout-grid-cols-sm-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
}
@container (width >= 927px) {
  :host([cols-md="1"]), .ids-layout-grid-cols-md-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="2"]), .ids-layout-grid-cols-md-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="3"]), .ids-layout-grid-cols-md-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="4"]), .ids-layout-grid-cols-md-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="5"]), .ids-layout-grid-cols-md-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="6"]), .ids-layout-grid-cols-md-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="7"]), .ids-layout-grid-cols-md-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="8"]), .ids-layout-grid-cols-md-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="9"]), .ids-layout-grid-cols-md-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="10"]), .ids-layout-grid-cols-md-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="11"]), .ids-layout-grid-cols-md-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="12"]), .ids-layout-grid-cols-md-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="13"]), .ids-layout-grid-cols-md-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="14"]), .ids-layout-grid-cols-md-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="15"]), .ids-layout-grid-cols-md-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="16"]), .ids-layout-grid-cols-md-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="17"]), .ids-layout-grid-cols-md-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="18"]), .ids-layout-grid-cols-md-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="19"]), .ids-layout-grid-cols-md-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="20"]), .ids-layout-grid-cols-md-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="21"]), .ids-layout-grid-cols-md-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="22"]), .ids-layout-grid-cols-md-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="23"]), .ids-layout-grid-cols-md-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-md="24"]), .ids-layout-grid-cols-md-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
}
@container (width >= 928px) {
  :host([cols-lg="1"]), .ids-layout-grid-cols-lg-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="2"]), .ids-layout-grid-cols-lg-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="3"]), .ids-layout-grid-cols-lg-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="4"]), .ids-layout-grid-cols-lg-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="5"]), .ids-layout-grid-cols-lg-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="6"]), .ids-layout-grid-cols-lg-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="7"]), .ids-layout-grid-cols-lg-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="8"]), .ids-layout-grid-cols-lg-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="9"]), .ids-layout-grid-cols-lg-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="10"]), .ids-layout-grid-cols-lg-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="11"]), .ids-layout-grid-cols-lg-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="12"]), .ids-layout-grid-cols-lg-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="13"]), .ids-layout-grid-cols-lg-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="14"]), .ids-layout-grid-cols-lg-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="15"]), .ids-layout-grid-cols-lg-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="16"]), .ids-layout-grid-cols-lg-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="17"]), .ids-layout-grid-cols-lg-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="18"]), .ids-layout-grid-cols-lg-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="19"]), .ids-layout-grid-cols-lg-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="20"]), .ids-layout-grid-cols-lg-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="21"]), .ids-layout-grid-cols-lg-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="22"]), .ids-layout-grid-cols-lg-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="23"]), .ids-layout-grid-cols-lg-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-lg="24"]), .ids-layout-grid-cols-lg-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
}
@container (width >= 1183px) {
  :host([cols-xl="1"]), .ids-layout-grid-cols-xl-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="2"]), .ids-layout-grid-cols-xl-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="3"]), .ids-layout-grid-cols-xl-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="4"]), .ids-layout-grid-cols-xl-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="5"]), .ids-layout-grid-cols-xl-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="6"]), .ids-layout-grid-cols-xl-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="7"]), .ids-layout-grid-cols-xl-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="8"]), .ids-layout-grid-cols-xl-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="9"]), .ids-layout-grid-cols-xl-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="10"]), .ids-layout-grid-cols-xl-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="11"]), .ids-layout-grid-cols-xl-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="12"]), .ids-layout-grid-cols-xl-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="13"]), .ids-layout-grid-cols-xl-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="14"]), .ids-layout-grid-cols-xl-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="15"]), .ids-layout-grid-cols-xl-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="16"]), .ids-layout-grid-cols-xl-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="17"]), .ids-layout-grid-cols-xl-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="18"]), .ids-layout-grid-cols-xl-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="19"]), .ids-layout-grid-cols-xl-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="20"]), .ids-layout-grid-cols-xl-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="21"]), .ids-layout-grid-cols-xl-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="22"]), .ids-layout-grid-cols-xl-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="23"]), .ids-layout-grid-cols-xl-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xl="24"]), .ids-layout-grid-cols-xl-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
}
@container (width >= 2463px) {
  :host([cols-xxl="1"]), .ids-layout-grid-cols-xxl-1 {
    width: 100%;
    grid-template-columns: repeat(1, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="2"]), .ids-layout-grid-cols-xxl-2 {
    width: 100%;
    grid-template-columns: repeat(2, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="3"]), .ids-layout-grid-cols-xxl-3 {
    width: 100%;
    grid-template-columns: repeat(3, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="4"]), .ids-layout-grid-cols-xxl-4 {
    width: 100%;
    grid-template-columns: repeat(4, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="5"]), .ids-layout-grid-cols-xxl-5 {
    width: 100%;
    grid-template-columns: repeat(5, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="6"]), .ids-layout-grid-cols-xxl-6 {
    width: 100%;
    grid-template-columns: repeat(6, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="7"]), .ids-layout-grid-cols-xxl-7 {
    width: 100%;
    grid-template-columns: repeat(7, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="8"]), .ids-layout-grid-cols-xxl-8 {
    width: 100%;
    grid-template-columns: repeat(8, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="9"]), .ids-layout-grid-cols-xxl-9 {
    width: 100%;
    grid-template-columns: repeat(9, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="10"]), .ids-layout-grid-cols-xxl-10 {
    width: 100%;
    grid-template-columns: repeat(10, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="11"]), .ids-layout-grid-cols-xxl-11 {
    width: 100%;
    grid-template-columns: repeat(11, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="12"]), .ids-layout-grid-cols-xxl-12 {
    width: 100%;
    grid-template-columns: repeat(12, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="13"]), .ids-layout-grid-cols-xxl-13 {
    width: 100%;
    grid-template-columns: repeat(13, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="14"]), .ids-layout-grid-cols-xxl-14 {
    width: 100%;
    grid-template-columns: repeat(14, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="15"]), .ids-layout-grid-cols-xxl-15 {
    width: 100%;
    grid-template-columns: repeat(15, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="16"]), .ids-layout-grid-cols-xxl-16 {
    width: 100%;
    grid-template-columns: repeat(16, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="17"]), .ids-layout-grid-cols-xxl-17 {
    width: 100%;
    grid-template-columns: repeat(17, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="18"]), .ids-layout-grid-cols-xxl-18 {
    width: 100%;
    grid-template-columns: repeat(18, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="19"]), .ids-layout-grid-cols-xxl-19 {
    width: 100%;
    grid-template-columns: repeat(19, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="20"]), .ids-layout-grid-cols-xxl-20 {
    width: 100%;
    grid-template-columns: repeat(20, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="21"]), .ids-layout-grid-cols-xxl-21 {
    width: 100%;
    grid-template-columns: repeat(21, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="22"]), .ids-layout-grid-cols-xxl-22 {
    width: 100%;
    grid-template-columns: repeat(22, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="23"]), .ids-layout-grid-cols-xxl-23 {
    width: 100%;
    grid-template-columns: repeat(23, minmax(var(--min-col-width), var(--max-col-width)));
  }
  :host([cols-xxl="24"]), .ids-layout-grid-cols-xxl-24 {
    width: 100%;
    grid-template-columns: repeat(24, minmax(var(--min-col-width), var(--max-col-width)));
  }
}
/* Use media queries by default */
@media (width >= 320px) {
  :host(:not([enable-container])) > ::slotted([col-span-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-xs="1"], :host(:not([enable-container])).ids-layout-grid-rows-xs-1,
  .ids-layout-grid:not([enable-container])[rows-xs="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="2"], :host(:not([enable-container])).ids-layout-grid-rows-xs-2,
  .ids-layout-grid:not([enable-container])[rows-xs="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="3"], :host(:not([enable-container])).ids-layout-grid-rows-xs-3,
  .ids-layout-grid:not([enable-container])[rows-xs="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="4"], :host(:not([enable-container])).ids-layout-grid-rows-xs-4,
  .ids-layout-grid:not([enable-container])[rows-xs="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="5"], :host(:not([enable-container])).ids-layout-grid-rows-xs-5,
  .ids-layout-grid:not([enable-container])[rows-xs="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="6"], :host(:not([enable-container])).ids-layout-grid-rows-xs-6,
  .ids-layout-grid:not([enable-container])[rows-xs="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="7"], :host(:not([enable-container])).ids-layout-grid-rows-xs-7,
  .ids-layout-grid:not([enable-container])[rows-xs="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="8"], :host(:not([enable-container])).ids-layout-grid-rows-xs-8,
  .ids-layout-grid:not([enable-container])[rows-xs="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="9"], :host(:not([enable-container])).ids-layout-grid-rows-xs-9,
  .ids-layout-grid:not([enable-container])[rows-xs="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="10"], :host(:not([enable-container])).ids-layout-grid-rows-xs-10,
  .ids-layout-grid:not([enable-container])[rows-xs="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="11"], :host(:not([enable-container])).ids-layout-grid-rows-xs-11,
  .ids-layout-grid:not([enable-container])[rows-xs="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="12"], :host(:not([enable-container])).ids-layout-grid-rows-xs-12,
  .ids-layout-grid:not([enable-container])[rows-xs="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="13"], :host(:not([enable-container])).ids-layout-grid-rows-xs-13,
  .ids-layout-grid:not([enable-container])[rows-xs="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="14"], :host(:not([enable-container])).ids-layout-grid-rows-xs-14,
  .ids-layout-grid:not([enable-container])[rows-xs="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="15"], :host(:not([enable-container])).ids-layout-grid-rows-xs-15,
  .ids-layout-grid:not([enable-container])[rows-xs="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="16"], :host(:not([enable-container])).ids-layout-grid-rows-xs-16,
  .ids-layout-grid:not([enable-container])[rows-xs="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="17"], :host(:not([enable-container])).ids-layout-grid-rows-xs-17,
  .ids-layout-grid:not([enable-container])[rows-xs="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="18"], :host(:not([enable-container])).ids-layout-grid-rows-xs-18,
  .ids-layout-grid:not([enable-container])[rows-xs="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="19"], :host(:not([enable-container])).ids-layout-grid-rows-xs-19,
  .ids-layout-grid:not([enable-container])[rows-xs="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="20"], :host(:not([enable-container])).ids-layout-grid-rows-xs-20,
  .ids-layout-grid:not([enable-container])[rows-xs="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="21"], :host(:not([enable-container])).ids-layout-grid-rows-xs-21,
  .ids-layout-grid:not([enable-container])[rows-xs="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="22"], :host(:not([enable-container])).ids-layout-grid-rows-xs-22,
  .ids-layout-grid:not([enable-container])[rows-xs="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="23"], :host(:not([enable-container])).ids-layout-grid-rows-xs-23,
  .ids-layout-grid:not([enable-container])[rows-xs="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="24"], :host(:not([enable-container])).ids-layout-grid-rows-xs-24,
  .ids-layout-grid:not([enable-container])[rows-xs="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="25"], :host(:not([enable-container])).ids-layout-grid-rows-xs-25,
  .ids-layout-grid:not([enable-container])[rows-xs="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="26"], :host(:not([enable-container])).ids-layout-grid-rows-xs-26,
  .ids-layout-grid:not([enable-container])[rows-xs="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="27"], :host(:not([enable-container])).ids-layout-grid-rows-xs-27,
  .ids-layout-grid:not([enable-container])[rows-xs="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="28"], :host(:not([enable-container])).ids-layout-grid-rows-xs-28,
  .ids-layout-grid:not([enable-container])[rows-xs="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="29"], :host(:not([enable-container])).ids-layout-grid-rows-xs-29,
  .ids-layout-grid:not([enable-container])[rows-xs="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="30"], :host(:not([enable-container])).ids-layout-grid-rows-xs-30,
  .ids-layout-grid:not([enable-container])[rows-xs="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="31"], :host(:not([enable-container])).ids-layout-grid-rows-xs-31,
  .ids-layout-grid:not([enable-container])[rows-xs="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="32"], :host(:not([enable-container])).ids-layout-grid-rows-xs-32,
  .ids-layout-grid:not([enable-container])[rows-xs="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="33"], :host(:not([enable-container])).ids-layout-grid-rows-xs-33,
  .ids-layout-grid:not([enable-container])[rows-xs="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="34"], :host(:not([enable-container])).ids-layout-grid-rows-xs-34,
  .ids-layout-grid:not([enable-container])[rows-xs="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="35"], :host(:not([enable-container])).ids-layout-grid-rows-xs-35,
  .ids-layout-grid:not([enable-container])[rows-xs="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="36"], :host(:not([enable-container])).ids-layout-grid-rows-xs-36,
  .ids-layout-grid:not([enable-container])[rows-xs="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="37"], :host(:not([enable-container])).ids-layout-grid-rows-xs-37,
  .ids-layout-grid:not([enable-container])[rows-xs="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="38"], :host(:not([enable-container])).ids-layout-grid-rows-xs-38,
  .ids-layout-grid:not([enable-container])[rows-xs="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="39"], :host(:not([enable-container])).ids-layout-grid-rows-xs-39,
  .ids-layout-grid:not([enable-container])[rows-xs="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="40"], :host(:not([enable-container])).ids-layout-grid-rows-xs-40,
  .ids-layout-grid:not([enable-container])[rows-xs="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="41"], :host(:not([enable-container])).ids-layout-grid-rows-xs-41,
  .ids-layout-grid:not([enable-container])[rows-xs="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="42"], :host(:not([enable-container])).ids-layout-grid-rows-xs-42,
  .ids-layout-grid:not([enable-container])[rows-xs="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="43"], :host(:not([enable-container])).ids-layout-grid-rows-xs-43,
  .ids-layout-grid:not([enable-container])[rows-xs="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="44"], :host(:not([enable-container])).ids-layout-grid-rows-xs-44,
  .ids-layout-grid:not([enable-container])[rows-xs="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="45"], :host(:not([enable-container])).ids-layout-grid-rows-xs-45,
  .ids-layout-grid:not([enable-container])[rows-xs="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="46"], :host(:not([enable-container])).ids-layout-grid-rows-xs-46,
  .ids-layout-grid:not([enable-container])[rows-xs="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="47"], :host(:not([enable-container])).ids-layout-grid-rows-xs-47,
  .ids-layout-grid:not([enable-container])[rows-xs="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="48"], :host(:not([enable-container])).ids-layout-grid-rows-xs-48,
  .ids-layout-grid:not([enable-container])[rows-xs="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="49"], :host(:not([enable-container])).ids-layout-grid-rows-xs-49,
  .ids-layout-grid:not([enable-container])[rows-xs="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xs="50"], :host(:not([enable-container])).ids-layout-grid-rows-xs-50,
  .ids-layout-grid:not([enable-container])[rows-xs="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xs-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xs="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xs-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xs="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xs="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xs="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=xs]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=xs]) {
    display: block;
  }
}
@media (width >= 767px) {
  :host(:not([enable-container])) > ::slotted([col-span-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-sm="1"], :host(:not([enable-container])).ids-layout-grid-rows-sm-1,
  .ids-layout-grid:not([enable-container])[rows-sm="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="2"], :host(:not([enable-container])).ids-layout-grid-rows-sm-2,
  .ids-layout-grid:not([enable-container])[rows-sm="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="3"], :host(:not([enable-container])).ids-layout-grid-rows-sm-3,
  .ids-layout-grid:not([enable-container])[rows-sm="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="4"], :host(:not([enable-container])).ids-layout-grid-rows-sm-4,
  .ids-layout-grid:not([enable-container])[rows-sm="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="5"], :host(:not([enable-container])).ids-layout-grid-rows-sm-5,
  .ids-layout-grid:not([enable-container])[rows-sm="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="6"], :host(:not([enable-container])).ids-layout-grid-rows-sm-6,
  .ids-layout-grid:not([enable-container])[rows-sm="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="7"], :host(:not([enable-container])).ids-layout-grid-rows-sm-7,
  .ids-layout-grid:not([enable-container])[rows-sm="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="8"], :host(:not([enable-container])).ids-layout-grid-rows-sm-8,
  .ids-layout-grid:not([enable-container])[rows-sm="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="9"], :host(:not([enable-container])).ids-layout-grid-rows-sm-9,
  .ids-layout-grid:not([enable-container])[rows-sm="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="10"], :host(:not([enable-container])).ids-layout-grid-rows-sm-10,
  .ids-layout-grid:not([enable-container])[rows-sm="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="11"], :host(:not([enable-container])).ids-layout-grid-rows-sm-11,
  .ids-layout-grid:not([enable-container])[rows-sm="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="12"], :host(:not([enable-container])).ids-layout-grid-rows-sm-12,
  .ids-layout-grid:not([enable-container])[rows-sm="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="13"], :host(:not([enable-container])).ids-layout-grid-rows-sm-13,
  .ids-layout-grid:not([enable-container])[rows-sm="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="14"], :host(:not([enable-container])).ids-layout-grid-rows-sm-14,
  .ids-layout-grid:not([enable-container])[rows-sm="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="15"], :host(:not([enable-container])).ids-layout-grid-rows-sm-15,
  .ids-layout-grid:not([enable-container])[rows-sm="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="16"], :host(:not([enable-container])).ids-layout-grid-rows-sm-16,
  .ids-layout-grid:not([enable-container])[rows-sm="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="17"], :host(:not([enable-container])).ids-layout-grid-rows-sm-17,
  .ids-layout-grid:not([enable-container])[rows-sm="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="18"], :host(:not([enable-container])).ids-layout-grid-rows-sm-18,
  .ids-layout-grid:not([enable-container])[rows-sm="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="19"], :host(:not([enable-container])).ids-layout-grid-rows-sm-19,
  .ids-layout-grid:not([enable-container])[rows-sm="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="20"], :host(:not([enable-container])).ids-layout-grid-rows-sm-20,
  .ids-layout-grid:not([enable-container])[rows-sm="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="21"], :host(:not([enable-container])).ids-layout-grid-rows-sm-21,
  .ids-layout-grid:not([enable-container])[rows-sm="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="22"], :host(:not([enable-container])).ids-layout-grid-rows-sm-22,
  .ids-layout-grid:not([enable-container])[rows-sm="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="23"], :host(:not([enable-container])).ids-layout-grid-rows-sm-23,
  .ids-layout-grid:not([enable-container])[rows-sm="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="24"], :host(:not([enable-container])).ids-layout-grid-rows-sm-24,
  .ids-layout-grid:not([enable-container])[rows-sm="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="25"], :host(:not([enable-container])).ids-layout-grid-rows-sm-25,
  .ids-layout-grid:not([enable-container])[rows-sm="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="26"], :host(:not([enable-container])).ids-layout-grid-rows-sm-26,
  .ids-layout-grid:not([enable-container])[rows-sm="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="27"], :host(:not([enable-container])).ids-layout-grid-rows-sm-27,
  .ids-layout-grid:not([enable-container])[rows-sm="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="28"], :host(:not([enable-container])).ids-layout-grid-rows-sm-28,
  .ids-layout-grid:not([enable-container])[rows-sm="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="29"], :host(:not([enable-container])).ids-layout-grid-rows-sm-29,
  .ids-layout-grid:not([enable-container])[rows-sm="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="30"], :host(:not([enable-container])).ids-layout-grid-rows-sm-30,
  .ids-layout-grid:not([enable-container])[rows-sm="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="31"], :host(:not([enable-container])).ids-layout-grid-rows-sm-31,
  .ids-layout-grid:not([enable-container])[rows-sm="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="32"], :host(:not([enable-container])).ids-layout-grid-rows-sm-32,
  .ids-layout-grid:not([enable-container])[rows-sm="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="33"], :host(:not([enable-container])).ids-layout-grid-rows-sm-33,
  .ids-layout-grid:not([enable-container])[rows-sm="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="34"], :host(:not([enable-container])).ids-layout-grid-rows-sm-34,
  .ids-layout-grid:not([enable-container])[rows-sm="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="35"], :host(:not([enable-container])).ids-layout-grid-rows-sm-35,
  .ids-layout-grid:not([enable-container])[rows-sm="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="36"], :host(:not([enable-container])).ids-layout-grid-rows-sm-36,
  .ids-layout-grid:not([enable-container])[rows-sm="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="37"], :host(:not([enable-container])).ids-layout-grid-rows-sm-37,
  .ids-layout-grid:not([enable-container])[rows-sm="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="38"], :host(:not([enable-container])).ids-layout-grid-rows-sm-38,
  .ids-layout-grid:not([enable-container])[rows-sm="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="39"], :host(:not([enable-container])).ids-layout-grid-rows-sm-39,
  .ids-layout-grid:not([enable-container])[rows-sm="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="40"], :host(:not([enable-container])).ids-layout-grid-rows-sm-40,
  .ids-layout-grid:not([enable-container])[rows-sm="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="41"], :host(:not([enable-container])).ids-layout-grid-rows-sm-41,
  .ids-layout-grid:not([enable-container])[rows-sm="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="42"], :host(:not([enable-container])).ids-layout-grid-rows-sm-42,
  .ids-layout-grid:not([enable-container])[rows-sm="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="43"], :host(:not([enable-container])).ids-layout-grid-rows-sm-43,
  .ids-layout-grid:not([enable-container])[rows-sm="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="44"], :host(:not([enable-container])).ids-layout-grid-rows-sm-44,
  .ids-layout-grid:not([enable-container])[rows-sm="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="45"], :host(:not([enable-container])).ids-layout-grid-rows-sm-45,
  .ids-layout-grid:not([enable-container])[rows-sm="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="46"], :host(:not([enable-container])).ids-layout-grid-rows-sm-46,
  .ids-layout-grid:not([enable-container])[rows-sm="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="47"], :host(:not([enable-container])).ids-layout-grid-rows-sm-47,
  .ids-layout-grid:not([enable-container])[rows-sm="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="48"], :host(:not([enable-container])).ids-layout-grid-rows-sm-48,
  .ids-layout-grid:not([enable-container])[rows-sm="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="49"], :host(:not([enable-container])).ids-layout-grid-rows-sm-49,
  .ids-layout-grid:not([enable-container])[rows-sm="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-sm="50"], :host(:not([enable-container])).ids-layout-grid-rows-sm-50,
  .ids-layout-grid:not([enable-container])[rows-sm="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-sm-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-sm="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-sm-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-sm="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-sm="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-sm="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=sm]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=sm]) {
    display: block;
  }
}
@media (width >= 927px) {
  :host(:not([enable-container])) > ::slotted([col-span-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-md="1"], :host(:not([enable-container])).ids-layout-grid-rows-md-1,
  .ids-layout-grid:not([enable-container])[rows-md="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-md="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="2"], :host(:not([enable-container])).ids-layout-grid-rows-md-2,
  .ids-layout-grid:not([enable-container])[rows-md="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-md="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="3"], :host(:not([enable-container])).ids-layout-grid-rows-md-3,
  .ids-layout-grid:not([enable-container])[rows-md="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-md="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="4"], :host(:not([enable-container])).ids-layout-grid-rows-md-4,
  .ids-layout-grid:not([enable-container])[rows-md="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-md="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="5"], :host(:not([enable-container])).ids-layout-grid-rows-md-5,
  .ids-layout-grid:not([enable-container])[rows-md="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-md="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="6"], :host(:not([enable-container])).ids-layout-grid-rows-md-6,
  .ids-layout-grid:not([enable-container])[rows-md="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-md="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="7"], :host(:not([enable-container])).ids-layout-grid-rows-md-7,
  .ids-layout-grid:not([enable-container])[rows-md="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-md="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="8"], :host(:not([enable-container])).ids-layout-grid-rows-md-8,
  .ids-layout-grid:not([enable-container])[rows-md="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-md="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="9"], :host(:not([enable-container])).ids-layout-grid-rows-md-9,
  .ids-layout-grid:not([enable-container])[rows-md="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-md="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="10"], :host(:not([enable-container])).ids-layout-grid-rows-md-10,
  .ids-layout-grid:not([enable-container])[rows-md="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-md="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="11"], :host(:not([enable-container])).ids-layout-grid-rows-md-11,
  .ids-layout-grid:not([enable-container])[rows-md="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-md="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="12"], :host(:not([enable-container])).ids-layout-grid-rows-md-12,
  .ids-layout-grid:not([enable-container])[rows-md="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-md="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="13"], :host(:not([enable-container])).ids-layout-grid-rows-md-13,
  .ids-layout-grid:not([enable-container])[rows-md="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-md="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="14"], :host(:not([enable-container])).ids-layout-grid-rows-md-14,
  .ids-layout-grid:not([enable-container])[rows-md="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-md="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="15"], :host(:not([enable-container])).ids-layout-grid-rows-md-15,
  .ids-layout-grid:not([enable-container])[rows-md="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-md="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="16"], :host(:not([enable-container])).ids-layout-grid-rows-md-16,
  .ids-layout-grid:not([enable-container])[rows-md="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-md="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="17"], :host(:not([enable-container])).ids-layout-grid-rows-md-17,
  .ids-layout-grid:not([enable-container])[rows-md="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-md="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="18"], :host(:not([enable-container])).ids-layout-grid-rows-md-18,
  .ids-layout-grid:not([enable-container])[rows-md="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-md="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="19"], :host(:not([enable-container])).ids-layout-grid-rows-md-19,
  .ids-layout-grid:not([enable-container])[rows-md="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-md="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="20"], :host(:not([enable-container])).ids-layout-grid-rows-md-20,
  .ids-layout-grid:not([enable-container])[rows-md="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-md="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="21"], :host(:not([enable-container])).ids-layout-grid-rows-md-21,
  .ids-layout-grid:not([enable-container])[rows-md="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-md="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="22"], :host(:not([enable-container])).ids-layout-grid-rows-md-22,
  .ids-layout-grid:not([enable-container])[rows-md="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-md="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="23"], :host(:not([enable-container])).ids-layout-grid-rows-md-23,
  .ids-layout-grid:not([enable-container])[rows-md="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-md="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="24"], :host(:not([enable-container])).ids-layout-grid-rows-md-24,
  .ids-layout-grid:not([enable-container])[rows-md="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-md="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="25"], :host(:not([enable-container])).ids-layout-grid-rows-md-25,
  .ids-layout-grid:not([enable-container])[rows-md="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-md="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="26"], :host(:not([enable-container])).ids-layout-grid-rows-md-26,
  .ids-layout-grid:not([enable-container])[rows-md="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-md="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="27"], :host(:not([enable-container])).ids-layout-grid-rows-md-27,
  .ids-layout-grid:not([enable-container])[rows-md="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-md="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="28"], :host(:not([enable-container])).ids-layout-grid-rows-md-28,
  .ids-layout-grid:not([enable-container])[rows-md="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-md="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="29"], :host(:not([enable-container])).ids-layout-grid-rows-md-29,
  .ids-layout-grid:not([enable-container])[rows-md="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-md="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="30"], :host(:not([enable-container])).ids-layout-grid-rows-md-30,
  .ids-layout-grid:not([enable-container])[rows-md="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-md="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="31"], :host(:not([enable-container])).ids-layout-grid-rows-md-31,
  .ids-layout-grid:not([enable-container])[rows-md="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-md="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="32"], :host(:not([enable-container])).ids-layout-grid-rows-md-32,
  .ids-layout-grid:not([enable-container])[rows-md="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-md="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="33"], :host(:not([enable-container])).ids-layout-grid-rows-md-33,
  .ids-layout-grid:not([enable-container])[rows-md="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-md="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="34"], :host(:not([enable-container])).ids-layout-grid-rows-md-34,
  .ids-layout-grid:not([enable-container])[rows-md="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-md="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="35"], :host(:not([enable-container])).ids-layout-grid-rows-md-35,
  .ids-layout-grid:not([enable-container])[rows-md="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-md="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="36"], :host(:not([enable-container])).ids-layout-grid-rows-md-36,
  .ids-layout-grid:not([enable-container])[rows-md="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-md="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="37"], :host(:not([enable-container])).ids-layout-grid-rows-md-37,
  .ids-layout-grid:not([enable-container])[rows-md="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-md="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="38"], :host(:not([enable-container])).ids-layout-grid-rows-md-38,
  .ids-layout-grid:not([enable-container])[rows-md="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-md="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="39"], :host(:not([enable-container])).ids-layout-grid-rows-md-39,
  .ids-layout-grid:not([enable-container])[rows-md="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-md="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="40"], :host(:not([enable-container])).ids-layout-grid-rows-md-40,
  .ids-layout-grid:not([enable-container])[rows-md="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-md="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="41"], :host(:not([enable-container])).ids-layout-grid-rows-md-41,
  .ids-layout-grid:not([enable-container])[rows-md="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-md="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="42"], :host(:not([enable-container])).ids-layout-grid-rows-md-42,
  .ids-layout-grid:not([enable-container])[rows-md="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-md="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="43"], :host(:not([enable-container])).ids-layout-grid-rows-md-43,
  .ids-layout-grid:not([enable-container])[rows-md="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-md="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="44"], :host(:not([enable-container])).ids-layout-grid-rows-md-44,
  .ids-layout-grid:not([enable-container])[rows-md="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-md="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="45"], :host(:not([enable-container])).ids-layout-grid-rows-md-45,
  .ids-layout-grid:not([enable-container])[rows-md="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-md="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="46"], :host(:not([enable-container])).ids-layout-grid-rows-md-46,
  .ids-layout-grid:not([enable-container])[rows-md="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-md="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="47"], :host(:not([enable-container])).ids-layout-grid-rows-md-47,
  .ids-layout-grid:not([enable-container])[rows-md="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-md="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="48"], :host(:not([enable-container])).ids-layout-grid-rows-md-48,
  .ids-layout-grid:not([enable-container])[rows-md="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-md="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="49"], :host(:not([enable-container])).ids-layout-grid-rows-md-49,
  .ids-layout-grid:not([enable-container])[rows-md="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-md="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-md="50"], :host(:not([enable-container])).ids-layout-grid-rows-md-50,
  .ids-layout-grid:not([enable-container])[rows-md="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-md-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-md="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-md-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-md="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-md="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-md="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-md="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=md]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=md]) {
    display: block;
  }
}
@media (width >= 928px) {
  :host(:not([enable-container])) > ::slotted([col-span-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-lg="1"], :host(:not([enable-container])).ids-layout-grid-rows-lg-1,
  .ids-layout-grid:not([enable-container])[rows-lg="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="2"], :host(:not([enable-container])).ids-layout-grid-rows-lg-2,
  .ids-layout-grid:not([enable-container])[rows-lg="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="3"], :host(:not([enable-container])).ids-layout-grid-rows-lg-3,
  .ids-layout-grid:not([enable-container])[rows-lg="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="4"], :host(:not([enable-container])).ids-layout-grid-rows-lg-4,
  .ids-layout-grid:not([enable-container])[rows-lg="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="5"], :host(:not([enable-container])).ids-layout-grid-rows-lg-5,
  .ids-layout-grid:not([enable-container])[rows-lg="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="6"], :host(:not([enable-container])).ids-layout-grid-rows-lg-6,
  .ids-layout-grid:not([enable-container])[rows-lg="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="7"], :host(:not([enable-container])).ids-layout-grid-rows-lg-7,
  .ids-layout-grid:not([enable-container])[rows-lg="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="8"], :host(:not([enable-container])).ids-layout-grid-rows-lg-8,
  .ids-layout-grid:not([enable-container])[rows-lg="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="9"], :host(:not([enable-container])).ids-layout-grid-rows-lg-9,
  .ids-layout-grid:not([enable-container])[rows-lg="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="10"], :host(:not([enable-container])).ids-layout-grid-rows-lg-10,
  .ids-layout-grid:not([enable-container])[rows-lg="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="11"], :host(:not([enable-container])).ids-layout-grid-rows-lg-11,
  .ids-layout-grid:not([enable-container])[rows-lg="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="12"], :host(:not([enable-container])).ids-layout-grid-rows-lg-12,
  .ids-layout-grid:not([enable-container])[rows-lg="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="13"], :host(:not([enable-container])).ids-layout-grid-rows-lg-13,
  .ids-layout-grid:not([enable-container])[rows-lg="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="14"], :host(:not([enable-container])).ids-layout-grid-rows-lg-14,
  .ids-layout-grid:not([enable-container])[rows-lg="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="15"], :host(:not([enable-container])).ids-layout-grid-rows-lg-15,
  .ids-layout-grid:not([enable-container])[rows-lg="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="16"], :host(:not([enable-container])).ids-layout-grid-rows-lg-16,
  .ids-layout-grid:not([enable-container])[rows-lg="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="17"], :host(:not([enable-container])).ids-layout-grid-rows-lg-17,
  .ids-layout-grid:not([enable-container])[rows-lg="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="18"], :host(:not([enable-container])).ids-layout-grid-rows-lg-18,
  .ids-layout-grid:not([enable-container])[rows-lg="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="19"], :host(:not([enable-container])).ids-layout-grid-rows-lg-19,
  .ids-layout-grid:not([enable-container])[rows-lg="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="20"], :host(:not([enable-container])).ids-layout-grid-rows-lg-20,
  .ids-layout-grid:not([enable-container])[rows-lg="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="21"], :host(:not([enable-container])).ids-layout-grid-rows-lg-21,
  .ids-layout-grid:not([enable-container])[rows-lg="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="22"], :host(:not([enable-container])).ids-layout-grid-rows-lg-22,
  .ids-layout-grid:not([enable-container])[rows-lg="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="23"], :host(:not([enable-container])).ids-layout-grid-rows-lg-23,
  .ids-layout-grid:not([enable-container])[rows-lg="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="24"], :host(:not([enable-container])).ids-layout-grid-rows-lg-24,
  .ids-layout-grid:not([enable-container])[rows-lg="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="25"], :host(:not([enable-container])).ids-layout-grid-rows-lg-25,
  .ids-layout-grid:not([enable-container])[rows-lg="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="26"], :host(:not([enable-container])).ids-layout-grid-rows-lg-26,
  .ids-layout-grid:not([enable-container])[rows-lg="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="27"], :host(:not([enable-container])).ids-layout-grid-rows-lg-27,
  .ids-layout-grid:not([enable-container])[rows-lg="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="28"], :host(:not([enable-container])).ids-layout-grid-rows-lg-28,
  .ids-layout-grid:not([enable-container])[rows-lg="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="29"], :host(:not([enable-container])).ids-layout-grid-rows-lg-29,
  .ids-layout-grid:not([enable-container])[rows-lg="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="30"], :host(:not([enable-container])).ids-layout-grid-rows-lg-30,
  .ids-layout-grid:not([enable-container])[rows-lg="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="31"], :host(:not([enable-container])).ids-layout-grid-rows-lg-31,
  .ids-layout-grid:not([enable-container])[rows-lg="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="32"], :host(:not([enable-container])).ids-layout-grid-rows-lg-32,
  .ids-layout-grid:not([enable-container])[rows-lg="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="33"], :host(:not([enable-container])).ids-layout-grid-rows-lg-33,
  .ids-layout-grid:not([enable-container])[rows-lg="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="34"], :host(:not([enable-container])).ids-layout-grid-rows-lg-34,
  .ids-layout-grid:not([enable-container])[rows-lg="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="35"], :host(:not([enable-container])).ids-layout-grid-rows-lg-35,
  .ids-layout-grid:not([enable-container])[rows-lg="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="36"], :host(:not([enable-container])).ids-layout-grid-rows-lg-36,
  .ids-layout-grid:not([enable-container])[rows-lg="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="37"], :host(:not([enable-container])).ids-layout-grid-rows-lg-37,
  .ids-layout-grid:not([enable-container])[rows-lg="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="38"], :host(:not([enable-container])).ids-layout-grid-rows-lg-38,
  .ids-layout-grid:not([enable-container])[rows-lg="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="39"], :host(:not([enable-container])).ids-layout-grid-rows-lg-39,
  .ids-layout-grid:not([enable-container])[rows-lg="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="40"], :host(:not([enable-container])).ids-layout-grid-rows-lg-40,
  .ids-layout-grid:not([enable-container])[rows-lg="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="41"], :host(:not([enable-container])).ids-layout-grid-rows-lg-41,
  .ids-layout-grid:not([enable-container])[rows-lg="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="42"], :host(:not([enable-container])).ids-layout-grid-rows-lg-42,
  .ids-layout-grid:not([enable-container])[rows-lg="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="43"], :host(:not([enable-container])).ids-layout-grid-rows-lg-43,
  .ids-layout-grid:not([enable-container])[rows-lg="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="44"], :host(:not([enable-container])).ids-layout-grid-rows-lg-44,
  .ids-layout-grid:not([enable-container])[rows-lg="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="45"], :host(:not([enable-container])).ids-layout-grid-rows-lg-45,
  .ids-layout-grid:not([enable-container])[rows-lg="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="46"], :host(:not([enable-container])).ids-layout-grid-rows-lg-46,
  .ids-layout-grid:not([enable-container])[rows-lg="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="47"], :host(:not([enable-container])).ids-layout-grid-rows-lg-47,
  .ids-layout-grid:not([enable-container])[rows-lg="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="48"], :host(:not([enable-container])).ids-layout-grid-rows-lg-48,
  .ids-layout-grid:not([enable-container])[rows-lg="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="49"], :host(:not([enable-container])).ids-layout-grid-rows-lg-49,
  .ids-layout-grid:not([enable-container])[rows-lg="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-lg="50"], :host(:not([enable-container])).ids-layout-grid-rows-lg-50,
  .ids-layout-grid:not([enable-container])[rows-lg="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-lg-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-lg="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-lg-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-lg="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-lg="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-lg="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=lg]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=lg]) {
    display: block;
  }
}
@media (width >= 1183px) {
  :host(:not([enable-container])) > ::slotted([col-span-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-xl="1"], :host(:not([enable-container])).ids-layout-grid-rows-xl-1,
  .ids-layout-grid:not([enable-container])[rows-xl="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="2"], :host(:not([enable-container])).ids-layout-grid-rows-xl-2,
  .ids-layout-grid:not([enable-container])[rows-xl="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="3"], :host(:not([enable-container])).ids-layout-grid-rows-xl-3,
  .ids-layout-grid:not([enable-container])[rows-xl="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="4"], :host(:not([enable-container])).ids-layout-grid-rows-xl-4,
  .ids-layout-grid:not([enable-container])[rows-xl="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="5"], :host(:not([enable-container])).ids-layout-grid-rows-xl-5,
  .ids-layout-grid:not([enable-container])[rows-xl="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="6"], :host(:not([enable-container])).ids-layout-grid-rows-xl-6,
  .ids-layout-grid:not([enable-container])[rows-xl="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="7"], :host(:not([enable-container])).ids-layout-grid-rows-xl-7,
  .ids-layout-grid:not([enable-container])[rows-xl="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="8"], :host(:not([enable-container])).ids-layout-grid-rows-xl-8,
  .ids-layout-grid:not([enable-container])[rows-xl="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="9"], :host(:not([enable-container])).ids-layout-grid-rows-xl-9,
  .ids-layout-grid:not([enable-container])[rows-xl="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="10"], :host(:not([enable-container])).ids-layout-grid-rows-xl-10,
  .ids-layout-grid:not([enable-container])[rows-xl="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="11"], :host(:not([enable-container])).ids-layout-grid-rows-xl-11,
  .ids-layout-grid:not([enable-container])[rows-xl="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="12"], :host(:not([enable-container])).ids-layout-grid-rows-xl-12,
  .ids-layout-grid:not([enable-container])[rows-xl="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="13"], :host(:not([enable-container])).ids-layout-grid-rows-xl-13,
  .ids-layout-grid:not([enable-container])[rows-xl="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="14"], :host(:not([enable-container])).ids-layout-grid-rows-xl-14,
  .ids-layout-grid:not([enable-container])[rows-xl="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="15"], :host(:not([enable-container])).ids-layout-grid-rows-xl-15,
  .ids-layout-grid:not([enable-container])[rows-xl="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="16"], :host(:not([enable-container])).ids-layout-grid-rows-xl-16,
  .ids-layout-grid:not([enable-container])[rows-xl="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="17"], :host(:not([enable-container])).ids-layout-grid-rows-xl-17,
  .ids-layout-grid:not([enable-container])[rows-xl="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="18"], :host(:not([enable-container])).ids-layout-grid-rows-xl-18,
  .ids-layout-grid:not([enable-container])[rows-xl="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="19"], :host(:not([enable-container])).ids-layout-grid-rows-xl-19,
  .ids-layout-grid:not([enable-container])[rows-xl="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="20"], :host(:not([enable-container])).ids-layout-grid-rows-xl-20,
  .ids-layout-grid:not([enable-container])[rows-xl="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="21"], :host(:not([enable-container])).ids-layout-grid-rows-xl-21,
  .ids-layout-grid:not([enable-container])[rows-xl="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="22"], :host(:not([enable-container])).ids-layout-grid-rows-xl-22,
  .ids-layout-grid:not([enable-container])[rows-xl="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="23"], :host(:not([enable-container])).ids-layout-grid-rows-xl-23,
  .ids-layout-grid:not([enable-container])[rows-xl="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="24"], :host(:not([enable-container])).ids-layout-grid-rows-xl-24,
  .ids-layout-grid:not([enable-container])[rows-xl="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="25"], :host(:not([enable-container])).ids-layout-grid-rows-xl-25,
  .ids-layout-grid:not([enable-container])[rows-xl="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="26"], :host(:not([enable-container])).ids-layout-grid-rows-xl-26,
  .ids-layout-grid:not([enable-container])[rows-xl="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="27"], :host(:not([enable-container])).ids-layout-grid-rows-xl-27,
  .ids-layout-grid:not([enable-container])[rows-xl="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="28"], :host(:not([enable-container])).ids-layout-grid-rows-xl-28,
  .ids-layout-grid:not([enable-container])[rows-xl="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="29"], :host(:not([enable-container])).ids-layout-grid-rows-xl-29,
  .ids-layout-grid:not([enable-container])[rows-xl="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="30"], :host(:not([enable-container])).ids-layout-grid-rows-xl-30,
  .ids-layout-grid:not([enable-container])[rows-xl="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="31"], :host(:not([enable-container])).ids-layout-grid-rows-xl-31,
  .ids-layout-grid:not([enable-container])[rows-xl="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="32"], :host(:not([enable-container])).ids-layout-grid-rows-xl-32,
  .ids-layout-grid:not([enable-container])[rows-xl="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="33"], :host(:not([enable-container])).ids-layout-grid-rows-xl-33,
  .ids-layout-grid:not([enable-container])[rows-xl="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="34"], :host(:not([enable-container])).ids-layout-grid-rows-xl-34,
  .ids-layout-grid:not([enable-container])[rows-xl="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="35"], :host(:not([enable-container])).ids-layout-grid-rows-xl-35,
  .ids-layout-grid:not([enable-container])[rows-xl="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="36"], :host(:not([enable-container])).ids-layout-grid-rows-xl-36,
  .ids-layout-grid:not([enable-container])[rows-xl="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="37"], :host(:not([enable-container])).ids-layout-grid-rows-xl-37,
  .ids-layout-grid:not([enable-container])[rows-xl="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="38"], :host(:not([enable-container])).ids-layout-grid-rows-xl-38,
  .ids-layout-grid:not([enable-container])[rows-xl="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="39"], :host(:not([enable-container])).ids-layout-grid-rows-xl-39,
  .ids-layout-grid:not([enable-container])[rows-xl="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="40"], :host(:not([enable-container])).ids-layout-grid-rows-xl-40,
  .ids-layout-grid:not([enable-container])[rows-xl="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="41"], :host(:not([enable-container])).ids-layout-grid-rows-xl-41,
  .ids-layout-grid:not([enable-container])[rows-xl="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="42"], :host(:not([enable-container])).ids-layout-grid-rows-xl-42,
  .ids-layout-grid:not([enable-container])[rows-xl="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="43"], :host(:not([enable-container])).ids-layout-grid-rows-xl-43,
  .ids-layout-grid:not([enable-container])[rows-xl="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="44"], :host(:not([enable-container])).ids-layout-grid-rows-xl-44,
  .ids-layout-grid:not([enable-container])[rows-xl="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="45"], :host(:not([enable-container])).ids-layout-grid-rows-xl-45,
  .ids-layout-grid:not([enable-container])[rows-xl="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="46"], :host(:not([enable-container])).ids-layout-grid-rows-xl-46,
  .ids-layout-grid:not([enable-container])[rows-xl="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="47"], :host(:not([enable-container])).ids-layout-grid-rows-xl-47,
  .ids-layout-grid:not([enable-container])[rows-xl="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="48"], :host(:not([enable-container])).ids-layout-grid-rows-xl-48,
  .ids-layout-grid:not([enable-container])[rows-xl="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="49"], :host(:not([enable-container])).ids-layout-grid-rows-xl-49,
  .ids-layout-grid:not([enable-container])[rows-xl="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xl="50"], :host(:not([enable-container])).ids-layout-grid-rows-xl-50,
  .ids-layout-grid:not([enable-container])[rows-xl="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xl="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xl-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xl="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=xl]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=xl]) {
    display: block;
  }
}
@media (width >= 2463px) {
  :host(:not([enable-container])) > ::slotted([col-span-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-1 {
    grid-column: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-1 {
    grid-column-start: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-1 {
    grid-column-end: 1;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-2 {
    grid-column: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-2 {
    grid-column-start: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-2 {
    grid-column-end: 2;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-3 {
    grid-column: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-3 {
    grid-column-start: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-3 {
    grid-column-end: 3;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-4 {
    grid-column: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-4 {
    grid-column-start: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-4 {
    grid-column-end: 4;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-5 {
    grid-column: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-5 {
    grid-column-start: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-5 {
    grid-column-end: 5;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-6 {
    grid-column: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-6 {
    grid-column-start: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-6 {
    grid-column-end: 6;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-7 {
    grid-column: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-7 {
    grid-column-start: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-7 {
    grid-column-end: 7;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-8 {
    grid-column: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-8 {
    grid-column-start: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-8 {
    grid-column-end: 8;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-9 {
    grid-column: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-9 {
    grid-column-start: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-9 {
    grid-column-end: 9;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-10 {
    grid-column: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-10 {
    grid-column-start: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-10 {
    grid-column-end: 10;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-11 {
    grid-column: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-11 {
    grid-column-start: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-11 {
    grid-column-end: 11;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-12 {
    grid-column: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-12 {
    grid-column-start: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-12 {
    grid-column-end: 12;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-13 {
    grid-column: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-13 {
    grid-column-start: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-13 {
    grid-column-end: 13;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-14 {
    grid-column: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-14 {
    grid-column-start: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-14 {
    grid-column-end: 14;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-15 {
    grid-column: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-15 {
    grid-column-start: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-15 {
    grid-column-end: 15;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-16 {
    grid-column: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-16 {
    grid-column-start: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-16 {
    grid-column-end: 16;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-17 {
    grid-column: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-17 {
    grid-column-start: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-17 {
    grid-column-end: 17;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-18 {
    grid-column: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-18 {
    grid-column-start: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-18 {
    grid-column-end: 18;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-19 {
    grid-column: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-19 {
    grid-column-start: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-19 {
    grid-column-end: 19;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-20 {
    grid-column: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-20 {
    grid-column-start: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-20 {
    grid-column-end: 20;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-21 {
    grid-column: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-21 {
    grid-column-start: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-21 {
    grid-column-end: 21;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-22 {
    grid-column: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-22 {
    grid-column-start: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-22 {
    grid-column-end: 22;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-23 {
    grid-column: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-23 {
    grid-column-start: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-23 {
    grid-column-end: 23;
  }
  :host(:not([enable-container])) > ::slotted([col-span-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-span-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-span-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-24 {
    grid-column: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([col-start-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-start-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-start-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-24 {
    grid-column-start: 24;
  }
  :host(:not([enable-container])) > ::slotted([col-end-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-col-end-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([col-end-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-24 {
    grid-column-end: 24;
  }
  :host(:not([enable-container]))[rows-xxl="1"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-1,
  .ids-layout-grid:not([enable-container])[rows-xxl="1"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-1 {
    grid-row: span 1/span 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-1 {
    order: 1;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="2"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-2,
  .ids-layout-grid:not([enable-container])[rows-xxl="2"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-2 {
    grid-row: span 2/span 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="2"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-2,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="2"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-2 {
    order: 2;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="3"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-3,
  .ids-layout-grid:not([enable-container])[rows-xxl="3"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-3 {
    grid-row: span 3/span 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="3"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-3,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="3"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-3 {
    order: 3;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="4"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-4,
  .ids-layout-grid:not([enable-container])[rows-xxl="4"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-4 {
    grid-row: span 4/span 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="4"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-4,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="4"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-4 {
    order: 4;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="5"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-5,
  .ids-layout-grid:not([enable-container])[rows-xxl="5"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-5 {
    grid-row: span 5/span 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="5"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-5,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="5"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-5 {
    order: 5;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="6"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-6,
  .ids-layout-grid:not([enable-container])[rows-xxl="6"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-6 {
    grid-row: span 6/span 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="6"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-6,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="6"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-6 {
    order: 6;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="7"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-7,
  .ids-layout-grid:not([enable-container])[rows-xxl="7"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-7 {
    grid-row: span 7/span 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="7"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-7,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="7"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-7 {
    order: 7;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="8"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-8,
  .ids-layout-grid:not([enable-container])[rows-xxl="8"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-8 {
    grid-row: span 8/span 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="8"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-8,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="8"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-8 {
    order: 8;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="9"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-9,
  .ids-layout-grid:not([enable-container])[rows-xxl="9"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-9 {
    grid-row: span 9/span 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="9"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-9,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="9"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-9 {
    order: 9;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="10"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-10,
  .ids-layout-grid:not([enable-container])[rows-xxl="10"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-10 {
    grid-row: span 10/span 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="10"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-10,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="10"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-10 {
    order: 10;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="11"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-11,
  .ids-layout-grid:not([enable-container])[rows-xxl="11"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-11 {
    grid-row: span 11/span 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="11"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-11,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="11"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-11 {
    order: 11;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="12"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-12,
  .ids-layout-grid:not([enable-container])[rows-xxl="12"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-12 {
    grid-row: span 12/span 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="12"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-12,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="12"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-12 {
    order: 12;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="13"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-13,
  .ids-layout-grid:not([enable-container])[rows-xxl="13"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-13 {
    grid-row: span 13/span 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="13"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-13,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="13"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-13 {
    order: 13;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="14"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-14,
  .ids-layout-grid:not([enable-container])[rows-xxl="14"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-14 {
    grid-row: span 14/span 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="14"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-14,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="14"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-14 {
    order: 14;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="15"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-15,
  .ids-layout-grid:not([enable-container])[rows-xxl="15"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-15 {
    grid-row: span 15/span 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="15"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-15,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="15"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-15 {
    order: 15;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="16"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-16,
  .ids-layout-grid:not([enable-container])[rows-xxl="16"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-16 {
    grid-row: span 16/span 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="16"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-16,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="16"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-16 {
    order: 16;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="17"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-17,
  .ids-layout-grid:not([enable-container])[rows-xxl="17"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-17 {
    grid-row: span 17/span 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="17"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-17,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="17"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-17 {
    order: 17;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="18"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-18,
  .ids-layout-grid:not([enable-container])[rows-xxl="18"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-18 {
    grid-row: span 18/span 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="18"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-18,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="18"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-18 {
    order: 18;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="19"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-19,
  .ids-layout-grid:not([enable-container])[rows-xxl="19"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-19 {
    grid-row: span 19/span 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="19"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-19,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="19"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-19 {
    order: 19;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="20"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-20,
  .ids-layout-grid:not([enable-container])[rows-xxl="20"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-20 {
    grid-row: span 20/span 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="20"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-20,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="20"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-20 {
    order: 20;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="21"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-21,
  .ids-layout-grid:not([enable-container])[rows-xxl="21"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-21 {
    grid-row: span 21/span 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="21"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-21,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="21"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-21 {
    order: 21;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="22"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-22,
  .ids-layout-grid:not([enable-container])[rows-xxl="22"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-22 {
    grid-row: span 22/span 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="22"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-22,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="22"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-22 {
    order: 22;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="23"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-23,
  .ids-layout-grid:not([enable-container])[rows-xxl="23"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-23 {
    grid-row: span 23/span 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="23"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-23,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="23"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-23 {
    order: 23;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="24"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-24,
  .ids-layout-grid:not([enable-container])[rows-xxl="24"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-24 {
    grid-row: span 24/span 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="24"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-24,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="24"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-24 {
    order: 24;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="25"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-25,
  .ids-layout-grid:not([enable-container])[rows-xxl="25"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-25 {
    grid-row: span 25/span 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="25"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-25,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="25"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-25 {
    order: 25;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="26"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-26,
  .ids-layout-grid:not([enable-container])[rows-xxl="26"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-26 {
    grid-row: span 26/span 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="26"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-26,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="26"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-26 {
    order: 26;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="27"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-27,
  .ids-layout-grid:not([enable-container])[rows-xxl="27"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-27 {
    grid-row: span 27/span 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="27"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-27,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="27"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-27 {
    order: 27;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="28"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-28,
  .ids-layout-grid:not([enable-container])[rows-xxl="28"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-28 {
    grid-row: span 28/span 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="28"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-28,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="28"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-28 {
    order: 28;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="29"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-29,
  .ids-layout-grid:not([enable-container])[rows-xxl="29"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-29 {
    grid-row: span 29/span 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="29"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-29,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="29"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-29 {
    order: 29;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="30"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-30,
  .ids-layout-grid:not([enable-container])[rows-xxl="30"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-30 {
    grid-row: span 30/span 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="30"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-30,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="30"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-30 {
    order: 30;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="31"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-31,
  .ids-layout-grid:not([enable-container])[rows-xxl="31"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-31 {
    grid-row: span 31/span 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="31"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-31,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="31"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-31 {
    order: 31;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="32"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-32,
  .ids-layout-grid:not([enable-container])[rows-xxl="32"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-32 {
    grid-row: span 32/span 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="32"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-32,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="32"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-32 {
    order: 32;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="33"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-33,
  .ids-layout-grid:not([enable-container])[rows-xxl="33"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-33 {
    grid-row: span 33/span 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="33"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-33,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="33"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-33 {
    order: 33;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="34"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-34,
  .ids-layout-grid:not([enable-container])[rows-xxl="34"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-34 {
    grid-row: span 34/span 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="34"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-34,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="34"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-34 {
    order: 34;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="35"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-35,
  .ids-layout-grid:not([enable-container])[rows-xxl="35"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-35 {
    grid-row: span 35/span 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="35"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-35,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="35"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-35 {
    order: 35;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="36"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-36,
  .ids-layout-grid:not([enable-container])[rows-xxl="36"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-36 {
    grid-row: span 36/span 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="36"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-36,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="36"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-36 {
    order: 36;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="37"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-37,
  .ids-layout-grid:not([enable-container])[rows-xxl="37"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-37 {
    grid-row: span 37/span 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="37"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-37,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="37"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-37 {
    order: 37;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="38"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-38,
  .ids-layout-grid:not([enable-container])[rows-xxl="38"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-38 {
    grid-row: span 38/span 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="38"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-38,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="38"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-38 {
    order: 38;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="39"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-39,
  .ids-layout-grid:not([enable-container])[rows-xxl="39"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-39 {
    grid-row: span 39/span 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="39"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-39,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="39"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-39 {
    order: 39;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="40"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-40,
  .ids-layout-grid:not([enable-container])[rows-xxl="40"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-40 {
    grid-row: span 40/span 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="40"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-40,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="40"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-40 {
    order: 40;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="41"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-41,
  .ids-layout-grid:not([enable-container])[rows-xxl="41"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-41 {
    grid-row: span 41/span 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="41"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-41,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="41"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-41 {
    order: 41;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="42"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-42,
  .ids-layout-grid:not([enable-container])[rows-xxl="42"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-42 {
    grid-row: span 42/span 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="42"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-42,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="42"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-42 {
    order: 42;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="43"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-43,
  .ids-layout-grid:not([enable-container])[rows-xxl="43"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-43 {
    grid-row: span 43/span 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="43"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-43,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="43"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-43 {
    order: 43;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="44"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-44,
  .ids-layout-grid:not([enable-container])[rows-xxl="44"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-44 {
    grid-row: span 44/span 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="44"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-44,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="44"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-44 {
    order: 44;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="45"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-45,
  .ids-layout-grid:not([enable-container])[rows-xxl="45"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-45 {
    grid-row: span 45/span 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="45"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-45,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="45"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-45 {
    order: 45;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="46"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-46,
  .ids-layout-grid:not([enable-container])[rows-xxl="46"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-46 {
    grid-row: span 46/span 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="46"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-46,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="46"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-46 {
    order: 46;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="47"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-47,
  .ids-layout-grid:not([enable-container])[rows-xxl="47"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-47 {
    grid-row: span 47/span 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="47"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-47,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="47"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-47 {
    order: 47;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="48"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-48,
  .ids-layout-grid:not([enable-container])[rows-xxl="48"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-48 {
    grid-row: span 48/span 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="48"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-48,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="48"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-48 {
    order: 48;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="49"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-49,
  .ids-layout-grid:not([enable-container])[rows-xxl="49"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-49 {
    grid-row: span 49/span 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="49"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-49,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="49"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-49 {
    order: 49;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container]))[rows-xxl="50"], :host(:not([enable-container])).ids-layout-grid-rows-xxl-50,
  .ids-layout-grid:not([enable-container])[rows-xxl="50"],
  .ids-layout-grid:not([enable-container]).ids-layout-grid-rows-xxl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host(:not([enable-container])) > ::slotted([row-span-xxl="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-row-span-xxl-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([row-span-xxl="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-50 {
    grid-row: span 50/span 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="50"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl-50,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="50"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-50 {
    order: 50;
  }
  :host(:not([enable-container])) > ::slotted([order-xxl="-1"]), :host(:not([enable-container])).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid:not([enable-container]) > ::slotted([order-xxl="-1"]),
  .ids-layout-grid:not([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host(:not([enable-container])) > ::slotted([hide=xxl]),
  .ids-layout-grid:not([enable-container]) > ::slotted([hide=xxl]) {
    display: block;
  }
}

/* Use container queries if enabled */
:host([enable-container]),
.ids-layout-grid[enable-container] {
  container-type: inline-size;
}
@container (width >= 320px) {
  :host([enable-container]) > ::slotted([col-span-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xs-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xs-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xs-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-xs="1"], :host([enable-container]).ids-layout-grid-rows-xs-1,
  .ids-layout-grid[enable-container][rows-xs="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-xs="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="2"], :host([enable-container]).ids-layout-grid-rows-xs-2,
  .ids-layout-grid[enable-container][rows-xs="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-xs="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-2,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="3"], :host([enable-container]).ids-layout-grid-rows-xs-3,
  .ids-layout-grid[enable-container][rows-xs="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-xs="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-3,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="4"], :host([enable-container]).ids-layout-grid-rows-xs-4,
  .ids-layout-grid[enable-container][rows-xs="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-xs="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-4,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="5"], :host([enable-container]).ids-layout-grid-rows-xs-5,
  .ids-layout-grid[enable-container][rows-xs="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-xs="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-5,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="6"], :host([enable-container]).ids-layout-grid-rows-xs-6,
  .ids-layout-grid[enable-container][rows-xs="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-xs="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-6,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="7"], :host([enable-container]).ids-layout-grid-rows-xs-7,
  .ids-layout-grid[enable-container][rows-xs="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-xs="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-7,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="8"], :host([enable-container]).ids-layout-grid-rows-xs-8,
  .ids-layout-grid[enable-container][rows-xs="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-xs="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-8,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="9"], :host([enable-container]).ids-layout-grid-rows-xs-9,
  .ids-layout-grid[enable-container][rows-xs="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-xs="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-9,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="10"], :host([enable-container]).ids-layout-grid-rows-xs-10,
  .ids-layout-grid[enable-container][rows-xs="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-xs="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-10,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="11"], :host([enable-container]).ids-layout-grid-rows-xs-11,
  .ids-layout-grid[enable-container][rows-xs="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-xs="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-11,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="12"], :host([enable-container]).ids-layout-grid-rows-xs-12,
  .ids-layout-grid[enable-container][rows-xs="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-xs="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-12,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="13"], :host([enable-container]).ids-layout-grid-rows-xs-13,
  .ids-layout-grid[enable-container][rows-xs="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-xs="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-13,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="14"], :host([enable-container]).ids-layout-grid-rows-xs-14,
  .ids-layout-grid[enable-container][rows-xs="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-xs="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-14,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="15"], :host([enable-container]).ids-layout-grid-rows-xs-15,
  .ids-layout-grid[enable-container][rows-xs="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-xs="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-15,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="16"], :host([enable-container]).ids-layout-grid-rows-xs-16,
  .ids-layout-grid[enable-container][rows-xs="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-xs="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-16,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="17"], :host([enable-container]).ids-layout-grid-rows-xs-17,
  .ids-layout-grid[enable-container][rows-xs="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-xs="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-17,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="18"], :host([enable-container]).ids-layout-grid-rows-xs-18,
  .ids-layout-grid[enable-container][rows-xs="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-xs="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-18,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="19"], :host([enable-container]).ids-layout-grid-rows-xs-19,
  .ids-layout-grid[enable-container][rows-xs="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-xs="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-19,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="20"], :host([enable-container]).ids-layout-grid-rows-xs-20,
  .ids-layout-grid[enable-container][rows-xs="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-xs="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-20,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="21"], :host([enable-container]).ids-layout-grid-rows-xs-21,
  .ids-layout-grid[enable-container][rows-xs="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-xs="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-21,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="22"], :host([enable-container]).ids-layout-grid-rows-xs-22,
  .ids-layout-grid[enable-container][rows-xs="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-xs="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-22,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="23"], :host([enable-container]).ids-layout-grid-rows-xs-23,
  .ids-layout-grid[enable-container][rows-xs="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-xs="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-23,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="24"], :host([enable-container]).ids-layout-grid-rows-xs-24,
  .ids-layout-grid[enable-container][rows-xs="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-xs="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-24,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="25"], :host([enable-container]).ids-layout-grid-rows-xs-25,
  .ids-layout-grid[enable-container][rows-xs="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-xs="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-25,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="26"], :host([enable-container]).ids-layout-grid-rows-xs-26,
  .ids-layout-grid[enable-container][rows-xs="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-xs="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-26,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="27"], :host([enable-container]).ids-layout-grid-rows-xs-27,
  .ids-layout-grid[enable-container][rows-xs="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-xs="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-27,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="28"], :host([enable-container]).ids-layout-grid-rows-xs-28,
  .ids-layout-grid[enable-container][rows-xs="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-xs="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-28,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="29"], :host([enable-container]).ids-layout-grid-rows-xs-29,
  .ids-layout-grid[enable-container][rows-xs="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-xs="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-29,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="30"], :host([enable-container]).ids-layout-grid-rows-xs-30,
  .ids-layout-grid[enable-container][rows-xs="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-xs="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-30,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="31"], :host([enable-container]).ids-layout-grid-rows-xs-31,
  .ids-layout-grid[enable-container][rows-xs="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-xs="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-31,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="32"], :host([enable-container]).ids-layout-grid-rows-xs-32,
  .ids-layout-grid[enable-container][rows-xs="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-xs="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-32,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="33"], :host([enable-container]).ids-layout-grid-rows-xs-33,
  .ids-layout-grid[enable-container][rows-xs="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-xs="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-33,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="34"], :host([enable-container]).ids-layout-grid-rows-xs-34,
  .ids-layout-grid[enable-container][rows-xs="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-xs="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-34,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="35"], :host([enable-container]).ids-layout-grid-rows-xs-35,
  .ids-layout-grid[enable-container][rows-xs="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-xs="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-35,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="36"], :host([enable-container]).ids-layout-grid-rows-xs-36,
  .ids-layout-grid[enable-container][rows-xs="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-xs="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-36,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="37"], :host([enable-container]).ids-layout-grid-rows-xs-37,
  .ids-layout-grid[enable-container][rows-xs="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-xs="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-37,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="38"], :host([enable-container]).ids-layout-grid-rows-xs-38,
  .ids-layout-grid[enable-container][rows-xs="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-xs="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-38,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="39"], :host([enable-container]).ids-layout-grid-rows-xs-39,
  .ids-layout-grid[enable-container][rows-xs="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-xs="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-39,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="40"], :host([enable-container]).ids-layout-grid-rows-xs-40,
  .ids-layout-grid[enable-container][rows-xs="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-xs="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-40,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="41"], :host([enable-container]).ids-layout-grid-rows-xs-41,
  .ids-layout-grid[enable-container][rows-xs="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-xs="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-41,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="42"], :host([enable-container]).ids-layout-grid-rows-xs-42,
  .ids-layout-grid[enable-container][rows-xs="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-xs="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-42,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="43"], :host([enable-container]).ids-layout-grid-rows-xs-43,
  .ids-layout-grid[enable-container][rows-xs="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-xs="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-43,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="44"], :host([enable-container]).ids-layout-grid-rows-xs-44,
  .ids-layout-grid[enable-container][rows-xs="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-xs="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-44,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="45"], :host([enable-container]).ids-layout-grid-rows-xs-45,
  .ids-layout-grid[enable-container][rows-xs="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-xs="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-45,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="46"], :host([enable-container]).ids-layout-grid-rows-xs-46,
  .ids-layout-grid[enable-container][rows-xs="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-xs="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-46,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="47"], :host([enable-container]).ids-layout-grid-rows-xs-47,
  .ids-layout-grid[enable-container][rows-xs="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-xs="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-47,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="48"], :host([enable-container]).ids-layout-grid-rows-xs-48,
  .ids-layout-grid[enable-container][rows-xs="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-xs="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-48,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="49"], :host([enable-container]).ids-layout-grid-rows-xs-49,
  .ids-layout-grid[enable-container][rows-xs="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-xs="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-49,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container])[rows-xs="50"], :host([enable-container]).ids-layout-grid-rows-xs-50,
  .ids-layout-grid[enable-container][rows-xs="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xs-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xs="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xs-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xs="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xs-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-xs="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs-50,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-xs="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xs--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xs="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xs--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=xs]),
  .ids-layout-grid[enable-container] > ::slotted([hide=xs]) {
    display: block;
  }
}
@container (width >= 767px) {
  :host([enable-container]) > ::slotted([col-span-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-sm-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-sm-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-sm-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-sm="1"], :host([enable-container]).ids-layout-grid-rows-sm-1,
  .ids-layout-grid[enable-container][rows-sm="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-sm="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="2"], :host([enable-container]).ids-layout-grid-rows-sm-2,
  .ids-layout-grid[enable-container][rows-sm="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-sm="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-2,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="3"], :host([enable-container]).ids-layout-grid-rows-sm-3,
  .ids-layout-grid[enable-container][rows-sm="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-sm="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-3,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="4"], :host([enable-container]).ids-layout-grid-rows-sm-4,
  .ids-layout-grid[enable-container][rows-sm="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-sm="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-4,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="5"], :host([enable-container]).ids-layout-grid-rows-sm-5,
  .ids-layout-grid[enable-container][rows-sm="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-sm="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-5,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="6"], :host([enable-container]).ids-layout-grid-rows-sm-6,
  .ids-layout-grid[enable-container][rows-sm="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-sm="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-6,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="7"], :host([enable-container]).ids-layout-grid-rows-sm-7,
  .ids-layout-grid[enable-container][rows-sm="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-sm="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-7,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="8"], :host([enable-container]).ids-layout-grid-rows-sm-8,
  .ids-layout-grid[enable-container][rows-sm="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-sm="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-8,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="9"], :host([enable-container]).ids-layout-grid-rows-sm-9,
  .ids-layout-grid[enable-container][rows-sm="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-sm="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-9,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="10"], :host([enable-container]).ids-layout-grid-rows-sm-10,
  .ids-layout-grid[enable-container][rows-sm="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-sm="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-10,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="11"], :host([enable-container]).ids-layout-grid-rows-sm-11,
  .ids-layout-grid[enable-container][rows-sm="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-sm="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-11,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="12"], :host([enable-container]).ids-layout-grid-rows-sm-12,
  .ids-layout-grid[enable-container][rows-sm="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-sm="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-12,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="13"], :host([enable-container]).ids-layout-grid-rows-sm-13,
  .ids-layout-grid[enable-container][rows-sm="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-sm="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-13,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="14"], :host([enable-container]).ids-layout-grid-rows-sm-14,
  .ids-layout-grid[enable-container][rows-sm="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-sm="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-14,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="15"], :host([enable-container]).ids-layout-grid-rows-sm-15,
  .ids-layout-grid[enable-container][rows-sm="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-sm="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-15,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="16"], :host([enable-container]).ids-layout-grid-rows-sm-16,
  .ids-layout-grid[enable-container][rows-sm="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-sm="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-16,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="17"], :host([enable-container]).ids-layout-grid-rows-sm-17,
  .ids-layout-grid[enable-container][rows-sm="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-sm="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-17,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="18"], :host([enable-container]).ids-layout-grid-rows-sm-18,
  .ids-layout-grid[enable-container][rows-sm="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-sm="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-18,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="19"], :host([enable-container]).ids-layout-grid-rows-sm-19,
  .ids-layout-grid[enable-container][rows-sm="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-sm="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-19,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="20"], :host([enable-container]).ids-layout-grid-rows-sm-20,
  .ids-layout-grid[enable-container][rows-sm="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-sm="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-20,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="21"], :host([enable-container]).ids-layout-grid-rows-sm-21,
  .ids-layout-grid[enable-container][rows-sm="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-sm="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-21,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="22"], :host([enable-container]).ids-layout-grid-rows-sm-22,
  .ids-layout-grid[enable-container][rows-sm="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-sm="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-22,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="23"], :host([enable-container]).ids-layout-grid-rows-sm-23,
  .ids-layout-grid[enable-container][rows-sm="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-sm="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-23,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="24"], :host([enable-container]).ids-layout-grid-rows-sm-24,
  .ids-layout-grid[enable-container][rows-sm="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-sm="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-24,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="25"], :host([enable-container]).ids-layout-grid-rows-sm-25,
  .ids-layout-grid[enable-container][rows-sm="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-sm="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-25,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="26"], :host([enable-container]).ids-layout-grid-rows-sm-26,
  .ids-layout-grid[enable-container][rows-sm="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-sm="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-26,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="27"], :host([enable-container]).ids-layout-grid-rows-sm-27,
  .ids-layout-grid[enable-container][rows-sm="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-sm="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-27,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="28"], :host([enable-container]).ids-layout-grid-rows-sm-28,
  .ids-layout-grid[enable-container][rows-sm="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-sm="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-28,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="29"], :host([enable-container]).ids-layout-grid-rows-sm-29,
  .ids-layout-grid[enable-container][rows-sm="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-sm="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-29,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="30"], :host([enable-container]).ids-layout-grid-rows-sm-30,
  .ids-layout-grid[enable-container][rows-sm="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-sm="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-30,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="31"], :host([enable-container]).ids-layout-grid-rows-sm-31,
  .ids-layout-grid[enable-container][rows-sm="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-sm="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-31,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="32"], :host([enable-container]).ids-layout-grid-rows-sm-32,
  .ids-layout-grid[enable-container][rows-sm="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-sm="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-32,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="33"], :host([enable-container]).ids-layout-grid-rows-sm-33,
  .ids-layout-grid[enable-container][rows-sm="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-sm="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-33,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="34"], :host([enable-container]).ids-layout-grid-rows-sm-34,
  .ids-layout-grid[enable-container][rows-sm="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-sm="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-34,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="35"], :host([enable-container]).ids-layout-grid-rows-sm-35,
  .ids-layout-grid[enable-container][rows-sm="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-sm="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-35,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="36"], :host([enable-container]).ids-layout-grid-rows-sm-36,
  .ids-layout-grid[enable-container][rows-sm="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-sm="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-36,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="37"], :host([enable-container]).ids-layout-grid-rows-sm-37,
  .ids-layout-grid[enable-container][rows-sm="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-sm="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-37,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="38"], :host([enable-container]).ids-layout-grid-rows-sm-38,
  .ids-layout-grid[enable-container][rows-sm="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-sm="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-38,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="39"], :host([enable-container]).ids-layout-grid-rows-sm-39,
  .ids-layout-grid[enable-container][rows-sm="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-sm="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-39,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="40"], :host([enable-container]).ids-layout-grid-rows-sm-40,
  .ids-layout-grid[enable-container][rows-sm="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-sm="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-40,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="41"], :host([enable-container]).ids-layout-grid-rows-sm-41,
  .ids-layout-grid[enable-container][rows-sm="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-sm="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-41,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="42"], :host([enable-container]).ids-layout-grid-rows-sm-42,
  .ids-layout-grid[enable-container][rows-sm="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-sm="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-42,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="43"], :host([enable-container]).ids-layout-grid-rows-sm-43,
  .ids-layout-grid[enable-container][rows-sm="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-sm="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-43,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="44"], :host([enable-container]).ids-layout-grid-rows-sm-44,
  .ids-layout-grid[enable-container][rows-sm="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-sm="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-44,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="45"], :host([enable-container]).ids-layout-grid-rows-sm-45,
  .ids-layout-grid[enable-container][rows-sm="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-sm="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-45,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="46"], :host([enable-container]).ids-layout-grid-rows-sm-46,
  .ids-layout-grid[enable-container][rows-sm="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-sm="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-46,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="47"], :host([enable-container]).ids-layout-grid-rows-sm-47,
  .ids-layout-grid[enable-container][rows-sm="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-sm="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-47,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="48"], :host([enable-container]).ids-layout-grid-rows-sm-48,
  .ids-layout-grid[enable-container][rows-sm="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-sm="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-48,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="49"], :host([enable-container]).ids-layout-grid-rows-sm-49,
  .ids-layout-grid[enable-container][rows-sm="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-sm="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-49,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container])[rows-sm="50"], :host([enable-container]).ids-layout-grid-rows-sm-50,
  .ids-layout-grid[enable-container][rows-sm="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-sm-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-sm="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-sm-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-sm="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-sm-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-sm="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm-50,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-sm="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-sm--1,
  .ids-layout-grid[enable-container] > ::slotted([order-sm="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-sm--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=sm]),
  .ids-layout-grid[enable-container] > ::slotted([hide=sm]) {
    display: block;
  }
}
@container (width >= 927px) {
  :host([enable-container]) > ::slotted([col-span-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-md-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-md-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-md-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-md-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-md-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-md-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-md="1"], :host([enable-container]).ids-layout-grid-rows-md-1,
  .ids-layout-grid[enable-container][rows-md="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-md="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="2"], :host([enable-container]).ids-layout-grid-rows-md-2,
  .ids-layout-grid[enable-container][rows-md="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-md="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-2,
  .ids-layout-grid[enable-container] > ::slotted([order-md="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="3"], :host([enable-container]).ids-layout-grid-rows-md-3,
  .ids-layout-grid[enable-container][rows-md="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-md="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-3,
  .ids-layout-grid[enable-container] > ::slotted([order-md="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="4"], :host([enable-container]).ids-layout-grid-rows-md-4,
  .ids-layout-grid[enable-container][rows-md="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-md="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-4,
  .ids-layout-grid[enable-container] > ::slotted([order-md="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="5"], :host([enable-container]).ids-layout-grid-rows-md-5,
  .ids-layout-grid[enable-container][rows-md="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-md="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-5,
  .ids-layout-grid[enable-container] > ::slotted([order-md="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="6"], :host([enable-container]).ids-layout-grid-rows-md-6,
  .ids-layout-grid[enable-container][rows-md="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-md="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-6,
  .ids-layout-grid[enable-container] > ::slotted([order-md="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="7"], :host([enable-container]).ids-layout-grid-rows-md-7,
  .ids-layout-grid[enable-container][rows-md="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-md="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-7,
  .ids-layout-grid[enable-container] > ::slotted([order-md="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="8"], :host([enable-container]).ids-layout-grid-rows-md-8,
  .ids-layout-grid[enable-container][rows-md="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-md="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-8,
  .ids-layout-grid[enable-container] > ::slotted([order-md="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="9"], :host([enable-container]).ids-layout-grid-rows-md-9,
  .ids-layout-grid[enable-container][rows-md="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-md="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-9,
  .ids-layout-grid[enable-container] > ::slotted([order-md="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="10"], :host([enable-container]).ids-layout-grid-rows-md-10,
  .ids-layout-grid[enable-container][rows-md="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-md="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-10,
  .ids-layout-grid[enable-container] > ::slotted([order-md="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="11"], :host([enable-container]).ids-layout-grid-rows-md-11,
  .ids-layout-grid[enable-container][rows-md="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-md="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-11,
  .ids-layout-grid[enable-container] > ::slotted([order-md="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="12"], :host([enable-container]).ids-layout-grid-rows-md-12,
  .ids-layout-grid[enable-container][rows-md="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-md="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-12,
  .ids-layout-grid[enable-container] > ::slotted([order-md="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="13"], :host([enable-container]).ids-layout-grid-rows-md-13,
  .ids-layout-grid[enable-container][rows-md="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-md="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-13,
  .ids-layout-grid[enable-container] > ::slotted([order-md="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="14"], :host([enable-container]).ids-layout-grid-rows-md-14,
  .ids-layout-grid[enable-container][rows-md="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-md="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-14,
  .ids-layout-grid[enable-container] > ::slotted([order-md="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="15"], :host([enable-container]).ids-layout-grid-rows-md-15,
  .ids-layout-grid[enable-container][rows-md="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-md="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-15,
  .ids-layout-grid[enable-container] > ::slotted([order-md="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="16"], :host([enable-container]).ids-layout-grid-rows-md-16,
  .ids-layout-grid[enable-container][rows-md="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-md="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-16,
  .ids-layout-grid[enable-container] > ::slotted([order-md="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="17"], :host([enable-container]).ids-layout-grid-rows-md-17,
  .ids-layout-grid[enable-container][rows-md="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-md="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-17,
  .ids-layout-grid[enable-container] > ::slotted([order-md="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="18"], :host([enable-container]).ids-layout-grid-rows-md-18,
  .ids-layout-grid[enable-container][rows-md="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-md="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-18,
  .ids-layout-grid[enable-container] > ::slotted([order-md="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="19"], :host([enable-container]).ids-layout-grid-rows-md-19,
  .ids-layout-grid[enable-container][rows-md="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-md="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-19,
  .ids-layout-grid[enable-container] > ::slotted([order-md="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="20"], :host([enable-container]).ids-layout-grid-rows-md-20,
  .ids-layout-grid[enable-container][rows-md="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-md="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-20,
  .ids-layout-grid[enable-container] > ::slotted([order-md="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="21"], :host([enable-container]).ids-layout-grid-rows-md-21,
  .ids-layout-grid[enable-container][rows-md="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-md="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-21,
  .ids-layout-grid[enable-container] > ::slotted([order-md="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="22"], :host([enable-container]).ids-layout-grid-rows-md-22,
  .ids-layout-grid[enable-container][rows-md="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-md="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-22,
  .ids-layout-grid[enable-container] > ::slotted([order-md="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="23"], :host([enable-container]).ids-layout-grid-rows-md-23,
  .ids-layout-grid[enable-container][rows-md="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-md="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-23,
  .ids-layout-grid[enable-container] > ::slotted([order-md="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="24"], :host([enable-container]).ids-layout-grid-rows-md-24,
  .ids-layout-grid[enable-container][rows-md="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-md="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-24,
  .ids-layout-grid[enable-container] > ::slotted([order-md="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="25"], :host([enable-container]).ids-layout-grid-rows-md-25,
  .ids-layout-grid[enable-container][rows-md="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-md="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-25,
  .ids-layout-grid[enable-container] > ::slotted([order-md="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="26"], :host([enable-container]).ids-layout-grid-rows-md-26,
  .ids-layout-grid[enable-container][rows-md="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-md="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-26,
  .ids-layout-grid[enable-container] > ::slotted([order-md="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="27"], :host([enable-container]).ids-layout-grid-rows-md-27,
  .ids-layout-grid[enable-container][rows-md="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-md="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-27,
  .ids-layout-grid[enable-container] > ::slotted([order-md="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="28"], :host([enable-container]).ids-layout-grid-rows-md-28,
  .ids-layout-grid[enable-container][rows-md="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-md="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-28,
  .ids-layout-grid[enable-container] > ::slotted([order-md="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="29"], :host([enable-container]).ids-layout-grid-rows-md-29,
  .ids-layout-grid[enable-container][rows-md="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-md="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-29,
  .ids-layout-grid[enable-container] > ::slotted([order-md="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="30"], :host([enable-container]).ids-layout-grid-rows-md-30,
  .ids-layout-grid[enable-container][rows-md="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-md="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-30,
  .ids-layout-grid[enable-container] > ::slotted([order-md="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="31"], :host([enable-container]).ids-layout-grid-rows-md-31,
  .ids-layout-grid[enable-container][rows-md="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-md="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-31,
  .ids-layout-grid[enable-container] > ::slotted([order-md="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="32"], :host([enable-container]).ids-layout-grid-rows-md-32,
  .ids-layout-grid[enable-container][rows-md="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-md="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-32,
  .ids-layout-grid[enable-container] > ::slotted([order-md="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="33"], :host([enable-container]).ids-layout-grid-rows-md-33,
  .ids-layout-grid[enable-container][rows-md="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-md="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-33,
  .ids-layout-grid[enable-container] > ::slotted([order-md="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="34"], :host([enable-container]).ids-layout-grid-rows-md-34,
  .ids-layout-grid[enable-container][rows-md="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-md="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-34,
  .ids-layout-grid[enable-container] > ::slotted([order-md="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="35"], :host([enable-container]).ids-layout-grid-rows-md-35,
  .ids-layout-grid[enable-container][rows-md="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-md="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-35,
  .ids-layout-grid[enable-container] > ::slotted([order-md="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="36"], :host([enable-container]).ids-layout-grid-rows-md-36,
  .ids-layout-grid[enable-container][rows-md="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-md="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-36,
  .ids-layout-grid[enable-container] > ::slotted([order-md="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="37"], :host([enable-container]).ids-layout-grid-rows-md-37,
  .ids-layout-grid[enable-container][rows-md="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-md="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-37,
  .ids-layout-grid[enable-container] > ::slotted([order-md="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="38"], :host([enable-container]).ids-layout-grid-rows-md-38,
  .ids-layout-grid[enable-container][rows-md="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-md="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-38,
  .ids-layout-grid[enable-container] > ::slotted([order-md="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="39"], :host([enable-container]).ids-layout-grid-rows-md-39,
  .ids-layout-grid[enable-container][rows-md="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-md="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-39,
  .ids-layout-grid[enable-container] > ::slotted([order-md="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="40"], :host([enable-container]).ids-layout-grid-rows-md-40,
  .ids-layout-grid[enable-container][rows-md="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-md="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-40,
  .ids-layout-grid[enable-container] > ::slotted([order-md="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="41"], :host([enable-container]).ids-layout-grid-rows-md-41,
  .ids-layout-grid[enable-container][rows-md="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-md="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-41,
  .ids-layout-grid[enable-container] > ::slotted([order-md="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="42"], :host([enable-container]).ids-layout-grid-rows-md-42,
  .ids-layout-grid[enable-container][rows-md="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-md="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-42,
  .ids-layout-grid[enable-container] > ::slotted([order-md="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="43"], :host([enable-container]).ids-layout-grid-rows-md-43,
  .ids-layout-grid[enable-container][rows-md="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-md="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-43,
  .ids-layout-grid[enable-container] > ::slotted([order-md="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="44"], :host([enable-container]).ids-layout-grid-rows-md-44,
  .ids-layout-grid[enable-container][rows-md="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-md="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-44,
  .ids-layout-grid[enable-container] > ::slotted([order-md="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="45"], :host([enable-container]).ids-layout-grid-rows-md-45,
  .ids-layout-grid[enable-container][rows-md="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-md="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-45,
  .ids-layout-grid[enable-container] > ::slotted([order-md="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="46"], :host([enable-container]).ids-layout-grid-rows-md-46,
  .ids-layout-grid[enable-container][rows-md="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-md="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-46,
  .ids-layout-grid[enable-container] > ::slotted([order-md="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="47"], :host([enable-container]).ids-layout-grid-rows-md-47,
  .ids-layout-grid[enable-container][rows-md="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-md="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-47,
  .ids-layout-grid[enable-container] > ::slotted([order-md="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="48"], :host([enable-container]).ids-layout-grid-rows-md-48,
  .ids-layout-grid[enable-container][rows-md="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-md="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-48,
  .ids-layout-grid[enable-container] > ::slotted([order-md="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="49"], :host([enable-container]).ids-layout-grid-rows-md-49,
  .ids-layout-grid[enable-container][rows-md="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-md="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-49,
  .ids-layout-grid[enable-container] > ::slotted([order-md="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container])[rows-md="50"], :host([enable-container]).ids-layout-grid-rows-md-50,
  .ids-layout-grid[enable-container][rows-md="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-md-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-md="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-md-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-md="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-md-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-md="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md-50,
  .ids-layout-grid[enable-container] > ::slotted([order-md="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-md="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-md--1,
  .ids-layout-grid[enable-container] > ::slotted([order-md="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-md--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=md]),
  .ids-layout-grid[enable-container] > ::slotted([hide=md]) {
    display: block;
  }
}
@container (width >= 928px) {
  :host([enable-container]) > ::slotted([col-span-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-lg-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-lg-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-lg-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-lg="1"], :host([enable-container]).ids-layout-grid-rows-lg-1,
  .ids-layout-grid[enable-container][rows-lg="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-lg="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="2"], :host([enable-container]).ids-layout-grid-rows-lg-2,
  .ids-layout-grid[enable-container][rows-lg="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-lg="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-2,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="3"], :host([enable-container]).ids-layout-grid-rows-lg-3,
  .ids-layout-grid[enable-container][rows-lg="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-lg="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-3,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="4"], :host([enable-container]).ids-layout-grid-rows-lg-4,
  .ids-layout-grid[enable-container][rows-lg="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-lg="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-4,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="5"], :host([enable-container]).ids-layout-grid-rows-lg-5,
  .ids-layout-grid[enable-container][rows-lg="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-lg="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-5,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="6"], :host([enable-container]).ids-layout-grid-rows-lg-6,
  .ids-layout-grid[enable-container][rows-lg="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-lg="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-6,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="7"], :host([enable-container]).ids-layout-grid-rows-lg-7,
  .ids-layout-grid[enable-container][rows-lg="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-lg="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-7,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="8"], :host([enable-container]).ids-layout-grid-rows-lg-8,
  .ids-layout-grid[enable-container][rows-lg="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-lg="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-8,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="9"], :host([enable-container]).ids-layout-grid-rows-lg-9,
  .ids-layout-grid[enable-container][rows-lg="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-lg="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-9,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="10"], :host([enable-container]).ids-layout-grid-rows-lg-10,
  .ids-layout-grid[enable-container][rows-lg="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-lg="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-10,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="11"], :host([enable-container]).ids-layout-grid-rows-lg-11,
  .ids-layout-grid[enable-container][rows-lg="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-lg="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-11,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="12"], :host([enable-container]).ids-layout-grid-rows-lg-12,
  .ids-layout-grid[enable-container][rows-lg="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-lg="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-12,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="13"], :host([enable-container]).ids-layout-grid-rows-lg-13,
  .ids-layout-grid[enable-container][rows-lg="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-lg="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-13,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="14"], :host([enable-container]).ids-layout-grid-rows-lg-14,
  .ids-layout-grid[enable-container][rows-lg="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-lg="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-14,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="15"], :host([enable-container]).ids-layout-grid-rows-lg-15,
  .ids-layout-grid[enable-container][rows-lg="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-lg="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-15,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="16"], :host([enable-container]).ids-layout-grid-rows-lg-16,
  .ids-layout-grid[enable-container][rows-lg="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-lg="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-16,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="17"], :host([enable-container]).ids-layout-grid-rows-lg-17,
  .ids-layout-grid[enable-container][rows-lg="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-lg="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-17,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="18"], :host([enable-container]).ids-layout-grid-rows-lg-18,
  .ids-layout-grid[enable-container][rows-lg="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-lg="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-18,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="19"], :host([enable-container]).ids-layout-grid-rows-lg-19,
  .ids-layout-grid[enable-container][rows-lg="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-lg="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-19,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="20"], :host([enable-container]).ids-layout-grid-rows-lg-20,
  .ids-layout-grid[enable-container][rows-lg="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-lg="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-20,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="21"], :host([enable-container]).ids-layout-grid-rows-lg-21,
  .ids-layout-grid[enable-container][rows-lg="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-lg="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-21,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="22"], :host([enable-container]).ids-layout-grid-rows-lg-22,
  .ids-layout-grid[enable-container][rows-lg="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-lg="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-22,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="23"], :host([enable-container]).ids-layout-grid-rows-lg-23,
  .ids-layout-grid[enable-container][rows-lg="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-lg="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-23,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="24"], :host([enable-container]).ids-layout-grid-rows-lg-24,
  .ids-layout-grid[enable-container][rows-lg="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-lg="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-24,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="25"], :host([enable-container]).ids-layout-grid-rows-lg-25,
  .ids-layout-grid[enable-container][rows-lg="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-lg="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-25,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="26"], :host([enable-container]).ids-layout-grid-rows-lg-26,
  .ids-layout-grid[enable-container][rows-lg="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-lg="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-26,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="27"], :host([enable-container]).ids-layout-grid-rows-lg-27,
  .ids-layout-grid[enable-container][rows-lg="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-lg="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-27,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="28"], :host([enable-container]).ids-layout-grid-rows-lg-28,
  .ids-layout-grid[enable-container][rows-lg="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-lg="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-28,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="29"], :host([enable-container]).ids-layout-grid-rows-lg-29,
  .ids-layout-grid[enable-container][rows-lg="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-lg="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-29,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="30"], :host([enable-container]).ids-layout-grid-rows-lg-30,
  .ids-layout-grid[enable-container][rows-lg="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-lg="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-30,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="31"], :host([enable-container]).ids-layout-grid-rows-lg-31,
  .ids-layout-grid[enable-container][rows-lg="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-lg="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-31,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="32"], :host([enable-container]).ids-layout-grid-rows-lg-32,
  .ids-layout-grid[enable-container][rows-lg="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-lg="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-32,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="33"], :host([enable-container]).ids-layout-grid-rows-lg-33,
  .ids-layout-grid[enable-container][rows-lg="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-lg="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-33,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="34"], :host([enable-container]).ids-layout-grid-rows-lg-34,
  .ids-layout-grid[enable-container][rows-lg="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-lg="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-34,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="35"], :host([enable-container]).ids-layout-grid-rows-lg-35,
  .ids-layout-grid[enable-container][rows-lg="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-lg="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-35,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="36"], :host([enable-container]).ids-layout-grid-rows-lg-36,
  .ids-layout-grid[enable-container][rows-lg="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-lg="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-36,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="37"], :host([enable-container]).ids-layout-grid-rows-lg-37,
  .ids-layout-grid[enable-container][rows-lg="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-lg="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-37,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="38"], :host([enable-container]).ids-layout-grid-rows-lg-38,
  .ids-layout-grid[enable-container][rows-lg="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-lg="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-38,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="39"], :host([enable-container]).ids-layout-grid-rows-lg-39,
  .ids-layout-grid[enable-container][rows-lg="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-lg="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-39,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="40"], :host([enable-container]).ids-layout-grid-rows-lg-40,
  .ids-layout-grid[enable-container][rows-lg="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-lg="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-40,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="41"], :host([enable-container]).ids-layout-grid-rows-lg-41,
  .ids-layout-grid[enable-container][rows-lg="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-lg="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-41,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="42"], :host([enable-container]).ids-layout-grid-rows-lg-42,
  .ids-layout-grid[enable-container][rows-lg="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-lg="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-42,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="43"], :host([enable-container]).ids-layout-grid-rows-lg-43,
  .ids-layout-grid[enable-container][rows-lg="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-lg="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-43,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="44"], :host([enable-container]).ids-layout-grid-rows-lg-44,
  .ids-layout-grid[enable-container][rows-lg="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-lg="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-44,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="45"], :host([enable-container]).ids-layout-grid-rows-lg-45,
  .ids-layout-grid[enable-container][rows-lg="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-lg="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-45,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="46"], :host([enable-container]).ids-layout-grid-rows-lg-46,
  .ids-layout-grid[enable-container][rows-lg="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-lg="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-46,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="47"], :host([enable-container]).ids-layout-grid-rows-lg-47,
  .ids-layout-grid[enable-container][rows-lg="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-lg="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-47,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="48"], :host([enable-container]).ids-layout-grid-rows-lg-48,
  .ids-layout-grid[enable-container][rows-lg="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-lg="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-48,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="49"], :host([enable-container]).ids-layout-grid-rows-lg-49,
  .ids-layout-grid[enable-container][rows-lg="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-lg="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-49,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container])[rows-lg="50"], :host([enable-container]).ids-layout-grid-rows-lg-50,
  .ids-layout-grid[enable-container][rows-lg="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-lg-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-lg="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-lg-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-lg="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-lg-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-lg="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg-50,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-lg="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-lg--1,
  .ids-layout-grid[enable-container] > ::slotted([order-lg="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-lg--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=lg]),
  .ids-layout-grid[enable-container] > ::slotted([hide=lg]) {
    display: block;
  }
}
@container (width >= 1183px) {
  :host([enable-container]) > ::slotted([col-span-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xl-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xl-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xl-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-xl="1"], :host([enable-container]).ids-layout-grid-rows-xl-1,
  .ids-layout-grid[enable-container][rows-xl="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-xl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="2"], :host([enable-container]).ids-layout-grid-rows-xl-2,
  .ids-layout-grid[enable-container][rows-xl="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-xl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-2,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="3"], :host([enable-container]).ids-layout-grid-rows-xl-3,
  .ids-layout-grid[enable-container][rows-xl="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-xl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-3,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="4"], :host([enable-container]).ids-layout-grid-rows-xl-4,
  .ids-layout-grid[enable-container][rows-xl="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-xl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-4,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="5"], :host([enable-container]).ids-layout-grid-rows-xl-5,
  .ids-layout-grid[enable-container][rows-xl="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-xl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-5,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="6"], :host([enable-container]).ids-layout-grid-rows-xl-6,
  .ids-layout-grid[enable-container][rows-xl="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-xl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-6,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="7"], :host([enable-container]).ids-layout-grid-rows-xl-7,
  .ids-layout-grid[enable-container][rows-xl="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-xl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-7,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="8"], :host([enable-container]).ids-layout-grid-rows-xl-8,
  .ids-layout-grid[enable-container][rows-xl="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-xl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-8,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="9"], :host([enable-container]).ids-layout-grid-rows-xl-9,
  .ids-layout-grid[enable-container][rows-xl="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-xl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-9,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="10"], :host([enable-container]).ids-layout-grid-rows-xl-10,
  .ids-layout-grid[enable-container][rows-xl="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-xl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-10,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="11"], :host([enable-container]).ids-layout-grid-rows-xl-11,
  .ids-layout-grid[enable-container][rows-xl="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-xl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-11,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="12"], :host([enable-container]).ids-layout-grid-rows-xl-12,
  .ids-layout-grid[enable-container][rows-xl="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-xl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-12,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="13"], :host([enable-container]).ids-layout-grid-rows-xl-13,
  .ids-layout-grid[enable-container][rows-xl="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-xl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-13,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="14"], :host([enable-container]).ids-layout-grid-rows-xl-14,
  .ids-layout-grid[enable-container][rows-xl="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-xl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-14,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="15"], :host([enable-container]).ids-layout-grid-rows-xl-15,
  .ids-layout-grid[enable-container][rows-xl="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-xl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-15,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="16"], :host([enable-container]).ids-layout-grid-rows-xl-16,
  .ids-layout-grid[enable-container][rows-xl="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-xl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-16,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="17"], :host([enable-container]).ids-layout-grid-rows-xl-17,
  .ids-layout-grid[enable-container][rows-xl="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-xl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-17,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="18"], :host([enable-container]).ids-layout-grid-rows-xl-18,
  .ids-layout-grid[enable-container][rows-xl="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-xl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-18,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="19"], :host([enable-container]).ids-layout-grid-rows-xl-19,
  .ids-layout-grid[enable-container][rows-xl="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-xl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-19,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="20"], :host([enable-container]).ids-layout-grid-rows-xl-20,
  .ids-layout-grid[enable-container][rows-xl="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-xl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-20,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="21"], :host([enable-container]).ids-layout-grid-rows-xl-21,
  .ids-layout-grid[enable-container][rows-xl="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-xl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-21,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="22"], :host([enable-container]).ids-layout-grid-rows-xl-22,
  .ids-layout-grid[enable-container][rows-xl="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-xl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-22,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="23"], :host([enable-container]).ids-layout-grid-rows-xl-23,
  .ids-layout-grid[enable-container][rows-xl="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-xl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-23,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="24"], :host([enable-container]).ids-layout-grid-rows-xl-24,
  .ids-layout-grid[enable-container][rows-xl="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-xl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-24,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="25"], :host([enable-container]).ids-layout-grid-rows-xl-25,
  .ids-layout-grid[enable-container][rows-xl="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-xl="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-25,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="26"], :host([enable-container]).ids-layout-grid-rows-xl-26,
  .ids-layout-grid[enable-container][rows-xl="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-xl="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-26,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="27"], :host([enable-container]).ids-layout-grid-rows-xl-27,
  .ids-layout-grid[enable-container][rows-xl="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-xl="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-27,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="28"], :host([enable-container]).ids-layout-grid-rows-xl-28,
  .ids-layout-grid[enable-container][rows-xl="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-xl="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-28,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="29"], :host([enable-container]).ids-layout-grid-rows-xl-29,
  .ids-layout-grid[enable-container][rows-xl="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-xl="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-29,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="30"], :host([enable-container]).ids-layout-grid-rows-xl-30,
  .ids-layout-grid[enable-container][rows-xl="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-xl="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-30,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="31"], :host([enable-container]).ids-layout-grid-rows-xl-31,
  .ids-layout-grid[enable-container][rows-xl="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-xl="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-31,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="32"], :host([enable-container]).ids-layout-grid-rows-xl-32,
  .ids-layout-grid[enable-container][rows-xl="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-xl="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-32,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="33"], :host([enable-container]).ids-layout-grid-rows-xl-33,
  .ids-layout-grid[enable-container][rows-xl="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-xl="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-33,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="34"], :host([enable-container]).ids-layout-grid-rows-xl-34,
  .ids-layout-grid[enable-container][rows-xl="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-xl="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-34,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="35"], :host([enable-container]).ids-layout-grid-rows-xl-35,
  .ids-layout-grid[enable-container][rows-xl="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-xl="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-35,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="36"], :host([enable-container]).ids-layout-grid-rows-xl-36,
  .ids-layout-grid[enable-container][rows-xl="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-xl="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-36,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="37"], :host([enable-container]).ids-layout-grid-rows-xl-37,
  .ids-layout-grid[enable-container][rows-xl="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-xl="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-37,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="38"], :host([enable-container]).ids-layout-grid-rows-xl-38,
  .ids-layout-grid[enable-container][rows-xl="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-xl="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-38,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="39"], :host([enable-container]).ids-layout-grid-rows-xl-39,
  .ids-layout-grid[enable-container][rows-xl="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-xl="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-39,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="40"], :host([enable-container]).ids-layout-grid-rows-xl-40,
  .ids-layout-grid[enable-container][rows-xl="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-xl="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-40,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="41"], :host([enable-container]).ids-layout-grid-rows-xl-41,
  .ids-layout-grid[enable-container][rows-xl="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-xl="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-41,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="42"], :host([enable-container]).ids-layout-grid-rows-xl-42,
  .ids-layout-grid[enable-container][rows-xl="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-xl="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-42,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="43"], :host([enable-container]).ids-layout-grid-rows-xl-43,
  .ids-layout-grid[enable-container][rows-xl="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-xl="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-43,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="44"], :host([enable-container]).ids-layout-grid-rows-xl-44,
  .ids-layout-grid[enable-container][rows-xl="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-xl="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-44,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="45"], :host([enable-container]).ids-layout-grid-rows-xl-45,
  .ids-layout-grid[enable-container][rows-xl="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-xl="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-45,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="46"], :host([enable-container]).ids-layout-grid-rows-xl-46,
  .ids-layout-grid[enable-container][rows-xl="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-xl="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-46,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="47"], :host([enable-container]).ids-layout-grid-rows-xl-47,
  .ids-layout-grid[enable-container][rows-xl="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-xl="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-47,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="48"], :host([enable-container]).ids-layout-grid-rows-xl-48,
  .ids-layout-grid[enable-container][rows-xl="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-xl="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-48,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="49"], :host([enable-container]).ids-layout-grid-rows-xl-49,
  .ids-layout-grid[enable-container][rows-xl="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-xl="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-49,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xl="50"], :host([enable-container]).ids-layout-grid-rows-xl-50,
  .ids-layout-grid[enable-container][rows-xl="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xl="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xl-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xl="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xl-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-xl="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl-50,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-xl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xl--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=xl]),
  .ids-layout-grid[enable-container] > ::slotted([hide=xl]) {
    display: block;
  }
}
@container (width >= 2463px) {
  :host([enable-container]) > ::slotted([col-span-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-1 {
    grid-column: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-1 {
    grid-column-start: 1;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-1 {
    grid-column-end: 1;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-2 {
    grid-column: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-2 {
    grid-column-start: 2;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-2 {
    grid-column-end: 2;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-3 {
    grid-column: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-3 {
    grid-column-start: 3;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-3 {
    grid-column-end: 3;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-4 {
    grid-column: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-4 {
    grid-column-start: 4;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-4 {
    grid-column-end: 4;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-5 {
    grid-column: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-5 {
    grid-column-start: 5;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-5 {
    grid-column-end: 5;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-6 {
    grid-column: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-6 {
    grid-column-start: 6;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-6 {
    grid-column-end: 6;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-7 {
    grid-column: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-7 {
    grid-column-start: 7;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-7 {
    grid-column-end: 7;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-8 {
    grid-column: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-8 {
    grid-column-start: 8;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-8 {
    grid-column-end: 8;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-9 {
    grid-column: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-9 {
    grid-column-start: 9;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-9 {
    grid-column-end: 9;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-10 {
    grid-column: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-10 {
    grid-column-start: 10;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-10 {
    grid-column-end: 10;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-11 {
    grid-column: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-11 {
    grid-column-start: 11;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-11 {
    grid-column-end: 11;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-12 {
    grid-column: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-12 {
    grid-column-start: 12;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-12 {
    grid-column-end: 12;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-13 {
    grid-column: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-13 {
    grid-column-start: 13;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-13 {
    grid-column-end: 13;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-14 {
    grid-column: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-14 {
    grid-column-start: 14;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-14 {
    grid-column-end: 14;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-15 {
    grid-column: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-15 {
    grid-column-start: 15;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-15 {
    grid-column-end: 15;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-16 {
    grid-column: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-16 {
    grid-column-start: 16;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-16 {
    grid-column-end: 16;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-17 {
    grid-column: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-17 {
    grid-column-start: 17;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-17 {
    grid-column-end: 17;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-18 {
    grid-column: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-18 {
    grid-column-start: 18;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-18 {
    grid-column-end: 18;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-19 {
    grid-column: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-19 {
    grid-column-start: 19;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-19 {
    grid-column-end: 19;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-20 {
    grid-column: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-20 {
    grid-column-start: 20;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-20 {
    grid-column-end: 20;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-21 {
    grid-column: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-21 {
    grid-column-start: 21;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-21 {
    grid-column-end: 21;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-22 {
    grid-column: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-22 {
    grid-column-start: 22;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-22 {
    grid-column-end: 22;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-23 {
    grid-column: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-23 {
    grid-column-start: 23;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-23 {
    grid-column-end: 23;
  }
  :host([enable-container]) > ::slotted([col-span-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-span-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-span-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-span-xxl-24 {
    grid-column: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([col-start-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-start-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-start-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-start-xxl-24 {
    grid-column-start: 24;
  }
  :host([enable-container]) > ::slotted([col-end-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-col-end-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([col-end-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-col-end-xxl-24 {
    grid-column-end: 24;
  }
  :host([enable-container])[rows-xxl="1"], :host([enable-container]).ids-layout-grid-rows-xxl-1,
  .ids-layout-grid[enable-container][rows-xxl="1"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-1 {
    grid-row: span 1/span 1;
  }
  :host([enable-container]) > ::slotted([order-xxl="1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-1 {
    order: 1;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="2"], :host([enable-container]).ids-layout-grid-rows-xxl-2,
  .ids-layout-grid[enable-container][rows-xxl="2"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-2 {
    grid-row: span 2/span 2;
  }
  :host([enable-container]) > ::slotted([order-xxl="2"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-2,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="2"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-2 {
    order: 2;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="3"], :host([enable-container]).ids-layout-grid-rows-xxl-3,
  .ids-layout-grid[enable-container][rows-xxl="3"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-3 {
    grid-row: span 3/span 3;
  }
  :host([enable-container]) > ::slotted([order-xxl="3"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-3,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="3"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-3 {
    order: 3;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="4"], :host([enable-container]).ids-layout-grid-rows-xxl-4,
  .ids-layout-grid[enable-container][rows-xxl="4"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-4 {
    grid-row: span 4/span 4;
  }
  :host([enable-container]) > ::slotted([order-xxl="4"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-4,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="4"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-4 {
    order: 4;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="5"], :host([enable-container]).ids-layout-grid-rows-xxl-5,
  .ids-layout-grid[enable-container][rows-xxl="5"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-5 {
    grid-row: span 5/span 5;
  }
  :host([enable-container]) > ::slotted([order-xxl="5"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-5,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="5"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-5 {
    order: 5;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="6"], :host([enable-container]).ids-layout-grid-rows-xxl-6,
  .ids-layout-grid[enable-container][rows-xxl="6"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-6 {
    grid-row: span 6/span 6;
  }
  :host([enable-container]) > ::slotted([order-xxl="6"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-6,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="6"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-6 {
    order: 6;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="7"], :host([enable-container]).ids-layout-grid-rows-xxl-7,
  .ids-layout-grid[enable-container][rows-xxl="7"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-7 {
    grid-template-rows: repeat(7, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-7 {
    grid-row: span 7/span 7;
  }
  :host([enable-container]) > ::slotted([order-xxl="7"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-7,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="7"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-7 {
    order: 7;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="8"], :host([enable-container]).ids-layout-grid-rows-xxl-8,
  .ids-layout-grid[enable-container][rows-xxl="8"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-8 {
    grid-template-rows: repeat(8, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-8 {
    grid-row: span 8/span 8;
  }
  :host([enable-container]) > ::slotted([order-xxl="8"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-8,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="8"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-8 {
    order: 8;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="9"], :host([enable-container]).ids-layout-grid-rows-xxl-9,
  .ids-layout-grid[enable-container][rows-xxl="9"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-9 {
    grid-template-rows: repeat(9, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-9 {
    grid-row: span 9/span 9;
  }
  :host([enable-container]) > ::slotted([order-xxl="9"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-9,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="9"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-9 {
    order: 9;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="10"], :host([enable-container]).ids-layout-grid-rows-xxl-10,
  .ids-layout-grid[enable-container][rows-xxl="10"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-10 {
    grid-template-rows: repeat(10, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-10 {
    grid-row: span 10/span 10;
  }
  :host([enable-container]) > ::slotted([order-xxl="10"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-10,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="10"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-10 {
    order: 10;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="11"], :host([enable-container]).ids-layout-grid-rows-xxl-11,
  .ids-layout-grid[enable-container][rows-xxl="11"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-11 {
    grid-template-rows: repeat(11, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-11 {
    grid-row: span 11/span 11;
  }
  :host([enable-container]) > ::slotted([order-xxl="11"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-11,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="11"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-11 {
    order: 11;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="12"], :host([enable-container]).ids-layout-grid-rows-xxl-12,
  .ids-layout-grid[enable-container][rows-xxl="12"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-12 {
    grid-template-rows: repeat(12, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-12 {
    grid-row: span 12/span 12;
  }
  :host([enable-container]) > ::slotted([order-xxl="12"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-12,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="12"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-12 {
    order: 12;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="13"], :host([enable-container]).ids-layout-grid-rows-xxl-13,
  .ids-layout-grid[enable-container][rows-xxl="13"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-13 {
    grid-template-rows: repeat(13, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-13 {
    grid-row: span 13/span 13;
  }
  :host([enable-container]) > ::slotted([order-xxl="13"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-13,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="13"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-13 {
    order: 13;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="14"], :host([enable-container]).ids-layout-grid-rows-xxl-14,
  .ids-layout-grid[enable-container][rows-xxl="14"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-14 {
    grid-template-rows: repeat(14, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-14 {
    grid-row: span 14/span 14;
  }
  :host([enable-container]) > ::slotted([order-xxl="14"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-14,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="14"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-14 {
    order: 14;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="15"], :host([enable-container]).ids-layout-grid-rows-xxl-15,
  .ids-layout-grid[enable-container][rows-xxl="15"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-15 {
    grid-template-rows: repeat(15, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-15 {
    grid-row: span 15/span 15;
  }
  :host([enable-container]) > ::slotted([order-xxl="15"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-15,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="15"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-15 {
    order: 15;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="16"], :host([enable-container]).ids-layout-grid-rows-xxl-16,
  .ids-layout-grid[enable-container][rows-xxl="16"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-16 {
    grid-template-rows: repeat(16, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-16 {
    grid-row: span 16/span 16;
  }
  :host([enable-container]) > ::slotted([order-xxl="16"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-16,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="16"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-16 {
    order: 16;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="17"], :host([enable-container]).ids-layout-grid-rows-xxl-17,
  .ids-layout-grid[enable-container][rows-xxl="17"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-17 {
    grid-template-rows: repeat(17, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-17 {
    grid-row: span 17/span 17;
  }
  :host([enable-container]) > ::slotted([order-xxl="17"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-17,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="17"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-17 {
    order: 17;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="18"], :host([enable-container]).ids-layout-grid-rows-xxl-18,
  .ids-layout-grid[enable-container][rows-xxl="18"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-18 {
    grid-template-rows: repeat(18, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-18 {
    grid-row: span 18/span 18;
  }
  :host([enable-container]) > ::slotted([order-xxl="18"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-18,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="18"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-18 {
    order: 18;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="19"], :host([enable-container]).ids-layout-grid-rows-xxl-19,
  .ids-layout-grid[enable-container][rows-xxl="19"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-19 {
    grid-template-rows: repeat(19, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-19 {
    grid-row: span 19/span 19;
  }
  :host([enable-container]) > ::slotted([order-xxl="19"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-19,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="19"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-19 {
    order: 19;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="20"], :host([enable-container]).ids-layout-grid-rows-xxl-20,
  .ids-layout-grid[enable-container][rows-xxl="20"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-20 {
    grid-template-rows: repeat(20, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-20 {
    grid-row: span 20/span 20;
  }
  :host([enable-container]) > ::slotted([order-xxl="20"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-20,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="20"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-20 {
    order: 20;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="21"], :host([enable-container]).ids-layout-grid-rows-xxl-21,
  .ids-layout-grid[enable-container][rows-xxl="21"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-21 {
    grid-template-rows: repeat(21, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-21 {
    grid-row: span 21/span 21;
  }
  :host([enable-container]) > ::slotted([order-xxl="21"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-21,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="21"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-21 {
    order: 21;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="22"], :host([enable-container]).ids-layout-grid-rows-xxl-22,
  .ids-layout-grid[enable-container][rows-xxl="22"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-22 {
    grid-template-rows: repeat(22, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-22 {
    grid-row: span 22/span 22;
  }
  :host([enable-container]) > ::slotted([order-xxl="22"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-22,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="22"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-22 {
    order: 22;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="23"], :host([enable-container]).ids-layout-grid-rows-xxl-23,
  .ids-layout-grid[enable-container][rows-xxl="23"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-23 {
    grid-template-rows: repeat(23, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-23 {
    grid-row: span 23/span 23;
  }
  :host([enable-container]) > ::slotted([order-xxl="23"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-23,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="23"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-23 {
    order: 23;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="24"], :host([enable-container]).ids-layout-grid-rows-xxl-24,
  .ids-layout-grid[enable-container][rows-xxl="24"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-24 {
    grid-template-rows: repeat(24, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-24 {
    grid-row: span 24/span 24;
  }
  :host([enable-container]) > ::slotted([order-xxl="24"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-24,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="24"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-24 {
    order: 24;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="25"], :host([enable-container]).ids-layout-grid-rows-xxl-25,
  .ids-layout-grid[enable-container][rows-xxl="25"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-25 {
    grid-template-rows: repeat(25, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-25,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-25 {
    grid-row: span 25/span 25;
  }
  :host([enable-container]) > ::slotted([order-xxl="25"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-25,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="25"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-25 {
    order: 25;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="26"], :host([enable-container]).ids-layout-grid-rows-xxl-26,
  .ids-layout-grid[enable-container][rows-xxl="26"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-26 {
    grid-template-rows: repeat(26, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-26,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-26 {
    grid-row: span 26/span 26;
  }
  :host([enable-container]) > ::slotted([order-xxl="26"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-26,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="26"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-26 {
    order: 26;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="27"], :host([enable-container]).ids-layout-grid-rows-xxl-27,
  .ids-layout-grid[enable-container][rows-xxl="27"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-27 {
    grid-template-rows: repeat(27, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-27,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-27 {
    grid-row: span 27/span 27;
  }
  :host([enable-container]) > ::slotted([order-xxl="27"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-27,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="27"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-27 {
    order: 27;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="28"], :host([enable-container]).ids-layout-grid-rows-xxl-28,
  .ids-layout-grid[enable-container][rows-xxl="28"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-28 {
    grid-template-rows: repeat(28, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-28,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-28 {
    grid-row: span 28/span 28;
  }
  :host([enable-container]) > ::slotted([order-xxl="28"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-28,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="28"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-28 {
    order: 28;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="29"], :host([enable-container]).ids-layout-grid-rows-xxl-29,
  .ids-layout-grid[enable-container][rows-xxl="29"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-29 {
    grid-template-rows: repeat(29, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-29,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-29 {
    grid-row: span 29/span 29;
  }
  :host([enable-container]) > ::slotted([order-xxl="29"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-29,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="29"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-29 {
    order: 29;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="30"], :host([enable-container]).ids-layout-grid-rows-xxl-30,
  .ids-layout-grid[enable-container][rows-xxl="30"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-30 {
    grid-template-rows: repeat(30, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-30,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-30 {
    grid-row: span 30/span 30;
  }
  :host([enable-container]) > ::slotted([order-xxl="30"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-30,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="30"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-30 {
    order: 30;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="31"], :host([enable-container]).ids-layout-grid-rows-xxl-31,
  .ids-layout-grid[enable-container][rows-xxl="31"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-31 {
    grid-template-rows: repeat(31, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-31,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-31 {
    grid-row: span 31/span 31;
  }
  :host([enable-container]) > ::slotted([order-xxl="31"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-31,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="31"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-31 {
    order: 31;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="32"], :host([enable-container]).ids-layout-grid-rows-xxl-32,
  .ids-layout-grid[enable-container][rows-xxl="32"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-32 {
    grid-template-rows: repeat(32, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-32,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-32 {
    grid-row: span 32/span 32;
  }
  :host([enable-container]) > ::slotted([order-xxl="32"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-32,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="32"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-32 {
    order: 32;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="33"], :host([enable-container]).ids-layout-grid-rows-xxl-33,
  .ids-layout-grid[enable-container][rows-xxl="33"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-33 {
    grid-template-rows: repeat(33, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-33,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-33 {
    grid-row: span 33/span 33;
  }
  :host([enable-container]) > ::slotted([order-xxl="33"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-33,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="33"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-33 {
    order: 33;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="34"], :host([enable-container]).ids-layout-grid-rows-xxl-34,
  .ids-layout-grid[enable-container][rows-xxl="34"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-34 {
    grid-template-rows: repeat(34, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-34,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-34 {
    grid-row: span 34/span 34;
  }
  :host([enable-container]) > ::slotted([order-xxl="34"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-34,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="34"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-34 {
    order: 34;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="35"], :host([enable-container]).ids-layout-grid-rows-xxl-35,
  .ids-layout-grid[enable-container][rows-xxl="35"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-35 {
    grid-template-rows: repeat(35, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-35,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-35 {
    grid-row: span 35/span 35;
  }
  :host([enable-container]) > ::slotted([order-xxl="35"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-35,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="35"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-35 {
    order: 35;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="36"], :host([enable-container]).ids-layout-grid-rows-xxl-36,
  .ids-layout-grid[enable-container][rows-xxl="36"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-36 {
    grid-template-rows: repeat(36, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-36,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-36 {
    grid-row: span 36/span 36;
  }
  :host([enable-container]) > ::slotted([order-xxl="36"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-36,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="36"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-36 {
    order: 36;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="37"], :host([enable-container]).ids-layout-grid-rows-xxl-37,
  .ids-layout-grid[enable-container][rows-xxl="37"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-37 {
    grid-template-rows: repeat(37, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-37,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-37 {
    grid-row: span 37/span 37;
  }
  :host([enable-container]) > ::slotted([order-xxl="37"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-37,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="37"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-37 {
    order: 37;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="38"], :host([enable-container]).ids-layout-grid-rows-xxl-38,
  .ids-layout-grid[enable-container][rows-xxl="38"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-38 {
    grid-template-rows: repeat(38, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-38,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-38 {
    grid-row: span 38/span 38;
  }
  :host([enable-container]) > ::slotted([order-xxl="38"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-38,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="38"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-38 {
    order: 38;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="39"], :host([enable-container]).ids-layout-grid-rows-xxl-39,
  .ids-layout-grid[enable-container][rows-xxl="39"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-39 {
    grid-template-rows: repeat(39, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-39,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-39 {
    grid-row: span 39/span 39;
  }
  :host([enable-container]) > ::slotted([order-xxl="39"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-39,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="39"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-39 {
    order: 39;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="40"], :host([enable-container]).ids-layout-grid-rows-xxl-40,
  .ids-layout-grid[enable-container][rows-xxl="40"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-40 {
    grid-template-rows: repeat(40, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-40,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-40 {
    grid-row: span 40/span 40;
  }
  :host([enable-container]) > ::slotted([order-xxl="40"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-40,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="40"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-40 {
    order: 40;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="41"], :host([enable-container]).ids-layout-grid-rows-xxl-41,
  .ids-layout-grid[enable-container][rows-xxl="41"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-41 {
    grid-template-rows: repeat(41, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-41,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-41 {
    grid-row: span 41/span 41;
  }
  :host([enable-container]) > ::slotted([order-xxl="41"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-41,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="41"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-41 {
    order: 41;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="42"], :host([enable-container]).ids-layout-grid-rows-xxl-42,
  .ids-layout-grid[enable-container][rows-xxl="42"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-42 {
    grid-template-rows: repeat(42, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-42,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-42 {
    grid-row: span 42/span 42;
  }
  :host([enable-container]) > ::slotted([order-xxl="42"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-42,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="42"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-42 {
    order: 42;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="43"], :host([enable-container]).ids-layout-grid-rows-xxl-43,
  .ids-layout-grid[enable-container][rows-xxl="43"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-43 {
    grid-template-rows: repeat(43, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-43,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-43 {
    grid-row: span 43/span 43;
  }
  :host([enable-container]) > ::slotted([order-xxl="43"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-43,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="43"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-43 {
    order: 43;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="44"], :host([enable-container]).ids-layout-grid-rows-xxl-44,
  .ids-layout-grid[enable-container][rows-xxl="44"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-44 {
    grid-template-rows: repeat(44, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-44,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-44 {
    grid-row: span 44/span 44;
  }
  :host([enable-container]) > ::slotted([order-xxl="44"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-44,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="44"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-44 {
    order: 44;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="45"], :host([enable-container]).ids-layout-grid-rows-xxl-45,
  .ids-layout-grid[enable-container][rows-xxl="45"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-45 {
    grid-template-rows: repeat(45, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-45,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-45 {
    grid-row: span 45/span 45;
  }
  :host([enable-container]) > ::slotted([order-xxl="45"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-45,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="45"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-45 {
    order: 45;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="46"], :host([enable-container]).ids-layout-grid-rows-xxl-46,
  .ids-layout-grid[enable-container][rows-xxl="46"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-46 {
    grid-template-rows: repeat(46, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-46,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-46 {
    grid-row: span 46/span 46;
  }
  :host([enable-container]) > ::slotted([order-xxl="46"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-46,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="46"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-46 {
    order: 46;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="47"], :host([enable-container]).ids-layout-grid-rows-xxl-47,
  .ids-layout-grid[enable-container][rows-xxl="47"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-47 {
    grid-template-rows: repeat(47, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-47,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-47 {
    grid-row: span 47/span 47;
  }
  :host([enable-container]) > ::slotted([order-xxl="47"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-47,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="47"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-47 {
    order: 47;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="48"], :host([enable-container]).ids-layout-grid-rows-xxl-48,
  .ids-layout-grid[enable-container][rows-xxl="48"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-48 {
    grid-template-rows: repeat(48, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-48,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-48 {
    grid-row: span 48/span 48;
  }
  :host([enable-container]) > ::slotted([order-xxl="48"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-48,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="48"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-48 {
    order: 48;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="49"], :host([enable-container]).ids-layout-grid-rows-xxl-49,
  .ids-layout-grid[enable-container][rows-xxl="49"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-49 {
    grid-template-rows: repeat(49, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-49,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-49 {
    grid-row: span 49/span 49;
  }
  :host([enable-container]) > ::slotted([order-xxl="49"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-49,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="49"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-49 {
    order: 49;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container])[rows-xxl="50"], :host([enable-container]).ids-layout-grid-rows-xxl-50,
  .ids-layout-grid[enable-container][rows-xxl="50"],
  .ids-layout-grid[enable-container].ids-layout-grid-rows-xxl-50 {
    grid-template-rows: repeat(50, minmax(0, 1fr));
  }
  :host([enable-container]) > ::slotted([row-span-xxl="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-row-span-xxl-50,
  .ids-layout-grid[enable-container] > ::slotted([row-span-xxl="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-row-span-xxl-50 {
    grid-row: span 50/span 50;
  }
  :host([enable-container]) > ::slotted([order-xxl="50"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl-50,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="50"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl-50 {
    order: 50;
  }
  :host([enable-container]) > ::slotted([order-xxl="-1"]), :host([enable-container]).ids-layout-grid > .ids-layout-grid-order-xxl--1,
  .ids-layout-grid[enable-container] > ::slotted([order-xxl="-1"]),
  .ids-layout-grid[enable-container].ids-layout-grid > .ids-layout-grid-order-xxl--1 {
    order: -1;
  }
  :host([enable-container]) > ::slotted([hide=xxl]),
  .ids-layout-grid[enable-container] > ::slotted([hide=xxl]) {
    display: block;
  }
}

/* Grid Gaps */
:host([gap=none]),
.ids-layout-grid.ids-layout-grid-gap-none {
  /* stylelint-disable-next-line property-no-deprecated */
  grid-gap: 0;
}

:host([gap=sm]),
.ids-layout-grid.ids-layout-grid-gap-sm {
  /* stylelint-disable-next-line property-no-deprecated */
  grid-gap: 16px;
}

:host([gap=md]),
.ids-layout-grid.ids-layout-grid-gap-md {
  /* stylelint-disable-next-line property-no-deprecated */
  grid-gap: 16px;
}

:host([gap=lg]),
.ids-layout-grid.ids-layout-grid-gap-lg {
  /* stylelint-disable-next-line property-no-deprecated */
  grid-gap: 16px;
}

:host([gap=xl]),
.ids-layout-grid.ids-layout-grid-gap-xl {
  /* stylelint-disable-next-line property-no-deprecated */
  grid-gap: 16px;
}

/* Grid Margins */
:host([margin=xs]),
.ids-layout-grid.ids-layout-grid-margin-xs {
  margin: 16px;
}

:host([margin=sm]),
.ids-layout-grid.ids-layout-grid-margin-sm {
  margin: 16px;
}

:host([margin=md]),
.ids-layout-grid.ids-layout-grid-margin-md {
  margin: 16px;
}

:host([margin=lg]),
.ids-layout-grid.ids-layout-grid-margin-lg {
  margin: 24px;
}

:host([margin=xl]),
.ids-layout-grid.ids-layout-grid-margin-xl {
  margin: 24px;
}

:host([margin=auto]),
.ids-layout-grid.ids-layout-grid-margin-auto {
  margin: auto;
}

/* Grid Margin Y */
:host([margin-y=xs]),
.ids-layout-grid.ids-layout-grid-margin-y-xs {
  margin-block: 16px;
}

:host([margin-y=sm]),
.ids-layout-grid.ids-layout-grid-margin-y-sm {
  margin-block: 16px;
}

:host([margin-y=md]),
.ids-layout-grid.ids-layout-grid-margin-y-md {
  margin-block: 16px;
}

:host([margin-y=lg]),
.ids-layout-grid.ids-layout-grid-margin-y-lg {
  margin-block: 24px;
}

:host([margin-y=xl]),
.ids-layout-grid.ids-layout-grid-margin-y-xl {
  margin-block: 24px;
}

/* Grid Max Width */
:host([max-width=xs]),
.ids-layout-grid.ids-layout-grid-max-width-xs {
  max-width: 320px;
}

:host([max-width=sm]),
.ids-layout-grid.ids-layout-grid-max-width-sm {
  max-width: 767px;
}

:host([max-width=md]),
.ids-layout-grid.ids-layout-grid-max-width-md {
  max-width: 927px;
}

:host([max-width=lg]),
.ids-layout-grid.ids-layout-grid-max-width-lg {
  max-width: 928px;
}

:host([max-width=xl]),
.ids-layout-grid.ids-layout-grid-max-width-xl {
  max-width: 1183px;
}

:host([max-width=xxl]),
.ids-layout-grid.ids-layout-grid-max-width-xxl {
  max-width: 2463px;
}

:host([max-width\$=px]) {
  max-width: var(--max-width);
}

/* Grid Padding */
:host([padding=xs]),
::slotted([padding=xs]),
.ids-layout-grid.ids-layout-grid-padding-xs {
  padding: 8px;
}

:host([padding=sm]),
::slotted([padding=sm]),
.ids-layout-grid.ids-layout-grid-padding-sm {
  padding: 16px;
}

:host([padding=md]),
::slotted([padding=md]),
.ids-layout-grid.ids-layout-grid-padding-md {
  padding: 24px;
}

:host([padding=lg]),
::slotted([padding=lg]),
.ids-layout-grid.ids-layout-grid-padding-lg {
  padding: 32px;
}

:host([padding=xl]),
::slotted([padding=xl]),
.ids-layout-grid.ids-layout-grid-padding-xl {
  padding: 40px;
}

/* Grid Padding X */
:host([padding-x=xs]),
.ids-layout-grid.ids-layout-grid-padding-x-xs {
  padding-inline: 8px;
}

:host([padding-x=sm]),
.ids-layout-grid.ids-layout-grid-padding-x-sm {
  padding-inline: 16px;
}

:host([padding-x=md]),
.ids-layout-grid.ids-layout-grid-padding-x-md {
  padding-inline: 24px;
}

:host([padding-x=lg]),
.ids-layout-grid.ids-layout-grid-padding-x-lg {
  padding-inline: 32px;
}

:host([padding-x=xl]),
.ids-layout-grid.ids-layout-grid-padding-x-xl {
  padding-inline: 40px;
}

/* Grid Padding Y */
:host([padding-y=xs]),
.ids-layout-grid.ids-layout-grid-padding-y-xs {
  padding-block: 8px;
}

:host([padding-y=xxs]),
.ids-layout-grid.ids-layout-grid-padding-y-xxs {
  padding-block: 4px;
}

:host([padding-y=sm]),
.ids-layout-grid.ids-layout-grid-padding-y-sm {
  padding-block: 16px;
}

:host([padding-y=md]),
.ids-layout-grid.ids-layout-grid-padding-y-md {
  padding-block: 24px;
}

:host([padding-y=lg]),
.ids-layout-grid.ids-layout-grid-padding-y-lg {
  padding-block: 32px;
}

:host([padding-y=xl]),
.ids-layout-grid.ids-layout-grid-padding-y-xl {
  padding-block: 40px;
}

/* Grid Padding Bottom */
:host([padding-bottom=xxs]),
.ids-layout-grid.ids-layout-grid-padding-bottom-xxs {
  padding-block-end: 4px;
}

:host([padding-bottom=xs]),
.ids-layout-grid.ids-layout-grid-padding-bottom-xs {
  padding-block-end: 8px;
}

:host([padding-bottom=sm]),
.ids-layout-grid.ids-layout-grid-padding-bottom-sm {
  padding-block-end: 16px;
}

:host([padding-bottom=md]),
.ids-layout-grid.ids-layout-grid-padding-bottom-md {
  padding-block-end: 24px;
}

:host([padding-bottom=lg]),
.ids-layout-grid.ids-layout-grid-padding-bottom-lg {
  padding-block-end: 32px;
}

:host([padding-bottom=xl]),
.ids-layout-grid.ids-layout-grid-padding-bottom-xl {
  padding-block-end: 40px;
}

/* Grid - Auto Fit/Fill */
:host([auto-fit]),
.ids-layout-grid-auto-fit {
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(var(--min-col-width), var(--max-col-width)));
}

:host([auto-fill]),
.ids-layout-grid-auto-fill {
  width: 100%;
  grid-template-columns: repeat(auto-fill, minmax(var(--min-col-width), var(--max-col-width)));
}

/* Grid - Auto Columns - TODO - Add settings for grid-auto-columns */
:host(.ids-layout-grid-cols-auto),
.ids-layout-grid-cols-auto {
  grid-auto-columns: auto;
}

:host(.ids-layout-grid-cols-min),
.ids-layout-grid-cols-min {
  grid-auto-columns: min-content;
}

:host(.ids-layout-grid-cols-max),
.ids-layout-grid-cols-max {
  grid-auto-columns: max-content;
}

:host(.ids-layout-grid-cols-fr),
.ids-layout-grid-cols-fr {
  grid-auto-columns: minmax(0, 1fr);
}

/* Grid Flow */
:host([flow=row]),
.ids-layout-grid-flow-row {
  grid-auto-flow: row;
}

:host([flow=column]),
.ids-layout-grid-flow-col {
  grid-auto-flow: column;
}

:host([flow=dense]),
.ids-layout-grid-flow-dense {
  grid-auto-flow: dense;
}

:host([flow=row-dense]),
.ids-layout-grid-flow-row-dense {
  grid-auto-flow: row dense;
}

:host([flow=column-dense]),
.ids-layout-grid-flow-col-dense {
  grid-auto-flow: column dense;
}

/* Grid - Auto Rows - TODO - Add settings for grid-auto-rows */
:host(.ids-layout-grid-auto-rows-auto),
.ids-layout-grid-auto-rows-auto {
  grid-auto-rows: auto;
}

:host(.ids-layout-grid-auto-rows-min),
.ids-layout-grid-auto-rows-min {
  grid-auto-rows: min-content;
}

:host(.ids-layout-grid-auto-rows-max),
.ids-layout-grid-auto-rows-max {
  grid-auto-rows: max-content;
}

:host(.ids-layout-grid-auto-rows-fr),
.ids-layout-grid-auto-rows-fr {
  grid-auto-rows: minmax(0, 1fr);
}

:host([row-height]),
.ids-layout-grid-auto-row-height {
  grid-auto-rows: var(--grid-auto-row-height);
}

/* Grid - Template Rows */
:host([template-rows]),
.ids-layout-grid-template-rows {
  grid-template-rows: var(--grid-template-rows);
}

/** Align items */
:host([align-items=start]),
.ids-layout-grid-align-items-start {
  align-items: start;
}

:host([align-items=end]),
.ids-layout-grid-align-items-end {
  align-items: end;
}

:host([align-items=center]),
.ids-layout-grid-align-items-center {
  align-items: center;
}

:host([align-items=stretch]),
.ids-layout-grid-align-items-stretch {
  align-items: stretch;
}

/* Justify Content and Align Content */
:host([justify-content=start]),
.ids-layout-grid-justify-start {
  justify-content: start;
}

:host([align-content=start]),
.ids-layout-grid-align-start {
  align-content: start;
}

::slotted([justify-content=start]),
.ids-layout-grid > .ids-layout-grid-justify-start {
  display: grid;
  justify-content: start;
}

::slotted([align-content=start]),
.ids-layout-grid > .ids-layout-grid-align-start {
  display: grid;
  align-content: start;
}

:host([justify-content=center]),
.ids-layout-grid-justify-center {
  justify-content: center;
}

:host([align-content=center]),
.ids-layout-grid-align-center {
  align-content: center;
}

::slotted([justify-content=center]),
.ids-layout-grid > .ids-layout-grid-justify-center {
  display: grid;
  justify-content: center;
}

::slotted([align-content=center]),
.ids-layout-grid > .ids-layout-grid-align-center {
  display: grid;
  align-content: center;
}

:host([justify-content=space-between]),
.ids-layout-grid-justify-space-between {
  justify-content: space-between;
}

:host([align-content=space-between]),
.ids-layout-grid-align-space-between {
  align-content: space-between;
}

::slotted([justify-content=space-between]),
.ids-layout-grid > .ids-layout-grid-justify-space-between {
  display: grid;
  justify-content: space-between;
}

::slotted([align-content=space-between]),
.ids-layout-grid > .ids-layout-grid-align-space-between {
  display: grid;
  align-content: space-between;
}

:host([justify-content=space-around]),
.ids-layout-grid-justify-space-around {
  justify-content: space-around;
}

:host([align-content=space-around]),
.ids-layout-grid-align-space-around {
  align-content: space-around;
}

::slotted([justify-content=space-around]),
.ids-layout-grid > .ids-layout-grid-justify-space-around {
  display: grid;
  justify-content: space-around;
}

::slotted([align-content=space-around]),
.ids-layout-grid > .ids-layout-grid-align-space-around {
  display: grid;
  align-content: space-around;
}

:host([justify-content=space-evenly]),
.ids-layout-grid-justify-space-evenly {
  justify-content: space-evenly;
}

:host([align-content=space-evenly]),
.ids-layout-grid-align-space-evenly {
  align-content: space-evenly;
}

::slotted([justify-content=space-evenly]),
.ids-layout-grid > .ids-layout-grid-justify-space-evenly {
  display: grid;
  justify-content: space-evenly;
}

::slotted([align-content=space-evenly]),
.ids-layout-grid > .ids-layout-grid-align-space-evenly {
  display: grid;
  align-content: space-evenly;
}

:host([justify-content=end]),
.ids-layout-grid-justify-end {
  justify-content: end;
}

:host([align-content=end]),
.ids-layout-grid-align-end {
  align-content: end;
}

::slotted([justify-content=end]),
.ids-layout-grid > .ids-layout-grid-justify-end {
  display: grid;
  justify-content: end;
}

::slotted([align-content=end]),
.ids-layout-grid > .ids-layout-grid-align-end {
  display: grid;
  align-content: end;
}

/* Grid Col/Row Span All and Sticky */
::slotted([col-span=all]),
.ids-layout-grid > .ids-layout-grid-col-span-all {
  grid-column: 1/-1;
}

::slotted([row-span=all]),
.ids-layout-grid > .ids-layout-grid-row-span-all {
  grid-row: 1/-1;
}

::slotted([sticky]),
.ids-layout-grid > .ids-layout-grid-sticky {
  position: sticky;
  top: var(--sticky-position);
}

/* Hide Cell on Breakpoints */
:host > ::slotted([hide=xs]) {
  display: none;
}

:host > ::slotted([hide=sm]) {
  display: none;
}

:host > ::slotted([hide=md]) {
  display: none;
}

:host > ::slotted([hide=lg]) {
  display: none;
}

:host > ::slotted([hide=xl]) {
  display: none;
}

:host > ::slotted([hide=xxl]) {
  display: none;
}

:host > ::slotted([hide=always]) {
  display: none;
}

:host([row-gap=none]),
::slotted([row-gap=none]),
.ids-layout-grid.ids-layout-grid-row-gap-none {
  row-gap: 0;
}

:host([row-gap=xs]),
::slotted([row-gap=xs]),
.ids-layout-grid.ids-layout-grid-row-gap-xs {
  row-gap: 8px;
}

:host([row-gap=sm]),
::slotted([row-gap=sm]),
.ids-layout-grid.ids-layout-grid-row-gap-sm {
  row-gap: 16px;
}

:host([row-gap=md]),
::slotted([row-gap=md]),
.ids-layout-grid.ids-layout-grid-row-gap-md {
  row-gap: 24px;
}

:host([row-gap=lg]),
::slotted([row-gap=lg]),
.ids-layout-grid.ids-layout-grid-row-gap-lg {
  row-gap: 32px;
}

:host([row-gap=xl]),
::slotted([row-gap=xl]),
.ids-layout-grid.ids-layout-grid-row-gap-xl {
  row-gap: 40px;
}

:host([col-gap=none]),
::slotted([col-gap=none]),
.ids-layout-grid.ids-layout-grid-col-gap-none {
  column-gap: 0;
}

:host([col-gap=xs]),
::slotted([col-gap=xs]),
.ids-layout-grid.ids-layout-grid-col-gap-xs {
  column-gap: 8px;
}

:host([col-gap=sm]),
::slotted([col-gap=sm]),
.ids-layout-grid.ids-layout-grid-col-gap-sm {
  column-gap: 16px;
}

:host([col-gap=md]),
::slotted([col-gap=md]),
.ids-layout-grid.ids-layout-grid-col-gap-md {
  column-gap: 24px;
}

:host([col-gap=lg]),
::slotted([col-gap=lg]),
.ids-layout-grid.ids-layout-grid-col-gap-lg {
  column-gap: 32px;
}

:host([col-gap=xl]),
::slotted([col-gap=xl]),
.ids-layout-grid.ids-layout-grid-col-gap-xl {
  column-gap: 40px;
}

/* Editable */
::slotted([editable]) > ids-button,
.ids-layout-grid > .ids-layout-grid-cell.editable > ids-button {
  position: absolute;
  top: 0;
  right: 0;
}

/* Fill */
::slotted([fill]),
.ids-layout-grid > .ids-layout-grid-cell.fill {
  background-color: var(--grid-fill-color);
  color: var(--grid-text-color);
}

/* Height */
::slotted([height=auto]),
.ids-layout-grid > .ids-layout-grid-height-auto {
  height: auto;
}

/* When containing an auto-fit data grid cell, fill available height */
:host(.ids-layout-grid-has-auto-fit-cell) {
  block-size: 100%;
  min-block-size: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-layout-grid/ids-layout-grid-base.scss","webpack://./src/components/ids-layout-grid/ids-layout-grid.scss","webpack://./src/components/ids-layout-grid/ids-layout-grid-responsive.scss","webpack://./src/themes/mixins/ids-core-mixins.scss"],"names":[],"mappings":"AAAA,mBAAA;AACA;EACE,yBAAA;EACA,0DAAA;EACA,oDAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,oBAAA;ACCF;;ADEA,mBAAA;AAoCA,kCAAA;AACA;;EAEE,aAAA;EACA,uDAAA;EACA,cAjCY;EAkCZ,sBAAA;EACA,sBAAA;AClCF;;ADqCA;EACE,aAAA;AClCF;;ADqCA,wBAAA;AAEE;;EAEE,WAAA;EACA,oFAAA;ACnCJ;;ADsCE;;EAEE,0BAAA;ACnCJ;;ADsCE;;EAEE,oBAdS;ACrBb;;ADsCE;;EAEE,kBAnBS;AChBb;;ADiBE;;EAEE,WAAA;EACA,oFAAA;ACdJ;;ADiBE;;EAEE,0BAAA;ACdJ;;ADiBE;;EAEE,oBAdS;ACAb;;ADiBE;;EAEE,kBAnBS;ACKb;;ADJE;;EAEE,WAAA;EACA,oFAAA;ACOJ;;ADJE;;EAEE,0BAAA;ACOJ;;ADJE;;EAEE,oBAdS;ACqBb;;ADJE;;EAEE,kBAnBS;AC0Bb;;ADzBE;;EAEE,WAAA;EACA,oFAAA;AC4BJ;;ADzBE;;EAEE,0BAAA;AC4BJ;;ADzBE;;EAEE,oBAdS;AC0Cb;;ADzBE;;EAEE,kBAnBS;AC+Cb;;AD9CE;;EAEE,WAAA;EACA,oFAAA;ACiDJ;;AD9CE;;EAEE,0BAAA;ACiDJ;;AD9CE;;EAEE,oBAdS;AC+Db;;AD9CE;;EAEE,kBAnBS;ACoEb;;ADnEE;;EAEE,WAAA;EACA,oFAAA;ACsEJ;;ADnEE;;EAEE,0BAAA;ACsEJ;;ADnEE;;EAEE,oBAdS;ACoFb;;ADnEE;;EAEE,kBAnBS;ACyFb;;ADxFE;;EAEE,WAAA;EACA,oFAAA;AC2FJ;;ADxFE;;EAEE,0BAAA;AC2FJ;;ADxFE;;EAEE,oBAdS;ACyGb;;ADxFE;;EAEE,kBAnBS;AC8Gb;;AD7GE;;EAEE,WAAA;EACA,oFAAA;ACgHJ;;AD7GE;;EAEE,0BAAA;ACgHJ;;AD7GE;;EAEE,oBAdS;AC8Hb;;AD7GE;;EAEE,kBAnBS;ACmIb;;ADlIE;;EAEE,WAAA;EACA,oFAAA;ACqIJ;;ADlIE;;EAEE,0BAAA;ACqIJ;;ADlIE;;EAEE,oBAdS;ACmJb;;ADlIE;;EAEE,kBAnBS;ACwJb;;ADvJE;;EAEE,WAAA;EACA,qFAAA;AC0JJ;;ADvJE;;EAEE,4BAAA;AC0JJ;;ADvJE;;EAEE,qBAdS;ACwKb;;ADvJE;;EAEE,mBAnBS;AC6Kb;;AD5KE;;EAEE,WAAA;EACA,qFAAA;AC+KJ;;AD5KE;;EAEE,4BAAA;AC+KJ;;AD5KE;;EAEE,qBAdS;AC6Lb;;AD5KE;;EAEE,mBAnBS;ACkMb;;ADjME;;EAEE,WAAA;EACA,qFAAA;ACoMJ;;ADjME;;EAEE,4BAAA;ACoMJ;;ADjME;;EAEE,qBAdS;ACkNb;;ADjME;;EAEE,mBAnBS;ACuNb;;ADtNE;;EAEE,WAAA;EACA,qFAAA;ACyNJ;;ADtNE;;EAEE,4BAAA;ACyNJ;;ADtNE;;EAEE,qBAdS;ACuOb;;ADtNE;;EAEE,mBAnBS;AC4Ob;;AD3OE;;EAEE,WAAA;EACA,qFAAA;AC8OJ;;AD3OE;;EAEE,4BAAA;AC8OJ;;AD3OE;;EAEE,qBAdS;AC4Pb;;AD3OE;;EAEE,mBAnBS;ACiQb;;ADhQE;;EAEE,WAAA;EACA,qFAAA;ACmQJ;;ADhQE;;EAEE,4BAAA;ACmQJ;;ADhQE;;EAEE,qBAdS;ACiRb;;ADhQE;;EAEE,mBAnBS;ACsRb;;ADrRE;;EAEE,WAAA;EACA,qFAAA;ACwRJ;;ADrRE;;EAEE,4BAAA;ACwRJ;;ADrRE;;EAEE,qBAdS;ACsSb;;ADrRE;;EAEE,mBAnBS;AC2Sb;;AD1SE;;EAEE,WAAA;EACA,qFAAA;AC6SJ;;AD1SE;;EAEE,4BAAA;AC6SJ;;AD1SE;;EAEE,qBAdS;AC2Tb;;AD1SE;;EAEE,mBAnBS;ACgUb;;AD/TE;;EAEE,WAAA;EACA,qFAAA;ACkUJ;;AD/TE;;EAEE,4BAAA;ACkUJ;;AD/TE;;EAEE,qBAdS;ACgVb;;AD/TE;;EAEE,mBAnBS;ACqVb;;ADpVE;;EAEE,WAAA;EACA,qFAAA;ACuVJ;;ADpVE;;EAEE,4BAAA;ACuVJ;;ADpVE;;EAEE,qBAdS;ACqWb;;ADpVE;;EAEE,mBAnBS;AC0Wb;;ADzWE;;EAEE,WAAA;EACA,qFAAA;AC4WJ;;ADzWE;;EAEE,4BAAA;AC4WJ;;ADzWE;;EAEE,qBAdS;AC0Xb;;ADzWE;;EAEE,mBAnBS;AC+Xb;;AD9XE;;EAEE,WAAA;EACA,qFAAA;ACiYJ;;AD9XE;;EAEE,4BAAA;ACiYJ;;AD9XE;;EAEE,qBAdS;AC+Yb;;AD9XE;;EAEE,mBAnBS;ACoZb;;ADnZE;;EAEE,WAAA;EACA,qFAAA;ACsZJ;;ADnZE;;EAEE,4BAAA;ACsZJ;;ADnZE;;EAEE,qBAdS;ACoab;;ADnZE;;EAEE,mBAnBS;ACyab;;ADxaE;;EAEE,WAAA;EACA,qFAAA;AC2aJ;;ADxaE;;EAEE,4BAAA;AC2aJ;;ADxaE;;EAEE,qBAdS;ACybb;;ADxaE;;EAEE,mBAnBS;AC8bb;;AD7bE;;EAEE,WAAA;EACA,qFAAA;ACgcJ;;AD7bE;;EAEE,4BAAA;ACgcJ;;AD7bE;;EAEE,qBAdS;AC8cb;;AD7bE;;EAEE,mBAnBS;ACmdb;;AD5bA,qBAAA;AAEE;;EAEE,mFAAA;AC8bJ;;AD3bE;;EAEE,uBAAA;AC8bJ;;AD3bE;;EAEE,QAbS;AC2cb;;AD3bE;;EAEE,SAAA;AC8bJ;;AD/cE;;EAEE,mFAAA;ACkdJ;;AD/cE;;EAEE,uBAAA;ACkdJ;;AD/cE;;EAEE,QAbS;AC+db;;AD/cE;;EAEE,SAAA;ACkdJ;;ADneE;;EAEE,mFAAA;ACseJ;;ADneE;;EAEE,uBAAA;ACseJ;;ADneE;;EAEE,QAbS;ACmfb;;ADneE;;EAEE,SAAA;ACseJ;;ADvfE;;EAEE,mFAAA;AC0fJ;;ADvfE;;EAEE,uBAAA;AC0fJ;;ADvfE;;EAEE,QAbS;ACugBb;;ADvfE;;EAEE,SAAA;AC0fJ;;AD3gBE;;EAEE,mFAAA;AC8gBJ;;AD3gBE;;EAEE,uBAAA;AC8gBJ;;AD3gBE;;EAEE,QAbS;AC2hBb;;AD3gBE;;EAEE,SAAA;AC8gBJ;;AD/hBE;;EAEE,mFAAA;ACkiBJ;;AD/hBE;;EAEE,uBAAA;ACkiBJ;;AD/hBE;;EAEE,QAbS;AC+iBb;;AD/hBE;;EAEE,SAAA;ACkiBJ;;ADnjBE;;EAEE,mFAAA;ACsjBJ;;ADnjBE;;EAEE,uBAAA;ACsjBJ;;ADnjBE;;EAEE,QAbS;ACmkBb;;ADnjBE;;EAEE,SAAA;ACsjBJ;;ADvkBE;;EAEE,mFAAA;AC0kBJ;;ADvkBE;;EAEE,uBAAA;AC0kBJ;;ADvkBE;;EAEE,QAbS;ACulBb;;ADvkBE;;EAEE,SAAA;AC0kBJ;;AD3lBE;;EAEE,mFAAA;AC8lBJ;;AD3lBE;;EAEE,uBAAA;AC8lBJ;;AD3lBE;;EAEE,QAbS;AC2mBb;;AD3lBE;;EAEE,SAAA;AC8lBJ;;AD/mBE;;EAEE,oFAAA;ACknBJ;;AD/mBE;;EAEE,yBAAA;ACknBJ;;AD/mBE;;EAEE,SAbS;AC+nBb;;AD/mBE;;EAEE,SAAA;ACknBJ;;ADnoBE;;EAEE,oFAAA;ACsoBJ;;ADnoBE;;EAEE,yBAAA;ACsoBJ;;ADnoBE;;EAEE,SAbS;ACmpBb;;ADnoBE;;EAEE,SAAA;ACsoBJ;;ADvpBE;;EAEE,oFAAA;AC0pBJ;;ADvpBE;;EAEE,yBAAA;AC0pBJ;;ADvpBE;;EAEE,SAbS;ACuqBb;;ADvpBE;;EAEE,SAAA;AC0pBJ;;AD3qBE;;EAEE,oFAAA;AC8qBJ;;AD3qBE;;EAEE,yBAAA;AC8qBJ;;AD3qBE;;EAEE,SAbS;AC2rBb;;AD3qBE;;EAEE,SAAA;AC8qBJ;;AD/rBE;;EAEE,oFAAA;ACksBJ;;AD/rBE;;EAEE,yBAAA;ACksBJ;;AD/rBE;;EAEE,SAbS;AC+sBb;;AD/rBE;;EAEE,SAAA;ACksBJ;;ADntBE;;EAEE,oFAAA;ACstBJ;;ADntBE;;EAEE,yBAAA;ACstBJ;;ADntBE;;EAEE,SAbS;ACmuBb;;ADntBE;;EAEE,SAAA;ACstBJ;;ADvuBE;;EAEE,oFAAA;AC0uBJ;;ADvuBE;;EAEE,yBAAA;AC0uBJ;;ADvuBE;;EAEE,SAbS;ACuvBb;;ADvuBE;;EAEE,SAAA;AC0uBJ;;AD3vBE;;EAEE,oFAAA;AC8vBJ;;AD3vBE;;EAEE,yBAAA;AC8vBJ;;AD3vBE;;EAEE,SAbS;AC2wBb;;AD3vBE;;EAEE,SAAA;AC8vBJ;;AD/wBE;;EAEE,oFAAA;ACkxBJ;;AD/wBE;;EAEE,yBAAA;ACkxBJ;;AD/wBE;;EAEE,SAbS;AC+xBb;;AD/wBE;;EAEE,SAAA;ACkxBJ;;ADnyBE;;EAEE,oFAAA;ACsyBJ;;ADnyBE;;EAEE,yBAAA;ACsyBJ;;ADnyBE;;EAEE,SAbS;ACmzBb;;ADnyBE;;EAEE,SAAA;ACsyBJ;;ADvzBE;;EAEE,oFAAA;AC0zBJ;;ADvzBE;;EAEE,yBAAA;AC0zBJ;;ADvzBE;;EAEE,SAbS;ACu0Bb;;ADvzBE;;EAEE,SAAA;AC0zBJ;;AD30BE;;EAEE,oFAAA;AC80BJ;;AD30BE;;EAEE,yBAAA;AC80BJ;;AD30BE;;EAEE,SAbS;AC21Bb;;AD30BE;;EAEE,SAAA;AC80BJ;;AD/1BE;;EAEE,oFAAA;ACk2BJ;;AD/1BE;;EAEE,yBAAA;ACk2BJ;;AD/1BE;;EAEE,SAbS;AC+2Bb;;AD/1BE;;EAEE,SAAA;ACk2BJ;;ADn3BE;;EAEE,oFAAA;ACs3BJ;;ADn3BE;;EAEE,yBAAA;ACs3BJ;;ADn3BE;;EAEE,SAbS;ACm4Bb;;ADn3BE;;EAEE,SAAA;ACs3BJ;;ADv4BE;;EAEE,oFAAA;AC04BJ;;ADv4BE;;EAEE,yBAAA;AC04BJ;;ADv4BE;;EAEE,SAbS;ACu5Bb;;ADv4BE;;EAEE,SAAA;AC04BJ;;AD35BE;;EAEE,oFAAA;AC85BJ;;AD35BE;;EAEE,yBAAA;AC85BJ;;AD35BE;;EAEE,SAbS;AC26Bb;;AD35BE;;EAEE,SAAA;AC85BJ;;AD/6BE;;EAEE,oFAAA;ACk7BJ;;AD/6BE;;EAEE,yBAAA;ACk7BJ;;AD/6BE;;EAEE,SAbS;AC+7Bb;;AD/6BE;;EAEE,SAAA;ACk7BJ;;ADn8BE;;EAEE,oFAAA;ACs8BJ;;ADn8BE;;EAEE,yBAAA;ACs8BJ;;ADn8BE;;EAEE,SAbS;ACm9Bb;;ADn8BE;;EAEE,SAAA;ACs8BJ;;ADv9BE;;EAEE,oFAAA;AC09BJ;;ADv9BE;;EAEE,yBAAA;AC09BJ;;ADv9BE;;EAEE,SAbS;ACu+Bb;;ADv9BE;;EAEE,SAAA;AC09BJ;;AD3+BE;;EAEE,oFAAA;AC8+BJ;;AD3+BE;;EAEE,yBAAA;AC8+BJ;;AD3+BE;;EAEE,SAbS;AC2/Bb;;AD3+BE;;EAEE,SAAA;AC8+BJ;;AD//BE;;EAEE,oFAAA;ACkgCJ;;AD//BE;;EAEE,yBAAA;ACkgCJ;;AD//BE;;EAEE,SAbS;AC+gCb;;AD//BE;;EAEE,SAAA;ACkgCJ;;ADnhCE;;EAEE,oFAAA;ACshCJ;;ADnhCE;;EAEE,yBAAA;ACshCJ;;ADnhCE;;EAEE,SAbS;ACmiCb;;ADnhCE;;EAEE,SAAA;ACshCJ;;ADviCE;;EAEE,oFAAA;AC0iCJ;;ADviCE;;EAEE,yBAAA;AC0iCJ;;ADviCE;;EAEE,SAbS;ACujCb;;ADviCE;;EAEE,SAAA;AC0iCJ;;AD3jCE;;EAEE,oFAAA;AC8jCJ;;AD3jCE;;EAEE,yBAAA;AC8jCJ;;AD3jCE;;EAEE,SAbS;AC2kCb;;AD3jCE;;EAEE,SAAA;AC8jCJ;;AD/kCE;;EAEE,oFAAA;ACklCJ;;AD/kCE;;EAEE,yBAAA;ACklCJ;;AD/kCE;;EAEE,SAbS;AC+lCb;;AD/kCE;;EAEE,SAAA;ACklCJ;;ADnmCE;;EAEE,oFAAA;ACsmCJ;;ADnmCE;;EAEE,yBAAA;ACsmCJ;;ADnmCE;;EAEE,SAbS;ACmnCb;;ADnmCE;;EAEE,SAAA;ACsmCJ;;ADvnCE;;EAEE,oFAAA;AC0nCJ;;ADvnCE;;EAEE,yBAAA;AC0nCJ;;ADvnCE;;EAEE,SAbS;ACuoCb;;ADvnCE;;EAEE,SAAA;AC0nCJ;;AD3oCE;;EAEE,oFAAA;AC8oCJ;;AD3oCE;;EAEE,yBAAA;AC8oCJ;;AD3oCE;;EAEE,SAbS;AC2pCb;;AD3oCE;;EAEE,SAAA;AC8oCJ;;AD/pCE;;EAEE,oFAAA;ACkqCJ;;AD/pCE;;EAEE,yBAAA;ACkqCJ;;AD/pCE;;EAEE,SAbS;AC+qCb;;AD/pCE;;EAEE,SAAA;ACkqCJ;;ADnrCE;;EAEE,oFAAA;ACsrCJ;;ADnrCE;;EAEE,yBAAA;ACsrCJ;;ADnrCE;;EAEE,SAbS;ACmsCb;;ADnrCE;;EAEE,SAAA;ACsrCJ;;ADvsCE;;EAEE,oFAAA;AC0sCJ;;ADvsCE;;EAEE,yBAAA;AC0sCJ;;ADvsCE;;EAEE,SAbS;ACutCb;;ADvsCE;;EAEE,SAAA;AC0sCJ;;AD3tCE;;EAEE,oFAAA;AC8tCJ;;AD3tCE;;EAEE,yBAAA;AC8tCJ;;AD3tCE;;EAEE,SAbS;AC2uCb;;AD3tCE;;EAEE,SAAA;AC8tCJ;;AD/uCE;;EAEE,oFAAA;ACkvCJ;;AD/uCE;;EAEE,yBAAA;ACkvCJ;;AD/uCE;;EAEE,SAbS;AC+vCb;;AD/uCE;;EAEE,SAAA;ACkvCJ;;ADnwCE;;EAEE,oFAAA;ACswCJ;;ADnwCE;;EAEE,yBAAA;ACswCJ;;ADnwCE;;EAEE,SAbS;ACmxCb;;ADnwCE;;EAEE,SAAA;ACswCJ;;ADvxCE;;EAEE,oFAAA;AC0xCJ;;ADvxCE;;EAEE,yBAAA;AC0xCJ;;ADvxCE;;EAEE,SAbS;ACuyCb;;ADvxCE;;EAEE,SAAA;AC0xCJ;;AD3yCE;;EAEE,oFAAA;AC8yCJ;;AD3yCE;;EAEE,yBAAA;AC8yCJ;;AD3yCE;;EAEE,SAbS;AC2zCb;;AD3yCE;;EAEE,SAAA;AC8yCJ;;AD/zCE;;EAEE,oFAAA;ACk0CJ;;AD/zCE;;EAEE,yBAAA;ACk0CJ;;AD/zCE;;EAEE,SAbS;AC+0Cb;;AD/zCE;;EAEE,SAAA;ACk0CJ;;ADn1CE;;EAEE,oFAAA;ACs1CJ;;ADn1CE;;EAEE,yBAAA;ACs1CJ;;ADn1CE;;EAEE,SAbS;ACm2Cb;;ADn1CE;;EAEE,SAAA;ACs1CJ;;ADv2CE;;EAEE,oFAAA;AC02CJ;;ADv2CE;;EAEE,yBAAA;AC02CJ;;ADv2CE;;EAEE,SAbS;ACu3Cb;;ADv2CE;;EAEE,SAAA;AC02CJ;;AD33CE;;EAEE,oFAAA;AC83CJ;;AD33CE;;EAEE,yBAAA;AC83CJ;;AD33CE;;EAEE,SAbS;AC24Cb;;AD33CE;;EAEE,SAAA;AC83CJ;;AD/4CE;;EAEE,oFAAA;ACk5CJ;;AD/4CE;;EAEE,yBAAA;ACk5CJ;;AD/4CE;;EAEE,SAbS;AC+5Cb;;AD/4CE;;EAEE,SAAA;ACk5CJ;;AC19CA;EAEI;;IAEE,WAAA;IACA,oFAAA;ED49CJ;EC/9CE;;IAEE,WAAA;IACA,oFAAA;EDi+CJ;ECp+CE;;IAEE,WAAA;IACA,oFAAA;EDs+CJ;ECz+CE;;IAEE,WAAA;IACA,oFAAA;ED2+CJ;EC9+CE;;IAEE,WAAA;IACA,oFAAA;EDg/CJ;ECn/CE;;IAEE,WAAA;IACA,oFAAA;EDq/CJ;ECx/CE;;IAEE,WAAA;IACA,oFAAA;ED0/CJ;EC7/CE;;IAEE,WAAA;IACA,oFAAA;ED+/CJ;EClgDE;;IAEE,WAAA;IACA,oFAAA;EDogDJ;ECvgDE;;IAEE,WAAA;IACA,qFAAA;EDygDJ;EC5gDE;;IAEE,WAAA;IACA,qFAAA;ED8gDJ;ECjhDE;;IAEE,WAAA;IACA,qFAAA;EDmhDJ;ECthDE;;IAEE,WAAA;IACA,qFAAA;EDwhDJ;EC3hDE;;IAEE,WAAA;IACA,qFAAA;ED6hDJ;EChiDE;;IAEE,WAAA;IACA,qFAAA;EDkiDJ;ECriDE;;IAEE,WAAA;IACA,qFAAA;EDuiDJ;EC1iDE;;IAEE,WAAA;IACA,qFAAA;ED4iDJ;EC/iDE;;IAEE,WAAA;IACA,qFAAA;EDijDJ;ECpjDE;;IAEE,WAAA;IACA,qFAAA;EDsjDJ;ECzjDE;;IAEE,WAAA;IACA,qFAAA;ED2jDJ;EC9jDE;;IAEE,WAAA;IACA,qFAAA;EDgkDJ;ECnkDE;;IAEE,WAAA;IACA,qFAAA;EDqkDJ;ECxkDE;;IAEE,WAAA;IACA,qFAAA;ED0kDJ;EC7kDE;;IAEE,WAAA;IACA,qFAAA;ED+kDJ;EC1kDE;;IAEE,6CAAA;ED4kDJ;EC9kDE;;IAEE,6CAAA;EDglDJ;ECllDE;;IAEE,6CAAA;EDolDJ;ECtlDE;;IAEE,6CAAA;EDwlDJ;EC1lDE;;IAEE,6CAAA;ED4lDJ;EC9lDE;;IAEE,6CAAA;EDgmDJ;EClmDE;;IAEE,6CAAA;EDomDJ;ECtmDE;;IAEE,6CAAA;EDwmDJ;EC1mDE;;IAEE,6CAAA;ED4mDJ;EC9mDE;;IAEE,8CAAA;EDgnDJ;EClnDE;;IAEE,8CAAA;EDonDJ;ECtnDE;;IAEE,8CAAA;EDwnDJ;EC1nDE;;IAEE,8CAAA;ED4nDJ;EC9nDE;;IAEE,8CAAA;EDgoDJ;ECloDE;;IAEE,8CAAA;EDooDJ;ECtoDE;;IAEE,8CAAA;EDwoDJ;EC1oDE;;IAEE,8CAAA;ED4oDJ;EC9oDE;;IAEE,8CAAA;EDgpDJ;EClpDE;;IAEE,8CAAA;EDopDJ;ECtpDE;;IAEE,8CAAA;EDwpDJ;EC1pDE;;IAEE,8CAAA;ED4pDJ;EC9pDE;;IAEE,8CAAA;EDgqDJ;EClqDE;;IAEE,8CAAA;EDoqDJ;ECtqDE;;IAEE,8CAAA;EDwqDJ;EC1qDE;;IAEE,8CAAA;ED4qDJ;EC9qDE;;IAEE,8CAAA;EDgrDJ;EClrDE;;IAEE,8CAAA;EDorDJ;ECtrDE;;IAEE,8CAAA;EDwrDJ;EC1rDE;;IAEE,8CAAA;ED4rDJ;EC9rDE;;IAEE,8CAAA;EDgsDJ;EClsDE;;IAEE,8CAAA;EDosDJ;ECtsDE;;IAEE,8CAAA;EDwsDJ;EC1sDE;;IAEE,8CAAA;ED4sDJ;EC9sDE;;IAEE,8CAAA;EDgtDJ;ECltDE;;IAEE,8CAAA;EDotDJ;ECttDE;;IAEE,8CAAA;EDwtDJ;EC1tDE;;IAEE,8CAAA;ED4tDJ;EC9tDE;;IAEE,8CAAA;EDguDJ;ECluDE;;IAEE,8CAAA;EDouDJ;ECtuDE;;IAEE,8CAAA;EDwuDJ;EC1uDE;;IAEE,8CAAA;ED4uDJ;EC9uDE;;IAEE,8CAAA;EDgvDJ;EClvDE;;IAEE,8CAAA;EDovDJ;ECtvDE;;IAEE,8CAAA;EDwvDJ;EC1vDE;;IAEE,8CAAA;ED4vDJ;EC9vDE;;IAEE,8CAAA;EDgwDJ;EClwDE;;IAEE,8CAAA;EDowDJ;ECtwDE;;IAEE,8CAAA;EDwwDJ;EC1wDE;;IAEE,8CAAA;ED4wDJ;EC9wDE;;IAEE,8CAAA;EDgxDJ;EC5wDA;IAAkD,mBAAA;ED+wDlD;EC9wDA;IAAqD,sBAAA;EDixDrD;EChxDA;IAAsD,qBAAA;EDmxDtD;EClxDA;IAA8D,yBAAA;EDqxD9D;ECpxDA;IAAiE,4BAAA;EDuxDjE;AACF;ACpxDA;EAEI;;IAEE,WAAA;IACA,oFAAA;EDqxDJ;ECxxDE;;IAEE,WAAA;IACA,oFAAA;ED0xDJ;EC7xDE;;IAEE,WAAA;IACA,oFAAA;ED+xDJ;EClyDE;;IAEE,WAAA;IACA,oFAAA;EDoyDJ;ECvyDE;;IAEE,WAAA;IACA,oFAAA;EDyyDJ;EC5yDE;;IAEE,WAAA;IACA,oFAAA;ED8yDJ;ECjzDE;;IAEE,WAAA;IACA,oFAAA;EDmzDJ;ECtzDE;;IAEE,WAAA;IACA,oFAAA;EDwzDJ;EC3zDE;;IAEE,WAAA;IACA,oFAAA;ED6zDJ;ECh0DE;;IAEE,WAAA;IACA,qFAAA;EDk0DJ;ECr0DE;;IAEE,WAAA;IACA,qFAAA;EDu0DJ;EC10DE;;IAEE,WAAA;IACA,qFAAA;ED40DJ;EC/0DE;;IAEE,WAAA;IACA,qFAAA;EDi1DJ;ECp1DE;;IAEE,WAAA;IACA,qFAAA;EDs1DJ;ECz1DE;;IAEE,WAAA;IACA,qFAAA;ED21DJ;EC91DE;;IAEE,WAAA;IACA,qFAAA;EDg2DJ;ECn2DE;;IAEE,WAAA;IACA,qFAAA;EDq2DJ;ECx2DE;;IAEE,WAAA;IACA,qFAAA;ED02DJ;EC72DE;;IAEE,WAAA;IACA,qFAAA;ED+2DJ;ECl3DE;;IAEE,WAAA;IACA,qFAAA;EDo3DJ;ECv3DE;;IAEE,WAAA;IACA,qFAAA;EDy3DJ;EC53DE;;IAEE,WAAA;IACA,qFAAA;ED83DJ;ECj4DE;;IAEE,WAAA;IACA,qFAAA;EDm4DJ;ECt4DE;;IAEE,WAAA;IACA,qFAAA;EDw4DJ;ECn4DE;;IAEE,6CAAA;EDq4DJ;ECv4DE;;IAEE,6CAAA;EDy4DJ;EC34DE;;IAEE,6CAAA;ED64DJ;EC/4DE;;IAEE,6CAAA;EDi5DJ;ECn5DE;;IAEE,6CAAA;EDq5DJ;ECv5DE;;IAEE,6CAAA;EDy5DJ;EC35DE;;IAEE,6CAAA;ED65DJ;EC/5DE;;IAEE,6CAAA;EDi6DJ;ECn6DE;;IAEE,6CAAA;EDq6DJ;ECv6DE;;IAEE,8CAAA;EDy6DJ;EC36DE;;IAEE,8CAAA;ED66DJ;EC/6DE;;IAEE,8CAAA;EDi7DJ;ECn7DE;;IAEE,8CAAA;EDq7DJ;ECv7DE;;IAEE,8CAAA;EDy7DJ;EC37DE;;IAEE,8CAAA;ED67DJ;EC/7DE;;IAEE,8CAAA;EDi8DJ;ECn8DE;;IAEE,8CAAA;EDq8DJ;ECv8DE;;IAEE,8CAAA;EDy8DJ;EC38DE;;IAEE,8CAAA;ED68DJ;EC/8DE;;IAEE,8CAAA;EDi9DJ;ECn9DE;;IAEE,8CAAA;EDq9DJ;ECv9DE;;IAEE,8CAAA;EDy9DJ;EC39DE;;IAEE,8CAAA;ED69DJ;EC/9DE;;IAEE,8CAAA;EDi+DJ;ECn+DE;;IAEE,8CAAA;EDq+DJ;ECv+DE;;IAEE,8CAAA;EDy+DJ;EC3+DE;;IAEE,8CAAA;ED6+DJ;EC/+DE;;IAEE,8CAAA;EDi/DJ;ECn/DE;;IAEE,8CAAA;EDq/DJ;ECv/DE;;IAEE,8CAAA;EDy/DJ;EC3/DE;;IAEE,8CAAA;ED6/DJ;EC//DE;;IAEE,8CAAA;EDigEJ;ECngEE;;IAEE,8CAAA;EDqgEJ;ECvgEE;;IAEE,8CAAA;EDygEJ;EC3gEE;;IAEE,8CAAA;ED6gEJ;EC/gEE;;IAEE,8CAAA;EDihEJ;ECnhEE;;IAEE,8CAAA;EDqhEJ;ECvhEE;;IAEE,8CAAA;EDyhEJ;EC3hEE;;IAEE,8CAAA;ED6hEJ;EC/hEE;;IAEE,8CAAA;EDiiEJ;ECniEE;;IAEE,8CAAA;EDqiEJ;ECviEE;;IAEE,8CAAA;EDyiEJ;EC3iEE;;IAEE,8CAAA;ED6iEJ;EC/iEE;;IAEE,8CAAA;EDijEJ;ECnjEE;;IAEE,8CAAA;EDqjEJ;ECvjEE;;IAEE,8CAAA;EDyjEJ;EC3jEE;;IAEE,8CAAA;ED6jEJ;EC/jEE;;IAEE,8CAAA;EDikEJ;ECnkEE;;IAEE,8CAAA;EDqkEJ;ECvkEE;;IAEE,8CAAA;EDykEJ;ECtkEA;IAAkD,mBAAA;EDykElD;ECxkEA;IAAqD,sBAAA;ED2kErD;EC1kEA;IAAsD,qBAAA;ED6kEtD;EC5kEA;IAA8D,yBAAA;ED+kE9D;EC9kEA;IAAiE,4BAAA;EDilEjE;AACF;AC9kEA;EAEI;;IAEE,WAAA;IACA,oFAAA;ED+kEJ;ECllEE;;IAEE,WAAA;IACA,oFAAA;EDolEJ;ECvlEE;;IAEE,WAAA;IACA,oFAAA;EDylEJ;EC5lEE;;IAEE,WAAA;IACA,oFAAA;ED8lEJ;ECjmEE;;IAEE,WAAA;IACA,oFAAA;EDmmEJ;ECtmEE;;IAEE,WAAA;IACA,oFAAA;EDwmEJ;EC3mEE;;IAEE,WAAA;IACA,oFAAA;ED6mEJ;EChnEE;;IAEE,WAAA;IACA,oFAAA;EDknEJ;ECrnEE;;IAEE,WAAA;IACA,oFAAA;EDunEJ;EC1nEE;;IAEE,WAAA;IACA,qFAAA;ED4nEJ;EC/nEE;;IAEE,WAAA;IACA,qFAAA;EDioEJ;ECpoEE;;IAEE,WAAA;IACA,qFAAA;EDsoEJ;ECzoEE;;IAEE,WAAA;IACA,qFAAA;ED2oEJ;EC9oEE;;IAEE,WAAA;IACA,qFAAA;EDgpEJ;ECnpEE;;IAEE,WAAA;IACA,qFAAA;EDqpEJ;ECxpEE;;IAEE,WAAA;IACA,qFAAA;ED0pEJ;EC7pEE;;IAEE,WAAA;IACA,qFAAA;ED+pEJ;EClqEE;;IAEE,WAAA;IACA,qFAAA;EDoqEJ;ECvqEE;;IAEE,WAAA;IACA,qFAAA;EDyqEJ;EC5qEE;;IAEE,WAAA;IACA,qFAAA;ED8qEJ;ECjrEE;;IAEE,WAAA;IACA,qFAAA;EDmrEJ;ECtrEE;;IAEE,WAAA;IACA,qFAAA;EDwrEJ;EC3rEE;;IAEE,WAAA;IACA,qFAAA;ED6rEJ;EChsEE;;IAEE,WAAA;IACA,qFAAA;EDksEJ;EC7rEE;;IAEE,6CAAA;ED+rEJ;ECjsEE;;IAEE,6CAAA;EDmsEJ;ECrsEE;;IAEE,6CAAA;EDusEJ;ECzsEE;;IAEE,6CAAA;ED2sEJ;EC7sEE;;IAEE,6CAAA;ED+sEJ;ECjtEE;;IAEE,6CAAA;EDmtEJ;ECrtEE;;IAEE,6CAAA;EDutEJ;ECztEE;;IAEE,6CAAA;ED2tEJ;EC7tEE;;IAEE,6CAAA;ED+tEJ;ECjuEE;;IAEE,8CAAA;EDmuEJ;ECruEE;;IAEE,8CAAA;EDuuEJ;ECzuEE;;IAEE,8CAAA;ED2uEJ;EC7uEE;;IAEE,8CAAA;ED+uEJ;ECjvEE;;IAEE,8CAAA;EDmvEJ;ECrvEE;;IAEE,8CAAA;EDuvEJ;ECzvEE;;IAEE,8CAAA;ED2vEJ;EC7vEE;;IAEE,8CAAA;ED+vEJ;ECjwEE;;IAEE,8CAAA;EDmwEJ;ECrwEE;;IAEE,8CAAA;EDuwEJ;ECzwEE;;IAEE,8CAAA;ED2wEJ;EC7wEE;;IAEE,8CAAA;ED+wEJ;ECjxEE;;IAEE,8CAAA;EDmxEJ;ECrxEE;;IAEE,8CAAA;EDuxEJ;ECzxEE;;IAEE,8CAAA;ED2xEJ;EC7xEE;;IAEE,8CAAA;ED+xEJ;ECjyEE;;IAEE,8CAAA;EDmyEJ;ECryEE;;IAEE,8CAAA;EDuyEJ;ECzyEE;;IAEE,8CAAA;ED2yEJ;EC7yEE;;IAEE,8CAAA;ED+yEJ;ECjzEE;;IAEE,8CAAA;EDmzEJ;ECrzEE;;IAEE,8CAAA;EDuzEJ;ECzzEE;;IAEE,8CAAA;ED2zEJ;EC7zEE;;IAEE,8CAAA;ED+zEJ;ECj0EE;;IAEE,8CAAA;EDm0EJ;ECr0EE;;IAEE,8CAAA;EDu0EJ;ECz0EE;;IAEE,8CAAA;ED20EJ;EC70EE;;IAEE,8CAAA;ED+0EJ;ECj1EE;;IAEE,8CAAA;EDm1EJ;ECr1EE;;IAEE,8CAAA;EDu1EJ;ECz1EE;;IAEE,8CAAA;ED21EJ;EC71EE;;IAEE,8CAAA;ED+1EJ;ECj2EE;;IAEE,8CAAA;EDm2EJ;ECr2EE;;IAEE,8CAAA;EDu2EJ;ECz2EE;;IAEE,8CAAA;ED22EJ;EC72EE;;IAEE,8CAAA;ED+2EJ;ECj3EE;;IAEE,8CAAA;EDm3EJ;ECr3EE;;IAEE,8CAAA;EDu3EJ;ECz3EE;;IAEE,8CAAA;ED23EJ;EC73EE;;IAEE,8CAAA;ED+3EJ;ECj4EE;;IAEE,8CAAA;EDm4EJ;ECh4EA;IAAkD,mBAAA;EDm4ElD;ECl4EA;IAAqD,sBAAA;EDq4ErD;ECp4EA;IAAsD,qBAAA;EDu4EtD;ECt4EA;IAA8D,yBAAA;EDy4E9D;ECx4EA;IAAiE,4BAAA;ED24EjE;AACF;ACx4EA;EAEI;;IAEE,WAAA;IACA,oFAAA;EDy4EJ;EC54EE;;IAEE,WAAA;IACA,oFAAA;ED84EJ;ECj5EE;;IAEE,WAAA;IACA,oFAAA;EDm5EJ;ECt5EE;;IAEE,WAAA;IACA,oFAAA;EDw5EJ;EC35EE;;IAEE,WAAA;IACA,oFAAA;ED65EJ;ECh6EE;;IAEE,WAAA;IACA,oFAAA;EDk6EJ;ECr6EE;;IAEE,WAAA;IACA,oFAAA;EDu6EJ;EC16EE;;IAEE,WAAA;IACA,oFAAA;ED46EJ;EC/6EE;;IAEE,WAAA;IACA,oFAAA;EDi7EJ;ECp7EE;;IAEE,WAAA;IACA,qFAAA;EDs7EJ;ECz7EE;;IAEE,WAAA;IACA,qFAAA;ED27EJ;EC97EE;;IAEE,WAAA;IACA,qFAAA;EDg8EJ;ECn8EE;;IAEE,WAAA;IACA,qFAAA;EDq8EJ;ECx8EE;;IAEE,WAAA;IACA,qFAAA;ED08EJ;EC78EE;;IAEE,WAAA;IACA,qFAAA;ED+8EJ;ECl9EE;;IAEE,WAAA;IACA,qFAAA;EDo9EJ;ECv9EE;;IAEE,WAAA;IACA,qFAAA;EDy9EJ;EC59EE;;IAEE,WAAA;IACA,qFAAA;ED89EJ;ECj+EE;;IAEE,WAAA;IACA,qFAAA;EDm+EJ;ECt+EE;;IAEE,WAAA;IACA,qFAAA;EDw+EJ;EC3+EE;;IAEE,WAAA;IACA,qFAAA;ED6+EJ;ECh/EE;;IAEE,WAAA;IACA,qFAAA;EDk/EJ;ECr/EE;;IAEE,WAAA;IACA,qFAAA;EDu/EJ;EC1/EE;;IAEE,WAAA;IACA,qFAAA;ED4/EJ;ECv/EE;;IAEE,6CAAA;EDy/EJ;EC3/EE;;IAEE,6CAAA;ED6/EJ;EC//EE;;IAEE,6CAAA;EDigFJ;ECngFE;;IAEE,6CAAA;EDqgFJ;ECvgFE;;IAEE,6CAAA;EDygFJ;EC3gFE;;IAEE,6CAAA;ED6gFJ;EC/gFE;;IAEE,6CAAA;EDihFJ;ECnhFE;;IAEE,6CAAA;EDqhFJ;ECvhFE;;IAEE,6CAAA;EDyhFJ;EC3hFE;;IAEE,8CAAA;ED6hFJ;EC/hFE;;IAEE,8CAAA;EDiiFJ;ECniFE;;IAEE,8CAAA;EDqiFJ;ECviFE;;IAEE,8CAAA;EDyiFJ;EC3iFE;;IAEE,8CAAA;ED6iFJ;EC/iFE;;IAEE,8CAAA;EDijFJ;ECnjFE;;IAEE,8CAAA;EDqjFJ;ECvjFE;;IAEE,8CAAA;EDyjFJ;EC3jFE;;IAEE,8CAAA;ED6jFJ;EC/jFE;;IAEE,8CAAA;EDikFJ;ECnkFE;;IAEE,8CAAA;EDqkFJ;ECvkFE;;IAEE,8CAAA;EDykFJ;EC3kFE;;IAEE,8CAAA;ED6kFJ;EC/kFE;;IAEE,8CAAA;EDilFJ;ECnlFE;;IAEE,8CAAA;EDqlFJ;ECvlFE;;IAEE,8CAAA;EDylFJ;EC3lFE;;IAEE,8CAAA;ED6lFJ;EC/lFE;;IAEE,8CAAA;EDimFJ;ECnmFE;;IAEE,8CAAA;EDqmFJ;ECvmFE;;IAEE,8CAAA;EDymFJ;EC3mFE;;IAEE,8CAAA;ED6mFJ;EC/mFE;;IAEE,8CAAA;EDinFJ;ECnnFE;;IAEE,8CAAA;EDqnFJ;ECvnFE;;IAEE,8CAAA;EDynFJ;EC3nFE;;IAEE,8CAAA;ED6nFJ;EC/nFE;;IAEE,8CAAA;EDioFJ;ECnoFE;;IAEE,8CAAA;EDqoFJ;ECvoFE;;IAEE,8CAAA;EDyoFJ;EC3oFE;;IAEE,8CAAA;ED6oFJ;EC/oFE;;IAEE,8CAAA;EDipFJ;ECnpFE;;IAEE,8CAAA;EDqpFJ;ECvpFE;;IAEE,8CAAA;EDypFJ;EC3pFE;;IAEE,8CAAA;ED6pFJ;EC/pFE;;IAEE,8CAAA;EDiqFJ;ECnqFE;;IAEE,8CAAA;EDqqFJ;ECvqFE;;IAEE,8CAAA;EDyqFJ;EC3qFE;;IAEE,8CAAA;ED6qFJ;EC/qFE;;IAEE,8CAAA;EDirFJ;ECnrFE;;IAEE,8CAAA;EDqrFJ;ECvrFE;;IAEE,8CAAA;EDyrFJ;EC3rFE;;IAEE,8CAAA;ED6rFJ;EC1rFA;IAAkD,mBAAA;ED6rFlD;EC5rFA;IAAqD,sBAAA;ED+rFrD;EC9rFA;IAAsD,qBAAA;EDisFtD;EChsFA;IAA8D,yBAAA;EDmsF9D;EClsFA;IAAiE,4BAAA;EDqsFjE;AACF;AClsFA;EAEI;;IAEE,WAAA;IACA,oFAAA;EDmsFJ;ECtsFE;;IAEE,WAAA;IACA,oFAAA;EDwsFJ;EC3sFE;;IAEE,WAAA;IACA,oFAAA;ED6sFJ;EChtFE;;IAEE,WAAA;IACA,oFAAA;EDktFJ;ECrtFE;;IAEE,WAAA;IACA,oFAAA;EDutFJ;EC1tFE;;IAEE,WAAA;IACA,oFAAA;ED4tFJ;EC/tFE;;IAEE,WAAA;IACA,oFAAA;EDiuFJ;ECpuFE;;IAEE,WAAA;IACA,oFAAA;EDsuFJ;ECzuFE;;IAEE,WAAA;IACA,oFAAA;ED2uFJ;EC9uFE;;IAEE,WAAA;IACA,qFAAA;EDgvFJ;ECnvFE;;IAEE,WAAA;IACA,qFAAA;EDqvFJ;ECxvFE;;IAEE,WAAA;IACA,qFAAA;ED0vFJ;EC7vFE;;IAEE,WAAA;IACA,qFAAA;ED+vFJ;EClwFE;;IAEE,WAAA;IACA,qFAAA;EDowFJ;ECvwFE;;IAEE,WAAA;IACA,qFAAA;EDywFJ;EC5wFE;;IAEE,WAAA;IACA,qFAAA;ED8wFJ;ECjxFE;;IAEE,WAAA;IACA,qFAAA;EDmxFJ;ECtxFE;;IAEE,WAAA;IACA,qFAAA;EDwxFJ;EC3xFE;;IAEE,WAAA;IACA,qFAAA;ED6xFJ;EChyFE;;IAEE,WAAA;IACA,qFAAA;EDkyFJ;ECryFE;;IAEE,WAAA;IACA,qFAAA;EDuyFJ;EC1yFE;;IAEE,WAAA;IACA,qFAAA;ED4yFJ;EC/yFE;;IAEE,WAAA;IACA,qFAAA;EDizFJ;ECpzFE;;IAEE,WAAA;IACA,qFAAA;EDszFJ;ECjzFE;;IAEE,6CAAA;EDmzFJ;ECrzFE;;IAEE,6CAAA;EDuzFJ;ECzzFE;;IAEE,6CAAA;ED2zFJ;EC7zFE;;IAEE,6CAAA;ED+zFJ;ECj0FE;;IAEE,6CAAA;EDm0FJ;ECr0FE;;IAEE,6CAAA;EDu0FJ;ECz0FE;;IAEE,6CAAA;ED20FJ;EC70FE;;IAEE,6CAAA;ED+0FJ;ECj1FE;;IAEE,6CAAA;EDm1FJ;ECr1FE;;IAEE,8CAAA;EDu1FJ;ECz1FE;;IAEE,8CAAA;ED21FJ;EC71FE;;IAEE,8CAAA;ED+1FJ;ECj2FE;;IAEE,8CAAA;EDm2FJ;ECr2FE;;IAEE,8CAAA;EDu2FJ;ECz2FE;;IAEE,8CAAA;ED22FJ;EC72FE;;IAEE,8CAAA;ED+2FJ;ECj3FE;;IAEE,8CAAA;EDm3FJ;ECr3FE;;IAEE,8CAAA;EDu3FJ;ECz3FE;;IAEE,8CAAA;ED23FJ;EC73FE;;IAEE,8CAAA;ED+3FJ;ECj4FE;;IAEE,8CAAA;EDm4FJ;ECr4FE;;IAEE,8CAAA;EDu4FJ;ECz4FE;;IAEE,8CAAA;ED24FJ;EC74FE;;IAEE,8CAAA;ED+4FJ;ECj5FE;;IAEE,8CAAA;EDm5FJ;ECr5FE;;IAEE,8CAAA;EDu5FJ;ECz5FE;;IAEE,8CAAA;ED25FJ;EC75FE;;IAEE,8CAAA;ED+5FJ;ECj6FE;;IAEE,8CAAA;EDm6FJ;ECr6FE;;IAEE,8CAAA;EDu6FJ;ECz6FE;;IAEE,8CAAA;ED26FJ;EC76FE;;IAEE,8CAAA;ED+6FJ;ECj7FE;;IAEE,8CAAA;EDm7FJ;ECr7FE;;IAEE,8CAAA;EDu7FJ;ECz7FE;;IAEE,8CAAA;ED27FJ;EC77FE;;IAEE,8CAAA;ED+7FJ;ECj8FE;;IAEE,8CAAA;EDm8FJ;ECr8FE;;IAEE,8CAAA;EDu8FJ;ECz8FE;;IAEE,8CAAA;ED28FJ;EC78FE;;IAEE,8CAAA;ED+8FJ;ECj9FE;;IAEE,8CAAA;EDm9FJ;ECr9FE;;IAEE,8CAAA;EDu9FJ;ECz9FE;;IAEE,8CAAA;ED29FJ;EC79FE;;IAEE,8CAAA;ED+9FJ;ECj+FE;;IAEE,8CAAA;EDm+FJ;ECr+FE;;IAEE,8CAAA;EDu+FJ;ECz+FE;;IAEE,8CAAA;ED2+FJ;EC7+FE;;IAEE,8CAAA;ED++FJ;ECj/FE;;IAEE,8CAAA;EDm/FJ;ECr/FE;;IAEE,8CAAA;EDu/FJ;ECp/FA;IAAkD,mBAAA;EDu/FlD;ECt/FA;IAAqD,sBAAA;EDy/FrD;ECx/FA;IAAsD,qBAAA;ED2/FtD;EC1/FA;IAA8D,yBAAA;ED6/F9D;EC5/FA;IAAiE,4BAAA;ED+/FjE;AACF;AC5/FA;EAEI;;IAEE,WAAA;IACA,oFAAA;ED6/FJ;EChgGE;;IAEE,WAAA;IACA,oFAAA;EDkgGJ;ECrgGE;;IAEE,WAAA;IACA,oFAAA;EDugGJ;EC1gGE;;IAEE,WAAA;IACA,oFAAA;ED4gGJ;EC/gGE;;IAEE,WAAA;IACA,oFAAA;EDihGJ;ECphGE;;IAEE,WAAA;IACA,oFAAA;EDshGJ;ECzhGE;;IAEE,WAAA;IACA,oFAAA;ED2hGJ;EC9hGE;;IAEE,WAAA;IACA,oFAAA;EDgiGJ;ECniGE;;IAEE,WAAA;IACA,oFAAA;EDqiGJ;ECxiGE;;IAEE,WAAA;IACA,qFAAA;ED0iGJ;EC7iGE;;IAEE,WAAA;IACA,qFAAA;ED+iGJ;ECljGE;;IAEE,WAAA;IACA,qFAAA;EDojGJ;ECvjGE;;IAEE,WAAA;IACA,qFAAA;EDyjGJ;EC5jGE;;IAEE,WAAA;IACA,qFAAA;ED8jGJ;ECjkGE;;IAEE,WAAA;IACA,qFAAA;EDmkGJ;ECtkGE;;IAEE,WAAA;IACA,qFAAA;EDwkGJ;EC3kGE;;IAEE,WAAA;IACA,qFAAA;ED6kGJ;EChlGE;;IAEE,WAAA;IACA,qFAAA;EDklGJ;ECrlGE;;IAEE,WAAA;IACA,qFAAA;EDulGJ;EC1lGE;;IAEE,WAAA;IACA,qFAAA;ED4lGJ;EC/lGE;;IAEE,WAAA;IACA,qFAAA;EDimGJ;ECpmGE;;IAEE,WAAA;IACA,qFAAA;EDsmGJ;ECzmGE;;IAEE,WAAA;IACA,qFAAA;ED2mGJ;EC9mGE;;IAEE,WAAA;IACA,qFAAA;EDgnGJ;EC3mGE;;IAEE,6CAAA;ED6mGJ;EC/mGE;;IAEE,6CAAA;EDinGJ;ECnnGE;;IAEE,6CAAA;EDqnGJ;ECvnGE;;IAEE,6CAAA;EDynGJ;EC3nGE;;IAEE,6CAAA;ED6nGJ;EC/nGE;;IAEE,6CAAA;EDioGJ;ECnoGE;;IAEE,6CAAA;EDqoGJ;ECvoGE;;IAEE,6CAAA;EDyoGJ;EC3oGE;;IAEE,6CAAA;ED6oGJ;EC/oGE;;IAEE,8CAAA;EDipGJ;ECnpGE;;IAEE,8CAAA;EDqpGJ;ECvpGE;;IAEE,8CAAA;EDypGJ;EC3pGE;;IAEE,8CAAA;ED6pGJ;EC/pGE;;IAEE,8CAAA;EDiqGJ;ECnqGE;;IAEE,8CAAA;EDqqGJ;ECvqGE;;IAEE,8CAAA;EDyqGJ;EC3qGE;;IAEE,8CAAA;ED6qGJ;EC/qGE;;IAEE,8CAAA;EDirGJ;ECnrGE;;IAEE,8CAAA;EDqrGJ;ECvrGE;;IAEE,8CAAA;EDyrGJ;EC3rGE;;IAEE,8CAAA;ED6rGJ;EC/rGE;;IAEE,8CAAA;EDisGJ;ECnsGE;;IAEE,8CAAA;EDqsGJ;ECvsGE;;IAEE,8CAAA;EDysGJ;EC3sGE;;IAEE,8CAAA;ED6sGJ;EC/sGE;;IAEE,8CAAA;EDitGJ;ECntGE;;IAEE,8CAAA;EDqtGJ;ECvtGE;;IAEE,8CAAA;EDytGJ;EC3tGE;;IAEE,8CAAA;ED6tGJ;EC/tGE;;IAEE,8CAAA;EDiuGJ;ECnuGE;;IAEE,8CAAA;EDquGJ;ECvuGE;;IAEE,8CAAA;EDyuGJ;EC3uGE;;IAEE,8CAAA;ED6uGJ;EC/uGE;;IAEE,8CAAA;EDivGJ;ECnvGE;;IAEE,8CAAA;EDqvGJ;ECvvGE;;IAEE,8CAAA;EDyvGJ;EC3vGE;;IAEE,8CAAA;ED6vGJ;EC/vGE;;IAEE,8CAAA;EDiwGJ;ECnwGE;;IAEE,8CAAA;EDqwGJ;ECvwGE;;IAEE,8CAAA;EDywGJ;EC3wGE;;IAEE,8CAAA;ED6wGJ;EC/wGE;;IAEE,8CAAA;EDixGJ;ECnxGE;;IAEE,8CAAA;EDqxGJ;ECvxGE;;IAEE,8CAAA;EDyxGJ;EC3xGE;;IAEE,8CAAA;ED6xGJ;EC/xGE;;IAEE,8CAAA;EDiyGJ;ECnyGE;;IAEE,8CAAA;EDqyGJ;ECvyGE;;IAEE,8CAAA;EDyyGJ;EC3yGE;;IAEE,8CAAA;ED6yGJ;EC/yGE;;IAEE,8CAAA;EDizGJ;EC9yGA;IAAoD,mBAAA;EDizGpD;EChzGA;IAAuD,sBAAA;EDmzGvD;EClzGA;IAAwD,qBAAA;EDqzGxD;ECpzGA;IAAgE,yBAAA;EDuzGhE;ECtzGA;IAAmE,4BAAA;EDyzGnE;AACF;ACtzGA;EAEI;IACE,WAAA;IACA,oFAAA;EDuzGJ;ECzzGE;IACE,WAAA;IACA,oFAAA;ED2zGJ;EC7zGE;IACE,WAAA;IACA,oFAAA;ED+zGJ;ECj0GE;IACE,WAAA;IACA,oFAAA;EDm0GJ;ECr0GE;IACE,WAAA;IACA,oFAAA;EDu0GJ;ECz0GE;IACE,WAAA;IACA,oFAAA;ED20GJ;EC70GE;IACE,WAAA;IACA,oFAAA;ED+0GJ;ECj1GE;IACE,WAAA;IACA,oFAAA;EDm1GJ;ECr1GE;IACE,WAAA;IACA,oFAAA;EDu1GJ;ECz1GE;IACE,WAAA;IACA,qFAAA;ED21GJ;EC71GE;IACE,WAAA;IACA,qFAAA;ED+1GJ;ECj2GE;IACE,WAAA;IACA,qFAAA;EDm2GJ;ECr2GE;IACE,WAAA;IACA,qFAAA;EDu2GJ;ECz2GE;IACE,WAAA;IACA,qFAAA;ED22GJ;EC72GE;IACE,WAAA;IACA,qFAAA;ED+2GJ;ECj3GE;IACE,WAAA;IACA,qFAAA;EDm3GJ;ECr3GE;IACE,WAAA;IACA,qFAAA;EDu3GJ;ECz3GE;IACE,WAAA;IACA,qFAAA;ED23GJ;EC73GE;IACE,WAAA;IACA,qFAAA;ED+3GJ;ECj4GE;IACE,WAAA;IACA,qFAAA;EDm4GJ;ECr4GE;IACE,WAAA;IACA,qFAAA;EDu4GJ;ECz4GE;IACE,WAAA;IACA,qFAAA;ED24GJ;EC74GE;IACE,WAAA;IACA,qFAAA;ED+4GJ;ECj5GE;IACE,WAAA;IACA,qFAAA;EDm5GJ;AACF;AC/4GA;EAEI;IACE,WAAA;IACA,oFAAA;EDg5GJ;ECl5GE;IACE,WAAA;IACA,oFAAA;EDo5GJ;ECt5GE;IACE,WAAA;IACA,oFAAA;EDw5GJ;EC15GE;IACE,WAAA;IACA,oFAAA;ED45GJ;EC95GE;IACE,WAAA;IACA,oFAAA;EDg6GJ;ECl6GE;IACE,WAAA;IACA,oFAAA;EDo6GJ;ECt6GE;IACE,WAAA;IACA,oFAAA;EDw6GJ;EC16GE;IACE,WAAA;IACA,oFAAA;ED46GJ;EC96GE;IACE,WAAA;IACA,oFAAA;EDg7GJ;ECl7GE;IACE,WAAA;IACA,qFAAA;EDo7GJ;ECt7GE;IACE,WAAA;IACA,qFAAA;EDw7GJ;EC17GE;IACE,WAAA;IACA,qFAAA;ED47GJ;EC97GE;IACE,WAAA;IACA,qFAAA;EDg8GJ;ECl8GE;IACE,WAAA;IACA,qFAAA;EDo8GJ;ECt8GE;IACE,WAAA;IACA,qFAAA;EDw8GJ;EC18GE;IACE,WAAA;IACA,qFAAA;ED48GJ;EC98GE;IACE,WAAA;IACA,qFAAA;EDg9GJ;ECl9GE;IACE,WAAA;IACA,qFAAA;EDo9GJ;ECt9GE;IACE,WAAA;IACA,qFAAA;EDw9GJ;EC19GE;IACE,WAAA;IACA,qFAAA;ED49GJ;EC99GE;IACE,WAAA;IACA,qFAAA;EDg+GJ;ECl+GE;IACE,WAAA;IACA,qFAAA;EDo+GJ;ECt+GE;IACE,WAAA;IACA,qFAAA;EDw+GJ;EC1+GE;IACE,WAAA;IACA,qFAAA;ED4+GJ;AACF;ACx+GA;EAEI;IACE,WAAA;IACA,oFAAA;EDy+GJ;EC3+GE;IACE,WAAA;IACA,oFAAA;ED6+GJ;EC/+GE;IACE,WAAA;IACA,oFAAA;EDi/GJ;ECn/GE;IACE,WAAA;IACA,oFAAA;EDq/GJ;ECv/GE;IACE,WAAA;IACA,oFAAA;EDy/GJ;EC3/GE;IACE,WAAA;IACA,oFAAA;ED6/GJ;EC//GE;IACE,WAAA;IACA,oFAAA;EDigHJ;ECngHE;IACE,WAAA;IACA,oFAAA;EDqgHJ;ECvgHE;IACE,WAAA;IACA,oFAAA;EDygHJ;EC3gHE;IACE,WAAA;IACA,qFAAA;ED6gHJ;EC/gHE;IACE,WAAA;IACA,qFAAA;EDihHJ;ECnhHE;IACE,WAAA;IACA,qFAAA;EDqhHJ;ECvhHE;IACE,WAAA;IACA,qFAAA;EDyhHJ;EC3hHE;IACE,WAAA;IACA,qFAAA;ED6hHJ;EC/hHE;IACE,WAAA;IACA,qFAAA;EDiiHJ;ECniHE;IACE,WAAA;IACA,qFAAA;EDqiHJ;ECviHE;IACE,WAAA;IACA,qFAAA;EDyiHJ;EC3iHE;IACE,WAAA;IACA,qFAAA;ED6iHJ;EC/iHE;IACE,WAAA;IACA,qFAAA;EDijHJ;ECnjHE;IACE,WAAA;IACA,qFAAA;EDqjHJ;ECvjHE;IACE,WAAA;IACA,qFAAA;EDyjHJ;EC3jHE;IACE,WAAA;IACA,qFAAA;ED6jHJ;EC/jHE;IACE,WAAA;IACA,qFAAA;EDikHJ;ECnkHE;IACE,WAAA;IACA,qFAAA;EDqkHJ;AACF;ACjkHA;EAEI;IACE,WAAA;IACA,oFAAA;EDkkHJ;ECpkHE;IACE,WAAA;IACA,oFAAA;EDskHJ;ECxkHE;IACE,WAAA;IACA,oFAAA;ED0kHJ;EC5kHE;IACE,WAAA;IACA,oFAAA;ED8kHJ;EChlHE;IACE,WAAA;IACA,oFAAA;EDklHJ;ECplHE;IACE,WAAA;IACA,oFAAA;EDslHJ;ECxlHE;IACE,WAAA;IACA,oFAAA;ED0lHJ;EC5lHE;IACE,WAAA;IACA,oFAAA;ED8lHJ;EChmHE;IACE,WAAA;IACA,oFAAA;EDkmHJ;ECpmHE;IACE,WAAA;IACA,qFAAA;EDsmHJ;ECxmHE;IACE,WAAA;IACA,qFAAA;ED0mHJ;EC5mHE;IACE,WAAA;IACA,qFAAA;ED8mHJ;EChnHE;IACE,WAAA;IACA,qFAAA;EDknHJ;ECpnHE;IACE,WAAA;IACA,qFAAA;EDsnHJ;ECxnHE;IACE,WAAA;IACA,qFAAA;ED0nHJ;EC5nHE;IACE,WAAA;IACA,qFAAA;ED8nHJ;EChoHE;IACE,WAAA;IACA,qFAAA;EDkoHJ;ECpoHE;IACE,WAAA;IACA,qFAAA;EDsoHJ;ECxoHE;IACE,WAAA;IACA,qFAAA;ED0oHJ;EC5oHE;IACE,WAAA;IACA,qFAAA;ED8oHJ;EChpHE;IACE,WAAA;IACA,qFAAA;EDkpHJ;ECppHE;IACE,WAAA;IACA,qFAAA;EDspHJ;ECxpHE;IACE,WAAA;IACA,qFAAA;ED0pHJ;EC5pHE;IACE,WAAA;IACA,qFAAA;ED8pHJ;AACF;AC1pHA;EAEI;IACE,WAAA;IACA,oFAAA;ED2pHJ;EC7pHE;IACE,WAAA;IACA,oFAAA;ED+pHJ;ECjqHE;IACE,WAAA;IACA,oFAAA;EDmqHJ;ECrqHE;IACE,WAAA;IACA,oFAAA;EDuqHJ;ECzqHE;IACE,WAAA;IACA,oFAAA;ED2qHJ;EC7qHE;IACE,WAAA;IACA,oFAAA;ED+qHJ;ECjrHE;IACE,WAAA;IACA,oFAAA;EDmrHJ;ECrrHE;IACE,WAAA;IACA,oFAAA;EDurHJ;ECzrHE;IACE,WAAA;IACA,oFAAA;ED2rHJ;EC7rHE;IACE,WAAA;IACA,qFAAA;ED+rHJ;ECjsHE;IACE,WAAA;IACA,qFAAA;EDmsHJ;ECrsHE;IACE,WAAA;IACA,qFAAA;EDusHJ;ECzsHE;IACE,WAAA;IACA,qFAAA;ED2sHJ;EC7sHE;IACE,WAAA;IACA,qFAAA;ED+sHJ;ECjtHE;IACE,WAAA;IACA,qFAAA;EDmtHJ;ECrtHE;IACE,WAAA;IACA,qFAAA;EDutHJ;ECztHE;IACE,WAAA;IACA,qFAAA;ED2tHJ;EC7tHE;IACE,WAAA;IACA,qFAAA;ED+tHJ;ECjuHE;IACE,WAAA;IACA,qFAAA;EDmuHJ;ECruHE;IACE,WAAA;IACA,qFAAA;EDuuHJ;ECzuHE;IACE,WAAA;IACA,qFAAA;ED2uHJ;EC7uHE;IACE,WAAA;IACA,qFAAA;ED+uHJ;ECjvHE;IACE,WAAA;IACA,qFAAA;EDmvHJ;ECrvHE;IACE,WAAA;IACA,qFAAA;EDuvHJ;AACF;ACnvHA;EAEI;IACE,WAAA;IACA,oFAAA;EDovHJ;ECtvHE;IACE,WAAA;IACA,oFAAA;EDwvHJ;EC1vHE;IACE,WAAA;IACA,oFAAA;ED4vHJ;EC9vHE;IACE,WAAA;IACA,oFAAA;EDgwHJ;EClwHE;IACE,WAAA;IACA,oFAAA;EDowHJ;ECtwHE;IACE,WAAA;IACA,oFAAA;EDwwHJ;EC1wHE;IACE,WAAA;IACA,oFAAA;ED4wHJ;EC9wHE;IACE,WAAA;IACA,oFAAA;EDgxHJ;EClxHE;IACE,WAAA;IACA,oFAAA;EDoxHJ;ECtxHE;IACE,WAAA;IACA,qFAAA;EDwxHJ;EC1xHE;IACE,WAAA;IACA,qFAAA;ED4xHJ;EC9xHE;IACE,WAAA;IACA,qFAAA;EDgyHJ;EClyHE;IACE,WAAA;IACA,qFAAA;EDoyHJ;ECtyHE;IACE,WAAA;IACA,qFAAA;EDwyHJ;EC1yHE;IACE,WAAA;IACA,qFAAA;ED4yHJ;EC9yHE;IACE,WAAA;IACA,qFAAA;EDgzHJ;EClzHE;IACE,WAAA;IACA,qFAAA;EDozHJ;ECtzHE;IACE,WAAA;IACA,qFAAA;EDwzHJ;EC1zHE;IACE,WAAA;IACA,qFAAA;ED4zHJ;EC9zHE;IACE,WAAA;IACA,qFAAA;EDg0HJ;ECl0HE;IACE,WAAA;IACA,qFAAA;EDo0HJ;ECt0HE;IACE,WAAA;IACA,qFAAA;EDw0HJ;EC10HE;IACE,WAAA;IACA,qFAAA;ED40HJ;EC90HE;IACE,WAAA;IACA,qFAAA;EDg1HJ;AACF;AAxiIA,iCAAA;AC2OE;EAeE;;;IAEE,0BAAA;EDmzHJ;ECjzHE;;;IAEE,oBAPS;ED2zHb;EClzHE;;;IAEE,kBAXS;EDg0Hb;EC/zHE;;;IAEE,0BAAA;EDk0HJ;ECh0HE;;;IAEE,oBAPS;ED00Hb;ECj0HE;;;IAEE,kBAXS;ED+0Hb;EC90HE;;;IAEE,0BAAA;EDi1HJ;EC/0HE;;;IAEE,oBAPS;EDy1Hb;ECh1HE;;;IAEE,kBAXS;ED81Hb;EC71HE;;;IAEE,0BAAA;EDg2HJ;EC91HE;;;IAEE,oBAPS;EDw2Hb;EC/1HE;;;IAEE,kBAXS;ED62Hb;EC52HE;;;IAEE,0BAAA;ED+2HJ;EC72HE;;;IAEE,oBAPS;EDu3Hb;EC92HE;;;IAEE,kBAXS;ED43Hb;EC33HE;;;IAEE,0BAAA;ED83HJ;EC53HE;;;IAEE,oBAPS;EDs4Hb;EC73HE;;;IAEE,kBAXS;ED24Hb;EC14HE;;;IAEE,0BAAA;ED64HJ;EC34HE;;;IAEE,oBAPS;EDq5Hb;EC54HE;;;IAEE,kBAXS;ED05Hb;ECz5HE;;;IAEE,0BAAA;ED45HJ;EC15HE;;;IAEE,oBAPS;EDo6Hb;EC35HE;;;IAEE,kBAXS;EDy6Hb;ECx6HE;;;IAEE,0BAAA;ED26HJ;ECz6HE;;;IAEE,oBAPS;EDm7Hb;EC16HE;;;IAEE,kBAXS;EDw7Hb;ECv7HE;;;IAEE,4BAAA;ED07HJ;ECx7HE;;;IAEE,qBAPS;EDk8Hb;ECz7HE;;;IAEE,mBAXS;EDu8Hb;ECt8HE;;;IAEE,4BAAA;EDy8HJ;ECv8HE;;;IAEE,qBAPS;EDi9Hb;ECx8HE;;;IAEE,mBAXS;EDs9Hb;ECr9HE;;;IAEE,4BAAA;EDw9HJ;ECt9HE;;;IAEE,qBAPS;EDg+Hb;ECv9HE;;;IAEE,mBAXS;EDq+Hb;ECp+HE;;;IAEE,4BAAA;EDu+HJ;ECr+HE;;;IAEE,qBAPS;ED++Hb;ECt+HE;;;IAEE,mBAXS;EDo/Hb;ECn/HE;;;IAEE,4BAAA;EDs/HJ;ECp/HE;;;IAEE,qBAPS;ED8/Hb;ECr/HE;;;IAEE,mBAXS;EDmgIb;EClgIE;;;IAEE,4BAAA;EDqgIJ;ECngIE;;;IAEE,qBAPS;ED6gIb;ECpgIE;;;IAEE,mBAXS;EDkhIb;ECjhIE;;;IAEE,4BAAA;EDohIJ;EClhIE;;;IAEE,qBAPS;ED4hIb;ECnhIE;;;IAEE,mBAXS;EDiiIb;EChiIE;;;IAEE,4BAAA;EDmiIJ;ECjiIE;;;IAEE,qBAPS;ED2iIb;ECliIE;;;IAEE,mBAXS;EDgjIb;EC/iIE;;;IAEE,4BAAA;EDkjIJ;EChjIE;;;IAEE,qBAPS;ED0jIb;ECjjIE;;;IAEE,mBAXS;ED+jIb;EC9jIE;;;IAEE,4BAAA;EDikIJ;EC/jIE;;;IAEE,qBAPS;EDykIb;EChkIE;;;IAEE,mBAXS;ED8kIb;EC7kIE;;;IAEE,4BAAA;EDglIJ;EC9kIE;;;IAEE,qBAPS;EDwlIb;EC/kIE;;;IAEE,mBAXS;ED6lIb;EC5lIE;;;IAEE,4BAAA;ED+lIJ;EC7lIE;;;IAEE,qBAPS;EDumIb;EC9lIE;;;IAEE,mBAXS;ED4mIb;EC3mIE;;;IAEE,4BAAA;ED8mIJ;EC5mIE;;;IAEE,qBAPS;EDsnIb;EC7mIE;;;IAEE,mBAXS;ED2nIb;EC1nIE;;;IAEE,4BAAA;ED6nIJ;EC3nIE;;;IAEE,qBAPS;EDqoIb;EC5nIE;;;IAEE,mBAXS;ED0oIb;ECzoIE;;;IAEE,4BAAA;ED4oIJ;EC1oIE;;;IAEE,qBAPS;EDopIb;EC3oIE;;;IAEE,mBAXS;EDypIb;ECj5IE;;;IAEE,6CAAA;EDo5IJ;ECl5IE;;;IAEE,uBAAA;EDq5IJ;ECn5IE;;;IAEE,QAXS;EDi6Ib;ECp5IE;;;IAEE,SAAA;EDu5IJ;ECr6IE;;;IAEE,6CAAA;EDw6IJ;ECt6IE;;;IAEE,uBAAA;EDy6IJ;ECv6IE;;;IAEE,QAXS;EDq7Ib;ECx6IE;;;IAEE,SAAA;ED26IJ;ECz7IE;;;IAEE,6CAAA;ED47IJ;EC17IE;;;IAEE,uBAAA;ED67IJ;EC37IE;;;IAEE,QAXS;EDy8Ib;EC57IE;;;IAEE,SAAA;ED+7IJ;EC78IE;;;IAEE,6CAAA;EDg9IJ;EC98IE;;;IAEE,uBAAA;EDi9IJ;EC/8IE;;;IAEE,QAXS;ED69Ib;ECh9IE;;;IAEE,SAAA;EDm9IJ;ECj+IE;;;IAEE,6CAAA;EDo+IJ;ECl+IE;;;IAEE,uBAAA;EDq+IJ;ECn+IE;;;IAEE,QAXS;EDi/Ib;ECp+IE;;;IAEE,SAAA;EDu+IJ;ECr/IE;;;IAEE,6CAAA;EDw/IJ;ECt/IE;;;IAEE,uBAAA;EDy/IJ;ECv/IE;;;IAEE,QAXS;EDqgJb;ECx/IE;;;IAEE,SAAA;ED2/IJ;ECzgJE;;;IAEE,6CAAA;ED4gJJ;EC1gJE;;;IAEE,uBAAA;ED6gJJ;EC3gJE;;;IAEE,QAXS;EDyhJb;EC5gJE;;;IAEE,SAAA;ED+gJJ;EC7hJE;;;IAEE,6CAAA;EDgiJJ;EC9hJE;;;IAEE,uBAAA;EDiiJJ;EC/hJE;;;IAEE,QAXS;ED6iJb;EChiJE;;;IAEE,SAAA;EDmiJJ;ECjjJE;;;IAEE,6CAAA;EDojJJ;ECljJE;;;IAEE,uBAAA;EDqjJJ;ECnjJE;;;IAEE,QAXS;EDikJb;ECpjJE;;;IAEE,SAAA;EDujJJ;ECrkJE;;;IAEE,8CAAA;EDwkJJ;ECtkJE;;;IAEE,yBAAA;EDykJJ;ECvkJE;;;IAEE,SAXS;EDqlJb;ECxkJE;;;IAEE,SAAA;ED2kJJ;ECzlJE;;;IAEE,8CAAA;ED4lJJ;EC1lJE;;;IAEE,yBAAA;ED6lJJ;EC3lJE;;;IAEE,SAXS;EDymJb;EC5lJE;;;IAEE,SAAA;ED+lJJ;EC7mJE;;;IAEE,8CAAA;EDgnJJ;EC9mJE;;;IAEE,yBAAA;EDinJJ;EC/mJE;;;IAEE,SAXS;ED6nJb;EChnJE;;;IAEE,SAAA;EDmnJJ;ECjoJE;;;IAEE,8CAAA;EDooJJ;ECloJE;;;IAEE,yBAAA;EDqoJJ;ECnoJE;;;IAEE,SAXS;EDipJb;ECpoJE;;;IAEE,SAAA;EDuoJJ;ECrpJE;;;IAEE,8CAAA;EDwpJJ;ECtpJE;;;IAEE,yBAAA;EDypJJ;ECvpJE;;;IAEE,SAXS;EDqqJb;ECxpJE;;;IAEE,SAAA;ED2pJJ;ECzqJE;;;IAEE,8CAAA;ED4qJJ;EC1qJE;;;IAEE,yBAAA;ED6qJJ;EC3qJE;;;IAEE,SAXS;EDyrJb;EC5qJE;;;IAEE,SAAA;ED+qJJ;EC7rJE;;;IAEE,8CAAA;EDgsJJ;EC9rJE;;;IAEE,yBAAA;EDisJJ;EC/rJE;;;IAEE,SAXS;ED6sJb;EChsJE;;;IAEE,SAAA;EDmsJJ;ECjtJE;;;IAEE,8CAAA;EDotJJ;ECltJE;;;IAEE,yBAAA;EDqtJJ;ECntJE;;;IAEE,SAXS;EDiuJb;ECptJE;;;IAEE,SAAA;EDutJJ;ECruJE;;;IAEE,8CAAA;EDwuJJ;ECtuJE;;;IAEE,yBAAA;EDyuJJ;ECvuJE;;;IAEE,SAXS;EDqvJb;ECxuJE;;;IAEE,SAAA;ED2uJJ;ECzvJE;;;IAEE,8CAAA;ED4vJJ;EC1vJE;;;IAEE,yBAAA;ED6vJJ;EC3vJE;;;IAEE,SAXS;EDywJb;EC5vJE;;;IAEE,SAAA;ED+vJJ;EC7wJE;;;IAEE,8CAAA;EDgxJJ;EC9wJE;;;IAEE,yBAAA;EDixJJ;EC/wJE;;;IAEE,SAXS;ED6xJb;EChxJE;;;IAEE,SAAA;EDmxJJ;ECjyJE;;;IAEE,8CAAA;EDoyJJ;EClyJE;;;IAEE,yBAAA;EDqyJJ;ECnyJE;;;IAEE,SAXS;EDizJb;ECpyJE;;;IAEE,SAAA;EDuyJJ;ECrzJE;;;IAEE,8CAAA;EDwzJJ;ECtzJE;;;IAEE,yBAAA;EDyzJJ;ECvzJE;;;IAEE,SAXS;EDq0Jb;ECxzJE;;;IAEE,SAAA;ED2zJJ;ECz0JE;;;IAEE,8CAAA;ED40JJ;EC10JE;;;IAEE,yBAAA;ED60JJ;EC30JE;;;IAEE,SAXS;EDy1Jb;EC50JE;;;IAEE,SAAA;ED+0JJ;EC71JE;;;IAEE,8CAAA;EDg2JJ;EC91JE;;;IAEE,yBAAA;EDi2JJ;EC/1JE;;;IAEE,SAXS;ED62Jb;ECh2JE;;;IAEE,SAAA;EDm2JJ;ECj3JE;;;IAEE,8CAAA;EDo3JJ;ECl3JE;;;IAEE,yBAAA;EDq3JJ;ECn3JE;;;IAEE,SAXS;EDi4Jb;ECp3JE;;;IAEE,SAAA;EDu3JJ;ECr4JE;;;IAEE,8CAAA;EDw4JJ;ECt4JE;;;IAEE,yBAAA;EDy4JJ;ECv4JE;;;IAEE,SAXS;EDq5Jb;ECx4JE;;;IAEE,SAAA;ED24JJ;ECz5JE;;;IAEE,8CAAA;ED45JJ;EC15JE;;;IAEE,yBAAA;ED65JJ;EC35JE;;;IAEE,SAXS;EDy6Jb;EC55JE;;;IAEE,SAAA;ED+5JJ;EC76JE;;;IAEE,8CAAA;EDg7JJ;EC96JE;;;IAEE,yBAAA;EDi7JJ;EC/6JE;;;IAEE,SAXS;ED67Jb;ECh7JE;;;IAEE,SAAA;EDm7JJ;ECj8JE;;;IAEE,8CAAA;EDo8JJ;ECl8JE;;;IAEE,yBAAA;EDq8JJ;ECn8JE;;;IAEE,SAXS;EDi9Jb;ECp8JE;;;IAEE,SAAA;EDu8JJ;ECr9JE;;;IAEE,8CAAA;EDw9JJ;ECt9JE;;;IAEE,yBAAA;EDy9JJ;ECv9JE;;;IAEE,SAXS;EDq+Jb;ECx9JE;;;IAEE,SAAA;ED29JJ;ECz+JE;;;IAEE,8CAAA;ED4+JJ;EC1+JE;;;IAEE,yBAAA;ED6+JJ;EC3+JE;;;IAEE,SAXS;EDy/Jb;EC5+JE;;;IAEE,SAAA;ED++JJ;EC7/JE;;;IAEE,8CAAA;EDggKJ;EC9/JE;;;IAEE,yBAAA;EDigKJ;EC//JE;;;IAEE,SAXS;ED6gKb;EChgKE;;;IAEE,SAAA;EDmgKJ;ECjhKE;;;IAEE,8CAAA;EDohKJ;EClhKE;;;IAEE,yBAAA;EDqhKJ;ECnhKE;;;IAEE,SAXS;EDiiKb;ECphKE;;;IAEE,SAAA;EDuhKJ;ECriKE;;;IAEE,8CAAA;EDwiKJ;ECtiKE;;;IAEE,yBAAA;EDyiKJ;ECviKE;;;IAEE,SAXS;EDqjKb;ECxiKE;;;IAEE,SAAA;ED2iKJ;ECzjKE;;;IAEE,8CAAA;ED4jKJ;EC1jKE;;;IAEE,yBAAA;ED6jKJ;EC3jKE;;;IAEE,SAXS;EDykKb;EC5jKE;;;IAEE,SAAA;ED+jKJ;EC7kKE;;;IAEE,8CAAA;EDglKJ;EC9kKE;;;IAEE,yBAAA;EDilKJ;EC/kKE;;;IAEE,SAXS;ED6lKb;EChlKE;;;IAEE,SAAA;EDmlKJ;ECjmKE;;;IAEE,8CAAA;EDomKJ;EClmKE;;;IAEE,yBAAA;EDqmKJ;ECnmKE;;;IAEE,SAXS;EDinKb;ECpmKE;;;IAEE,SAAA;EDumKJ;ECrnKE;;;IAEE,8CAAA;EDwnKJ;ECtnKE;;;IAEE,yBAAA;EDynKJ;ECvnKE;;;IAEE,SAXS;EDqoKb;ECxnKE;;;IAEE,SAAA;ED2nKJ;ECzoKE;;;IAEE,8CAAA;ED4oKJ;EC1oKE;;;IAEE,yBAAA;ED6oKJ;EC3oKE;;;IAEE,SAXS;EDypKb;EC5oKE;;;IAEE,SAAA;ED+oKJ;EC7pKE;;;IAEE,8CAAA;EDgqKJ;EC9pKE;;;IAEE,yBAAA;EDiqKJ;EC/pKE;;;IAEE,SAXS;ED6qKb;EChqKE;;;IAEE,SAAA;EDmqKJ;ECjrKE;;;IAEE,8CAAA;EDorKJ;EClrKE;;;IAEE,yBAAA;EDqrKJ;ECnrKE;;;IAEE,SAXS;EDisKb;ECprKE;;;IAEE,SAAA;EDurKJ;ECrsKE;;;IAEE,8CAAA;EDwsKJ;ECtsKE;;;IAEE,yBAAA;EDysKJ;ECvsKE;;;IAEE,SAXS;EDqtKb;ECxsKE;;;IAEE,SAAA;ED2sKJ;ECztKE;;;IAEE,8CAAA;ED4tKJ;EC1tKE;;;IAEE,yBAAA;ED6tKJ;EC3tKE;;;IAEE,SAXS;EDyuKb;EC5tKE;;;IAEE,SAAA;ED+tKJ;EC7uKE;;;IAEE,8CAAA;EDgvKJ;EC9uKE;;;IAEE,yBAAA;EDivKJ;EC/uKE;;;IAEE,SAXS;ED6vKb;EChvKE;;;IAEE,SAAA;EDmvKJ;ECjwKE;;;IAEE,8CAAA;EDowKJ;EClwKE;;;IAEE,yBAAA;EDqwKJ;ECnwKE;;;IAEE,SAXS;EDixKb;ECpwKE;;;IAEE,SAAA;EDuwKJ;ECrxKE;;;IAEE,8CAAA;EDwxKJ;ECtxKE;;;IAEE,yBAAA;EDyxKJ;ECvxKE;;;IAEE,SAXS;EDqyKb;ECxxKE;;;IAEE,SAAA;ED2xKJ;ECzyKE;;;IAEE,8CAAA;ED4yKJ;EC1yKE;;;IAEE,yBAAA;ED6yKJ;EC3yKE;;;IAEE,SAXS;EDyzKb;EC5yKE;;;IAEE,SAAA;ED+yKJ;EC7zKE;;;IAEE,8CAAA;EDg0KJ;EC9zKE;;;IAEE,yBAAA;EDi0KJ;EC/zKE;;;IAEE,SAXS;ED60Kb;ECh0KE;;;IAEE,SAAA;EDm0KJ;ECj1KE;;;IAEE,8CAAA;EDo1KJ;ECl1KE;;;IAEE,yBAAA;EDq1KJ;ECn1KE;;;IAEE,SAXS;EDi2Kb;ECp1KE;;;IAEE,SAAA;EDu1KJ;ECr2KE;;;IAEE,8CAAA;EDw2KJ;ECt2KE;;;IAEE,yBAAA;EDy2KJ;ECv2KE;;;IAEE,SAXS;EDq3Kb;ECx2KE;;;IAEE,SAAA;ED22KJ;ECr2KA;;IACE,cAAA;EDw2KF;AACF;AClpKE;EAaE;;;IAEE,0BAAA;EDyoKJ;ECvoKE;;;IAEE,oBAPS;EDipKb;ECxoKE;;;IAEE,kBAXS;EDspKb;ECrpKE;;;IAEE,0BAAA;EDwpKJ;ECtpKE;;;IAEE,oBAPS;EDgqKb;ECvpKE;;;IAEE,kBAXS;EDqqKb;ECpqKE;;;IAEE,0BAAA;EDuqKJ;ECrqKE;;;IAEE,oBAPS;ED+qKb;ECtqKE;;;IAEE,kBAXS;EDorKb;ECnrKE;;;IAEE,0BAAA;EDsrKJ;ECprKE;;;IAEE,oBAPS;ED8rKb;ECrrKE;;;IAEE,kBAXS;EDmsKb;EClsKE;;;IAEE,0BAAA;EDqsKJ;ECnsKE;;;IAEE,oBAPS;ED6sKb;ECpsKE;;;IAEE,kBAXS;EDktKb;ECjtKE;;;IAEE,0BAAA;EDotKJ;ECltKE;;;IAEE,oBAPS;ED4tKb;ECntKE;;;IAEE,kBAXS;EDiuKb;EChuKE;;;IAEE,0BAAA;EDmuKJ;ECjuKE;;;IAEE,oBAPS;ED2uKb;ECluKE;;;IAEE,kBAXS;EDgvKb;EC/uKE;;;IAEE,0BAAA;EDkvKJ;EChvKE;;;IAEE,oBAPS;ED0vKb;ECjvKE;;;IAEE,kBAXS;ED+vKb;EC9vKE;;;IAEE,0BAAA;EDiwKJ;EC/vKE;;;IAEE,oBAPS;EDywKb;EChwKE;;;IAEE,kBAXS;ED8wKb;EC7wKE;;;IAEE,4BAAA;EDgxKJ;EC9wKE;;;IAEE,qBAPS;EDwxKb;EC/wKE;;;IAEE,mBAXS;ED6xKb;EC5xKE;;;IAEE,4BAAA;ED+xKJ;EC7xKE;;;IAEE,qBAPS;EDuyKb;EC9xKE;;;IAEE,mBAXS;ED4yKb;EC3yKE;;;IAEE,4BAAA;ED8yKJ;EC5yKE;;;IAEE,qBAPS;EDszKb;EC7yKE;;;IAEE,mBAXS;ED2zKb;EC1zKE;;;IAEE,4BAAA;ED6zKJ;EC3zKE;;;IAEE,qBAPS;EDq0Kb;EC5zKE;;;IAEE,mBAXS;ED00Kb;ECz0KE;;;IAEE,4BAAA;ED40KJ;EC10KE;;;IAEE,qBAPS;EDo1Kb;EC30KE;;;IAEE,mBAXS;EDy1Kb;ECx1KE;;;IAEE,4BAAA;ED21KJ;ECz1KE;;;IAEE,qBAPS;EDm2Kb;EC11KE;;;IAEE,mBAXS;EDw2Kb;ECv2KE;;;IAEE,4BAAA;ED02KJ;ECx2KE;;;IAEE,qBAPS;EDk3Kb;ECz2KE;;;IAEE,mBAXS;EDu3Kb;ECt3KE;;;IAEE,4BAAA;EDy3KJ;ECv3KE;;;IAEE,qBAPS;EDi4Kb;ECx3KE;;;IAEE,mBAXS;EDs4Kb;ECr4KE;;;IAEE,4BAAA;EDw4KJ;ECt4KE;;;IAEE,qBAPS;EDg5Kb;ECv4KE;;;IAEE,mBAXS;EDq5Kb;ECp5KE;;;IAEE,4BAAA;EDu5KJ;ECr5KE;;;IAEE,qBAPS;ED+5Kb;ECt5KE;;;IAEE,mBAXS;EDo6Kb;ECn6KE;;;IAEE,4BAAA;EDs6KJ;ECp6KE;;;IAEE,qBAPS;ED86Kb;ECr6KE;;;IAEE,mBAXS;EDm7Kb;ECl7KE;;;IAEE,4BAAA;EDq7KJ;ECn7KE;;;IAEE,qBAPS;ED67Kb;ECp7KE;;;IAEE,mBAXS;EDk8Kb;ECj8KE;;;IAEE,4BAAA;EDo8KJ;ECl8KE;;;IAEE,qBAPS;ED48Kb;ECn8KE;;;IAEE,mBAXS;EDi9Kb;ECh9KE;;;IAEE,4BAAA;EDm9KJ;ECj9KE;;;IAEE,qBAPS;ED29Kb;ECl9KE;;;IAEE,mBAXS;EDg+Kb;EC/9KE;;;IAEE,4BAAA;EDk+KJ;ECh+KE;;;IAEE,qBAPS;ED0+Kb;ECj+KE;;;IAEE,mBAXS;ED++Kb;ECvuLE;;;IAEE,6CAAA;ED0uLJ;ECxuLE;;;IAEE,uBAAA;ED2uLJ;ECzuLE;;;IAEE,QAXS;EDuvLb;EC1uLE;;;IAEE,SAAA;ED6uLJ;EC3vLE;;;IAEE,6CAAA;ED8vLJ;EC5vLE;;;IAEE,uBAAA;ED+vLJ;EC7vLE;;;IAEE,QAXS;ED2wLb;EC9vLE;;;IAEE,SAAA;EDiwLJ;EC/wLE;;;IAEE,6CAAA;EDkxLJ;EChxLE;;;IAEE,uBAAA;EDmxLJ;ECjxLE;;;IAEE,QAXS;ED+xLb;EClxLE;;;IAEE,SAAA;EDqxLJ;ECnyLE;;;IAEE,6CAAA;EDsyLJ;ECpyLE;;;IAEE,uBAAA;EDuyLJ;ECryLE;;;IAEE,QAXS;EDmzLb;ECtyLE;;;IAEE,SAAA;EDyyLJ;ECvzLE;;;IAEE,6CAAA;ED0zLJ;ECxzLE;;;IAEE,uBAAA;ED2zLJ;ECzzLE;;;IAEE,QAXS;EDu0Lb;EC1zLE;;;IAEE,SAAA;ED6zLJ;EC30LE;;;IAEE,6CAAA;ED80LJ;EC50LE;;;IAEE,uBAAA;ED+0LJ;EC70LE;;;IAEE,QAXS;ED21Lb;EC90LE;;;IAEE,SAAA;EDi1LJ;EC/1LE;;;IAEE,6CAAA;EDk2LJ;ECh2LE;;;IAEE,uBAAA;EDm2LJ;ECj2LE;;;IAEE,QAXS;ED+2Lb;ECl2LE;;;IAEE,SAAA;EDq2LJ;ECn3LE;;;IAEE,6CAAA;EDs3LJ;ECp3LE;;;IAEE,uBAAA;EDu3LJ;ECr3LE;;;IAEE,QAXS;EDm4Lb;ECt3LE;;;IAEE,SAAA;EDy3LJ;ECv4LE;;;IAEE,6CAAA;ED04LJ;ECx4LE;;;IAEE,uBAAA;ED24LJ;ECz4LE;;;IAEE,QAXS;EDu5Lb;EC14LE;;;IAEE,SAAA;ED64LJ;EC35LE;;;IAEE,8CAAA;ED85LJ;EC55LE;;;IAEE,yBAAA;ED+5LJ;EC75LE;;;IAEE,SAXS;ED26Lb;EC95LE;;;IAEE,SAAA;EDi6LJ;EC/6LE;;;IAEE,8CAAA;EDk7LJ;ECh7LE;;;IAEE,yBAAA;EDm7LJ;ECj7LE;;;IAEE,SAXS;ED+7Lb;ECl7LE;;;IAEE,SAAA;EDq7LJ;ECn8LE;;;IAEE,8CAAA;EDs8LJ;ECp8LE;;;IAEE,yBAAA;EDu8LJ;ECr8LE;;;IAEE,SAXS;EDm9Lb;ECt8LE;;;IAEE,SAAA;EDy8LJ;ECv9LE;;;IAEE,8CAAA;ED09LJ;ECx9LE;;;IAEE,yBAAA;ED29LJ;ECz9LE;;;IAEE,SAXS;EDu+Lb;EC19LE;;;IAEE,SAAA;ED69LJ;EC3+LE;;;IAEE,8CAAA;ED8+LJ;EC5+LE;;;IAEE,yBAAA;ED++LJ;EC7+LE;;;IAEE,SAXS;ED2/Lb;EC9+LE;;;IAEE,SAAA;EDi/LJ;EC//LE;;;IAEE,8CAAA;EDkgMJ;EChgME;;;IAEE,yBAAA;EDmgMJ;ECjgME;;;IAEE,SAXS;ED+gMb;EClgME;;;IAEE,SAAA;EDqgMJ;ECnhME;;;IAEE,8CAAA;EDshMJ;ECphME;;;IAEE,yBAAA;EDuhMJ;ECrhME;;;IAEE,SAXS;EDmiMb;ECthME;;;IAEE,SAAA;EDyhMJ;ECviME;;;IAEE,8CAAA;ED0iMJ;ECxiME;;;IAEE,yBAAA;ED2iMJ;ECziME;;;IAEE,SAXS;EDujMb;EC1iME;;;IAEE,SAAA;ED6iMJ;EC3jME;;;IAEE,8CAAA;ED8jMJ;EC5jME;;;IAEE,yBAAA;ED+jMJ;EC7jME;;;IAEE,SAXS;ED2kMb;EC9jME;;;IAEE,SAAA;EDikMJ;EC/kME;;;IAEE,8CAAA;EDklMJ;EChlME;;;IAEE,yBAAA;EDmlMJ;ECjlME;;;IAEE,SAXS;ED+lMb;ECllME;;;IAEE,SAAA;EDqlMJ;ECnmME;;;IAEE,8CAAA;EDsmMJ;ECpmME;;;IAEE,yBAAA;EDumMJ;ECrmME;;;IAEE,SAXS;EDmnMb;ECtmME;;;IAEE,SAAA;EDymMJ;ECvnME;;;IAEE,8CAAA;ED0nMJ;ECxnME;;;IAEE,yBAAA;ED2nMJ;ECznME;;;IAEE,SAXS;EDuoMb;EC1nME;;;IAEE,SAAA;ED6nMJ;EC3oME;;;IAEE,8CAAA;ED8oMJ;EC5oME;;;IAEE,yBAAA;ED+oMJ;EC7oME;;;IAEE,SAXS;ED2pMb;EC9oME;;;IAEE,SAAA;EDipMJ;EC/pME;;;IAEE,8CAAA;EDkqMJ;EChqME;;;IAEE,yBAAA;EDmqMJ;ECjqME;;;IAEE,SAXS;ED+qMb;EClqME;;;IAEE,SAAA;EDqqMJ;ECnrME;;;IAEE,8CAAA;EDsrMJ;ECprME;;;IAEE,yBAAA;EDurMJ;ECrrME;;;IAEE,SAXS;EDmsMb;ECtrME;;;IAEE,SAAA;EDyrMJ;ECvsME;;;IAEE,8CAAA;ED0sMJ;ECxsME;;;IAEE,yBAAA;ED2sMJ;ECzsME;;;IAEE,SAXS;EDutMb;EC1sME;;;IAEE,SAAA;ED6sMJ;EC3tME;;;IAEE,8CAAA;ED8tMJ;EC5tME;;;IAEE,yBAAA;ED+tMJ;EC7tME;;;IAEE,SAXS;ED2uMb;EC9tME;;;IAEE,SAAA;EDiuMJ;EC/uME;;;IAEE,8CAAA;EDkvMJ;EChvME;;;IAEE,yBAAA;EDmvMJ;ECjvME;;;IAEE,SAXS;ED+vMb;EClvME;;;IAEE,SAAA;EDqvMJ;ECnwME;;;IAEE,8CAAA;EDswMJ;ECpwME;;;IAEE,yBAAA;EDuwMJ;ECrwME;;;IAEE,SAXS;EDmxMb;ECtwME;;;IAEE,SAAA;EDywMJ;ECvxME;;;IAEE,8CAAA;ED0xMJ;ECxxME;;;IAEE,yBAAA;ED2xMJ;ECzxME;;;IAEE,SAXS;EDuyMb;EC1xME;;;IAEE,SAAA;ED6xMJ;EC3yME;;;IAEE,8CAAA;ED8yMJ;EC5yME;;;IAEE,yBAAA;ED+yMJ;EC7yME;;;IAEE,SAXS;ED2zMb;EC9yME;;;IAEE,SAAA;EDizMJ;EC/zME;;;IAEE,8CAAA;EDk0MJ;ECh0ME;;;IAEE,yBAAA;EDm0MJ;ECj0ME;;;IAEE,SAXS;ED+0Mb;ECl0ME;;;IAEE,SAAA;EDq0MJ;ECn1ME;;;IAEE,8CAAA;EDs1MJ;ECp1ME;;;IAEE,yBAAA;EDu1MJ;ECr1ME;;;IAEE,SAXS;EDm2Mb;ECt1ME;;;IAEE,SAAA;EDy1MJ;ECv2ME;;;IAEE,8CAAA;ED02MJ;ECx2ME;;;IAEE,yBAAA;ED22MJ;ECz2ME;;;IAEE,SAXS;EDu3Mb;EC12ME;;;IAEE,SAAA;ED62MJ;EC33ME;;;IAEE,8CAAA;ED83MJ;EC53ME;;;IAEE,yBAAA;ED+3MJ;EC73ME;;;IAEE,SAXS;ED24Mb;EC93ME;;;IAEE,SAAA;EDi4MJ;EC/4ME;;;IAEE,8CAAA;EDk5MJ;ECh5ME;;;IAEE,yBAAA;EDm5MJ;ECj5ME;;;IAEE,SAXS;ED+5Mb;ECl5ME;;;IAEE,SAAA;EDq5MJ;ECn6ME;;;IAEE,8CAAA;EDs6MJ;ECp6ME;;;IAEE,yBAAA;EDu6MJ;ECr6ME;;;IAEE,SAXS;EDm7Mb;ECt6ME;;;IAEE,SAAA;EDy6MJ;ECv7ME;;;IAEE,8CAAA;ED07MJ;ECx7ME;;;IAEE,yBAAA;ED27MJ;ECz7ME;;;IAEE,SAXS;EDu8Mb;EC17ME;;;IAEE,SAAA;ED67MJ;EC38ME;;;IAEE,8CAAA;ED88MJ;EC58ME;;;IAEE,yBAAA;ED+8MJ;EC78ME;;;IAEE,SAXS;ED29Mb;EC98ME;;;IAEE,SAAA;EDi9MJ;EC/9ME;;;IAEE,8CAAA;EDk+MJ;ECh+ME;;;IAEE,yBAAA;EDm+MJ;ECj+ME;;;IAEE,SAXS;ED++Mb;ECl+ME;;;IAEE,SAAA;EDq+MJ;ECn/ME;;;IAEE,8CAAA;EDs/MJ;ECp/ME;;;IAEE,yBAAA;EDu/MJ;ECr/ME;;;IAEE,SAXS;EDmgNb;ECt/ME;;;IAEE,SAAA;EDy/MJ;ECvgNE;;;IAEE,8CAAA;ED0gNJ;ECxgNE;;;IAEE,yBAAA;ED2gNJ;ECzgNE;;;IAEE,SAXS;EDuhNb;EC1gNE;;;IAEE,SAAA;ED6gNJ;EC3hNE;;;IAEE,8CAAA;ED8hNJ;EC5hNE;;;IAEE,yBAAA;ED+hNJ;EC7hNE;;;IAEE,SAXS;ED2iNb;EC9hNE;;;IAEE,SAAA;EDiiNJ;EC/iNE;;;IAEE,8CAAA;EDkjNJ;EChjNE;;;IAEE,yBAAA;EDmjNJ;ECjjNE;;;IAEE,SAXS;ED+jNb;ECljNE;;;IAEE,SAAA;EDqjNJ;ECnkNE;;;IAEE,8CAAA;EDskNJ;ECpkNE;;;IAEE,yBAAA;EDukNJ;ECrkNE;;;IAEE,SAXS;EDmlNb;ECtkNE;;;IAEE,SAAA;EDykNJ;ECvlNE;;;IAEE,8CAAA;ED0lNJ;ECxlNE;;;IAEE,yBAAA;ED2lNJ;ECzlNE;;;IAEE,SAXS;EDumNb;EC1lNE;;;IAEE,SAAA;ED6lNJ;EC3mNE;;;IAEE,8CAAA;ED8mNJ;EC5mNE;;;IAEE,yBAAA;ED+mNJ;EC7mNE;;;IAEE,SAXS;ED2nNb;EC9mNE;;;IAEE,SAAA;EDinNJ;EC/nNE;;;IAEE,8CAAA;EDkoNJ;EChoNE;;;IAEE,yBAAA;EDmoNJ;ECjoNE;;;IAEE,SAXS;ED+oNb;ECloNE;;;IAEE,SAAA;EDqoNJ;ECnpNE;;;IAEE,8CAAA;EDspNJ;ECppNE;;;IAEE,yBAAA;EDupNJ;ECrpNE;;;IAEE,SAXS;EDmqNb;ECtpNE;;;IAEE,SAAA;EDypNJ;ECvqNE;;;IAEE,8CAAA;ED0qNJ;ECxqNE;;;IAEE,yBAAA;ED2qNJ;ECzqNE;;;IAEE,SAXS;EDurNb;EC1qNE;;;IAEE,SAAA;ED6qNJ;EC3rNE;;;IAEE,8CAAA;ED8rNJ;EC5rNE;;;IAEE,yBAAA;ED+rNJ;EC7rNE;;;IAEE,SAXS;ED2sNb;EC9rNE;;;IAEE,SAAA;EDisNJ;EC3rNA;;IACE,cAAA;ED8rNF;AACF;ACt+ME;EAWE;;;IAEE,0BAAA;ED+9MJ;EC79ME;;;IAEE,oBAPS;EDu+Mb;EC99ME;;;IAEE,kBAXS;ED4+Mb;EC3+ME;;;IAEE,0BAAA;ED8+MJ;EC5+ME;;;IAEE,oBAPS;EDs/Mb;EC7+ME;;;IAEE,kBAXS;ED2/Mb;EC1/ME;;;IAEE,0BAAA;ED6/MJ;EC3/ME;;;IAEE,oBAPS;EDqgNb;EC5/ME;;;IAEE,kBAXS;ED0gNb;ECzgNE;;;IAEE,0BAAA;ED4gNJ;EC1gNE;;;IAEE,oBAPS;EDohNb;EC3gNE;;;IAEE,kBAXS;EDyhNb;ECxhNE;;;IAEE,0BAAA;ED2hNJ;ECzhNE;;;IAEE,oBAPS;EDmiNb;EC1hNE;;;IAEE,kBAXS;EDwiNb;ECviNE;;;IAEE,0BAAA;ED0iNJ;ECxiNE;;;IAEE,oBAPS;EDkjNb;ECziNE;;;IAEE,kBAXS;EDujNb;ECtjNE;;;IAEE,0BAAA;EDyjNJ;ECvjNE;;;IAEE,oBAPS;EDikNb;ECxjNE;;;IAEE,kBAXS;EDskNb;ECrkNE;;;IAEE,0BAAA;EDwkNJ;ECtkNE;;;IAEE,oBAPS;EDglNb;ECvkNE;;;IAEE,kBAXS;EDqlNb;ECplNE;;;IAEE,0BAAA;EDulNJ;ECrlNE;;;IAEE,oBAPS;ED+lNb;ECtlNE;;;IAEE,kBAXS;EDomNb;ECnmNE;;;IAEE,4BAAA;EDsmNJ;ECpmNE;;;IAEE,qBAPS;ED8mNb;ECrmNE;;;IAEE,mBAXS;EDmnNb;EClnNE;;;IAEE,4BAAA;EDqnNJ;ECnnNE;;;IAEE,qBAPS;ED6nNb;ECpnNE;;;IAEE,mBAXS;EDkoNb;ECjoNE;;;IAEE,4BAAA;EDooNJ;ECloNE;;;IAEE,qBAPS;ED4oNb;ECnoNE;;;IAEE,mBAXS;EDipNb;EChpNE;;;IAEE,4BAAA;EDmpNJ;ECjpNE;;;IAEE,qBAPS;ED2pNb;EClpNE;;;IAEE,mBAXS;EDgqNb;EC/pNE;;;IAEE,4BAAA;EDkqNJ;EChqNE;;;IAEE,qBAPS;ED0qNb;ECjqNE;;;IAEE,mBAXS;ED+qNb;EC9qNE;;;IAEE,4BAAA;EDirNJ;EC/qNE;;;IAEE,qBAPS;EDyrNb;EChrNE;;;IAEE,mBAXS;ED8rNb;EC7rNE;;;IAEE,4BAAA;EDgsNJ;EC9rNE;;;IAEE,qBAPS;EDwsNb;EC/rNE;;;IAEE,mBAXS;ED6sNb;EC5sNE;;;IAEE,4BAAA;ED+sNJ;EC7sNE;;;IAEE,qBAPS;EDutNb;EC9sNE;;;IAEE,mBAXS;ED4tNb;EC3tNE;;;IAEE,4BAAA;ED8tNJ;EC5tNE;;;IAEE,qBAPS;EDsuNb;EC7tNE;;;IAEE,mBAXS;ED2uNb;EC1uNE;;;IAEE,4BAAA;ED6uNJ;EC3uNE;;;IAEE,qBAPS;EDqvNb;EC5uNE;;;IAEE,mBAXS;ED0vNb;ECzvNE;;;IAEE,4BAAA;ED4vNJ;EC1vNE;;;IAEE,qBAPS;EDowNb;EC3vNE;;;IAEE,mBAXS;EDywNb;ECxwNE;;;IAEE,4BAAA;ED2wNJ;ECzwNE;;;IAEE,qBAPS;EDmxNb;EC1wNE;;;IAEE,mBAXS;EDwxNb;ECvxNE;;;IAEE,4BAAA;ED0xNJ;ECxxNE;;;IAEE,qBAPS;EDkyNb;ECzxNE;;;IAEE,mBAXS;EDuyNb;ECtyNE;;;IAEE,4BAAA;EDyyNJ;ECvyNE;;;IAEE,qBAPS;EDizNb;ECxyNE;;;IAEE,mBAXS;EDszNb;ECrzNE;;;IAEE,4BAAA;EDwzNJ;ECtzNE;;;IAEE,qBAPS;EDg0Nb;ECvzNE;;;IAEE,mBAXS;EDq0Nb;EC7jOE;;;IAEE,6CAAA;EDgkOJ;EC9jOE;;;IAEE,uBAAA;EDikOJ;EC/jOE;;;IAEE,QAXS;ED6kOb;EChkOE;;;IAEE,SAAA;EDmkOJ;ECjlOE;;;IAEE,6CAAA;EDolOJ;ECllOE;;;IAEE,uBAAA;EDqlOJ;ECnlOE;;;IAEE,QAXS;EDimOb;ECplOE;;;IAEE,SAAA;EDulOJ;ECrmOE;;;IAEE,6CAAA;EDwmOJ;ECtmOE;;;IAEE,uBAAA;EDymOJ;ECvmOE;;;IAEE,QAXS;EDqnOb;ECxmOE;;;IAEE,SAAA;ED2mOJ;ECznOE;;;IAEE,6CAAA;ED4nOJ;EC1nOE;;;IAEE,uBAAA;ED6nOJ;EC3nOE;;;IAEE,QAXS;EDyoOb;EC5nOE;;;IAEE,SAAA;ED+nOJ;EC7oOE;;;IAEE,6CAAA;EDgpOJ;EC9oOE;;;IAEE,uBAAA;EDipOJ;EC/oOE;;;IAEE,QAXS;ED6pOb;EChpOE;;;IAEE,SAAA;EDmpOJ;ECjqOE;;;IAEE,6CAAA;EDoqOJ;EClqOE;;;IAEE,uBAAA;EDqqOJ;ECnqOE;;;IAEE,QAXS;EDirOb;ECpqOE;;;IAEE,SAAA;EDuqOJ;ECrrOE;;;IAEE,6CAAA;EDwrOJ;ECtrOE;;;IAEE,uBAAA;EDyrOJ;ECvrOE;;;IAEE,QAXS;EDqsOb;ECxrOE;;;IAEE,SAAA;ED2rOJ;ECzsOE;;;IAEE,6CAAA;ED4sOJ;EC1sOE;;;IAEE,uBAAA;ED6sOJ;EC3sOE;;;IAEE,QAXS;EDytOb;EC5sOE;;;IAEE,SAAA;ED+sOJ;EC7tOE;;;IAEE,6CAAA;EDguOJ;EC9tOE;;;IAEE,uBAAA;EDiuOJ;EC/tOE;;;IAEE,QAXS;ED6uOb;EChuOE;;;IAEE,SAAA;EDmuOJ;ECjvOE;;;IAEE,8CAAA;EDovOJ;EClvOE;;;IAEE,yBAAA;EDqvOJ;ECnvOE;;;IAEE,SAXS;EDiwOb;ECpvOE;;;IAEE,SAAA;EDuvOJ;ECrwOE;;;IAEE,8CAAA;EDwwOJ;ECtwOE;;;IAEE,yBAAA;EDywOJ;ECvwOE;;;IAEE,SAXS;EDqxOb;ECxwOE;;;IAEE,SAAA;ED2wOJ;ECzxOE;;;IAEE,8CAAA;ED4xOJ;EC1xOE;;;IAEE,yBAAA;ED6xOJ;EC3xOE;;;IAEE,SAXS;EDyyOb;EC5xOE;;;IAEE,SAAA;ED+xOJ;EC7yOE;;;IAEE,8CAAA;EDgzOJ;EC9yOE;;;IAEE,yBAAA;EDizOJ;EC/yOE;;;IAEE,SAXS;ED6zOb;EChzOE;;;IAEE,SAAA;EDmzOJ;ECj0OE;;;IAEE,8CAAA;EDo0OJ;ECl0OE;;;IAEE,yBAAA;EDq0OJ;ECn0OE;;;IAEE,SAXS;EDi1Ob;ECp0OE;;;IAEE,SAAA;EDu0OJ;ECr1OE;;;IAEE,8CAAA;EDw1OJ;ECt1OE;;;IAEE,yBAAA;EDy1OJ;ECv1OE;;;IAEE,SAXS;EDq2Ob;ECx1OE;;;IAEE,SAAA;ED21OJ;ECz2OE;;;IAEE,8CAAA;ED42OJ;EC12OE;;;IAEE,yBAAA;ED62OJ;EC32OE;;;IAEE,SAXS;EDy3Ob;EC52OE;;;IAEE,SAAA;ED+2OJ;EC73OE;;;IAEE,8CAAA;EDg4OJ;EC93OE;;;IAEE,yBAAA;EDi4OJ;EC/3OE;;;IAEE,SAXS;ED64Ob;ECh4OE;;;IAEE,SAAA;EDm4OJ;ECj5OE;;;IAEE,8CAAA;EDo5OJ;ECl5OE;;;IAEE,yBAAA;EDq5OJ;ECn5OE;;;IAEE,SAXS;EDi6Ob;ECp5OE;;;IAEE,SAAA;EDu5OJ;ECr6OE;;;IAEE,8CAAA;EDw6OJ;ECt6OE;;;IAEE,yBAAA;EDy6OJ;ECv6OE;;;IAEE,SAXS;EDq7Ob;ECx6OE;;;IAEE,SAAA;ED26OJ;ECz7OE;;;IAEE,8CAAA;ED47OJ;EC17OE;;;IAEE,yBAAA;ED67OJ;EC37OE;;;IAEE,SAXS;EDy8Ob;EC57OE;;;IAEE,SAAA;ED+7OJ;EC78OE;;;IAEE,8CAAA;EDg9OJ;EC98OE;;;IAEE,yBAAA;EDi9OJ;EC/8OE;;;IAEE,SAXS;ED69Ob;ECh9OE;;;IAEE,SAAA;EDm9OJ;ECj+OE;;;IAEE,8CAAA;EDo+OJ;ECl+OE;;;IAEE,yBAAA;EDq+OJ;ECn+OE;;;IAEE,SAXS;EDi/Ob;ECp+OE;;;IAEE,SAAA;EDu+OJ;ECr/OE;;;IAEE,8CAAA;EDw/OJ;ECt/OE;;;IAEE,yBAAA;EDy/OJ;ECv/OE;;;IAEE,SAXS;EDqgPb;ECx/OE;;;IAEE,SAAA;ED2/OJ;ECzgPE;;;IAEE,8CAAA;ED4gPJ;EC1gPE;;;IAEE,yBAAA;ED6gPJ;EC3gPE;;;IAEE,SAXS;EDyhPb;EC5gPE;;;IAEE,SAAA;ED+gPJ;EC7hPE;;;IAEE,8CAAA;EDgiPJ;EC9hPE;;;IAEE,yBAAA;EDiiPJ;EC/hPE;;;IAEE,SAXS;ED6iPb;EChiPE;;;IAEE,SAAA;EDmiPJ;ECjjPE;;;IAEE,8CAAA;EDojPJ;ECljPE;;;IAEE,yBAAA;EDqjPJ;ECnjPE;;;IAEE,SAXS;EDikPb;ECpjPE;;;IAEE,SAAA;EDujPJ;ECrkPE;;;IAEE,8CAAA;EDwkPJ;ECtkPE;;;IAEE,yBAAA;EDykPJ;ECvkPE;;;IAEE,SAXS;EDqlPb;ECxkPE;;;IAEE,SAAA;ED2kPJ;ECzlPE;;;IAEE,8CAAA;ED4lPJ;EC1lPE;;;IAEE,yBAAA;ED6lPJ;EC3lPE;;;IAEE,SAXS;EDymPb;EC5lPE;;;IAEE,SAAA;ED+lPJ;EC7mPE;;;IAEE,8CAAA;EDgnPJ;EC9mPE;;;IAEE,yBAAA;EDinPJ;EC/mPE;;;IAEE,SAXS;ED6nPb;EChnPE;;;IAEE,SAAA;EDmnPJ;ECjoPE;;;IAEE,8CAAA;EDooPJ;ECloPE;;;IAEE,yBAAA;EDqoPJ;ECnoPE;;;IAEE,SAXS;EDipPb;ECpoPE;;;IAEE,SAAA;EDuoPJ;ECrpPE;;;IAEE,8CAAA;EDwpPJ;ECtpPE;;;IAEE,yBAAA;EDypPJ;ECvpPE;;;IAEE,SAXS;EDqqPb;ECxpPE;;;IAEE,SAAA;ED2pPJ;ECzqPE;;;IAEE,8CAAA;ED4qPJ;EC1qPE;;;IAEE,yBAAA;ED6qPJ;EC3qPE;;;IAEE,SAXS;EDyrPb;EC5qPE;;;IAEE,SAAA;ED+qPJ;EC7rPE;;;IAEE,8CAAA;EDgsPJ;EC9rPE;;;IAEE,yBAAA;EDisPJ;EC/rPE;;;IAEE,SAXS;ED6sPb;EChsPE;;;IAEE,SAAA;EDmsPJ;ECjtPE;;;IAEE,8CAAA;EDotPJ;ECltPE;;;IAEE,yBAAA;EDqtPJ;ECntPE;;;IAEE,SAXS;EDiuPb;ECptPE;;;IAEE,SAAA;EDutPJ;ECruPE;;;IAEE,8CAAA;EDwuPJ;ECtuPE;;;IAEE,yBAAA;EDyuPJ;ECvuPE;;;IAEE,SAXS;EDqvPb;ECxuPE;;;IAEE,SAAA;ED2uPJ;ECzvPE;;;IAEE,8CAAA;ED4vPJ;EC1vPE;;;IAEE,yBAAA;ED6vPJ;EC3vPE;;;IAEE,SAXS;EDywPb;EC5vPE;;;IAEE,SAAA;ED+vPJ;EC7wPE;;;IAEE,8CAAA;EDgxPJ;EC9wPE;;;IAEE,yBAAA;EDixPJ;EC/wPE;;;IAEE,SAXS;ED6xPb;EChxPE;;;IAEE,SAAA;EDmxPJ;ECjyPE;;;IAEE,8CAAA;EDoyPJ;EClyPE;;;IAEE,yBAAA;EDqyPJ;ECnyPE;;;IAEE,SAXS;EDizPb;ECpyPE;;;IAEE,SAAA;EDuyPJ;ECrzPE;;;IAEE,8CAAA;EDwzPJ;ECtzPE;;;IAEE,yBAAA;EDyzPJ;ECvzPE;;;IAEE,SAXS;EDq0Pb;ECxzPE;;;IAEE,SAAA;ED2zPJ;ECz0PE;;;IAEE,8CAAA;ED40PJ;EC10PE;;;IAEE,yBAAA;ED60PJ;EC30PE;;;IAEE,SAXS;EDy1Pb;EC50PE;;;IAEE,SAAA;ED+0PJ;EC71PE;;;IAEE,8CAAA;EDg2PJ;EC91PE;;;IAEE,yBAAA;EDi2PJ;EC/1PE;;;IAEE,SAXS;ED62Pb;ECh2PE;;;IAEE,SAAA;EDm2PJ;ECj3PE;;;IAEE,8CAAA;EDo3PJ;ECl3PE;;;IAEE,yBAAA;EDq3PJ;ECn3PE;;;IAEE,SAXS;EDi4Pb;ECp3PE;;;IAEE,SAAA;EDu3PJ;ECr4PE;;;IAEE,8CAAA;EDw4PJ;ECt4PE;;;IAEE,yBAAA;EDy4PJ;ECv4PE;;;IAEE,SAXS;EDq5Pb;ECx4PE;;;IAEE,SAAA;ED24PJ;ECz5PE;;;IAEE,8CAAA;ED45PJ;EC15PE;;;IAEE,yBAAA;ED65PJ;EC35PE;;;IAEE,SAXS;EDy6Pb;EC55PE;;;IAEE,SAAA;ED+5PJ;EC76PE;;;IAEE,8CAAA;EDg7PJ;EC96PE;;;IAEE,yBAAA;EDi7PJ;EC/6PE;;;IAEE,SAXS;ED67Pb;ECh7PE;;;IAEE,SAAA;EDm7PJ;ECj8PE;;;IAEE,8CAAA;EDo8PJ;ECl8PE;;;IAEE,yBAAA;EDq8PJ;ECn8PE;;;IAEE,SAXS;EDi9Pb;ECp8PE;;;IAEE,SAAA;EDu8PJ;ECr9PE;;;IAEE,8CAAA;EDw9PJ;ECt9PE;;;IAEE,yBAAA;EDy9PJ;ECv9PE;;;IAEE,SAXS;EDq+Pb;ECx9PE;;;IAEE,SAAA;ED29PJ;ECz+PE;;;IAEE,8CAAA;ED4+PJ;EC1+PE;;;IAEE,yBAAA;ED6+PJ;EC3+PE;;;IAEE,SAXS;EDy/Pb;EC5+PE;;;IAEE,SAAA;ED++PJ;EC7/PE;;;IAEE,8CAAA;EDggQJ;EC9/PE;;;IAEE,yBAAA;EDigQJ;EC//PE;;;IAEE,SAXS;ED6gQb;EChgQE;;;IAEE,SAAA;EDmgQJ;ECjhQE;;;IAEE,8CAAA;EDohQJ;EClhQE;;;IAEE,yBAAA;EDqhQJ;ECnhQE;;;IAEE,SAXS;EDiiQb;ECphQE;;;IAEE,SAAA;EDuhQJ;ECjhQA;;IACE,cAAA;EDohQF;AACF;AC1zPE;EASE;;;IAEE,0BAAA;EDqzPJ;ECnzPE;;;IAEE,oBAPS;ED6zPb;ECpzPE;;;IAEE,kBAXS;EDk0Pb;ECj0PE;;;IAEE,0BAAA;EDo0PJ;ECl0PE;;;IAEE,oBAPS;ED40Pb;ECn0PE;;;IAEE,kBAXS;EDi1Pb;ECh1PE;;;IAEE,0BAAA;EDm1PJ;ECj1PE;;;IAEE,oBAPS;ED21Pb;ECl1PE;;;IAEE,kBAXS;EDg2Pb;EC/1PE;;;IAEE,0BAAA;EDk2PJ;ECh2PE;;;IAEE,oBAPS;ED02Pb;ECj2PE;;;IAEE,kBAXS;ED+2Pb;EC92PE;;;IAEE,0BAAA;EDi3PJ;EC/2PE;;;IAEE,oBAPS;EDy3Pb;ECh3PE;;;IAEE,kBAXS;ED83Pb;EC73PE;;;IAEE,0BAAA;EDg4PJ;EC93PE;;;IAEE,oBAPS;EDw4Pb;EC/3PE;;;IAEE,kBAXS;ED64Pb;EC54PE;;;IAEE,0BAAA;ED+4PJ;EC74PE;;;IAEE,oBAPS;EDu5Pb;EC94PE;;;IAEE,kBAXS;ED45Pb;EC35PE;;;IAEE,0BAAA;ED85PJ;EC55PE;;;IAEE,oBAPS;EDs6Pb;EC75PE;;;IAEE,kBAXS;ED26Pb;EC16PE;;;IAEE,0BAAA;ED66PJ;EC36PE;;;IAEE,oBAPS;EDq7Pb;EC56PE;;;IAEE,kBAXS;ED07Pb;ECz7PE;;;IAEE,4BAAA;ED47PJ;EC17PE;;;IAEE,qBAPS;EDo8Pb;EC37PE;;;IAEE,mBAXS;EDy8Pb;ECx8PE;;;IAEE,4BAAA;ED28PJ;ECz8PE;;;IAEE,qBAPS;EDm9Pb;EC18PE;;;IAEE,mBAXS;EDw9Pb;ECv9PE;;;IAEE,4BAAA;ED09PJ;ECx9PE;;;IAEE,qBAPS;EDk+Pb;ECz9PE;;;IAEE,mBAXS;EDu+Pb;ECt+PE;;;IAEE,4BAAA;EDy+PJ;ECv+PE;;;IAEE,qBAPS;EDi/Pb;ECx+PE;;;IAEE,mBAXS;EDs/Pb;ECr/PE;;;IAEE,4BAAA;EDw/PJ;ECt/PE;;;IAEE,qBAPS;EDggQb;ECv/PE;;;IAEE,mBAXS;EDqgQb;ECpgQE;;;IAEE,4BAAA;EDugQJ;ECrgQE;;;IAEE,qBAPS;ED+gQb;ECtgQE;;;IAEE,mBAXS;EDohQb;ECnhQE;;;IAEE,4BAAA;EDshQJ;ECphQE;;;IAEE,qBAPS;ED8hQb;ECrhQE;;;IAEE,mBAXS;EDmiQb;ECliQE;;;IAEE,4BAAA;EDqiQJ;ECniQE;;;IAEE,qBAPS;ED6iQb;ECpiQE;;;IAEE,mBAXS;EDkjQb;ECjjQE;;;IAEE,4BAAA;EDojQJ;ECljQE;;;IAEE,qBAPS;ED4jQb;ECnjQE;;;IAEE,mBAXS;EDikQb;EChkQE;;;IAEE,4BAAA;EDmkQJ;ECjkQE;;;IAEE,qBAPS;ED2kQb;EClkQE;;;IAEE,mBAXS;EDglQb;EC/kQE;;;IAEE,4BAAA;EDklQJ;EChlQE;;;IAEE,qBAPS;ED0lQb;ECjlQE;;;IAEE,mBAXS;ED+lQb;EC9lQE;;;IAEE,4BAAA;EDimQJ;EC/lQE;;;IAEE,qBAPS;EDymQb;EChmQE;;;IAEE,mBAXS;ED8mQb;EC7mQE;;;IAEE,4BAAA;EDgnQJ;EC9mQE;;;IAEE,qBAPS;EDwnQb;EC/mQE;;;IAEE,mBAXS;ED6nQb;EC5nQE;;;IAEE,4BAAA;ED+nQJ;EC7nQE;;;IAEE,qBAPS;EDuoQb;EC9nQE;;;IAEE,mBAXS;ED4oQb;EC3oQE;;;IAEE,4BAAA;ED8oQJ;EC5oQE;;;IAEE,qBAPS;EDspQb;EC7oQE;;;IAEE,mBAXS;ED2pQb;ECn5QE;;;IAEE,6CAAA;EDs5QJ;ECp5QE;;;IAEE,uBAAA;EDu5QJ;ECr5QE;;;IAEE,QAXS;EDm6Qb;ECt5QE;;;IAEE,SAAA;EDy5QJ;ECv6QE;;;IAEE,6CAAA;ED06QJ;ECx6QE;;;IAEE,uBAAA;ED26QJ;ECz6QE;;;IAEE,QAXS;EDu7Qb;EC16QE;;;IAEE,SAAA;ED66QJ;EC37QE;;;IAEE,6CAAA;ED87QJ;EC57QE;;;IAEE,uBAAA;ED+7QJ;EC77QE;;;IAEE,QAXS;ED28Qb;EC97QE;;;IAEE,SAAA;EDi8QJ;EC/8QE;;;IAEE,6CAAA;EDk9QJ;ECh9QE;;;IAEE,uBAAA;EDm9QJ;ECj9QE;;;IAEE,QAXS;ED+9Qb;ECl9QE;;;IAEE,SAAA;EDq9QJ;ECn+QE;;;IAEE,6CAAA;EDs+QJ;ECp+QE;;;IAEE,uBAAA;EDu+QJ;ECr+QE;;;IAEE,QAXS;EDm/Qb;ECt+QE;;;IAEE,SAAA;EDy+QJ;ECv/QE;;;IAEE,6CAAA;ED0/QJ;ECx/QE;;;IAEE,uBAAA;ED2/QJ;ECz/QE;;;IAEE,QAXS;EDugRb;EC1/QE;;;IAEE,SAAA;ED6/QJ;EC3gRE;;;IAEE,6CAAA;ED8gRJ;EC5gRE;;;IAEE,uBAAA;ED+gRJ;EC7gRE;;;IAEE,QAXS;ED2hRb;EC9gRE;;;IAEE,SAAA;EDihRJ;EC/hRE;;;IAEE,6CAAA;EDkiRJ;EChiRE;;;IAEE,uBAAA;EDmiRJ;ECjiRE;;;IAEE,QAXS;ED+iRb;ECliRE;;;IAEE,SAAA;EDqiRJ;ECnjRE;;;IAEE,6CAAA;EDsjRJ;ECpjRE;;;IAEE,uBAAA;EDujRJ;ECrjRE;;;IAEE,QAXS;EDmkRb;ECtjRE;;;IAEE,SAAA;EDyjRJ;ECvkRE;;;IAEE,8CAAA;ED0kRJ;ECxkRE;;;IAEE,yBAAA;ED2kRJ;ECzkRE;;;IAEE,SAXS;EDulRb;EC1kRE;;;IAEE,SAAA;ED6kRJ;EC3lRE;;;IAEE,8CAAA;ED8lRJ;EC5lRE;;;IAEE,yBAAA;ED+lRJ;EC7lRE;;;IAEE,SAXS;ED2mRb;EC9lRE;;;IAEE,SAAA;EDimRJ;EC/mRE;;;IAEE,8CAAA;EDknRJ;EChnRE;;;IAEE,yBAAA;EDmnRJ;ECjnRE;;;IAEE,SAXS;ED+nRb;EClnRE;;;IAEE,SAAA;EDqnRJ;ECnoRE;;;IAEE,8CAAA;EDsoRJ;ECpoRE;;;IAEE,yBAAA;EDuoRJ;ECroRE;;;IAEE,SAXS;EDmpRb;ECtoRE;;;IAEE,SAAA;EDyoRJ;ECvpRE;;;IAEE,8CAAA;ED0pRJ;ECxpRE;;;IAEE,yBAAA;ED2pRJ;ECzpRE;;;IAEE,SAXS;EDuqRb;EC1pRE;;;IAEE,SAAA;ED6pRJ;EC3qRE;;;IAEE,8CAAA;ED8qRJ;EC5qRE;;;IAEE,yBAAA;ED+qRJ;EC7qRE;;;IAEE,SAXS;ED2rRb;EC9qRE;;;IAEE,SAAA;EDirRJ;EC/rRE;;;IAEE,8CAAA;EDksRJ;EChsRE;;;IAEE,yBAAA;EDmsRJ;ECjsRE;;;IAEE,SAXS;ED+sRb;EClsRE;;;IAEE,SAAA;EDqsRJ;ECntRE;;;IAEE,8CAAA;EDstRJ;ECptRE;;;IAEE,yBAAA;EDutRJ;ECrtRE;;;IAEE,SAXS;EDmuRb;ECttRE;;;IAEE,SAAA;EDytRJ;ECvuRE;;;IAEE,8CAAA;ED0uRJ;ECxuRE;;;IAEE,yBAAA;ED2uRJ;ECzuRE;;;IAEE,SAXS;EDuvRb;EC1uRE;;;IAEE,SAAA;ED6uRJ;EC3vRE;;;IAEE,8CAAA;ED8vRJ;EC5vRE;;;IAEE,yBAAA;ED+vRJ;EC7vRE;;;IAEE,SAXS;ED2wRb;EC9vRE;;;IAEE,SAAA;EDiwRJ;EC/wRE;;;IAEE,8CAAA;EDkxRJ;EChxRE;;;IAEE,yBAAA;EDmxRJ;ECjxRE;;;IAEE,SAXS;ED+xRb;EClxRE;;;IAEE,SAAA;EDqxRJ;ECnyRE;;;IAEE,8CAAA;EDsyRJ;ECpyRE;;;IAEE,yBAAA;EDuyRJ;ECryRE;;;IAEE,SAXS;EDmzRb;ECtyRE;;;IAEE,SAAA;EDyyRJ;ECvzRE;;;IAEE,8CAAA;ED0zRJ;ECxzRE;;;IAEE,yBAAA;ED2zRJ;ECzzRE;;;IAEE,SAXS;EDu0Rb;EC1zRE;;;IAEE,SAAA;ED6zRJ;EC30RE;;;IAEE,8CAAA;ED80RJ;EC50RE;;;IAEE,yBAAA;ED+0RJ;EC70RE;;;IAEE,SAXS;ED21Rb;EC90RE;;;IAEE,SAAA;EDi1RJ;EC/1RE;;;IAEE,8CAAA;EDk2RJ;ECh2RE;;;IAEE,yBAAA;EDm2RJ;ECj2RE;;;IAEE,SAXS;ED+2Rb;ECl2RE;;;IAEE,SAAA;EDq2RJ;ECn3RE;;;IAEE,8CAAA;EDs3RJ;ECp3RE;;;IAEE,yBAAA;EDu3RJ;ECr3RE;;;IAEE,SAXS;EDm4Rb;ECt3RE;;;IAEE,SAAA;EDy3RJ;ECv4RE;;;IAEE,8CAAA;ED04RJ;ECx4RE;;;IAEE,yBAAA;ED24RJ;ECz4RE;;;IAEE,SAXS;EDu5Rb;EC14RE;;;IAEE,SAAA;ED64RJ;EC35RE;;;IAEE,8CAAA;ED85RJ;EC55RE;;;IAEE,yBAAA;ED+5RJ;EC75RE;;;IAEE,SAXS;ED26Rb;EC95RE;;;IAEE,SAAA;EDi6RJ;EC/6RE;;;IAEE,8CAAA;EDk7RJ;ECh7RE;;;IAEE,yBAAA;EDm7RJ;ECj7RE;;;IAEE,SAXS;ED+7Rb;ECl7RE;;;IAEE,SAAA;EDq7RJ;ECn8RE;;;IAEE,8CAAA;EDs8RJ;ECp8RE;;;IAEE,yBAAA;EDu8RJ;ECr8RE;;;IAEE,SAXS;EDm9Rb;ECt8RE;;;IAEE,SAAA;EDy8RJ;ECv9RE;;;IAEE,8CAAA;ED09RJ;ECx9RE;;;IAEE,yBAAA;ED29RJ;ECz9RE;;;IAEE,SAXS;EDu+Rb;EC19RE;;;IAEE,SAAA;ED69RJ;EC3+RE;;;IAEE,8CAAA;ED8+RJ;EC5+RE;;;IAEE,yBAAA;ED++RJ;EC7+RE;;;IAEE,SAXS;ED2/Rb;EC9+RE;;;IAEE,SAAA;EDi/RJ;EC//RE;;;IAEE,8CAAA;EDkgSJ;EChgSE;;;IAEE,yBAAA;EDmgSJ;ECjgSE;;;IAEE,SAXS;ED+gSb;EClgSE;;;IAEE,SAAA;EDqgSJ;ECnhSE;;;IAEE,8CAAA;EDshSJ;ECphSE;;;IAEE,yBAAA;EDuhSJ;ECrhSE;;;IAEE,SAXS;EDmiSb;ECthSE;;;IAEE,SAAA;EDyhSJ;ECviSE;;;IAEE,8CAAA;ED0iSJ;ECxiSE;;;IAEE,yBAAA;ED2iSJ;ECziSE;;;IAEE,SAXS;EDujSb;EC1iSE;;;IAEE,SAAA;ED6iSJ;EC3jSE;;;IAEE,8CAAA;ED8jSJ;EC5jSE;;;IAEE,yBAAA;ED+jSJ;EC7jSE;;;IAEE,SAXS;ED2kSb;EC9jSE;;;IAEE,SAAA;EDikSJ;EC/kSE;;;IAEE,8CAAA;EDklSJ;EChlSE;;;IAEE,yBAAA;EDmlSJ;ECjlSE;;;IAEE,SAXS;ED+lSb;ECllSE;;;IAEE,SAAA;EDqlSJ;ECnmSE;;;IAEE,8CAAA;EDsmSJ;ECpmSE;;;IAEE,yBAAA;EDumSJ;ECrmSE;;;IAEE,SAXS;EDmnSb;ECtmSE;;;IAEE,SAAA;EDymSJ;ECvnSE;;;IAEE,8CAAA;ED0nSJ;ECxnSE;;;IAEE,yBAAA;ED2nSJ;ECznSE;;;IAEE,SAXS;EDuoSb;EC1nSE;;;IAEE,SAAA;ED6nSJ;EC3oSE;;;IAEE,8CAAA;ED8oSJ;EC5oSE;;;IAEE,yBAAA;ED+oSJ;EC7oSE;;;IAEE,SAXS;ED2pSb;EC9oSE;;;IAEE,SAAA;EDipSJ;EC/pSE;;;IAEE,8CAAA;EDkqSJ;EChqSE;;;IAEE,yBAAA;EDmqSJ;ECjqSE;;;IAEE,SAXS;ED+qSb;EClqSE;;;IAEE,SAAA;EDqqSJ;ECnrSE;;;IAEE,8CAAA;EDsrSJ;ECprSE;;;IAEE,yBAAA;EDurSJ;ECrrSE;;;IAEE,SAXS;EDmsSb;ECtrSE;;;IAEE,SAAA;EDyrSJ;ECvsSE;;;IAEE,8CAAA;ED0sSJ;ECxsSE;;;IAEE,yBAAA;ED2sSJ;ECzsSE;;;IAEE,SAXS;EDutSb;EC1sSE;;;IAEE,SAAA;ED6sSJ;EC3tSE;;;IAEE,8CAAA;ED8tSJ;EC5tSE;;;IAEE,yBAAA;ED+tSJ;EC7tSE;;;IAEE,SAXS;ED2uSb;EC9tSE;;;IAEE,SAAA;EDiuSJ;EC/uSE;;;IAEE,8CAAA;EDkvSJ;EChvSE;;;IAEE,yBAAA;EDmvSJ;ECjvSE;;;IAEE,SAXS;ED+vSb;EClvSE;;;IAEE,SAAA;EDqvSJ;ECnwSE;;;IAEE,8CAAA;EDswSJ;ECpwSE;;;IAEE,yBAAA;EDuwSJ;ECrwSE;;;IAEE,SAXS;EDmxSb;ECtwSE;;;IAEE,SAAA;EDywSJ;ECvxSE;;;IAEE,8CAAA;ED0xSJ;ECxxSE;;;IAEE,yBAAA;ED2xSJ;ECzxSE;;;IAEE,SAXS;EDuySb;EC1xSE;;;IAEE,SAAA;ED6xSJ;EC3ySE;;;IAEE,8CAAA;ED8ySJ;EC5ySE;;;IAEE,yBAAA;ED+ySJ;EC7ySE;;;IAEE,SAXS;ED2zSb;EC9ySE;;;IAEE,SAAA;EDizSJ;EC/zSE;;;IAEE,8CAAA;EDk0SJ;ECh0SE;;;IAEE,yBAAA;EDm0SJ;ECj0SE;;;IAEE,SAXS;ED+0Sb;ECl0SE;;;IAEE,SAAA;EDq0SJ;ECn1SE;;;IAEE,8CAAA;EDs1SJ;ECp1SE;;;IAEE,yBAAA;EDu1SJ;ECr1SE;;;IAEE,SAXS;EDm2Sb;ECt1SE;;;IAEE,SAAA;EDy1SJ;ECv2SE;;;IAEE,8CAAA;ED02SJ;ECx2SE;;;IAEE,yBAAA;ED22SJ;ECz2SE;;;IAEE,SAXS;EDu3Sb;EC12SE;;;IAEE,SAAA;ED62SJ;ECv2SA;;IACE,cAAA;ED02SF;AACF;AC9oSE;EAOE;;;IAEE,0BAAA;ED2oSJ;ECzoSE;;;IAEE,oBAPS;EDmpSb;EC1oSE;;;IAEE,kBAXS;EDwpSb;ECvpSE;;;IAEE,0BAAA;ED0pSJ;ECxpSE;;;IAEE,oBAPS;EDkqSb;ECzpSE;;;IAEE,kBAXS;EDuqSb;ECtqSE;;;IAEE,0BAAA;EDyqSJ;ECvqSE;;;IAEE,oBAPS;EDirSb;ECxqSE;;;IAEE,kBAXS;EDsrSb;ECrrSE;;;IAEE,0BAAA;EDwrSJ;ECtrSE;;;IAEE,oBAPS;EDgsSb;ECvrSE;;;IAEE,kBAXS;EDqsSb;ECpsSE;;;IAEE,0BAAA;EDusSJ;ECrsSE;;;IAEE,oBAPS;ED+sSb;ECtsSE;;;IAEE,kBAXS;EDotSb;ECntSE;;;IAEE,0BAAA;EDstSJ;ECptSE;;;IAEE,oBAPS;ED8tSb;ECrtSE;;;IAEE,kBAXS;EDmuSb;ECluSE;;;IAEE,0BAAA;EDquSJ;ECnuSE;;;IAEE,oBAPS;ED6uSb;ECpuSE;;;IAEE,kBAXS;EDkvSb;ECjvSE;;;IAEE,0BAAA;EDovSJ;EClvSE;;;IAEE,oBAPS;ED4vSb;ECnvSE;;;IAEE,kBAXS;EDiwSb;EChwSE;;;IAEE,0BAAA;EDmwSJ;ECjwSE;;;IAEE,oBAPS;ED2wSb;EClwSE;;;IAEE,kBAXS;EDgxSb;EC/wSE;;;IAEE,4BAAA;EDkxSJ;EChxSE;;;IAEE,qBAPS;ED0xSb;ECjxSE;;;IAEE,mBAXS;ED+xSb;EC9xSE;;;IAEE,4BAAA;EDiySJ;EC/xSE;;;IAEE,qBAPS;EDyySb;EChySE;;;IAEE,mBAXS;ED8ySb;EC7ySE;;;IAEE,4BAAA;EDgzSJ;EC9ySE;;;IAEE,qBAPS;EDwzSb;EC/ySE;;;IAEE,mBAXS;ED6zSb;EC5zSE;;;IAEE,4BAAA;ED+zSJ;EC7zSE;;;IAEE,qBAPS;EDu0Sb;EC9zSE;;;IAEE,mBAXS;ED40Sb;EC30SE;;;IAEE,4BAAA;ED80SJ;EC50SE;;;IAEE,qBAPS;EDs1Sb;EC70SE;;;IAEE,mBAXS;ED21Sb;EC11SE;;;IAEE,4BAAA;ED61SJ;EC31SE;;;IAEE,qBAPS;EDq2Sb;EC51SE;;;IAEE,mBAXS;ED02Sb;ECz2SE;;;IAEE,4BAAA;ED42SJ;EC12SE;;;IAEE,qBAPS;EDo3Sb;EC32SE;;;IAEE,mBAXS;EDy3Sb;ECx3SE;;;IAEE,4BAAA;ED23SJ;ECz3SE;;;IAEE,qBAPS;EDm4Sb;EC13SE;;;IAEE,mBAXS;EDw4Sb;ECv4SE;;;IAEE,4BAAA;ED04SJ;ECx4SE;;;IAEE,qBAPS;EDk5Sb;ECz4SE;;;IAEE,mBAXS;EDu5Sb;ECt5SE;;;IAEE,4BAAA;EDy5SJ;ECv5SE;;;IAEE,qBAPS;EDi6Sb;ECx5SE;;;IAEE,mBAXS;EDs6Sb;ECr6SE;;;IAEE,4BAAA;EDw6SJ;ECt6SE;;;IAEE,qBAPS;EDg7Sb;ECv6SE;;;IAEE,mBAXS;EDq7Sb;ECp7SE;;;IAEE,4BAAA;EDu7SJ;ECr7SE;;;IAEE,qBAPS;ED+7Sb;ECt7SE;;;IAEE,mBAXS;EDo8Sb;ECn8SE;;;IAEE,4BAAA;EDs8SJ;ECp8SE;;;IAEE,qBAPS;ED88Sb;ECr8SE;;;IAEE,mBAXS;EDm9Sb;ECl9SE;;;IAEE,4BAAA;EDq9SJ;ECn9SE;;;IAEE,qBAPS;ED69Sb;ECp9SE;;;IAEE,mBAXS;EDk+Sb;ECj+SE;;;IAEE,4BAAA;EDo+SJ;ECl+SE;;;IAEE,qBAPS;ED4+Sb;ECn+SE;;;IAEE,mBAXS;EDi/Sb;ECzuTE;;;IAEE,6CAAA;ED4uTJ;EC1uTE;;;IAEE,uBAAA;ED6uTJ;EC3uTE;;;IAEE,QAXS;EDyvTb;EC5uTE;;;IAEE,SAAA;ED+uTJ;EC7vTE;;;IAEE,6CAAA;EDgwTJ;EC9vTE;;;IAEE,uBAAA;EDiwTJ;EC/vTE;;;IAEE,QAXS;ED6wTb;EChwTE;;;IAEE,SAAA;EDmwTJ;ECjxTE;;;IAEE,6CAAA;EDoxTJ;EClxTE;;;IAEE,uBAAA;EDqxTJ;ECnxTE;;;IAEE,QAXS;EDiyTb;ECpxTE;;;IAEE,SAAA;EDuxTJ;ECryTE;;;IAEE,6CAAA;EDwyTJ;ECtyTE;;;IAEE,uBAAA;EDyyTJ;ECvyTE;;;IAEE,QAXS;EDqzTb;ECxyTE;;;IAEE,SAAA;ED2yTJ;ECzzTE;;;IAEE,6CAAA;ED4zTJ;EC1zTE;;;IAEE,uBAAA;ED6zTJ;EC3zTE;;;IAEE,QAXS;EDy0Tb;EC5zTE;;;IAEE,SAAA;ED+zTJ;EC70TE;;;IAEE,6CAAA;EDg1TJ;EC90TE;;;IAEE,uBAAA;EDi1TJ;EC/0TE;;;IAEE,QAXS;ED61Tb;ECh1TE;;;IAEE,SAAA;EDm1TJ;ECj2TE;;;IAEE,6CAAA;EDo2TJ;ECl2TE;;;IAEE,uBAAA;EDq2TJ;ECn2TE;;;IAEE,QAXS;EDi3Tb;ECp2TE;;;IAEE,SAAA;EDu2TJ;ECr3TE;;;IAEE,6CAAA;EDw3TJ;ECt3TE;;;IAEE,uBAAA;EDy3TJ;ECv3TE;;;IAEE,QAXS;EDq4Tb;ECx3TE;;;IAEE,SAAA;ED23TJ;ECz4TE;;;IAEE,6CAAA;ED44TJ;EC14TE;;;IAEE,uBAAA;ED64TJ;EC34TE;;;IAEE,QAXS;EDy5Tb;EC54TE;;;IAEE,SAAA;ED+4TJ;EC75TE;;;IAEE,8CAAA;EDg6TJ;EC95TE;;;IAEE,yBAAA;EDi6TJ;EC/5TE;;;IAEE,SAXS;ED66Tb;ECh6TE;;;IAEE,SAAA;EDm6TJ;ECj7TE;;;IAEE,8CAAA;EDo7TJ;ECl7TE;;;IAEE,yBAAA;EDq7TJ;ECn7TE;;;IAEE,SAXS;EDi8Tb;ECp7TE;;;IAEE,SAAA;EDu7TJ;ECr8TE;;;IAEE,8CAAA;EDw8TJ;ECt8TE;;;IAEE,yBAAA;EDy8TJ;ECv8TE;;;IAEE,SAXS;EDq9Tb;ECx8TE;;;IAEE,SAAA;ED28TJ;ECz9TE;;;IAEE,8CAAA;ED49TJ;EC19TE;;;IAEE,yBAAA;ED69TJ;EC39TE;;;IAEE,SAXS;EDy+Tb;EC59TE;;;IAEE,SAAA;ED+9TJ;EC7+TE;;;IAEE,8CAAA;EDg/TJ;EC9+TE;;;IAEE,yBAAA;EDi/TJ;EC/+TE;;;IAEE,SAXS;ED6/Tb;ECh/TE;;;IAEE,SAAA;EDm/TJ;ECjgUE;;;IAEE,8CAAA;EDogUJ;EClgUE;;;IAEE,yBAAA;EDqgUJ;ECngUE;;;IAEE,SAXS;EDihUb;ECpgUE;;;IAEE,SAAA;EDugUJ;ECrhUE;;;IAEE,8CAAA;EDwhUJ;ECthUE;;;IAEE,yBAAA;EDyhUJ;ECvhUE;;;IAEE,SAXS;EDqiUb;ECxhUE;;;IAEE,SAAA;ED2hUJ;ECziUE;;;IAEE,8CAAA;ED4iUJ;EC1iUE;;;IAEE,yBAAA;ED6iUJ;EC3iUE;;;IAEE,SAXS;EDyjUb;EC5iUE;;;IAEE,SAAA;ED+iUJ;EC7jUE;;;IAEE,8CAAA;EDgkUJ;EC9jUE;;;IAEE,yBAAA;EDikUJ;EC/jUE;;;IAEE,SAXS;ED6kUb;EChkUE;;;IAEE,SAAA;EDmkUJ;ECjlUE;;;IAEE,8CAAA;EDolUJ;ECllUE;;;IAEE,yBAAA;EDqlUJ;ECnlUE;;;IAEE,SAXS;EDimUb;ECplUE;;;IAEE,SAAA;EDulUJ;ECrmUE;;;IAEE,8CAAA;EDwmUJ;ECtmUE;;;IAEE,yBAAA;EDymUJ;ECvmUE;;;IAEE,SAXS;EDqnUb;ECxmUE;;;IAEE,SAAA;ED2mUJ;ECznUE;;;IAEE,8CAAA;ED4nUJ;EC1nUE;;;IAEE,yBAAA;ED6nUJ;EC3nUE;;;IAEE,SAXS;EDyoUb;EC5nUE;;;IAEE,SAAA;ED+nUJ;EC7oUE;;;IAEE,8CAAA;EDgpUJ;EC9oUE;;;IAEE,yBAAA;EDipUJ;EC/oUE;;;IAEE,SAXS;ED6pUb;EChpUE;;;IAEE,SAAA;EDmpUJ;ECjqUE;;;IAEE,8CAAA;EDoqUJ;EClqUE;;;IAEE,yBAAA;EDqqUJ;ECnqUE;;;IAEE,SAXS;EDirUb;ECpqUE;;;IAEE,SAAA;EDuqUJ;ECrrUE;;;IAEE,8CAAA;EDwrUJ;ECtrUE;;;IAEE,yBAAA;EDyrUJ;ECvrUE;;;IAEE,SAXS;EDqsUb;ECxrUE;;;IAEE,SAAA;ED2rUJ;ECzsUE;;;IAEE,8CAAA;ED4sUJ;EC1sUE;;;IAEE,yBAAA;ED6sUJ;EC3sUE;;;IAEE,SAXS;EDytUb;EC5sUE;;;IAEE,SAAA;ED+sUJ;EC7tUE;;;IAEE,8CAAA;EDguUJ;EC9tUE;;;IAEE,yBAAA;EDiuUJ;EC/tUE;;;IAEE,SAXS;ED6uUb;EChuUE;;;IAEE,SAAA;EDmuUJ;ECjvUE;;;IAEE,8CAAA;EDovUJ;EClvUE;;;IAEE,yBAAA;EDqvUJ;ECnvUE;;;IAEE,SAXS;EDiwUb;ECpvUE;;;IAEE,SAAA;EDuvUJ;ECrwUE;;;IAEE,8CAAA;EDwwUJ;ECtwUE;;;IAEE,yBAAA;EDywUJ;ECvwUE;;;IAEE,SAXS;EDqxUb;ECxwUE;;;IAEE,SAAA;ED2wUJ;ECzxUE;;;IAEE,8CAAA;ED4xUJ;EC1xUE;;;IAEE,yBAAA;ED6xUJ;EC3xUE;;;IAEE,SAXS;EDyyUb;EC5xUE;;;IAEE,SAAA;ED+xUJ;EC7yUE;;;IAEE,8CAAA;EDgzUJ;EC9yUE;;;IAEE,yBAAA;EDizUJ;EC/yUE;;;IAEE,SAXS;ED6zUb;EChzUE;;;IAEE,SAAA;EDmzUJ;ECj0UE;;;IAEE,8CAAA;EDo0UJ;ECl0UE;;;IAEE,yBAAA;EDq0UJ;ECn0UE;;;IAEE,SAXS;EDi1Ub;ECp0UE;;;IAEE,SAAA;EDu0UJ;ECr1UE;;;IAEE,8CAAA;EDw1UJ;ECt1UE;;;IAEE,yBAAA;EDy1UJ;ECv1UE;;;IAEE,SAXS;EDq2Ub;ECx1UE;;;IAEE,SAAA;ED21UJ;ECz2UE;;;IAEE,8CAAA;ED42UJ;EC12UE;;;IAEE,yBAAA;ED62UJ;EC32UE;;;IAEE,SAXS;EDy3Ub;EC52UE;;;IAEE,SAAA;ED+2UJ;EC73UE;;;IAEE,8CAAA;EDg4UJ;EC93UE;;;IAEE,yBAAA;EDi4UJ;EC/3UE;;;IAEE,SAXS;ED64Ub;ECh4UE;;;IAEE,SAAA;EDm4UJ;ECj5UE;;;IAEE,8CAAA;EDo5UJ;ECl5UE;;;IAEE,yBAAA;EDq5UJ;ECn5UE;;;IAEE,SAXS;EDi6Ub;ECp5UE;;;IAEE,SAAA;EDu5UJ;ECr6UE;;;IAEE,8CAAA;EDw6UJ;ECt6UE;;;IAEE,yBAAA;EDy6UJ;ECv6UE;;;IAEE,SAXS;EDq7Ub;ECx6UE;;;IAEE,SAAA;ED26UJ;ECz7UE;;;IAEE,8CAAA;ED47UJ;EC17UE;;;IAEE,yBAAA;ED67UJ;EC37UE;;;IAEE,SAXS;EDy8Ub;EC57UE;;;IAEE,SAAA;ED+7UJ;EC78UE;;;IAEE,8CAAA;EDg9UJ;EC98UE;;;IAEE,yBAAA;EDi9UJ;EC/8UE;;;IAEE,SAXS;ED69Ub;ECh9UE;;;IAEE,SAAA;EDm9UJ;ECj+UE;;;IAEE,8CAAA;EDo+UJ;ECl+UE;;;IAEE,yBAAA;EDq+UJ;ECn+UE;;;IAEE,SAXS;EDi/Ub;ECp+UE;;;IAEE,SAAA;EDu+UJ;ECr/UE;;;IAEE,8CAAA;EDw/UJ;ECt/UE;;;IAEE,yBAAA;EDy/UJ;ECv/UE;;;IAEE,SAXS;EDqgVb;ECx/UE;;;IAEE,SAAA;ED2/UJ;ECzgVE;;;IAEE,8CAAA;ED4gVJ;EC1gVE;;;IAEE,yBAAA;ED6gVJ;EC3gVE;;;IAEE,SAXS;EDyhVb;EC5gVE;;;IAEE,SAAA;ED+gVJ;EC7hVE;;;IAEE,8CAAA;EDgiVJ;EC9hVE;;;IAEE,yBAAA;EDiiVJ;EC/hVE;;;IAEE,SAXS;ED6iVb;EChiVE;;;IAEE,SAAA;EDmiVJ;ECjjVE;;;IAEE,8CAAA;EDojVJ;ECljVE;;;IAEE,yBAAA;EDqjVJ;ECnjVE;;;IAEE,SAXS;EDikVb;ECpjVE;;;IAEE,SAAA;EDujVJ;ECrkVE;;;IAEE,8CAAA;EDwkVJ;ECtkVE;;;IAEE,yBAAA;EDykVJ;ECvkVE;;;IAEE,SAXS;EDqlVb;ECxkVE;;;IAEE,SAAA;ED2kVJ;ECzlVE;;;IAEE,8CAAA;ED4lVJ;EC1lVE;;;IAEE,yBAAA;ED6lVJ;EC3lVE;;;IAEE,SAXS;EDymVb;EC5lVE;;;IAEE,SAAA;ED+lVJ;EC7mVE;;;IAEE,8CAAA;EDgnVJ;EC9mVE;;;IAEE,yBAAA;EDinVJ;EC/mVE;;;IAEE,SAXS;ED6nVb;EChnVE;;;IAEE,SAAA;EDmnVJ;ECjoVE;;;IAEE,8CAAA;EDooVJ;ECloVE;;;IAEE,yBAAA;EDqoVJ;ECnoVE;;;IAEE,SAXS;EDipVb;ECpoVE;;;IAEE,SAAA;EDuoVJ;ECrpVE;;;IAEE,8CAAA;EDwpVJ;ECtpVE;;;IAEE,yBAAA;EDypVJ;ECvpVE;;;IAEE,SAXS;EDqqVb;ECxpVE;;;IAEE,SAAA;ED2pVJ;ECzqVE;;;IAEE,8CAAA;ED4qVJ;EC1qVE;;;IAEE,yBAAA;ED6qVJ;EC3qVE;;;IAEE,SAXS;EDyrVb;EC5qVE;;;IAEE,SAAA;ED+qVJ;EC7rVE;;;IAEE,8CAAA;EDgsVJ;EC9rVE;;;IAEE,yBAAA;EDisVJ;EC/rVE;;;IAEE,SAXS;ED6sVb;EChsVE;;;IAEE,SAAA;EDmsVJ;EC7rVA;;IACE,cAAA;EDgsVF;AACF;ACl+UE;EAKE;;;IAEE,0BAAA;EDi+UJ;EC/9UE;;;IAEE,oBAPS;EDy+Ub;ECh+UE;;;IAEE,kBAXS;ED8+Ub;EC7+UE;;;IAEE,0BAAA;EDg/UJ;EC9+UE;;;IAEE,oBAPS;EDw/Ub;EC/+UE;;;IAEE,kBAXS;ED6/Ub;EC5/UE;;;IAEE,0BAAA;ED+/UJ;EC7/UE;;;IAEE,oBAPS;EDugVb;EC9/UE;;;IAEE,kBAXS;ED4gVb;EC3gVE;;;IAEE,0BAAA;ED8gVJ;EC5gVE;;;IAEE,oBAPS;EDshVb;EC7gVE;;;IAEE,kBAXS;ED2hVb;EC1hVE;;;IAEE,0BAAA;ED6hVJ;EC3hVE;;;IAEE,oBAPS;EDqiVb;EC5hVE;;;IAEE,kBAXS;ED0iVb;ECziVE;;;IAEE,0BAAA;ED4iVJ;EC1iVE;;;IAEE,oBAPS;EDojVb;EC3iVE;;;IAEE,kBAXS;EDyjVb;ECxjVE;;;IAEE,0BAAA;ED2jVJ;ECzjVE;;;IAEE,oBAPS;EDmkVb;EC1jVE;;;IAEE,kBAXS;EDwkVb;ECvkVE;;;IAEE,0BAAA;ED0kVJ;ECxkVE;;;IAEE,oBAPS;EDklVb;ECzkVE;;;IAEE,kBAXS;EDulVb;ECtlVE;;;IAEE,0BAAA;EDylVJ;ECvlVE;;;IAEE,oBAPS;EDimVb;ECxlVE;;;IAEE,kBAXS;EDsmVb;ECrmVE;;;IAEE,4BAAA;EDwmVJ;ECtmVE;;;IAEE,qBAPS;EDgnVb;ECvmVE;;;IAEE,mBAXS;EDqnVb;ECpnVE;;;IAEE,4BAAA;EDunVJ;ECrnVE;;;IAEE,qBAPS;ED+nVb;ECtnVE;;;IAEE,mBAXS;EDooVb;ECnoVE;;;IAEE,4BAAA;EDsoVJ;ECpoVE;;;IAEE,qBAPS;ED8oVb;ECroVE;;;IAEE,mBAXS;EDmpVb;EClpVE;;;IAEE,4BAAA;EDqpVJ;ECnpVE;;;IAEE,qBAPS;ED6pVb;ECppVE;;;IAEE,mBAXS;EDkqVb;ECjqVE;;;IAEE,4BAAA;EDoqVJ;EClqVE;;;IAEE,qBAPS;ED4qVb;ECnqVE;;;IAEE,mBAXS;EDirVb;EChrVE;;;IAEE,4BAAA;EDmrVJ;ECjrVE;;;IAEE,qBAPS;ED2rVb;EClrVE;;;IAEE,mBAXS;EDgsVb;EC/rVE;;;IAEE,4BAAA;EDksVJ;EChsVE;;;IAEE,qBAPS;ED0sVb;ECjsVE;;;IAEE,mBAXS;ED+sVb;EC9sVE;;;IAEE,4BAAA;EDitVJ;EC/sVE;;;IAEE,qBAPS;EDytVb;EChtVE;;;IAEE,mBAXS;ED8tVb;EC7tVE;;;IAEE,4BAAA;EDguVJ;EC9tVE;;;IAEE,qBAPS;EDwuVb;EC/tVE;;;IAEE,mBAXS;ED6uVb;EC5uVE;;;IAEE,4BAAA;ED+uVJ;EC7uVE;;;IAEE,qBAPS;EDuvVb;EC9uVE;;;IAEE,mBAXS;ED4vVb;EC3vVE;;;IAEE,4BAAA;ED8vVJ;EC5vVE;;;IAEE,qBAPS;EDswVb;EC7vVE;;;IAEE,mBAXS;ED2wVb;EC1wVE;;;IAEE,4BAAA;ED6wVJ;EC3wVE;;;IAEE,qBAPS;EDqxVb;EC5wVE;;;IAEE,mBAXS;ED0xVb;ECzxVE;;;IAEE,4BAAA;ED4xVJ;EC1xVE;;;IAEE,qBAPS;EDoyVb;EC3xVE;;;IAEE,mBAXS;EDyyVb;ECxyVE;;;IAEE,4BAAA;ED2yVJ;ECzyVE;;;IAEE,qBAPS;EDmzVb;EC1yVE;;;IAEE,mBAXS;EDwzVb;ECvzVE;;;IAEE,4BAAA;ED0zVJ;ECxzVE;;;IAEE,qBAPS;EDk0Vb;ECzzVE;;;IAEE,mBAXS;EDu0Vb;EC/jWE;;;IAEE,6CAAA;EDkkWJ;EChkWE;;;IAEE,uBAAA;EDmkWJ;ECjkWE;;;IAEE,QAXS;ED+kWb;EClkWE;;;IAEE,SAAA;EDqkWJ;ECnlWE;;;IAEE,6CAAA;EDslWJ;ECplWE;;;IAEE,uBAAA;EDulWJ;ECrlWE;;;IAEE,QAXS;EDmmWb;ECtlWE;;;IAEE,SAAA;EDylWJ;ECvmWE;;;IAEE,6CAAA;ED0mWJ;ECxmWE;;;IAEE,uBAAA;ED2mWJ;ECzmWE;;;IAEE,QAXS;EDunWb;EC1mWE;;;IAEE,SAAA;ED6mWJ;EC3nWE;;;IAEE,6CAAA;ED8nWJ;EC5nWE;;;IAEE,uBAAA;ED+nWJ;EC7nWE;;;IAEE,QAXS;ED2oWb;EC9nWE;;;IAEE,SAAA;EDioWJ;EC/oWE;;;IAEE,6CAAA;EDkpWJ;EChpWE;;;IAEE,uBAAA;EDmpWJ;ECjpWE;;;IAEE,QAXS;ED+pWb;EClpWE;;;IAEE,SAAA;EDqpWJ;ECnqWE;;;IAEE,6CAAA;EDsqWJ;ECpqWE;;;IAEE,uBAAA;EDuqWJ;ECrqWE;;;IAEE,QAXS;EDmrWb;ECtqWE;;;IAEE,SAAA;EDyqWJ;ECvrWE;;;IAEE,6CAAA;ED0rWJ;ECxrWE;;;IAEE,uBAAA;ED2rWJ;ECzrWE;;;IAEE,QAXS;EDusWb;EC1rWE;;;IAEE,SAAA;ED6rWJ;EC3sWE;;;IAEE,6CAAA;ED8sWJ;EC5sWE;;;IAEE,uBAAA;ED+sWJ;EC7sWE;;;IAEE,QAXS;ED2tWb;EC9sWE;;;IAEE,SAAA;EDitWJ;EC/tWE;;;IAEE,6CAAA;EDkuWJ;EChuWE;;;IAEE,uBAAA;EDmuWJ;ECjuWE;;;IAEE,QAXS;ED+uWb;ECluWE;;;IAEE,SAAA;EDquWJ;ECnvWE;;;IAEE,8CAAA;EDsvWJ;ECpvWE;;;IAEE,yBAAA;EDuvWJ;ECrvWE;;;IAEE,SAXS;EDmwWb;ECtvWE;;;IAEE,SAAA;EDyvWJ;ECvwWE;;;IAEE,8CAAA;ED0wWJ;ECxwWE;;;IAEE,yBAAA;ED2wWJ;ECzwWE;;;IAEE,SAXS;EDuxWb;EC1wWE;;;IAEE,SAAA;ED6wWJ;EC3xWE;;;IAEE,8CAAA;ED8xWJ;EC5xWE;;;IAEE,yBAAA;ED+xWJ;EC7xWE;;;IAEE,SAXS;ED2yWb;EC9xWE;;;IAEE,SAAA;EDiyWJ;EC/yWE;;;IAEE,8CAAA;EDkzWJ;EChzWE;;;IAEE,yBAAA;EDmzWJ;ECjzWE;;;IAEE,SAXS;ED+zWb;EClzWE;;;IAEE,SAAA;EDqzWJ;ECn0WE;;;IAEE,8CAAA;EDs0WJ;ECp0WE;;;IAEE,yBAAA;EDu0WJ;ECr0WE;;;IAEE,SAXS;EDm1Wb;ECt0WE;;;IAEE,SAAA;EDy0WJ;ECv1WE;;;IAEE,8CAAA;ED01WJ;ECx1WE;;;IAEE,yBAAA;ED21WJ;ECz1WE;;;IAEE,SAXS;EDu2Wb;EC11WE;;;IAEE,SAAA;ED61WJ;EC32WE;;;IAEE,8CAAA;ED82WJ;EC52WE;;;IAEE,yBAAA;ED+2WJ;EC72WE;;;IAEE,SAXS;ED23Wb;EC92WE;;;IAEE,SAAA;EDi3WJ;EC/3WE;;;IAEE,8CAAA;EDk4WJ;ECh4WE;;;IAEE,yBAAA;EDm4WJ;ECj4WE;;;IAEE,SAXS;ED+4Wb;ECl4WE;;;IAEE,SAAA;EDq4WJ;ECn5WE;;;IAEE,8CAAA;EDs5WJ;ECp5WE;;;IAEE,yBAAA;EDu5WJ;ECr5WE;;;IAEE,SAXS;EDm6Wb;ECt5WE;;;IAEE,SAAA;EDy5WJ;ECv6WE;;;IAEE,8CAAA;ED06WJ;ECx6WE;;;IAEE,yBAAA;ED26WJ;ECz6WE;;;IAEE,SAXS;EDu7Wb;EC16WE;;;IAEE,SAAA;ED66WJ;EC37WE;;;IAEE,8CAAA;ED87WJ;EC57WE;;;IAEE,yBAAA;ED+7WJ;EC77WE;;;IAEE,SAXS;ED28Wb;EC97WE;;;IAEE,SAAA;EDi8WJ;EC/8WE;;;IAEE,8CAAA;EDk9WJ;ECh9WE;;;IAEE,yBAAA;EDm9WJ;ECj9WE;;;IAEE,SAXS;ED+9Wb;ECl9WE;;;IAEE,SAAA;EDq9WJ;ECn+WE;;;IAEE,8CAAA;EDs+WJ;ECp+WE;;;IAEE,yBAAA;EDu+WJ;ECr+WE;;;IAEE,SAXS;EDm/Wb;ECt+WE;;;IAEE,SAAA;EDy+WJ;ECv/WE;;;IAEE,8CAAA;ED0/WJ;ECx/WE;;;IAEE,yBAAA;ED2/WJ;ECz/WE;;;IAEE,SAXS;EDugXb;EC1/WE;;;IAEE,SAAA;ED6/WJ;EC3gXE;;;IAEE,8CAAA;ED8gXJ;EC5gXE;;;IAEE,yBAAA;ED+gXJ;EC7gXE;;;IAEE,SAXS;ED2hXb;EC9gXE;;;IAEE,SAAA;EDihXJ;EC/hXE;;;IAEE,8CAAA;EDkiXJ;EChiXE;;;IAEE,yBAAA;EDmiXJ;ECjiXE;;;IAEE,SAXS;ED+iXb;ECliXE;;;IAEE,SAAA;EDqiXJ;ECnjXE;;;IAEE,8CAAA;EDsjXJ;ECpjXE;;;IAEE,yBAAA;EDujXJ;ECrjXE;;;IAEE,SAXS;EDmkXb;ECtjXE;;;IAEE,SAAA;EDyjXJ;ECvkXE;;;IAEE,8CAAA;ED0kXJ;ECxkXE;;;IAEE,yBAAA;ED2kXJ;ECzkXE;;;IAEE,SAXS;EDulXb;EC1kXE;;;IAEE,SAAA;ED6kXJ;EC3lXE;;;IAEE,8CAAA;ED8lXJ;EC5lXE;;;IAEE,yBAAA;ED+lXJ;EC7lXE;;;IAEE,SAXS;ED2mXb;EC9lXE;;;IAEE,SAAA;EDimXJ;EC/mXE;;;IAEE,8CAAA;EDknXJ;EChnXE;;;IAEE,yBAAA;EDmnXJ;ECjnXE;;;IAEE,SAXS;ED+nXb;EClnXE;;;IAEE,SAAA;EDqnXJ;ECnoXE;;;IAEE,8CAAA;EDsoXJ;ECpoXE;;;IAEE,yBAAA;EDuoXJ;ECroXE;;;IAEE,SAXS;EDmpXb;ECtoXE;;;IAEE,SAAA;EDyoXJ;ECvpXE;;;IAEE,8CAAA;ED0pXJ;ECxpXE;;;IAEE,yBAAA;ED2pXJ;ECzpXE;;;IAEE,SAXS;EDuqXb;EC1pXE;;;IAEE,SAAA;ED6pXJ;EC3qXE;;;IAEE,8CAAA;ED8qXJ;EC5qXE;;;IAEE,yBAAA;ED+qXJ;EC7qXE;;;IAEE,SAXS;ED2rXb;EC9qXE;;;IAEE,SAAA;EDirXJ;EC/rXE;;;IAEE,8CAAA;EDksXJ;EChsXE;;;IAEE,yBAAA;EDmsXJ;ECjsXE;;;IAEE,SAXS;ED+sXb;EClsXE;;;IAEE,SAAA;EDqsXJ;ECntXE;;;IAEE,8CAAA;EDstXJ;ECptXE;;;IAEE,yBAAA;EDutXJ;ECrtXE;;;IAEE,SAXS;EDmuXb;ECttXE;;;IAEE,SAAA;EDytXJ;ECvuXE;;;IAEE,8CAAA;ED0uXJ;ECxuXE;;;IAEE,yBAAA;ED2uXJ;ECzuXE;;;IAEE,SAXS;EDuvXb;EC1uXE;;;IAEE,SAAA;ED6uXJ;EC3vXE;;;IAEE,8CAAA;ED8vXJ;EC5vXE;;;IAEE,yBAAA;ED+vXJ;EC7vXE;;;IAEE,SAXS;ED2wXb;EC9vXE;;;IAEE,SAAA;EDiwXJ;EC/wXE;;;IAEE,8CAAA;EDkxXJ;EChxXE;;;IAEE,yBAAA;EDmxXJ;ECjxXE;;;IAEE,SAXS;ED+xXb;EClxXE;;;IAEE,SAAA;EDqxXJ;ECnyXE;;;IAEE,8CAAA;EDsyXJ;ECpyXE;;;IAEE,yBAAA;EDuyXJ;ECryXE;;;IAEE,SAXS;EDmzXb;ECtyXE;;;IAEE,SAAA;EDyyXJ;ECvzXE;;;IAEE,8CAAA;ED0zXJ;ECxzXE;;;IAEE,yBAAA;ED2zXJ;ECzzXE;;;IAEE,SAXS;EDu0Xb;EC1zXE;;;IAEE,SAAA;ED6zXJ;EC30XE;;;IAEE,8CAAA;ED80XJ;EC50XE;;;IAEE,yBAAA;ED+0XJ;EC70XE;;;IAEE,SAXS;ED21Xb;EC90XE;;;IAEE,SAAA;EDi1XJ;EC/1XE;;;IAEE,8CAAA;EDk2XJ;ECh2XE;;;IAEE,yBAAA;EDm2XJ;ECj2XE;;;IAEE,SAXS;ED+2Xb;ECl2XE;;;IAEE,SAAA;EDq2XJ;ECn3XE;;;IAEE,8CAAA;EDs3XJ;ECp3XE;;;IAEE,yBAAA;EDu3XJ;ECr3XE;;;IAEE,SAXS;EDm4Xb;ECt3XE;;;IAEE,SAAA;EDy3XJ;ECv4XE;;;IAEE,8CAAA;ED04XJ;ECx4XE;;;IAEE,yBAAA;ED24XJ;ECz4XE;;;IAEE,SAXS;EDu5Xb;EC14XE;;;IAEE,SAAA;ED64XJ;EC35XE;;;IAEE,8CAAA;ED85XJ;EC55XE;;;IAEE,yBAAA;ED+5XJ;EC75XE;;;IAEE,SAXS;ED26Xb;EC95XE;;;IAEE,SAAA;EDi6XJ;EC/6XE;;;IAEE,8CAAA;EDk7XJ;ECh7XE;;;IAEE,yBAAA;EDm7XJ;ECj7XE;;;IAEE,SAXS;ED+7Xb;ECl7XE;;;IAEE,SAAA;EDq7XJ;ECn8XE;;;IAEE,8CAAA;EDs8XJ;ECp8XE;;;IAEE,yBAAA;EDu8XJ;ECr8XE;;;IAEE,SAXS;EDm9Xb;ECt8XE;;;IAEE,SAAA;EDy8XJ;ECv9XE;;;IAEE,8CAAA;ED09XJ;ECx9XE;;;IAEE,yBAAA;ED29XJ;ECz9XE;;;IAEE,SAXS;EDu+Xb;EC19XE;;;IAEE,SAAA;ED69XJ;EC3+XE;;;IAEE,8CAAA;ED8+XJ;EC5+XE;;;IAEE,yBAAA;ED++XJ;EC7+XE;;;IAEE,SAXS;ED2/Xb;EC9+XE;;;IAEE,SAAA;EDi/XJ;EC//XE;;;IAEE,8CAAA;EDkgYJ;EChgYE;;;IAEE,yBAAA;EDmgYJ;ECjgYE;;;IAEE,SAXS;ED+gYb;EClgYE;;;IAEE,SAAA;EDqgYJ;ECnhYE;;;IAEE,8CAAA;EDshYJ;ECphYE;;;IAEE,yBAAA;EDuhYJ;ECrhYE;;;IAEE,SAXS;EDmiYb;ECthYE;;;IAEE,SAAA;EDyhYJ;ECnhYA;;IACE,cAAA;EDshYF;AACF;;AAviYA,qCAAA;AACA;;EAEE,2BAAA;AA0iYF;ACt1XE;EA6BE;;;IAEE,0BAAA;ED6zXJ;EC3zXE;;;IAEE,oBAPS;EDq0Xb;EC5zXE;;;IAEE,kBAXS;ED00Xb;ECz0XE;;;IAEE,0BAAA;ED40XJ;EC10XE;;;IAEE,oBAPS;EDo1Xb;EC30XE;;;IAEE,kBAXS;EDy1Xb;ECx1XE;;;IAEE,0BAAA;ED21XJ;ECz1XE;;;IAEE,oBAPS;EDm2Xb;EC11XE;;;IAEE,kBAXS;EDw2Xb;ECv2XE;;;IAEE,0BAAA;ED02XJ;ECx2XE;;;IAEE,oBAPS;EDk3Xb;ECz2XE;;;IAEE,kBAXS;EDu3Xb;ECt3XE;;;IAEE,0BAAA;EDy3XJ;ECv3XE;;;IAEE,oBAPS;EDi4Xb;ECx3XE;;;IAEE,kBAXS;EDs4Xb;ECr4XE;;;IAEE,0BAAA;EDw4XJ;ECt4XE;;;IAEE,oBAPS;EDg5Xb;ECv4XE;;;IAEE,kBAXS;EDq5Xb;ECp5XE;;;IAEE,0BAAA;EDu5XJ;ECr5XE;;;IAEE,oBAPS;ED+5Xb;ECt5XE;;;IAEE,kBAXS;EDo6Xb;ECn6XE;;;IAEE,0BAAA;EDs6XJ;ECp6XE;;;IAEE,oBAPS;ED86Xb;ECr6XE;;;IAEE,kBAXS;EDm7Xb;ECl7XE;;;IAEE,0BAAA;EDq7XJ;ECn7XE;;;IAEE,oBAPS;ED67Xb;ECp7XE;;;IAEE,kBAXS;EDk8Xb;ECj8XE;;;IAEE,4BAAA;EDo8XJ;ECl8XE;;;IAEE,qBAPS;ED48Xb;ECn8XE;;;IAEE,mBAXS;EDi9Xb;ECh9XE;;;IAEE,4BAAA;EDm9XJ;ECj9XE;;;IAEE,qBAPS;ED29Xb;ECl9XE;;;IAEE,mBAXS;EDg+Xb;EC/9XE;;;IAEE,4BAAA;EDk+XJ;ECh+XE;;;IAEE,qBAPS;ED0+Xb;ECj+XE;;;IAEE,mBAXS;ED++Xb;EC9+XE;;;IAEE,4BAAA;EDi/XJ;EC/+XE;;;IAEE,qBAPS;EDy/Xb;ECh/XE;;;IAEE,mBAXS;ED8/Xb;EC7/XE;;;IAEE,4BAAA;EDggYJ;EC9/XE;;;IAEE,qBAPS;EDwgYb;EC//XE;;;IAEE,mBAXS;ED6gYb;EC5gYE;;;IAEE,4BAAA;ED+gYJ;EC7gYE;;;IAEE,qBAPS;EDuhYb;EC9gYE;;;IAEE,mBAXS;ED4hYb;EC3hYE;;;IAEE,4BAAA;ED8hYJ;EC5hYE;;;IAEE,qBAPS;EDsiYb;EC7hYE;;;IAEE,mBAXS;ED2iYb;EC1iYE;;;IAEE,4BAAA;ED6iYJ;EC3iYE;;;IAEE,qBAPS;EDqjYb;EC5iYE;;;IAEE,mBAXS;ED0jYb;ECzjYE;;;IAEE,4BAAA;ED4jYJ;EC1jYE;;;IAEE,qBAPS;EDokYb;EC3jYE;;;IAEE,mBAXS;EDykYb;ECxkYE;;;IAEE,4BAAA;ED2kYJ;ECzkYE;;;IAEE,qBAPS;EDmlYb;EC1kYE;;;IAEE,mBAXS;EDwlYb;ECvlYE;;;IAEE,4BAAA;ED0lYJ;ECxlYE;;;IAEE,qBAPS;EDkmYb;ECzlYE;;;IAEE,mBAXS;EDumYb;ECtmYE;;;IAEE,4BAAA;EDymYJ;ECvmYE;;;IAEE,qBAPS;EDinYb;ECxmYE;;;IAEE,mBAXS;EDsnYb;ECrnYE;;;IAEE,4BAAA;EDwnYJ;ECtnYE;;;IAEE,qBAPS;EDgoYb;ECvnYE;;;IAEE,mBAXS;EDqoYb;ECpoYE;;;IAEE,4BAAA;EDuoYJ;ECroYE;;;IAEE,qBAPS;ED+oYb;ECtoYE;;;IAEE,mBAXS;EDopYb;ECnpYE;;;IAEE,4BAAA;EDspYJ;ECppYE;;;IAEE,qBAPS;ED8pYb;ECrpYE;;;IAEE,mBAXS;EDmqYb;EC35YE;;;IAEE,6CAAA;ED85YJ;EC55YE;;;IAEE,uBAAA;ED+5YJ;EC75YE;;;IAEE,QAXS;ED26Yb;EC95YE;;;IAEE,SAAA;EDi6YJ;EC/6YE;;;IAEE,6CAAA;EDk7YJ;ECh7YE;;;IAEE,uBAAA;EDm7YJ;ECj7YE;;;IAEE,QAXS;ED+7Yb;ECl7YE;;;IAEE,SAAA;EDq7YJ;ECn8YE;;;IAEE,6CAAA;EDs8YJ;ECp8YE;;;IAEE,uBAAA;EDu8YJ;ECr8YE;;;IAEE,QAXS;EDm9Yb;ECt8YE;;;IAEE,SAAA;EDy8YJ;ECv9YE;;;IAEE,6CAAA;ED09YJ;ECx9YE;;;IAEE,uBAAA;ED29YJ;ECz9YE;;;IAEE,QAXS;EDu+Yb;EC19YE;;;IAEE,SAAA;ED69YJ;EC3+YE;;;IAEE,6CAAA;ED8+YJ;EC5+YE;;;IAEE,uBAAA;ED++YJ;EC7+YE;;;IAEE,QAXS;ED2/Yb;EC9+YE;;;IAEE,SAAA;EDi/YJ;EC//YE;;;IAEE,6CAAA;EDkgZJ;EChgZE;;;IAEE,uBAAA;EDmgZJ;ECjgZE;;;IAEE,QAXS;ED+gZb;EClgZE;;;IAEE,SAAA;EDqgZJ;ECnhZE;;;IAEE,6CAAA;EDshZJ;ECphZE;;;IAEE,uBAAA;EDuhZJ;ECrhZE;;;IAEE,QAXS;EDmiZb;ECthZE;;;IAEE,SAAA;EDyhZJ;ECviZE;;;IAEE,6CAAA;ED0iZJ;ECxiZE;;;IAEE,uBAAA;ED2iZJ;ECziZE;;;IAEE,QAXS;EDujZb;EC1iZE;;;IAEE,SAAA;ED6iZJ;EC3jZE;;;IAEE,6CAAA;ED8jZJ;EC5jZE;;;IAEE,uBAAA;ED+jZJ;EC7jZE;;;IAEE,QAXS;ED2kZb;EC9jZE;;;IAEE,SAAA;EDikZJ;EC/kZE;;;IAEE,8CAAA;EDklZJ;EChlZE;;;IAEE,yBAAA;EDmlZJ;ECjlZE;;;IAEE,SAXS;ED+lZb;ECllZE;;;IAEE,SAAA;EDqlZJ;ECnmZE;;;IAEE,8CAAA;EDsmZJ;ECpmZE;;;IAEE,yBAAA;EDumZJ;ECrmZE;;;IAEE,SAXS;EDmnZb;ECtmZE;;;IAEE,SAAA;EDymZJ;ECvnZE;;;IAEE,8CAAA;ED0nZJ;ECxnZE;;;IAEE,yBAAA;ED2nZJ;ECznZE;;;IAEE,SAXS;EDuoZb;EC1nZE;;;IAEE,SAAA;ED6nZJ;EC3oZE;;;IAEE,8CAAA;ED8oZJ;EC5oZE;;;IAEE,yBAAA;ED+oZJ;EC7oZE;;;IAEE,SAXS;ED2pZb;EC9oZE;;;IAEE,SAAA;EDipZJ;EC/pZE;;;IAEE,8CAAA;EDkqZJ;EChqZE;;;IAEE,yBAAA;EDmqZJ;ECjqZE;;;IAEE,SAXS;ED+qZb;EClqZE;;;IAEE,SAAA;EDqqZJ;ECnrZE;;;IAEE,8CAAA;EDsrZJ;ECprZE;;;IAEE,yBAAA;EDurZJ;ECrrZE;;;IAEE,SAXS;EDmsZb;ECtrZE;;;IAEE,SAAA;EDyrZJ;ECvsZE;;;IAEE,8CAAA;ED0sZJ;ECxsZE;;;IAEE,yBAAA;ED2sZJ;ECzsZE;;;IAEE,SAXS;EDutZb;EC1sZE;;;IAEE,SAAA;ED6sZJ;EC3tZE;;;IAEE,8CAAA;ED8tZJ;EC5tZE;;;IAEE,yBAAA;ED+tZJ;EC7tZE;;;IAEE,SAXS;ED2uZb;EC9tZE;;;IAEE,SAAA;EDiuZJ;EC/uZE;;;IAEE,8CAAA;EDkvZJ;EChvZE;;;IAEE,yBAAA;EDmvZJ;ECjvZE;;;IAEE,SAXS;ED+vZb;EClvZE;;;IAEE,SAAA;EDqvZJ;ECnwZE;;;IAEE,8CAAA;EDswZJ;ECpwZE;;;IAEE,yBAAA;EDuwZJ;ECrwZE;;;IAEE,SAXS;EDmxZb;ECtwZE;;;IAEE,SAAA;EDywZJ;ECvxZE;;;IAEE,8CAAA;ED0xZJ;ECxxZE;;;IAEE,yBAAA;ED2xZJ;ECzxZE;;;IAEE,SAXS;EDuyZb;EC1xZE;;;IAEE,SAAA;ED6xZJ;EC3yZE;;;IAEE,8CAAA;ED8yZJ;EC5yZE;;;IAEE,yBAAA;ED+yZJ;EC7yZE;;;IAEE,SAXS;ED2zZb;EC9yZE;;;IAEE,SAAA;EDizZJ;EC/zZE;;;IAEE,8CAAA;EDk0ZJ;ECh0ZE;;;IAEE,yBAAA;EDm0ZJ;ECj0ZE;;;IAEE,SAXS;ED+0Zb;ECl0ZE;;;IAEE,SAAA;EDq0ZJ;ECn1ZE;;;IAEE,8CAAA;EDs1ZJ;ECp1ZE;;;IAEE,yBAAA;EDu1ZJ;ECr1ZE;;;IAEE,SAXS;EDm2Zb;ECt1ZE;;;IAEE,SAAA;EDy1ZJ;ECv2ZE;;;IAEE,8CAAA;ED02ZJ;ECx2ZE;;;IAEE,yBAAA;ED22ZJ;ECz2ZE;;;IAEE,SAXS;EDu3Zb;EC12ZE;;;IAEE,SAAA;ED62ZJ;EC33ZE;;;IAEE,8CAAA;ED83ZJ;EC53ZE;;;IAEE,yBAAA;ED+3ZJ;EC73ZE;;;IAEE,SAXS;ED24Zb;EC93ZE;;;IAEE,SAAA;EDi4ZJ;EC/4ZE;;;IAEE,8CAAA;EDk5ZJ;ECh5ZE;;;IAEE,yBAAA;EDm5ZJ;ECj5ZE;;;IAEE,SAXS;ED+5Zb;ECl5ZE;;;IAEE,SAAA;EDq5ZJ;ECn6ZE;;;IAEE,8CAAA;EDs6ZJ;ECp6ZE;;;IAEE,yBAAA;EDu6ZJ;ECr6ZE;;;IAEE,SAXS;EDm7Zb;ECt6ZE;;;IAEE,SAAA;EDy6ZJ;ECv7ZE;;;IAEE,8CAAA;ED07ZJ;ECx7ZE;;;IAEE,yBAAA;ED27ZJ;ECz7ZE;;;IAEE,SAXS;EDu8Zb;EC17ZE;;;IAEE,SAAA;ED67ZJ;EC38ZE;;;IAEE,8CAAA;ED88ZJ;EC58ZE;;;IAEE,yBAAA;ED+8ZJ;EC78ZE;;;IAEE,SAXS;ED29Zb;EC98ZE;;;IAEE,SAAA;EDi9ZJ;EC/9ZE;;;IAEE,8CAAA;EDk+ZJ;ECh+ZE;;;IAEE,yBAAA;EDm+ZJ;ECj+ZE;;;IAEE,SAXS;ED++Zb;ECl+ZE;;;IAEE,SAAA;EDq+ZJ;ECn/ZE;;;IAEE,8CAAA;EDs/ZJ;ECp/ZE;;;IAEE,yBAAA;EDu/ZJ;ECr/ZE;;;IAEE,SAXS;EDmgab;ECt/ZE;;;IAEE,SAAA;EDy/ZJ;ECvgaE;;;IAEE,8CAAA;ED0gaJ;ECxgaE;;;IAEE,yBAAA;ED2gaJ;ECzgaE;;;IAEE,SAXS;EDuhab;EC1gaE;;;IAEE,SAAA;ED6gaJ;EC3haE;;;IAEE,8CAAA;ED8haJ;EC5haE;;;IAEE,yBAAA;ED+haJ;EC7haE;;;IAEE,SAXS;ED2iab;EC9haE;;;IAEE,SAAA;EDiiaJ;EC/iaE;;;IAEE,8CAAA;EDkjaJ;EChjaE;;;IAEE,yBAAA;EDmjaJ;ECjjaE;;;IAEE,SAXS;ED+jab;ECljaE;;;IAEE,SAAA;EDqjaJ;ECnkaE;;;IAEE,8CAAA;EDskaJ;ECpkaE;;;IAEE,yBAAA;EDukaJ;ECrkaE;;;IAEE,SAXS;EDmlab;ECtkaE;;;IAEE,SAAA;EDykaJ;ECvlaE;;;IAEE,8CAAA;ED0laJ;ECxlaE;;;IAEE,yBAAA;ED2laJ;ECzlaE;;;IAEE,SAXS;EDumab;EC1laE;;;IAEE,SAAA;ED6laJ;EC3maE;;;IAEE,8CAAA;ED8maJ;EC5maE;;;IAEE,yBAAA;ED+maJ;EC7maE;;;IAEE,SAXS;ED2nab;EC9maE;;;IAEE,SAAA;EDinaJ;EC/naE;;;IAEE,8CAAA;EDkoaJ;EChoaE;;;IAEE,yBAAA;EDmoaJ;ECjoaE;;;IAEE,SAXS;ED+oab;ECloaE;;;IAEE,SAAA;EDqoaJ;ECnpaE;;;IAEE,8CAAA;EDspaJ;ECppaE;;;IAEE,yBAAA;EDupaJ;ECrpaE;;;IAEE,SAXS;EDmqab;ECtpaE;;;IAEE,SAAA;EDypaJ;ECvqaE;;;IAEE,8CAAA;ED0qaJ;ECxqaE;;;IAEE,yBAAA;ED2qaJ;ECzqaE;;;IAEE,SAXS;EDurab;EC1qaE;;;IAEE,SAAA;ED6qaJ;EC3raE;;;IAEE,8CAAA;ED8raJ;EC5raE;;;IAEE,yBAAA;ED+raJ;EC7raE;;;IAEE,SAXS;ED2sab;EC9raE;;;IAEE,SAAA;EDisaJ;EC/saE;;;IAEE,8CAAA;EDktaJ;EChtaE;;;IAEE,yBAAA;EDmtaJ;ECjtaE;;;IAEE,SAXS;ED+tab;ECltaE;;;IAEE,SAAA;EDqtaJ;ECnuaE;;;IAEE,8CAAA;EDsuaJ;ECpuaE;;;IAEE,yBAAA;EDuuaJ;ECruaE;;;IAEE,SAXS;EDmvab;ECtuaE;;;IAEE,SAAA;EDyuaJ;ECvvaE;;;IAEE,8CAAA;ED0vaJ;ECxvaE;;;IAEE,yBAAA;ED2vaJ;ECzvaE;;;IAEE,SAXS;EDuwab;EC1vaE;;;IAEE,SAAA;ED6vaJ;EC3waE;;;IAEE,8CAAA;ED8waJ;EC5waE;;;IAEE,yBAAA;ED+waJ;EC7waE;;;IAEE,SAXS;ED2xab;EC9waE;;;IAEE,SAAA;EDixaJ;EC/xaE;;;IAEE,8CAAA;EDkyaJ;EChyaE;;;IAEE,yBAAA;EDmyaJ;ECjyaE;;;IAEE,SAXS;ED+yab;EClyaE;;;IAEE,SAAA;EDqyaJ;ECnzaE;;;IAEE,8CAAA;EDszaJ;ECpzaE;;;IAEE,yBAAA;EDuzaJ;ECrzaE;;;IAEE,SAXS;EDm0ab;ECtzaE;;;IAEE,SAAA;EDyzaJ;ECv0aE;;;IAEE,8CAAA;ED00aJ;ECx0aE;;;IAEE,yBAAA;ED20aJ;ECz0aE;;;IAEE,SAXS;EDu1ab;EC10aE;;;IAEE,SAAA;ED60aJ;EC31aE;;;IAEE,8CAAA;ED81aJ;EC51aE;;;IAEE,yBAAA;ED+1aJ;EC71aE;;;IAEE,SAXS;ED22ab;EC91aE;;;IAEE,SAAA;EDi2aJ;EC/2aE;;;IAEE,8CAAA;EDk3aJ;ECh3aE;;;IAEE,yBAAA;EDm3aJ;ECj3aE;;;IAEE,SAXS;ED+3ab;ECl3aE;;;IAEE,SAAA;EDq3aJ;EC/2aA;;IACE,cAAA;EDk3aF;AACF;AC1qaE;EA2BE;;;IAEE,0BAAA;EDmpaJ;ECjpaE;;;IAEE,oBAPS;ED2pab;EClpaE;;;IAEE,kBAXS;EDgqab;EC/paE;;;IAEE,0BAAA;EDkqaJ;EChqaE;;;IAEE,oBAPS;ED0qab;ECjqaE;;;IAEE,kBAXS;ED+qab;EC9qaE;;;IAEE,0BAAA;EDiraJ;EC/qaE;;;IAEE,oBAPS;EDyrab;EChraE;;;IAEE,kBAXS;ED8rab;EC7raE;;;IAEE,0BAAA;EDgsaJ;EC9raE;;;IAEE,oBAPS;EDwsab;EC/raE;;;IAEE,kBAXS;ED6sab;EC5saE;;;IAEE,0BAAA;ED+saJ;EC7saE;;;IAEE,oBAPS;EDutab;EC9saE;;;IAEE,kBAXS;ED4tab;EC3taE;;;IAEE,0BAAA;ED8taJ;EC5taE;;;IAEE,oBAPS;EDsuab;EC7taE;;;IAEE,kBAXS;ED2uab;EC1uaE;;;IAEE,0BAAA;ED6uaJ;EC3uaE;;;IAEE,oBAPS;EDqvab;EC5uaE;;;IAEE,kBAXS;ED0vab;ECzvaE;;;IAEE,0BAAA;ED4vaJ;EC1vaE;;;IAEE,oBAPS;EDowab;EC3vaE;;;IAEE,kBAXS;EDywab;ECxwaE;;;IAEE,0BAAA;ED2waJ;ECzwaE;;;IAEE,oBAPS;EDmxab;EC1waE;;;IAEE,kBAXS;EDwxab;ECvxaE;;;IAEE,4BAAA;ED0xaJ;ECxxaE;;;IAEE,qBAPS;EDkyab;ECzxaE;;;IAEE,mBAXS;EDuyab;ECtyaE;;;IAEE,4BAAA;EDyyaJ;ECvyaE;;;IAEE,qBAPS;EDizab;ECxyaE;;;IAEE,mBAXS;EDszab;ECrzaE;;;IAEE,4BAAA;EDwzaJ;ECtzaE;;;IAEE,qBAPS;EDg0ab;ECvzaE;;;IAEE,mBAXS;EDq0ab;ECp0aE;;;IAEE,4BAAA;EDu0aJ;ECr0aE;;;IAEE,qBAPS;ED+0ab;ECt0aE;;;IAEE,mBAXS;EDo1ab;ECn1aE;;;IAEE,4BAAA;EDs1aJ;ECp1aE;;;IAEE,qBAPS;ED81ab;ECr1aE;;;IAEE,mBAXS;EDm2ab;ECl2aE;;;IAEE,4BAAA;EDq2aJ;ECn2aE;;;IAEE,qBAPS;ED62ab;ECp2aE;;;IAEE,mBAXS;EDk3ab;ECj3aE;;;IAEE,4BAAA;EDo3aJ;ECl3aE;;;IAEE,qBAPS;ED43ab;ECn3aE;;;IAEE,mBAXS;EDi4ab;ECh4aE;;;IAEE,4BAAA;EDm4aJ;ECj4aE;;;IAEE,qBAPS;ED24ab;ECl4aE;;;IAEE,mBAXS;EDg5ab;EC/4aE;;;IAEE,4BAAA;EDk5aJ;ECh5aE;;;IAEE,qBAPS;ED05ab;ECj5aE;;;IAEE,mBAXS;ED+5ab;EC95aE;;;IAEE,4BAAA;EDi6aJ;EC/5aE;;;IAEE,qBAPS;EDy6ab;ECh6aE;;;IAEE,mBAXS;ED86ab;EC76aE;;;IAEE,4BAAA;EDg7aJ;EC96aE;;;IAEE,qBAPS;EDw7ab;EC/6aE;;;IAEE,mBAXS;ED67ab;EC57aE;;;IAEE,4BAAA;ED+7aJ;EC77aE;;;IAEE,qBAPS;EDu8ab;EC97aE;;;IAEE,mBAXS;ED48ab;EC38aE;;;IAEE,4BAAA;ED88aJ;EC58aE;;;IAEE,qBAPS;EDs9ab;EC78aE;;;IAEE,mBAXS;ED29ab;EC19aE;;;IAEE,4BAAA;ED69aJ;EC39aE;;;IAEE,qBAPS;EDq+ab;EC59aE;;;IAEE,mBAXS;ED0+ab;ECz+aE;;;IAEE,4BAAA;ED4+aJ;EC1+aE;;;IAEE,qBAPS;EDo/ab;EC3+aE;;;IAEE,mBAXS;EDy/ab;ECjvbE;;;IAEE,6CAAA;EDovbJ;EClvbE;;;IAEE,uBAAA;EDqvbJ;ECnvbE;;;IAEE,QAXS;EDiwbb;ECpvbE;;;IAEE,SAAA;EDuvbJ;ECrwbE;;;IAEE,6CAAA;EDwwbJ;ECtwbE;;;IAEE,uBAAA;EDywbJ;ECvwbE;;;IAEE,QAXS;EDqxbb;ECxwbE;;;IAEE,SAAA;ED2wbJ;ECzxbE;;;IAEE,6CAAA;ED4xbJ;EC1xbE;;;IAEE,uBAAA;ED6xbJ;EC3xbE;;;IAEE,QAXS;EDyybb;EC5xbE;;;IAEE,SAAA;ED+xbJ;EC7ybE;;;IAEE,6CAAA;EDgzbJ;EC9ybE;;;IAEE,uBAAA;EDizbJ;EC/ybE;;;IAEE,QAXS;ED6zbb;EChzbE;;;IAEE,SAAA;EDmzbJ;ECj0bE;;;IAEE,6CAAA;EDo0bJ;ECl0bE;;;IAEE,uBAAA;EDq0bJ;ECn0bE;;;IAEE,QAXS;EDi1bb;ECp0bE;;;IAEE,SAAA;EDu0bJ;ECr1bE;;;IAEE,6CAAA;EDw1bJ;ECt1bE;;;IAEE,uBAAA;EDy1bJ;ECv1bE;;;IAEE,QAXS;EDq2bb;ECx1bE;;;IAEE,SAAA;ED21bJ;ECz2bE;;;IAEE,6CAAA;ED42bJ;EC12bE;;;IAEE,uBAAA;ED62bJ;EC32bE;;;IAEE,QAXS;EDy3bb;EC52bE;;;IAEE,SAAA;ED+2bJ;EC73bE;;;IAEE,6CAAA;EDg4bJ;EC93bE;;;IAEE,uBAAA;EDi4bJ;EC/3bE;;;IAEE,QAXS;ED64bb;ECh4bE;;;IAEE,SAAA;EDm4bJ;ECj5bE;;;IAEE,6CAAA;EDo5bJ;ECl5bE;;;IAEE,uBAAA;EDq5bJ;ECn5bE;;;IAEE,QAXS;EDi6bb;ECp5bE;;;IAEE,SAAA;EDu5bJ;ECr6bE;;;IAEE,8CAAA;EDw6bJ;ECt6bE;;;IAEE,yBAAA;EDy6bJ;ECv6bE;;;IAEE,SAXS;EDq7bb;ECx6bE;;;IAEE,SAAA;ED26bJ;ECz7bE;;;IAEE,8CAAA;ED47bJ;EC17bE;;;IAEE,yBAAA;ED67bJ;EC37bE;;;IAEE,SAXS;EDy8bb;EC57bE;;;IAEE,SAAA;ED+7bJ;EC78bE;;;IAEE,8CAAA;EDg9bJ;EC98bE;;;IAEE,yBAAA;EDi9bJ;EC/8bE;;;IAEE,SAXS;ED69bb;ECh9bE;;;IAEE,SAAA;EDm9bJ;ECj+bE;;;IAEE,8CAAA;EDo+bJ;ECl+bE;;;IAEE,yBAAA;EDq+bJ;ECn+bE;;;IAEE,SAXS;EDi/bb;ECp+bE;;;IAEE,SAAA;EDu+bJ;ECr/bE;;;IAEE,8CAAA;EDw/bJ;ECt/bE;;;IAEE,yBAAA;EDy/bJ;ECv/bE;;;IAEE,SAXS;EDqgcb;ECx/bE;;;IAEE,SAAA;ED2/bJ;ECzgcE;;;IAEE,8CAAA;ED4gcJ;EC1gcE;;;IAEE,yBAAA;ED6gcJ;EC3gcE;;;IAEE,SAXS;EDyhcb;EC5gcE;;;IAEE,SAAA;ED+gcJ;EC7hcE;;;IAEE,8CAAA;EDgicJ;EC9hcE;;;IAEE,yBAAA;EDiicJ;EC/hcE;;;IAEE,SAXS;ED6icb;EChicE;;;IAEE,SAAA;EDmicJ;ECjjcE;;;IAEE,8CAAA;EDojcJ;ECljcE;;;IAEE,yBAAA;EDqjcJ;ECnjcE;;;IAEE,SAXS;EDikcb;ECpjcE;;;IAEE,SAAA;EDujcJ;ECrkcE;;;IAEE,8CAAA;EDwkcJ;ECtkcE;;;IAEE,yBAAA;EDykcJ;ECvkcE;;;IAEE,SAXS;EDqlcb;ECxkcE;;;IAEE,SAAA;ED2kcJ;ECzlcE;;;IAEE,8CAAA;ED4lcJ;EC1lcE;;;IAEE,yBAAA;ED6lcJ;EC3lcE;;;IAEE,SAXS;EDymcb;EC5lcE;;;IAEE,SAAA;ED+lcJ;EC7mcE;;;IAEE,8CAAA;EDgncJ;EC9mcE;;;IAEE,yBAAA;EDincJ;EC/mcE;;;IAEE,SAXS;ED6ncb;EChncE;;;IAEE,SAAA;EDmncJ;ECjocE;;;IAEE,8CAAA;EDoocJ;EClocE;;;IAEE,yBAAA;EDqocJ;ECnocE;;;IAEE,SAXS;EDipcb;ECpocE;;;IAEE,SAAA;EDuocJ;ECrpcE;;;IAEE,8CAAA;EDwpcJ;ECtpcE;;;IAEE,yBAAA;EDypcJ;ECvpcE;;;IAEE,SAXS;EDqqcb;ECxpcE;;;IAEE,SAAA;ED2pcJ;ECzqcE;;;IAEE,8CAAA;ED4qcJ;EC1qcE;;;IAEE,yBAAA;ED6qcJ;EC3qcE;;;IAEE,SAXS;EDyrcb;EC5qcE;;;IAEE,SAAA;ED+qcJ;EC7rcE;;;IAEE,8CAAA;EDgscJ;EC9rcE;;;IAEE,yBAAA;EDiscJ;EC/rcE;;;IAEE,SAXS;ED6scb;EChscE;;;IAEE,SAAA;EDmscJ;ECjtcE;;;IAEE,8CAAA;EDotcJ;ECltcE;;;IAEE,yBAAA;EDqtcJ;ECntcE;;;IAEE,SAXS;EDiucb;ECptcE;;;IAEE,SAAA;EDutcJ;ECrucE;;;IAEE,8CAAA;EDwucJ;ECtucE;;;IAEE,yBAAA;EDyucJ;ECvucE;;;IAEE,SAXS;EDqvcb;ECxucE;;;IAEE,SAAA;ED2ucJ;ECzvcE;;;IAEE,8CAAA;ED4vcJ;EC1vcE;;;IAEE,yBAAA;ED6vcJ;EC3vcE;;;IAEE,SAXS;EDywcb;EC5vcE;;;IAEE,SAAA;ED+vcJ;EC7wcE;;;IAEE,8CAAA;EDgxcJ;EC9wcE;;;IAEE,yBAAA;EDixcJ;EC/wcE;;;IAEE,SAXS;ED6xcb;EChxcE;;;IAEE,SAAA;EDmxcJ;ECjycE;;;IAEE,8CAAA;EDoycJ;EClycE;;;IAEE,yBAAA;EDqycJ;ECnycE;;;IAEE,SAXS;EDizcb;ECpycE;;;IAEE,SAAA;EDuycJ;ECrzcE;;;IAEE,8CAAA;EDwzcJ;ECtzcE;;;IAEE,yBAAA;EDyzcJ;ECvzcE;;;IAEE,SAXS;EDq0cb;ECxzcE;;;IAEE,SAAA;ED2zcJ;ECz0cE;;;IAEE,8CAAA;ED40cJ;EC10cE;;;IAEE,yBAAA;ED60cJ;EC30cE;;;IAEE,SAXS;EDy1cb;EC50cE;;;IAEE,SAAA;ED+0cJ;EC71cE;;;IAEE,8CAAA;EDg2cJ;EC91cE;;;IAEE,yBAAA;EDi2cJ;EC/1cE;;;IAEE,SAXS;ED62cb;ECh2cE;;;IAEE,SAAA;EDm2cJ;ECj3cE;;;IAEE,8CAAA;EDo3cJ;ECl3cE;;;IAEE,yBAAA;EDq3cJ;ECn3cE;;;IAEE,SAXS;EDi4cb;ECp3cE;;;IAEE,SAAA;EDu3cJ;ECr4cE;;;IAEE,8CAAA;EDw4cJ;ECt4cE;;;IAEE,yBAAA;EDy4cJ;ECv4cE;;;IAEE,SAXS;EDq5cb;ECx4cE;;;IAEE,SAAA;ED24cJ;ECz5cE;;;IAEE,8CAAA;ED45cJ;EC15cE;;;IAEE,yBAAA;ED65cJ;EC35cE;;;IAEE,SAXS;EDy6cb;EC55cE;;;IAEE,SAAA;ED+5cJ;EC76cE;;;IAEE,8CAAA;EDg7cJ;EC96cE;;;IAEE,yBAAA;EDi7cJ;EC/6cE;;;IAEE,SAXS;ED67cb;ECh7cE;;;IAEE,SAAA;EDm7cJ;ECj8cE;;;IAEE,8CAAA;EDo8cJ;ECl8cE;;;IAEE,yBAAA;EDq8cJ;ECn8cE;;;IAEE,SAXS;EDi9cb;ECp8cE;;;IAEE,SAAA;EDu8cJ;ECr9cE;;;IAEE,8CAAA;EDw9cJ;ECt9cE;;;IAEE,yBAAA;EDy9cJ;ECv9cE;;;IAEE,SAXS;EDq+cb;ECx9cE;;;IAEE,SAAA;ED29cJ;ECz+cE;;;IAEE,8CAAA;ED4+cJ;EC1+cE;;;IAEE,yBAAA;ED6+cJ;EC3+cE;;;IAEE,SAXS;EDy/cb;EC5+cE;;;IAEE,SAAA;ED++cJ;EC7/cE;;;IAEE,8CAAA;EDggdJ;EC9/cE;;;IAEE,yBAAA;EDigdJ;EC//cE;;;IAEE,SAXS;ED6gdb;EChgdE;;;IAEE,SAAA;EDmgdJ;ECjhdE;;;IAEE,8CAAA;EDohdJ;EClhdE;;;IAEE,yBAAA;EDqhdJ;ECnhdE;;;IAEE,SAXS;EDiidb;ECphdE;;;IAEE,SAAA;EDuhdJ;ECridE;;;IAEE,8CAAA;EDwidJ;ECtidE;;;IAEE,yBAAA;EDyidJ;ECvidE;;;IAEE,SAXS;EDqjdb;ECxidE;;;IAEE,SAAA;ED2idJ;ECzjdE;;;IAEE,8CAAA;ED4jdJ;EC1jdE;;;IAEE,yBAAA;ED6jdJ;EC3jdE;;;IAEE,SAXS;EDykdb;EC5jdE;;;IAEE,SAAA;ED+jdJ;EC7kdE;;;IAEE,8CAAA;EDgldJ;EC9kdE;;;IAEE,yBAAA;EDildJ;EC/kdE;;;IAEE,SAXS;ED6ldb;EChldE;;;IAEE,SAAA;EDmldJ;ECjmdE;;;IAEE,8CAAA;EDomdJ;EClmdE;;;IAEE,yBAAA;EDqmdJ;ECnmdE;;;IAEE,SAXS;EDindb;ECpmdE;;;IAEE,SAAA;EDumdJ;ECrndE;;;IAEE,8CAAA;EDwndJ;ECtndE;;;IAEE,yBAAA;EDyndJ;ECvndE;;;IAEE,SAXS;EDqodb;ECxndE;;;IAEE,SAAA;ED2ndJ;ECzodE;;;IAEE,8CAAA;ED4odJ;EC1odE;;;IAEE,yBAAA;ED6odJ;EC3odE;;;IAEE,SAXS;EDypdb;EC5odE;;;IAEE,SAAA;ED+odJ;EC7pdE;;;IAEE,8CAAA;EDgqdJ;EC9pdE;;;IAEE,yBAAA;EDiqdJ;EC/pdE;;;IAEE,SAXS;ED6qdb;EChqdE;;;IAEE,SAAA;EDmqdJ;ECjrdE;;;IAEE,8CAAA;EDordJ;EClrdE;;;IAEE,yBAAA;EDqrdJ;ECnrdE;;;IAEE,SAXS;EDisdb;ECprdE;;;IAEE,SAAA;EDurdJ;ECrsdE;;;IAEE,8CAAA;EDwsdJ;ECtsdE;;;IAEE,yBAAA;EDysdJ;ECvsdE;;;IAEE,SAXS;EDqtdb;ECxsdE;;;IAEE,SAAA;ED2sdJ;ECrsdA;;IACE,cAAA;EDwsdF;AACF;AC9/cE;EAyBE;;;IAEE,0BAAA;EDy+cJ;ECv+cE;;;IAEE,oBAPS;EDi/cb;ECx+cE;;;IAEE,kBAXS;EDs/cb;ECr/cE;;;IAEE,0BAAA;EDw/cJ;ECt/cE;;;IAEE,oBAPS;EDggdb;ECv/cE;;;IAEE,kBAXS;EDqgdb;ECpgdE;;;IAEE,0BAAA;EDugdJ;ECrgdE;;;IAEE,oBAPS;ED+gdb;ECtgdE;;;IAEE,kBAXS;EDohdb;ECnhdE;;;IAEE,0BAAA;EDshdJ;ECphdE;;;IAEE,oBAPS;ED8hdb;ECrhdE;;;IAEE,kBAXS;EDmidb;EClidE;;;IAEE,0BAAA;EDqidJ;ECnidE;;;IAEE,oBAPS;ED6idb;ECpidE;;;IAEE,kBAXS;EDkjdb;ECjjdE;;;IAEE,0BAAA;EDojdJ;ECljdE;;;IAEE,oBAPS;ED4jdb;ECnjdE;;;IAEE,kBAXS;EDikdb;EChkdE;;;IAEE,0BAAA;EDmkdJ;ECjkdE;;;IAEE,oBAPS;ED2kdb;EClkdE;;;IAEE,kBAXS;EDgldb;EC/kdE;;;IAEE,0BAAA;EDkldJ;EChldE;;;IAEE,oBAPS;ED0ldb;ECjldE;;;IAEE,kBAXS;ED+ldb;EC9ldE;;;IAEE,0BAAA;EDimdJ;EC/ldE;;;IAEE,oBAPS;EDymdb;EChmdE;;;IAEE,kBAXS;ED8mdb;EC7mdE;;;IAEE,4BAAA;EDgndJ;EC9mdE;;;IAEE,qBAPS;EDwndb;EC/mdE;;;IAEE,mBAXS;ED6ndb;EC5ndE;;;IAEE,4BAAA;ED+ndJ;EC7ndE;;;IAEE,qBAPS;EDuodb;EC9ndE;;;IAEE,mBAXS;ED4odb;EC3odE;;;IAEE,4BAAA;ED8odJ;EC5odE;;;IAEE,qBAPS;EDspdb;EC7odE;;;IAEE,mBAXS;ED2pdb;EC1pdE;;;IAEE,4BAAA;ED6pdJ;EC3pdE;;;IAEE,qBAPS;EDqqdb;EC5pdE;;;IAEE,mBAXS;ED0qdb;ECzqdE;;;IAEE,4BAAA;ED4qdJ;EC1qdE;;;IAEE,qBAPS;EDordb;EC3qdE;;;IAEE,mBAXS;EDyrdb;ECxrdE;;;IAEE,4BAAA;ED2rdJ;ECzrdE;;;IAEE,qBAPS;EDmsdb;EC1rdE;;;IAEE,mBAXS;EDwsdb;ECvsdE;;;IAEE,4BAAA;ED0sdJ;ECxsdE;;;IAEE,qBAPS;EDktdb;ECzsdE;;;IAEE,mBAXS;EDutdb;ECttdE;;;IAEE,4BAAA;EDytdJ;ECvtdE;;;IAEE,qBAPS;EDiudb;ECxtdE;;;IAEE,mBAXS;EDsudb;ECrudE;;;IAEE,4BAAA;EDwudJ;ECtudE;;;IAEE,qBAPS;EDgvdb;ECvudE;;;IAEE,mBAXS;EDqvdb;ECpvdE;;;IAEE,4BAAA;EDuvdJ;ECrvdE;;;IAEE,qBAPS;ED+vdb;ECtvdE;;;IAEE,mBAXS;EDowdb;ECnwdE;;;IAEE,4BAAA;EDswdJ;ECpwdE;;;IAEE,qBAPS;ED8wdb;ECrwdE;;;IAEE,mBAXS;EDmxdb;EClxdE;;;IAEE,4BAAA;EDqxdJ;ECnxdE;;;IAEE,qBAPS;ED6xdb;ECpxdE;;;IAEE,mBAXS;EDkydb;ECjydE;;;IAEE,4BAAA;EDoydJ;EClydE;;;IAEE,qBAPS;ED4ydb;ECnydE;;;IAEE,mBAXS;EDizdb;EChzdE;;;IAEE,4BAAA;EDmzdJ;ECjzdE;;;IAEE,qBAPS;ED2zdb;EClzdE;;;IAEE,mBAXS;EDg0db;EC/zdE;;;IAEE,4BAAA;EDk0dJ;ECh0dE;;;IAEE,qBAPS;ED00db;ECj0dE;;;IAEE,mBAXS;ED+0db;ECvkeE;;;IAEE,6CAAA;ED0keJ;ECxkeE;;;IAEE,uBAAA;ED2keJ;ECzkeE;;;IAEE,QAXS;EDuleb;EC1keE;;;IAEE,SAAA;ED6keJ;EC3leE;;;IAEE,6CAAA;ED8leJ;EC5leE;;;IAEE,uBAAA;ED+leJ;EC7leE;;;IAEE,QAXS;ED2meb;EC9leE;;;IAEE,SAAA;EDimeJ;EC/meE;;;IAEE,6CAAA;EDkneJ;EChneE;;;IAEE,uBAAA;EDmneJ;ECjneE;;;IAEE,QAXS;ED+neb;EClneE;;;IAEE,SAAA;EDqneJ;ECnoeE;;;IAEE,6CAAA;EDsoeJ;ECpoeE;;;IAEE,uBAAA;EDuoeJ;ECroeE;;;IAEE,QAXS;EDmpeb;ECtoeE;;;IAEE,SAAA;EDyoeJ;ECvpeE;;;IAEE,6CAAA;ED0peJ;ECxpeE;;;IAEE,uBAAA;ED2peJ;ECzpeE;;;IAEE,QAXS;EDuqeb;EC1peE;;;IAEE,SAAA;ED6peJ;EC3qeE;;;IAEE,6CAAA;ED8qeJ;EC5qeE;;;IAEE,uBAAA;ED+qeJ;EC7qeE;;;IAEE,QAXS;ED2reb;EC9qeE;;;IAEE,SAAA;EDireJ;EC/reE;;;IAEE,6CAAA;EDkseJ;EChseE;;;IAEE,uBAAA;EDmseJ;ECjseE;;;IAEE,QAXS;ED+seb;EClseE;;;IAEE,SAAA;EDqseJ;ECnteE;;;IAEE,6CAAA;EDsteJ;ECpteE;;;IAEE,uBAAA;EDuteJ;ECrteE;;;IAEE,QAXS;EDmueb;ECtteE;;;IAEE,SAAA;EDyteJ;ECvueE;;;IAEE,6CAAA;ED0ueJ;ECxueE;;;IAEE,uBAAA;ED2ueJ;ECzueE;;;IAEE,QAXS;EDuveb;EC1ueE;;;IAEE,SAAA;ED6ueJ;EC3veE;;;IAEE,8CAAA;ED8veJ;EC5veE;;;IAEE,yBAAA;ED+veJ;EC7veE;;;IAEE,SAXS;ED2web;EC9veE;;;IAEE,SAAA;EDiweJ;EC/weE;;;IAEE,8CAAA;EDkxeJ;EChxeE;;;IAEE,yBAAA;EDmxeJ;ECjxeE;;;IAEE,SAXS;ED+xeb;EClxeE;;;IAEE,SAAA;EDqxeJ;ECnyeE;;;IAEE,8CAAA;EDsyeJ;ECpyeE;;;IAEE,yBAAA;EDuyeJ;ECryeE;;;IAEE,SAXS;EDmzeb;ECtyeE;;;IAEE,SAAA;EDyyeJ;ECvzeE;;;IAEE,8CAAA;ED0zeJ;ECxzeE;;;IAEE,yBAAA;ED2zeJ;ECzzeE;;;IAEE,SAXS;EDu0eb;EC1zeE;;;IAEE,SAAA;ED6zeJ;EC30eE;;;IAEE,8CAAA;ED80eJ;EC50eE;;;IAEE,yBAAA;ED+0eJ;EC70eE;;;IAEE,SAXS;ED21eb;EC90eE;;;IAEE,SAAA;EDi1eJ;EC/1eE;;;IAEE,8CAAA;EDk2eJ;ECh2eE;;;IAEE,yBAAA;EDm2eJ;ECj2eE;;;IAEE,SAXS;ED+2eb;ECl2eE;;;IAEE,SAAA;EDq2eJ;ECn3eE;;;IAEE,8CAAA;EDs3eJ;ECp3eE;;;IAEE,yBAAA;EDu3eJ;ECr3eE;;;IAEE,SAXS;EDm4eb;ECt3eE;;;IAEE,SAAA;EDy3eJ;ECv4eE;;;IAEE,8CAAA;ED04eJ;ECx4eE;;;IAEE,yBAAA;ED24eJ;ECz4eE;;;IAEE,SAXS;EDu5eb;EC14eE;;;IAEE,SAAA;ED64eJ;EC35eE;;;IAEE,8CAAA;ED85eJ;EC55eE;;;IAEE,yBAAA;ED+5eJ;EC75eE;;;IAEE,SAXS;ED26eb;EC95eE;;;IAEE,SAAA;EDi6eJ;EC/6eE;;;IAEE,8CAAA;EDk7eJ;ECh7eE;;;IAEE,yBAAA;EDm7eJ;ECj7eE;;;IAEE,SAXS;ED+7eb;ECl7eE;;;IAEE,SAAA;EDq7eJ;ECn8eE;;;IAEE,8CAAA;EDs8eJ;ECp8eE;;;IAEE,yBAAA;EDu8eJ;ECr8eE;;;IAEE,SAXS;EDm9eb;ECt8eE;;;IAEE,SAAA;EDy8eJ;ECv9eE;;;IAEE,8CAAA;ED09eJ;ECx9eE;;;IAEE,yBAAA;ED29eJ;ECz9eE;;;IAEE,SAXS;EDu+eb;EC19eE;;;IAEE,SAAA;ED69eJ;EC3+eE;;;IAEE,8CAAA;ED8+eJ;EC5+eE;;;IAEE,yBAAA;ED++eJ;EC7+eE;;;IAEE,SAXS;ED2/eb;EC9+eE;;;IAEE,SAAA;EDi/eJ;EC//eE;;;IAEE,8CAAA;EDkgfJ;EChgfE;;;IAEE,yBAAA;EDmgfJ;ECjgfE;;;IAEE,SAXS;ED+gfb;EClgfE;;;IAEE,SAAA;EDqgfJ;ECnhfE;;;IAEE,8CAAA;EDshfJ;ECphfE;;;IAEE,yBAAA;EDuhfJ;ECrhfE;;;IAEE,SAXS;EDmifb;ECthfE;;;IAEE,SAAA;EDyhfJ;ECvifE;;;IAEE,8CAAA;ED0ifJ;ECxifE;;;IAEE,yBAAA;ED2ifJ;ECzifE;;;IAEE,SAXS;EDujfb;EC1ifE;;;IAEE,SAAA;ED6ifJ;EC3jfE;;;IAEE,8CAAA;ED8jfJ;EC5jfE;;;IAEE,yBAAA;ED+jfJ;EC7jfE;;;IAEE,SAXS;ED2kfb;EC9jfE;;;IAEE,SAAA;EDikfJ;EC/kfE;;;IAEE,8CAAA;EDklfJ;EChlfE;;;IAEE,yBAAA;EDmlfJ;ECjlfE;;;IAEE,SAXS;ED+lfb;ECllfE;;;IAEE,SAAA;EDqlfJ;ECnmfE;;;IAEE,8CAAA;EDsmfJ;ECpmfE;;;IAEE,yBAAA;EDumfJ;ECrmfE;;;IAEE,SAXS;EDmnfb;ECtmfE;;;IAEE,SAAA;EDymfJ;ECvnfE;;;IAEE,8CAAA;ED0nfJ;ECxnfE;;;IAEE,yBAAA;ED2nfJ;ECznfE;;;IAEE,SAXS;EDuofb;EC1nfE;;;IAEE,SAAA;ED6nfJ;EC3ofE;;;IAEE,8CAAA;ED8ofJ;EC5ofE;;;IAEE,yBAAA;ED+ofJ;EC7ofE;;;IAEE,SAXS;ED2pfb;EC9ofE;;;IAEE,SAAA;EDipfJ;EC/pfE;;;IAEE,8CAAA;EDkqfJ;EChqfE;;;IAEE,yBAAA;EDmqfJ;ECjqfE;;;IAEE,SAXS;ED+qfb;EClqfE;;;IAEE,SAAA;EDqqfJ;ECnrfE;;;IAEE,8CAAA;EDsrfJ;ECprfE;;;IAEE,yBAAA;EDurfJ;ECrrfE;;;IAEE,SAXS;EDmsfb;ECtrfE;;;IAEE,SAAA;EDyrfJ;ECvsfE;;;IAEE,8CAAA;ED0sfJ;ECxsfE;;;IAEE,yBAAA;ED2sfJ;ECzsfE;;;IAEE,SAXS;EDutfb;EC1sfE;;;IAEE,SAAA;ED6sfJ;EC3tfE;;;IAEE,8CAAA;ED8tfJ;EC5tfE;;;IAEE,yBAAA;ED+tfJ;EC7tfE;;;IAEE,SAXS;ED2ufb;EC9tfE;;;IAEE,SAAA;EDiufJ;EC/ufE;;;IAEE,8CAAA;EDkvfJ;EChvfE;;;IAEE,yBAAA;EDmvfJ;ECjvfE;;;IAEE,SAXS;ED+vfb;EClvfE;;;IAEE,SAAA;EDqvfJ;ECnwfE;;;IAEE,8CAAA;EDswfJ;ECpwfE;;;IAEE,yBAAA;EDuwfJ;ECrwfE;;;IAEE,SAXS;EDmxfb;ECtwfE;;;IAEE,SAAA;EDywfJ;ECvxfE;;;IAEE,8CAAA;ED0xfJ;ECxxfE;;;IAEE,yBAAA;ED2xfJ;ECzxfE;;;IAEE,SAXS;EDuyfb;EC1xfE;;;IAEE,SAAA;ED6xfJ;EC3yfE;;;IAEE,8CAAA;ED8yfJ;EC5yfE;;;IAEE,yBAAA;ED+yfJ;EC7yfE;;;IAEE,SAXS;ED2zfb;EC9yfE;;;IAEE,SAAA;EDizfJ;EC/zfE;;;IAEE,8CAAA;EDk0fJ;ECh0fE;;;IAEE,yBAAA;EDm0fJ;ECj0fE;;;IAEE,SAXS;ED+0fb;ECl0fE;;;IAEE,SAAA;EDq0fJ;ECn1fE;;;IAEE,8CAAA;EDs1fJ;ECp1fE;;;IAEE,yBAAA;EDu1fJ;ECr1fE;;;IAEE,SAXS;EDm2fb;ECt1fE;;;IAEE,SAAA;EDy1fJ;ECv2fE;;;IAEE,8CAAA;ED02fJ;ECx2fE;;;IAEE,yBAAA;ED22fJ;ECz2fE;;;IAEE,SAXS;EDu3fb;EC12fE;;;IAEE,SAAA;ED62fJ;EC33fE;;;IAEE,8CAAA;ED83fJ;EC53fE;;;IAEE,yBAAA;ED+3fJ;EC73fE;;;IAEE,SAXS;ED24fb;EC93fE;;;IAEE,SAAA;EDi4fJ;EC/4fE;;;IAEE,8CAAA;EDk5fJ;ECh5fE;;;IAEE,yBAAA;EDm5fJ;ECj5fE;;;IAEE,SAXS;ED+5fb;ECl5fE;;;IAEE,SAAA;EDq5fJ;ECn6fE;;;IAEE,8CAAA;EDs6fJ;ECp6fE;;;IAEE,yBAAA;EDu6fJ;ECr6fE;;;IAEE,SAXS;EDm7fb;ECt6fE;;;IAEE,SAAA;EDy6fJ;ECv7fE;;;IAEE,8CAAA;ED07fJ;ECx7fE;;;IAEE,yBAAA;ED27fJ;ECz7fE;;;IAEE,SAXS;EDu8fb;EC17fE;;;IAEE,SAAA;ED67fJ;EC38fE;;;IAEE,8CAAA;ED88fJ;EC58fE;;;IAEE,yBAAA;ED+8fJ;EC78fE;;;IAEE,SAXS;ED29fb;EC98fE;;;IAEE,SAAA;EDi9fJ;EC/9fE;;;IAEE,8CAAA;EDk+fJ;ECh+fE;;;IAEE,yBAAA;EDm+fJ;ECj+fE;;;IAEE,SAXS;ED++fb;ECl+fE;;;IAEE,SAAA;EDq+fJ;ECn/fE;;;IAEE,8CAAA;EDs/fJ;ECp/fE;;;IAEE,yBAAA;EDu/fJ;ECr/fE;;;IAEE,SAXS;EDmggBb;ECt/fE;;;IAEE,SAAA;EDy/fJ;ECvggBE;;;IAEE,8CAAA;ED0ggBJ;ECxggBE;;;IAEE,yBAAA;ED2ggBJ;ECzggBE;;;IAEE,SAXS;EDuhgBb;EC1ggBE;;;IAEE,SAAA;ED6ggBJ;EC3hgBE;;;IAEE,8CAAA;ED8hgBJ;EC5hgBE;;;IAEE,yBAAA;ED+hgBJ;EC7hgBE;;;IAEE,SAXS;ED2igBb;EC9hgBE;;;IAEE,SAAA;EDiigBJ;EC3hgBA;;IACE,cAAA;ED8hgBF;AACF;ACl1fE;EAuBE;;;IAEE,0BAAA;ED+zfJ;EC7zfE;;;IAEE,oBAPS;EDu0fb;EC9zfE;;;IAEE,kBAXS;ED40fb;EC30fE;;;IAEE,0BAAA;ED80fJ;EC50fE;;;IAEE,oBAPS;EDs1fb;EC70fE;;;IAEE,kBAXS;ED21fb;EC11fE;;;IAEE,0BAAA;ED61fJ;EC31fE;;;IAEE,oBAPS;EDq2fb;EC51fE;;;IAEE,kBAXS;ED02fb;ECz2fE;;;IAEE,0BAAA;ED42fJ;EC12fE;;;IAEE,oBAPS;EDo3fb;EC32fE;;;IAEE,kBAXS;EDy3fb;ECx3fE;;;IAEE,0BAAA;ED23fJ;ECz3fE;;;IAEE,oBAPS;EDm4fb;EC13fE;;;IAEE,kBAXS;EDw4fb;ECv4fE;;;IAEE,0BAAA;ED04fJ;ECx4fE;;;IAEE,oBAPS;EDk5fb;ECz4fE;;;IAEE,kBAXS;EDu5fb;ECt5fE;;;IAEE,0BAAA;EDy5fJ;ECv5fE;;;IAEE,oBAPS;EDi6fb;ECx5fE;;;IAEE,kBAXS;EDs6fb;ECr6fE;;;IAEE,0BAAA;EDw6fJ;ECt6fE;;;IAEE,oBAPS;EDg7fb;ECv6fE;;;IAEE,kBAXS;EDq7fb;ECp7fE;;;IAEE,0BAAA;EDu7fJ;ECr7fE;;;IAEE,oBAPS;ED+7fb;ECt7fE;;;IAEE,kBAXS;EDo8fb;ECn8fE;;;IAEE,4BAAA;EDs8fJ;ECp8fE;;;IAEE,qBAPS;ED88fb;ECr8fE;;;IAEE,mBAXS;EDm9fb;ECl9fE;;;IAEE,4BAAA;EDq9fJ;ECn9fE;;;IAEE,qBAPS;ED69fb;ECp9fE;;;IAEE,mBAXS;EDk+fb;ECj+fE;;;IAEE,4BAAA;EDo+fJ;ECl+fE;;;IAEE,qBAPS;ED4+fb;ECn+fE;;;IAEE,mBAXS;EDi/fb;ECh/fE;;;IAEE,4BAAA;EDm/fJ;ECj/fE;;;IAEE,qBAPS;ED2/fb;ECl/fE;;;IAEE,mBAXS;EDgggBb;EC//fE;;;IAEE,4BAAA;EDkggBJ;EChggBE;;;IAEE,qBAPS;ED0ggBb;ECjggBE;;;IAEE,mBAXS;ED+ggBb;EC9ggBE;;;IAEE,4BAAA;EDihgBJ;EC/ggBE;;;IAEE,qBAPS;EDyhgBb;EChhgBE;;;IAEE,mBAXS;ED8hgBb;EC7hgBE;;;IAEE,4BAAA;EDgigBJ;EC9hgBE;;;IAEE,qBAPS;EDwigBb;EC/hgBE;;;IAEE,mBAXS;ED6igBb;EC5igBE;;;IAEE,4BAAA;ED+igBJ;EC7igBE;;;IAEE,qBAPS;EDujgBb;EC9igBE;;;IAEE,mBAXS;ED4jgBb;EC3jgBE;;;IAEE,4BAAA;ED8jgBJ;EC5jgBE;;;IAEE,qBAPS;EDskgBb;EC7jgBE;;;IAEE,mBAXS;ED2kgBb;EC1kgBE;;;IAEE,4BAAA;ED6kgBJ;EC3kgBE;;;IAEE,qBAPS;EDqlgBb;EC5kgBE;;;IAEE,mBAXS;ED0lgBb;ECzlgBE;;;IAEE,4BAAA;ED4lgBJ;EC1lgBE;;;IAEE,qBAPS;EDomgBb;EC3lgBE;;;IAEE,mBAXS;EDymgBb;ECxmgBE;;;IAEE,4BAAA;ED2mgBJ;ECzmgBE;;;IAEE,qBAPS;EDmngBb;EC1mgBE;;;IAEE,mBAXS;EDwngBb;ECvngBE;;;IAEE,4BAAA;ED0ngBJ;ECxngBE;;;IAEE,qBAPS;EDkogBb;ECzngBE;;;IAEE,mBAXS;EDuogBb;ECtogBE;;;IAEE,4BAAA;EDyogBJ;ECvogBE;;;IAEE,qBAPS;EDipgBb;ECxogBE;;;IAEE,mBAXS;EDspgBb;ECrpgBE;;;IAEE,4BAAA;EDwpgBJ;ECtpgBE;;;IAEE,qBAPS;EDgqgBb;ECvpgBE;;;IAEE,mBAXS;EDqqgBb;EC75gBE;;;IAEE,6CAAA;EDg6gBJ;EC95gBE;;;IAEE,uBAAA;EDi6gBJ;EC/5gBE;;;IAEE,QAXS;ED66gBb;ECh6gBE;;;IAEE,SAAA;EDm6gBJ;ECj7gBE;;;IAEE,6CAAA;EDo7gBJ;ECl7gBE;;;IAEE,uBAAA;EDq7gBJ;ECn7gBE;;;IAEE,QAXS;EDi8gBb;ECp7gBE;;;IAEE,SAAA;EDu7gBJ;ECr8gBE;;;IAEE,6CAAA;EDw8gBJ;ECt8gBE;;;IAEE,uBAAA;EDy8gBJ;ECv8gBE;;;IAEE,QAXS;EDq9gBb;ECx8gBE;;;IAEE,SAAA;ED28gBJ;ECz9gBE;;;IAEE,6CAAA;ED49gBJ;EC19gBE;;;IAEE,uBAAA;ED69gBJ;EC39gBE;;;IAEE,QAXS;EDy+gBb;EC59gBE;;;IAEE,SAAA;ED+9gBJ;EC7+gBE;;;IAEE,6CAAA;EDg/gBJ;EC9+gBE;;;IAEE,uBAAA;EDi/gBJ;EC/+gBE;;;IAEE,QAXS;ED6/gBb;ECh/gBE;;;IAEE,SAAA;EDm/gBJ;ECjghBE;;;IAEE,6CAAA;EDoghBJ;EClghBE;;;IAEE,uBAAA;EDqghBJ;ECnghBE;;;IAEE,QAXS;EDihhBb;ECpghBE;;;IAEE,SAAA;EDughBJ;ECrhhBE;;;IAEE,6CAAA;EDwhhBJ;ECthhBE;;;IAEE,uBAAA;EDyhhBJ;ECvhhBE;;;IAEE,QAXS;EDqihBb;ECxhhBE;;;IAEE,SAAA;ED2hhBJ;ECzihBE;;;IAEE,6CAAA;ED4ihBJ;EC1ihBE;;;IAEE,uBAAA;ED6ihBJ;EC3ihBE;;;IAEE,QAXS;EDyjhBb;EC5ihBE;;;IAEE,SAAA;ED+ihBJ;EC7jhBE;;;IAEE,6CAAA;EDgkhBJ;EC9jhBE;;;IAEE,uBAAA;EDikhBJ;EC/jhBE;;;IAEE,QAXS;ED6khBb;EChkhBE;;;IAEE,SAAA;EDmkhBJ;ECjlhBE;;;IAEE,8CAAA;EDolhBJ;ECllhBE;;;IAEE,yBAAA;EDqlhBJ;ECnlhBE;;;IAEE,SAXS;EDimhBb;ECplhBE;;;IAEE,SAAA;EDulhBJ;ECrmhBE;;;IAEE,8CAAA;EDwmhBJ;ECtmhBE;;;IAEE,yBAAA;EDymhBJ;ECvmhBE;;;IAEE,SAXS;EDqnhBb;ECxmhBE;;;IAEE,SAAA;ED2mhBJ;ECznhBE;;;IAEE,8CAAA;ED4nhBJ;EC1nhBE;;;IAEE,yBAAA;ED6nhBJ;EC3nhBE;;;IAEE,SAXS;EDyohBb;EC5nhBE;;;IAEE,SAAA;ED+nhBJ;EC7ohBE;;;IAEE,8CAAA;EDgphBJ;EC9ohBE;;;IAEE,yBAAA;EDiphBJ;EC/ohBE;;;IAEE,SAXS;ED6phBb;EChphBE;;;IAEE,SAAA;EDmphBJ;ECjqhBE;;;IAEE,8CAAA;EDoqhBJ;EClqhBE;;;IAEE,yBAAA;EDqqhBJ;ECnqhBE;;;IAEE,SAXS;EDirhBb;ECpqhBE;;;IAEE,SAAA;EDuqhBJ;ECrrhBE;;;IAEE,8CAAA;EDwrhBJ;ECtrhBE;;;IAEE,yBAAA;EDyrhBJ;ECvrhBE;;;IAEE,SAXS;EDqshBb;ECxrhBE;;;IAEE,SAAA;ED2rhBJ;ECzshBE;;;IAEE,8CAAA;ED4shBJ;EC1shBE;;;IAEE,yBAAA;ED6shBJ;EC3shBE;;;IAEE,SAXS;EDythBb;EC5shBE;;;IAEE,SAAA;ED+shBJ;EC7thBE;;;IAEE,8CAAA;EDguhBJ;EC9thBE;;;IAEE,yBAAA;EDiuhBJ;EC/thBE;;;IAEE,SAXS;ED6uhBb;EChuhBE;;;IAEE,SAAA;EDmuhBJ;ECjvhBE;;;IAEE,8CAAA;EDovhBJ;EClvhBE;;;IAEE,yBAAA;EDqvhBJ;ECnvhBE;;;IAEE,SAXS;EDiwhBb;ECpvhBE;;;IAEE,SAAA;EDuvhBJ;ECrwhBE;;;IAEE,8CAAA;EDwwhBJ;ECtwhBE;;;IAEE,yBAAA;EDywhBJ;ECvwhBE;;;IAEE,SAXS;EDqxhBb;ECxwhBE;;;IAEE,SAAA;ED2whBJ;ECzxhBE;;;IAEE,8CAAA;ED4xhBJ;EC1xhBE;;;IAEE,yBAAA;ED6xhBJ;EC3xhBE;;;IAEE,SAXS;EDyyhBb;EC5xhBE;;;IAEE,SAAA;ED+xhBJ;EC7yhBE;;;IAEE,8CAAA;EDgzhBJ;EC9yhBE;;;IAEE,yBAAA;EDizhBJ;EC/yhBE;;;IAEE,SAXS;ED6zhBb;EChzhBE;;;IAEE,SAAA;EDmzhBJ;ECj0hBE;;;IAEE,8CAAA;EDo0hBJ;ECl0hBE;;;IAEE,yBAAA;EDq0hBJ;ECn0hBE;;;IAEE,SAXS;EDi1hBb;ECp0hBE;;;IAEE,SAAA;EDu0hBJ;ECr1hBE;;;IAEE,8CAAA;EDw1hBJ;ECt1hBE;;;IAEE,yBAAA;EDy1hBJ;ECv1hBE;;;IAEE,SAXS;EDq2hBb;ECx1hBE;;;IAEE,SAAA;ED21hBJ;ECz2hBE;;;IAEE,8CAAA;ED42hBJ;EC12hBE;;;IAEE,yBAAA;ED62hBJ;EC32hBE;;;IAEE,SAXS;EDy3hBb;EC52hBE;;;IAEE,SAAA;ED+2hBJ;EC73hBE;;;IAEE,8CAAA;EDg4hBJ;EC93hBE;;;IAEE,yBAAA;EDi4hBJ;EC/3hBE;;;IAEE,SAXS;ED64hBb;ECh4hBE;;;IAEE,SAAA;EDm4hBJ;ECj5hBE;;;IAEE,8CAAA;EDo5hBJ;ECl5hBE;;;IAEE,yBAAA;EDq5hBJ;ECn5hBE;;;IAEE,SAXS;EDi6hBb;ECp5hBE;;;IAEE,SAAA;EDu5hBJ;ECr6hBE;;;IAEE,8CAAA;EDw6hBJ;ECt6hBE;;;IAEE,yBAAA;EDy6hBJ;ECv6hBE;;;IAEE,SAXS;EDq7hBb;ECx6hBE;;;IAEE,SAAA;ED26hBJ;ECz7hBE;;;IAEE,8CAAA;ED47hBJ;EC17hBE;;;IAEE,yBAAA;ED67hBJ;EC37hBE;;;IAEE,SAXS;EDy8hBb;EC57hBE;;;IAEE,SAAA;ED+7hBJ;EC78hBE;;;IAEE,8CAAA;EDg9hBJ;EC98hBE;;;IAEE,yBAAA;EDi9hBJ;EC/8hBE;;;IAEE,SAXS;ED69hBb;ECh9hBE;;;IAEE,SAAA;EDm9hBJ;ECj+hBE;;;IAEE,8CAAA;EDo+hBJ;ECl+hBE;;;IAEE,yBAAA;EDq+hBJ;ECn+hBE;;;IAEE,SAXS;EDi/hBb;ECp+hBE;;;IAEE,SAAA;EDu+hBJ;ECr/hBE;;;IAEE,8CAAA;EDw/hBJ;ECt/hBE;;;IAEE,yBAAA;EDy/hBJ;ECv/hBE;;;IAEE,SAXS;EDqgiBb;ECx/hBE;;;IAEE,SAAA;ED2/hBJ;ECzgiBE;;;IAEE,8CAAA;ED4giBJ;EC1giBE;;;IAEE,yBAAA;ED6giBJ;EC3giBE;;;IAEE,SAXS;EDyhiBb;EC5giBE;;;IAEE,SAAA;ED+giBJ;EC7hiBE;;;IAEE,8CAAA;EDgiiBJ;EC9hiBE;;;IAEE,yBAAA;EDiiiBJ;EC/hiBE;;;IAEE,SAXS;ED6iiBb;EChiiBE;;;IAEE,SAAA;EDmiiBJ;ECjjiBE;;;IAEE,8CAAA;EDojiBJ;ECljiBE;;;IAEE,yBAAA;EDqjiBJ;ECnjiBE;;;IAEE,SAXS;EDikiBb;ECpjiBE;;;IAEE,SAAA;EDujiBJ;ECrkiBE;;;IAEE,8CAAA;EDwkiBJ;ECtkiBE;;;IAEE,yBAAA;EDykiBJ;ECvkiBE;;;IAEE,SAXS;EDqliBb;ECxkiBE;;;IAEE,SAAA;ED2kiBJ;ECzliBE;;;IAEE,8CAAA;ED4liBJ;EC1liBE;;;IAEE,yBAAA;ED6liBJ;EC3liBE;;;IAEE,SAXS;EDymiBb;EC5liBE;;;IAEE,SAAA;ED+liBJ;EC7miBE;;;IAEE,8CAAA;EDgniBJ;EC9miBE;;;IAEE,yBAAA;EDiniBJ;EC/miBE;;;IAEE,SAXS;ED6niBb;EChniBE;;;IAEE,SAAA;EDmniBJ;ECjoiBE;;;IAEE,8CAAA;EDooiBJ;ECloiBE;;;IAEE,yBAAA;EDqoiBJ;ECnoiBE;;;IAEE,SAXS;EDipiBb;ECpoiBE;;;IAEE,SAAA;EDuoiBJ;ECrpiBE;;;IAEE,8CAAA;EDwpiBJ;ECtpiBE;;;IAEE,yBAAA;EDypiBJ;ECvpiBE;;;IAEE,SAXS;EDqqiBb;ECxpiBE;;;IAEE,SAAA;ED2piBJ;ECzqiBE;;;IAEE,8CAAA;ED4qiBJ;EC1qiBE;;;IAEE,yBAAA;ED6qiBJ;EC3qiBE;;;IAEE,SAXS;EDyriBb;EC5qiBE;;;IAEE,SAAA;ED+qiBJ;EC7riBE;;;IAEE,8CAAA;EDgsiBJ;EC9riBE;;;IAEE,yBAAA;EDisiBJ;EC/riBE;;;IAEE,SAXS;ED6siBb;EChsiBE;;;IAEE,SAAA;EDmsiBJ;ECjtiBE;;;IAEE,8CAAA;EDotiBJ;ECltiBE;;;IAEE,yBAAA;EDqtiBJ;ECntiBE;;;IAEE,SAXS;EDiuiBb;ECptiBE;;;IAEE,SAAA;EDutiBJ;ECruiBE;;;IAEE,8CAAA;EDwuiBJ;ECtuiBE;;;IAEE,yBAAA;EDyuiBJ;ECvuiBE;;;IAEE,SAXS;EDqviBb;ECxuiBE;;;IAEE,SAAA;ED2uiBJ;ECzviBE;;;IAEE,8CAAA;ED4viBJ;EC1viBE;;;IAEE,yBAAA;ED6viBJ;EC3viBE;;;IAEE,SAXS;EDywiBb;EC5viBE;;;IAEE,SAAA;ED+viBJ;EC7wiBE;;;IAEE,8CAAA;EDgxiBJ;EC9wiBE;;;IAEE,yBAAA;EDixiBJ;EC/wiBE;;;IAEE,SAXS;ED6xiBb;EChxiBE;;;IAEE,SAAA;EDmxiBJ;ECjyiBE;;;IAEE,8CAAA;EDoyiBJ;EClyiBE;;;IAEE,yBAAA;EDqyiBJ;ECnyiBE;;;IAEE,SAXS;EDiziBb;ECpyiBE;;;IAEE,SAAA;EDuyiBJ;ECrziBE;;;IAEE,8CAAA;EDwziBJ;ECtziBE;;;IAEE,yBAAA;EDyziBJ;ECvziBE;;;IAEE,SAXS;EDq0iBb;ECxziBE;;;IAEE,SAAA;ED2ziBJ;ECz0iBE;;;IAEE,8CAAA;ED40iBJ;EC10iBE;;;IAEE,yBAAA;ED60iBJ;EC30iBE;;;IAEE,SAXS;EDy1iBb;EC50iBE;;;IAEE,SAAA;ED+0iBJ;EC71iBE;;;IAEE,8CAAA;EDg2iBJ;EC91iBE;;;IAEE,yBAAA;EDi2iBJ;EC/1iBE;;;IAEE,SAXS;ED62iBb;ECh2iBE;;;IAEE,SAAA;EDm2iBJ;ECj3iBE;;;IAEE,8CAAA;EDo3iBJ;ECl3iBE;;;IAEE,yBAAA;EDq3iBJ;ECn3iBE;;;IAEE,SAXS;EDi4iBb;ECp3iBE;;;IAEE,SAAA;EDu3iBJ;ECj3iBA;;IACE,cAAA;EDo3iBF;AACF;ACtqiBE;EAqBE;;;IAEE,0BAAA;EDqpiBJ;ECnpiBE;;;IAEE,oBAPS;ED6piBb;ECppiBE;;;IAEE,kBAXS;EDkqiBb;ECjqiBE;;;IAEE,0BAAA;EDoqiBJ;EClqiBE;;;IAEE,oBAPS;ED4qiBb;ECnqiBE;;;IAEE,kBAXS;EDiriBb;EChriBE;;;IAEE,0BAAA;EDmriBJ;ECjriBE;;;IAEE,oBAPS;ED2riBb;EClriBE;;;IAEE,kBAXS;EDgsiBb;EC/riBE;;;IAEE,0BAAA;EDksiBJ;EChsiBE;;;IAEE,oBAPS;ED0siBb;ECjsiBE;;;IAEE,kBAXS;ED+siBb;EC9siBE;;;IAEE,0BAAA;EDitiBJ;EC/siBE;;;IAEE,oBAPS;EDytiBb;EChtiBE;;;IAEE,kBAXS;ED8tiBb;EC7tiBE;;;IAEE,0BAAA;EDguiBJ;EC9tiBE;;;IAEE,oBAPS;EDwuiBb;EC/tiBE;;;IAEE,kBAXS;ED6uiBb;EC5uiBE;;;IAEE,0BAAA;ED+uiBJ;EC7uiBE;;;IAEE,oBAPS;EDuviBb;EC9uiBE;;;IAEE,kBAXS;ED4viBb;EC3viBE;;;IAEE,0BAAA;ED8viBJ;EC5viBE;;;IAEE,oBAPS;EDswiBb;EC7viBE;;;IAEE,kBAXS;ED2wiBb;EC1wiBE;;;IAEE,0BAAA;ED6wiBJ;EC3wiBE;;;IAEE,oBAPS;EDqxiBb;EC5wiBE;;;IAEE,kBAXS;ED0xiBb;ECzxiBE;;;IAEE,4BAAA;ED4xiBJ;EC1xiBE;;;IAEE,qBAPS;EDoyiBb;EC3xiBE;;;IAEE,mBAXS;EDyyiBb;ECxyiBE;;;IAEE,4BAAA;ED2yiBJ;ECzyiBE;;;IAEE,qBAPS;EDmziBb;EC1yiBE;;;IAEE,mBAXS;EDwziBb;ECvziBE;;;IAEE,4BAAA;ED0ziBJ;ECxziBE;;;IAEE,qBAPS;EDk0iBb;ECzziBE;;;IAEE,mBAXS;EDu0iBb;ECt0iBE;;;IAEE,4BAAA;EDy0iBJ;ECv0iBE;;;IAEE,qBAPS;EDi1iBb;ECx0iBE;;;IAEE,mBAXS;EDs1iBb;ECr1iBE;;;IAEE,4BAAA;EDw1iBJ;ECt1iBE;;;IAEE,qBAPS;EDg2iBb;ECv1iBE;;;IAEE,mBAXS;EDq2iBb;ECp2iBE;;;IAEE,4BAAA;EDu2iBJ;ECr2iBE;;;IAEE,qBAPS;ED+2iBb;ECt2iBE;;;IAEE,mBAXS;EDo3iBb;ECn3iBE;;;IAEE,4BAAA;EDs3iBJ;ECp3iBE;;;IAEE,qBAPS;ED83iBb;ECr3iBE;;;IAEE,mBAXS;EDm4iBb;ECl4iBE;;;IAEE,4BAAA;EDq4iBJ;ECn4iBE;;;IAEE,qBAPS;ED64iBb;ECp4iBE;;;IAEE,mBAXS;EDk5iBb;ECj5iBE;;;IAEE,4BAAA;EDo5iBJ;ECl5iBE;;;IAEE,qBAPS;ED45iBb;ECn5iBE;;;IAEE,mBAXS;EDi6iBb;ECh6iBE;;;IAEE,4BAAA;EDm6iBJ;ECj6iBE;;;IAEE,qBAPS;ED26iBb;ECl6iBE;;;IAEE,mBAXS;EDg7iBb;EC/6iBE;;;IAEE,4BAAA;EDk7iBJ;ECh7iBE;;;IAEE,qBAPS;ED07iBb;ECj7iBE;;;IAEE,mBAXS;ED+7iBb;EC97iBE;;;IAEE,4BAAA;EDi8iBJ;EC/7iBE;;;IAEE,qBAPS;EDy8iBb;ECh8iBE;;;IAEE,mBAXS;ED88iBb;EC78iBE;;;IAEE,4BAAA;EDg9iBJ;EC98iBE;;;IAEE,qBAPS;EDw9iBb;EC/8iBE;;;IAEE,mBAXS;ED69iBb;EC59iBE;;;IAEE,4BAAA;ED+9iBJ;EC79iBE;;;IAEE,qBAPS;EDu+iBb;EC99iBE;;;IAEE,mBAXS;ED4+iBb;EC3+iBE;;;IAEE,4BAAA;ED8+iBJ;EC5+iBE;;;IAEE,qBAPS;EDs/iBb;EC7+iBE;;;IAEE,mBAXS;ED2/iBb;ECnvjBE;;;IAEE,6CAAA;EDsvjBJ;ECpvjBE;;;IAEE,uBAAA;EDuvjBJ;ECrvjBE;;;IAEE,QAXS;EDmwjBb;ECtvjBE;;;IAEE,SAAA;EDyvjBJ;ECvwjBE;;;IAEE,6CAAA;ED0wjBJ;ECxwjBE;;;IAEE,uBAAA;ED2wjBJ;ECzwjBE;;;IAEE,QAXS;EDuxjBb;EC1wjBE;;;IAEE,SAAA;ED6wjBJ;EC3xjBE;;;IAEE,6CAAA;ED8xjBJ;EC5xjBE;;;IAEE,uBAAA;ED+xjBJ;EC7xjBE;;;IAEE,QAXS;ED2yjBb;EC9xjBE;;;IAEE,SAAA;EDiyjBJ;EC/yjBE;;;IAEE,6CAAA;EDkzjBJ;EChzjBE;;;IAEE,uBAAA;EDmzjBJ;ECjzjBE;;;IAEE,QAXS;ED+zjBb;EClzjBE;;;IAEE,SAAA;EDqzjBJ;ECn0jBE;;;IAEE,6CAAA;EDs0jBJ;ECp0jBE;;;IAEE,uBAAA;EDu0jBJ;ECr0jBE;;;IAEE,QAXS;EDm1jBb;ECt0jBE;;;IAEE,SAAA;EDy0jBJ;ECv1jBE;;;IAEE,6CAAA;ED01jBJ;ECx1jBE;;;IAEE,uBAAA;ED21jBJ;ECz1jBE;;;IAEE,QAXS;EDu2jBb;EC11jBE;;;IAEE,SAAA;ED61jBJ;EC32jBE;;;IAEE,6CAAA;ED82jBJ;EC52jBE;;;IAEE,uBAAA;ED+2jBJ;EC72jBE;;;IAEE,QAXS;ED23jBb;EC92jBE;;;IAEE,SAAA;EDi3jBJ;EC/3jBE;;;IAEE,6CAAA;EDk4jBJ;ECh4jBE;;;IAEE,uBAAA;EDm4jBJ;ECj4jBE;;;IAEE,QAXS;ED+4jBb;ECl4jBE;;;IAEE,SAAA;EDq4jBJ;ECn5jBE;;;IAEE,6CAAA;EDs5jBJ;ECp5jBE;;;IAEE,uBAAA;EDu5jBJ;ECr5jBE;;;IAEE,QAXS;EDm6jBb;ECt5jBE;;;IAEE,SAAA;EDy5jBJ;ECv6jBE;;;IAEE,8CAAA;ED06jBJ;ECx6jBE;;;IAEE,yBAAA;ED26jBJ;ECz6jBE;;;IAEE,SAXS;EDu7jBb;EC16jBE;;;IAEE,SAAA;ED66jBJ;EC37jBE;;;IAEE,8CAAA;ED87jBJ;EC57jBE;;;IAEE,yBAAA;ED+7jBJ;EC77jBE;;;IAEE,SAXS;ED28jBb;EC97jBE;;;IAEE,SAAA;EDi8jBJ;EC/8jBE;;;IAEE,8CAAA;EDk9jBJ;ECh9jBE;;;IAEE,yBAAA;EDm9jBJ;ECj9jBE;;;IAEE,SAXS;ED+9jBb;ECl9jBE;;;IAEE,SAAA;EDq9jBJ;ECn+jBE;;;IAEE,8CAAA;EDs+jBJ;ECp+jBE;;;IAEE,yBAAA;EDu+jBJ;ECr+jBE;;;IAEE,SAXS;EDm/jBb;ECt+jBE;;;IAEE,SAAA;EDy+jBJ;ECv/jBE;;;IAEE,8CAAA;ED0/jBJ;ECx/jBE;;;IAEE,yBAAA;ED2/jBJ;ECz/jBE;;;IAEE,SAXS;EDugkBb;EC1/jBE;;;IAEE,SAAA;ED6/jBJ;EC3gkBE;;;IAEE,8CAAA;ED8gkBJ;EC5gkBE;;;IAEE,yBAAA;ED+gkBJ;EC7gkBE;;;IAEE,SAXS;ED2hkBb;EC9gkBE;;;IAEE,SAAA;EDihkBJ;EC/hkBE;;;IAEE,8CAAA;EDkikBJ;EChikBE;;;IAEE,yBAAA;EDmikBJ;ECjikBE;;;IAEE,SAXS;ED+ikBb;EClikBE;;;IAEE,SAAA;EDqikBJ;ECnjkBE;;;IAEE,8CAAA;EDsjkBJ;ECpjkBE;;;IAEE,yBAAA;EDujkBJ;ECrjkBE;;;IAEE,SAXS;EDmkkBb;ECtjkBE;;;IAEE,SAAA;EDyjkBJ;ECvkkBE;;;IAEE,8CAAA;ED0kkBJ;ECxkkBE;;;IAEE,yBAAA;ED2kkBJ;ECzkkBE;;;IAEE,SAXS;EDulkBb;EC1kkBE;;;IAEE,SAAA;ED6kkBJ;EC3lkBE;;;IAEE,8CAAA;ED8lkBJ;EC5lkBE;;;IAEE,yBAAA;ED+lkBJ;EC7lkBE;;;IAEE,SAXS;ED2mkBb;EC9lkBE;;;IAEE,SAAA;EDimkBJ;EC/mkBE;;;IAEE,8CAAA;EDknkBJ;EChnkBE;;;IAEE,yBAAA;EDmnkBJ;ECjnkBE;;;IAEE,SAXS;ED+nkBb;EClnkBE;;;IAEE,SAAA;EDqnkBJ;ECnokBE;;;IAEE,8CAAA;EDsokBJ;ECpokBE;;;IAEE,yBAAA;EDuokBJ;ECrokBE;;;IAEE,SAXS;EDmpkBb;ECtokBE;;;IAEE,SAAA;EDyokBJ;ECvpkBE;;;IAEE,8CAAA;ED0pkBJ;ECxpkBE;;;IAEE,yBAAA;ED2pkBJ;ECzpkBE;;;IAEE,SAXS;EDuqkBb;EC1pkBE;;;IAEE,SAAA;ED6pkBJ;EC3qkBE;;;IAEE,8CAAA;ED8qkBJ;EC5qkBE;;;IAEE,yBAAA;ED+qkBJ;EC7qkBE;;;IAEE,SAXS;ED2rkBb;EC9qkBE;;;IAEE,SAAA;EDirkBJ;EC/rkBE;;;IAEE,8CAAA;EDkskBJ;EChskBE;;;IAEE,yBAAA;EDmskBJ;ECjskBE;;;IAEE,SAXS;ED+skBb;EClskBE;;;IAEE,SAAA;EDqskBJ;ECntkBE;;;IAEE,8CAAA;EDstkBJ;ECptkBE;;;IAEE,yBAAA;EDutkBJ;ECrtkBE;;;IAEE,SAXS;EDmukBb;ECttkBE;;;IAEE,SAAA;EDytkBJ;ECvukBE;;;IAEE,8CAAA;ED0ukBJ;ECxukBE;;;IAEE,yBAAA;ED2ukBJ;ECzukBE;;;IAEE,SAXS;EDuvkBb;EC1ukBE;;;IAEE,SAAA;ED6ukBJ;EC3vkBE;;;IAEE,8CAAA;ED8vkBJ;EC5vkBE;;;IAEE,yBAAA;ED+vkBJ;EC7vkBE;;;IAEE,SAXS;ED2wkBb;EC9vkBE;;;IAEE,SAAA;EDiwkBJ;EC/wkBE;;;IAEE,8CAAA;EDkxkBJ;EChxkBE;;;IAEE,yBAAA;EDmxkBJ;ECjxkBE;;;IAEE,SAXS;ED+xkBb;EClxkBE;;;IAEE,SAAA;EDqxkBJ;ECnykBE;;;IAEE,8CAAA;EDsykBJ;ECpykBE;;;IAEE,yBAAA;EDuykBJ;ECrykBE;;;IAEE,SAXS;EDmzkBb;ECtykBE;;;IAEE,SAAA;EDyykBJ;ECvzkBE;;;IAEE,8CAAA;ED0zkBJ;ECxzkBE;;;IAEE,yBAAA;ED2zkBJ;ECzzkBE;;;IAEE,SAXS;EDu0kBb;EC1zkBE;;;IAEE,SAAA;ED6zkBJ;EC30kBE;;;IAEE,8CAAA;ED80kBJ;EC50kBE;;;IAEE,yBAAA;ED+0kBJ;EC70kBE;;;IAEE,SAXS;ED21kBb;EC90kBE;;;IAEE,SAAA;EDi1kBJ;EC/1kBE;;;IAEE,8CAAA;EDk2kBJ;ECh2kBE;;;IAEE,yBAAA;EDm2kBJ;ECj2kBE;;;IAEE,SAXS;ED+2kBb;ECl2kBE;;;IAEE,SAAA;EDq2kBJ;ECn3kBE;;;IAEE,8CAAA;EDs3kBJ;ECp3kBE;;;IAEE,yBAAA;EDu3kBJ;ECr3kBE;;;IAEE,SAXS;EDm4kBb;ECt3kBE;;;IAEE,SAAA;EDy3kBJ;ECv4kBE;;;IAEE,8CAAA;ED04kBJ;ECx4kBE;;;IAEE,yBAAA;ED24kBJ;ECz4kBE;;;IAEE,SAXS;EDu5kBb;EC14kBE;;;IAEE,SAAA;ED64kBJ;EC35kBE;;;IAEE,8CAAA;ED85kBJ;EC55kBE;;;IAEE,yBAAA;ED+5kBJ;EC75kBE;;;IAEE,SAXS;ED26kBb;EC95kBE;;;IAEE,SAAA;EDi6kBJ;EC/6kBE;;;IAEE,8CAAA;EDk7kBJ;ECh7kBE;;;IAEE,yBAAA;EDm7kBJ;ECj7kBE;;;IAEE,SAXS;ED+7kBb;ECl7kBE;;;IAEE,SAAA;EDq7kBJ;ECn8kBE;;;IAEE,8CAAA;EDs8kBJ;ECp8kBE;;;IAEE,yBAAA;EDu8kBJ;ECr8kBE;;;IAEE,SAXS;EDm9kBb;ECt8kBE;;;IAEE,SAAA;EDy8kBJ;ECv9kBE;;;IAEE,8CAAA;ED09kBJ;ECx9kBE;;;IAEE,yBAAA;ED29kBJ;ECz9kBE;;;IAEE,SAXS;EDu+kBb;EC19kBE;;;IAEE,SAAA;ED69kBJ;EC3+kBE;;;IAEE,8CAAA;ED8+kBJ;EC5+kBE;;;IAEE,yBAAA;ED++kBJ;EC7+kBE;;;IAEE,SAXS;ED2/kBb;EC9+kBE;;;IAEE,SAAA;EDi/kBJ;EC//kBE;;;IAEE,8CAAA;EDkglBJ;EChglBE;;;IAEE,yBAAA;EDmglBJ;ECjglBE;;;IAEE,SAXS;ED+glBb;EClglBE;;;IAEE,SAAA;EDqglBJ;ECnhlBE;;;IAEE,8CAAA;EDshlBJ;ECphlBE;;;IAEE,yBAAA;EDuhlBJ;ECrhlBE;;;IAEE,SAXS;EDmilBb;ECthlBE;;;IAEE,SAAA;EDyhlBJ;ECvilBE;;;IAEE,8CAAA;ED0ilBJ;ECxilBE;;;IAEE,yBAAA;ED2ilBJ;ECzilBE;;;IAEE,SAXS;EDujlBb;EC1ilBE;;;IAEE,SAAA;ED6ilBJ;EC3jlBE;;;IAEE,8CAAA;ED8jlBJ;EC5jlBE;;;IAEE,yBAAA;ED+jlBJ;EC7jlBE;;;IAEE,SAXS;ED2klBb;EC9jlBE;;;IAEE,SAAA;EDiklBJ;EC/klBE;;;IAEE,8CAAA;EDkllBJ;EChllBE;;;IAEE,yBAAA;EDmllBJ;ECjllBE;;;IAEE,SAXS;ED+llBb;EClllBE;;;IAEE,SAAA;EDqllBJ;ECnmlBE;;;IAEE,8CAAA;EDsmlBJ;ECpmlBE;;;IAEE,yBAAA;EDumlBJ;ECrmlBE;;;IAEE,SAXS;EDmnlBb;ECtmlBE;;;IAEE,SAAA;EDymlBJ;ECvnlBE;;;IAEE,8CAAA;ED0nlBJ;ECxnlBE;;;IAEE,yBAAA;ED2nlBJ;ECznlBE;;;IAEE,SAXS;EDuolBb;EC1nlBE;;;IAEE,SAAA;ED6nlBJ;EC3olBE;;;IAEE,8CAAA;ED8olBJ;EC5olBE;;;IAEE,yBAAA;ED+olBJ;EC7olBE;;;IAEE,SAXS;ED2plBb;EC9olBE;;;IAEE,SAAA;EDiplBJ;EC/plBE;;;IAEE,8CAAA;EDkqlBJ;EChqlBE;;;IAEE,yBAAA;EDmqlBJ;ECjqlBE;;;IAEE,SAXS;ED+qlBb;EClqlBE;;;IAEE,SAAA;EDqqlBJ;ECnrlBE;;;IAEE,8CAAA;EDsrlBJ;ECprlBE;;;IAEE,yBAAA;EDurlBJ;ECrrlBE;;;IAEE,SAXS;EDmslBb;ECtrlBE;;;IAEE,SAAA;EDyrlBJ;ECvslBE;;;IAEE,8CAAA;ED0slBJ;ECxslBE;;;IAEE,yBAAA;ED2slBJ;ECzslBE;;;IAEE,SAXS;EDutlBb;EC1slBE;;;IAEE,SAAA;ED6slBJ;ECvslBA;;IACE,cAAA;ED0slBF;AACF;AC1/kBE;EAmBE;;;IAEE,0BAAA;ED2+kBJ;ECz+kBE;;;IAEE,oBAPS;EDm/kBb;EC1+kBE;;;IAEE,kBAXS;EDw/kBb;ECv/kBE;;;IAEE,0BAAA;ED0/kBJ;ECx/kBE;;;IAEE,oBAPS;EDkglBb;ECz/kBE;;;IAEE,kBAXS;EDuglBb;ECtglBE;;;IAEE,0BAAA;EDyglBJ;ECvglBE;;;IAEE,oBAPS;EDihlBb;ECxglBE;;;IAEE,kBAXS;EDshlBb;ECrhlBE;;;IAEE,0BAAA;EDwhlBJ;ECthlBE;;;IAEE,oBAPS;EDgilBb;ECvhlBE;;;IAEE,kBAXS;EDqilBb;ECpilBE;;;IAEE,0BAAA;EDuilBJ;ECrilBE;;;IAEE,oBAPS;ED+ilBb;ECtilBE;;;IAEE,kBAXS;EDojlBb;ECnjlBE;;;IAEE,0BAAA;EDsjlBJ;ECpjlBE;;;IAEE,oBAPS;ED8jlBb;ECrjlBE;;;IAEE,kBAXS;EDmklBb;EClklBE;;;IAEE,0BAAA;EDqklBJ;ECnklBE;;;IAEE,oBAPS;ED6klBb;ECpklBE;;;IAEE,kBAXS;EDkllBb;ECjllBE;;;IAEE,0BAAA;EDollBJ;EClllBE;;;IAEE,oBAPS;ED4llBb;ECnllBE;;;IAEE,kBAXS;EDimlBb;EChmlBE;;;IAEE,0BAAA;EDmmlBJ;ECjmlBE;;;IAEE,oBAPS;ED2mlBb;EClmlBE;;;IAEE,kBAXS;EDgnlBb;EC/mlBE;;;IAEE,4BAAA;EDknlBJ;EChnlBE;;;IAEE,qBAPS;ED0nlBb;ECjnlBE;;;IAEE,mBAXS;ED+nlBb;EC9nlBE;;;IAEE,4BAAA;EDiolBJ;EC/nlBE;;;IAEE,qBAPS;EDyolBb;ECholBE;;;IAEE,mBAXS;ED8olBb;EC7olBE;;;IAEE,4BAAA;EDgplBJ;EC9olBE;;;IAEE,qBAPS;EDwplBb;EC/olBE;;;IAEE,mBAXS;ED6plBb;EC5plBE;;;IAEE,4BAAA;ED+plBJ;EC7plBE;;;IAEE,qBAPS;EDuqlBb;EC9plBE;;;IAEE,mBAXS;ED4qlBb;EC3qlBE;;;IAEE,4BAAA;ED8qlBJ;EC5qlBE;;;IAEE,qBAPS;EDsrlBb;EC7qlBE;;;IAEE,mBAXS;ED2rlBb;EC1rlBE;;;IAEE,4BAAA;ED6rlBJ;EC3rlBE;;;IAEE,qBAPS;EDqslBb;EC5rlBE;;;IAEE,mBAXS;ED0slBb;ECzslBE;;;IAEE,4BAAA;ED4slBJ;EC1slBE;;;IAEE,qBAPS;EDotlBb;EC3slBE;;;IAEE,mBAXS;EDytlBb;ECxtlBE;;;IAEE,4BAAA;ED2tlBJ;ECztlBE;;;IAEE,qBAPS;EDmulBb;EC1tlBE;;;IAEE,mBAXS;EDwulBb;ECvulBE;;;IAEE,4BAAA;ED0ulBJ;ECxulBE;;;IAEE,qBAPS;EDkvlBb;ECzulBE;;;IAEE,mBAXS;EDuvlBb;ECtvlBE;;;IAEE,4BAAA;EDyvlBJ;ECvvlBE;;;IAEE,qBAPS;EDiwlBb;ECxvlBE;;;IAEE,mBAXS;EDswlBb;ECrwlBE;;;IAEE,4BAAA;EDwwlBJ;ECtwlBE;;;IAEE,qBAPS;EDgxlBb;ECvwlBE;;;IAEE,mBAXS;EDqxlBb;ECpxlBE;;;IAEE,4BAAA;EDuxlBJ;ECrxlBE;;;IAEE,qBAPS;ED+xlBb;ECtxlBE;;;IAEE,mBAXS;EDoylBb;ECnylBE;;;IAEE,4BAAA;EDsylBJ;ECpylBE;;;IAEE,qBAPS;ED8ylBb;ECrylBE;;;IAEE,mBAXS;EDmzlBb;EClzlBE;;;IAEE,4BAAA;EDqzlBJ;ECnzlBE;;;IAEE,qBAPS;ED6zlBb;ECpzlBE;;;IAEE,mBAXS;EDk0lBb;ECj0lBE;;;IAEE,4BAAA;EDo0lBJ;ECl0lBE;;;IAEE,qBAPS;ED40lBb;ECn0lBE;;;IAEE,mBAXS;EDi1lBb;ECzkmBE;;;IAEE,6CAAA;ED4kmBJ;EC1kmBE;;;IAEE,uBAAA;ED6kmBJ;EC3kmBE;;;IAEE,QAXS;EDylmBb;EC5kmBE;;;IAEE,SAAA;ED+kmBJ;EC7lmBE;;;IAEE,6CAAA;EDgmmBJ;EC9lmBE;;;IAEE,uBAAA;EDimmBJ;EC/lmBE;;;IAEE,QAXS;ED6mmBb;EChmmBE;;;IAEE,SAAA;EDmmmBJ;ECjnmBE;;;IAEE,6CAAA;EDonmBJ;EClnmBE;;;IAEE,uBAAA;EDqnmBJ;ECnnmBE;;;IAEE,QAXS;EDiomBb;ECpnmBE;;;IAEE,SAAA;EDunmBJ;ECromBE;;;IAEE,6CAAA;EDwomBJ;ECtomBE;;;IAEE,uBAAA;EDyomBJ;ECvomBE;;;IAEE,QAXS;EDqpmBb;ECxomBE;;;IAEE,SAAA;ED2omBJ;ECzpmBE;;;IAEE,6CAAA;ED4pmBJ;EC1pmBE;;;IAEE,uBAAA;ED6pmBJ;EC3pmBE;;;IAEE,QAXS;EDyqmBb;EC5pmBE;;;IAEE,SAAA;ED+pmBJ;EC7qmBE;;;IAEE,6CAAA;EDgrmBJ;EC9qmBE;;;IAEE,uBAAA;EDirmBJ;EC/qmBE;;;IAEE,QAXS;ED6rmBb;EChrmBE;;;IAEE,SAAA;EDmrmBJ;ECjsmBE;;;IAEE,6CAAA;EDosmBJ;EClsmBE;;;IAEE,uBAAA;EDqsmBJ;ECnsmBE;;;IAEE,QAXS;EDitmBb;ECpsmBE;;;IAEE,SAAA;EDusmBJ;ECrtmBE;;;IAEE,6CAAA;EDwtmBJ;ECttmBE;;;IAEE,uBAAA;EDytmBJ;ECvtmBE;;;IAEE,QAXS;EDqumBb;ECxtmBE;;;IAEE,SAAA;ED2tmBJ;ECzumBE;;;IAEE,6CAAA;ED4umBJ;EC1umBE;;;IAEE,uBAAA;ED6umBJ;EC3umBE;;;IAEE,QAXS;EDyvmBb;EC5umBE;;;IAEE,SAAA;ED+umBJ;EC7vmBE;;;IAEE,8CAAA;EDgwmBJ;EC9vmBE;;;IAEE,yBAAA;EDiwmBJ;EC/vmBE;;;IAEE,SAXS;ED6wmBb;EChwmBE;;;IAEE,SAAA;EDmwmBJ;ECjxmBE;;;IAEE,8CAAA;EDoxmBJ;EClxmBE;;;IAEE,yBAAA;EDqxmBJ;ECnxmBE;;;IAEE,SAXS;EDiymBb;ECpxmBE;;;IAEE,SAAA;EDuxmBJ;ECrymBE;;;IAEE,8CAAA;EDwymBJ;ECtymBE;;;IAEE,yBAAA;EDyymBJ;ECvymBE;;;IAEE,SAXS;EDqzmBb;ECxymBE;;;IAEE,SAAA;ED2ymBJ;ECzzmBE;;;IAEE,8CAAA;ED4zmBJ;EC1zmBE;;;IAEE,yBAAA;ED6zmBJ;EC3zmBE;;;IAEE,SAXS;EDy0mBb;EC5zmBE;;;IAEE,SAAA;ED+zmBJ;EC70mBE;;;IAEE,8CAAA;EDg1mBJ;EC90mBE;;;IAEE,yBAAA;EDi1mBJ;EC/0mBE;;;IAEE,SAXS;ED61mBb;ECh1mBE;;;IAEE,SAAA;EDm1mBJ;ECj2mBE;;;IAEE,8CAAA;EDo2mBJ;ECl2mBE;;;IAEE,yBAAA;EDq2mBJ;ECn2mBE;;;IAEE,SAXS;EDi3mBb;ECp2mBE;;;IAEE,SAAA;EDu2mBJ;ECr3mBE;;;IAEE,8CAAA;EDw3mBJ;ECt3mBE;;;IAEE,yBAAA;EDy3mBJ;ECv3mBE;;;IAEE,SAXS;EDq4mBb;ECx3mBE;;;IAEE,SAAA;ED23mBJ;ECz4mBE;;;IAEE,8CAAA;ED44mBJ;EC14mBE;;;IAEE,yBAAA;ED64mBJ;EC34mBE;;;IAEE,SAXS;EDy5mBb;EC54mBE;;;IAEE,SAAA;ED+4mBJ;EC75mBE;;;IAEE,8CAAA;EDg6mBJ;EC95mBE;;;IAEE,yBAAA;EDi6mBJ;EC/5mBE;;;IAEE,SAXS;ED66mBb;ECh6mBE;;;IAEE,SAAA;EDm6mBJ;ECj7mBE;;;IAEE,8CAAA;EDo7mBJ;ECl7mBE;;;IAEE,yBAAA;EDq7mBJ;ECn7mBE;;;IAEE,SAXS;EDi8mBb;ECp7mBE;;;IAEE,SAAA;EDu7mBJ;ECr8mBE;;;IAEE,8CAAA;EDw8mBJ;ECt8mBE;;;IAEE,yBAAA;EDy8mBJ;ECv8mBE;;;IAEE,SAXS;EDq9mBb;ECx8mBE;;;IAEE,SAAA;ED28mBJ;ECz9mBE;;;IAEE,8CAAA;ED49mBJ;EC19mBE;;;IAEE,yBAAA;ED69mBJ;EC39mBE;;;IAEE,SAXS;EDy+mBb;EC59mBE;;;IAEE,SAAA;ED+9mBJ;EC7+mBE;;;IAEE,8CAAA;EDg/mBJ;EC9+mBE;;;IAEE,yBAAA;EDi/mBJ;EC/+mBE;;;IAEE,SAXS;ED6/mBb;ECh/mBE;;;IAEE,SAAA;EDm/mBJ;ECjgnBE;;;IAEE,8CAAA;EDognBJ;EClgnBE;;;IAEE,yBAAA;EDqgnBJ;ECngnBE;;;IAEE,SAXS;EDihnBb;ECpgnBE;;;IAEE,SAAA;EDugnBJ;ECrhnBE;;;IAEE,8CAAA;EDwhnBJ;ECthnBE;;;IAEE,yBAAA;EDyhnBJ;ECvhnBE;;;IAEE,SAXS;EDqinBb;ECxhnBE;;;IAEE,SAAA;ED2hnBJ;ECzinBE;;;IAEE,8CAAA;ED4inBJ;EC1inBE;;;IAEE,yBAAA;ED6inBJ;EC3inBE;;;IAEE,SAXS;EDyjnBb;EC5inBE;;;IAEE,SAAA;ED+inBJ;EC7jnBE;;;IAEE,8CAAA;EDgknBJ;EC9jnBE;;;IAEE,yBAAA;EDiknBJ;EC/jnBE;;;IAEE,SAXS;ED6knBb;EChknBE;;;IAEE,SAAA;EDmknBJ;ECjlnBE;;;IAEE,8CAAA;EDolnBJ;ECllnBE;;;IAEE,yBAAA;EDqlnBJ;ECnlnBE;;;IAEE,SAXS;EDimnBb;ECplnBE;;;IAEE,SAAA;EDulnBJ;ECrmnBE;;;IAEE,8CAAA;EDwmnBJ;ECtmnBE;;;IAEE,yBAAA;EDymnBJ;ECvmnBE;;;IAEE,SAXS;EDqnnBb;ECxmnBE;;;IAEE,SAAA;ED2mnBJ;ECznnBE;;;IAEE,8CAAA;ED4nnBJ;EC1nnBE;;;IAEE,yBAAA;ED6nnBJ;EC3nnBE;;;IAEE,SAXS;EDyonBb;EC5nnBE;;;IAEE,SAAA;ED+nnBJ;EC7onBE;;;IAEE,8CAAA;EDgpnBJ;EC9onBE;;;IAEE,yBAAA;EDipnBJ;EC/onBE;;;IAEE,SAXS;ED6pnBb;EChpnBE;;;IAEE,SAAA;EDmpnBJ;ECjqnBE;;;IAEE,8CAAA;EDoqnBJ;EClqnBE;;;IAEE,yBAAA;EDqqnBJ;ECnqnBE;;;IAEE,SAXS;EDirnBb;ECpqnBE;;;IAEE,SAAA;EDuqnBJ;ECrrnBE;;;IAEE,8CAAA;EDwrnBJ;ECtrnBE;;;IAEE,yBAAA;EDyrnBJ;ECvrnBE;;;IAEE,SAXS;EDqsnBb;ECxrnBE;;;IAEE,SAAA;ED2rnBJ;ECzsnBE;;;IAEE,8CAAA;ED4snBJ;EC1snBE;;;IAEE,yBAAA;ED6snBJ;EC3snBE;;;IAEE,SAXS;EDytnBb;EC5snBE;;;IAEE,SAAA;ED+snBJ;EC7tnBE;;;IAEE,8CAAA;EDgunBJ;EC9tnBE;;;IAEE,yBAAA;EDiunBJ;EC/tnBE;;;IAEE,SAXS;ED6unBb;EChunBE;;;IAEE,SAAA;EDmunBJ;ECjvnBE;;;IAEE,8CAAA;EDovnBJ;EClvnBE;;;IAEE,yBAAA;EDqvnBJ;ECnvnBE;;;IAEE,SAXS;EDiwnBb;ECpvnBE;;;IAEE,SAAA;EDuvnBJ;ECrwnBE;;;IAEE,8CAAA;EDwwnBJ;ECtwnBE;;;IAEE,yBAAA;EDywnBJ;ECvwnBE;;;IAEE,SAXS;EDqxnBb;ECxwnBE;;;IAEE,SAAA;ED2wnBJ;ECzxnBE;;;IAEE,8CAAA;ED4xnBJ;EC1xnBE;;;IAEE,yBAAA;ED6xnBJ;EC3xnBE;;;IAEE,SAXS;EDyynBb;EC5xnBE;;;IAEE,SAAA;ED+xnBJ;EC7ynBE;;;IAEE,8CAAA;EDgznBJ;EC9ynBE;;;IAEE,yBAAA;EDiznBJ;EC/ynBE;;;IAEE,SAXS;ED6znBb;EChznBE;;;IAEE,SAAA;EDmznBJ;ECj0nBE;;;IAEE,8CAAA;EDo0nBJ;ECl0nBE;;;IAEE,yBAAA;EDq0nBJ;ECn0nBE;;;IAEE,SAXS;EDi1nBb;ECp0nBE;;;IAEE,SAAA;EDu0nBJ;ECr1nBE;;;IAEE,8CAAA;EDw1nBJ;ECt1nBE;;;IAEE,yBAAA;EDy1nBJ;ECv1nBE;;;IAEE,SAXS;EDq2nBb;ECx1nBE;;;IAEE,SAAA;ED21nBJ;ECz2nBE;;;IAEE,8CAAA;ED42nBJ;EC12nBE;;;IAEE,yBAAA;ED62nBJ;EC32nBE;;;IAEE,SAXS;EDy3nBb;EC52nBE;;;IAEE,SAAA;ED+2nBJ;EC73nBE;;;IAEE,8CAAA;EDg4nBJ;EC93nBE;;;IAEE,yBAAA;EDi4nBJ;EC/3nBE;;;IAEE,SAXS;ED64nBb;ECh4nBE;;;IAEE,SAAA;EDm4nBJ;ECj5nBE;;;IAEE,8CAAA;EDo5nBJ;ECl5nBE;;;IAEE,yBAAA;EDq5nBJ;ECn5nBE;;;IAEE,SAXS;EDi6nBb;ECp5nBE;;;IAEE,SAAA;EDu5nBJ;ECr6nBE;;;IAEE,8CAAA;EDw6nBJ;ECt6nBE;;;IAEE,yBAAA;EDy6nBJ;ECv6nBE;;;IAEE,SAXS;EDq7nBb;ECx6nBE;;;IAEE,SAAA;ED26nBJ;ECz7nBE;;;IAEE,8CAAA;ED47nBJ;EC17nBE;;;IAEE,yBAAA;ED67nBJ;EC37nBE;;;IAEE,SAXS;EDy8nBb;EC57nBE;;;IAEE,SAAA;ED+7nBJ;EC78nBE;;;IAEE,8CAAA;EDg9nBJ;EC98nBE;;;IAEE,yBAAA;EDi9nBJ;EC/8nBE;;;IAEE,SAXS;ED69nBb;ECh9nBE;;;IAEE,SAAA;EDm9nBJ;ECj+nBE;;;IAEE,8CAAA;EDo+nBJ;ECl+nBE;;;IAEE,yBAAA;EDq+nBJ;ECn+nBE;;;IAEE,SAXS;EDi/nBb;ECp+nBE;;;IAEE,SAAA;EDu+nBJ;ECr/nBE;;;IAEE,8CAAA;EDw/nBJ;ECt/nBE;;;IAEE,yBAAA;EDy/nBJ;ECv/nBE;;;IAEE,SAXS;EDqgoBb;ECx/nBE;;;IAEE,SAAA;ED2/nBJ;ECzgoBE;;;IAEE,8CAAA;ED4goBJ;EC1goBE;;;IAEE,yBAAA;ED6goBJ;EC3goBE;;;IAEE,SAXS;EDyhoBb;EC5goBE;;;IAEE,SAAA;ED+goBJ;EC7hoBE;;;IAEE,8CAAA;EDgioBJ;EC9hoBE;;;IAEE,yBAAA;EDiioBJ;EC/hoBE;;;IAEE,SAXS;ED6ioBb;EChioBE;;;IAEE,SAAA;EDmioBJ;EC7hoBA;;IACE,cAAA;EDgioBF;AACF;;AAzioBA,cAAA;AACA;;EAEE,uDAAA;EACA,WAAA;AA4ioBF;;AAzioBA;;EAEE,uDAAA;EACA,cDVY;ACsjoBd;;AAzioBA;;EAEE,uDAAA;EACA,cDfY;AC2joBd;;AAzioBA;;EAEE,uDAAA;EACA,cDpBY;ACgkoBd;;AAzioBA;;EAEE,uDAAA;EACA,cDzBY;ACqkoBd;;AAtioBA,iBAAA;AACA;;EAEE,YD9Be;ACukoBjB;;AAtioBA;;EAEE,YDlCe;AC2koBjB;;AAtioBA;;EAEE,YDtCe;AC+koBjB;;AAtioBA;;EAEE,YD1Ce;ACmloBjB;;AAtioBA;;EAEE,YD9Ce;ACuloBjB;;AAtioBA;;EAEE,YAAA;AAyioBF;;AAtioBA,kBAAA;AACA;;EAEE,kBD7De;ACsmoBjB;;AAtioBA;;EAEE,kBDjEe;AC0moBjB;;AAtioBA;;EAEE,kBDrEe;AC8moBjB;;AAtioBA;;EAEE,kBDzEe;ACknoBjB;;AAtioBA;;EAEE,kBD7Ee;ACsnoBjB;;AAtioBA,mBAAA;AACA;;EAEE,gBE7Gc;AFspoBhB;;AAtioBA;;EAEE,gBEnHc;AF4poBhB;;AAtioBA;;EAEE,gBEzHc;AFkqoBhB;;AAtioBA;;EAEE,gBE/Hc;AFwqoBhB;;AAtioBA;;EAEE,iBErIc;AF8qoBhB;;AAtioBA;;EAEE,iBE3Ie;AForoBjB;;AAtioBA;EACE,2BAAA;AAyioBF;;AAtioBA,iBAAA;AACA;;;EAGE,YDxIa;ACiroBf;;AAtioBA;;;EAGE,aDtHgB;AC+poBlB;;AAtioBA;;;EAGE,aD3HgB;ACoqoBlB;;AAtioBA;;;EAGE,aDhIgB;ACyqoBlB;;AAtioBA;;;EAGE,aDrIgB;AC8qoBlB;;AAtioBA,mBAAA;AACA;;EAEE,mBDtKa;AC+soBf;;AAtioBA;;EAEE,oBDnJgB;AC4roBlB;;AAtioBA;;EAEE,oBDvJgB;ACgsoBlB;;AAtioBA;;EAEE,oBD3JgB;ACosoBlB;;AAtioBA;;EAEE,oBD/JgB;ACwsoBlB;;AAtioBA,mBAAA;AACA;;EAEE,kBDhMa;ACyuoBf;;AAtioBA;;EAEE,kBD/KiB;ACwtoBnB;;AAtioBA;;EAEE,mBDlLgB;AC2toBlB;;AAtioBA;;EAEE,mBDtLgB;AC+toBlB;;AAtioBA;;EAEE,mBD1LgB;ACmuoBlB;;AAtioBA;;EAEE,mBD9LgB;ACuuoBlB;;AAtioBA,wBAAA;AACA;;EAEE,sBDzMiB;ACkvoBnB;;AAtioBA;;EAEE,sBDpOa;AC6woBf;;AAtioBA;;EAEE,uBDjNgB;AC0voBlB;;AAtioBA;;EAEE,uBDrNgB;AC8voBlB;;AAtioBA;;EAEE,uBDzNgB;ACkwoBlB;;AAtioBA;;EAEE,uBD7NgB;ACswoBlB;;AAnioBA,yBAAA;AACA;;EAEE,WAAA;EACA,2FAAA;AAsioBF;;AAnioBA;;EAEE,WAAA;EACA,4FAAA;AAsioBF;;AAnioBA,oEAAA;AACA;;EAEE,uBAAA;AAsioBF;;AAnioBA;;EAEE,8BAAA;AAsioBF;;AAnioBA;;EAEE,8BAAA;AAsioBF;;AAnioBA;;EAEE,iCAAA;AAsioBF;;AAnioBA,cAAA;AACA;;EAEE,mBAAA;AAsioBF;;AAnioBA;;EAEE,sBAAA;AAsioBF;;AAnioBA;;EAEE,qBAAA;AAsioBF;;AAnioBA;;EAEE,yBAAA;AAsioBF;;AAnioBA;;EAEE,4BAAA;AAsioBF;;AAnioBA,8DAAA;AACA;;EAEE,oBAAA;AAsioBF;;AAnioBA;;EAEE,2BAAA;AAsioBF;;AAnioBA;;EAEE,2BAAA;AAsioBF;;AAnioBA;;EAEE,8BAAA;AAsioBF;;AAnioBA;;EAEE,2CAAA;AAsioBF;;AAnioBA,yBAAA;AACA;;EAEE,6CAAA;AAsioBF;;AAnioBA,iBAAA;AAIE;;EAEE,kBALe;AAwioBnB;;AArioBE;;EAEE,gBALe;AA6ioBnB;;AA1ioBE;;EAEE,mBALe;AAkjoBnB;;AA/ioBE;;EAEE,oBALe;AAujoBnB;;AA9ioBA,sCAAA;AAIE;;EAEE,sBALiB;AAmjoBrB;;AA3ioBE;;EAEE,oBAViB;AAwjoBrB;;AA3ioBE;;EAEE,aAAA;EACA,sBAhBiB;AA8joBrB;;AA3ioBE;;EAEE,aAAA;EACA,oBAtBiB;AAokoBrB;;AAjkoBE;;EAEE,uBALiB;AAykoBrB;;AAjkoBE;;EAEE,qBAViB;AA8koBrB;;AAjkoBE;;EAEE,aAAA;EACA,uBAhBiB;AAoloBrB;;AAjkoBE;;EAEE,aAAA;EACA,qBAtBiB;AA0loBrB;;AAvloBE;;EAEE,8BALiB;AA+loBrB;;AAvloBE;;EAEE,4BAViB;AAomoBrB;;AAvloBE;;EAEE,aAAA;EACA,8BAhBiB;AA0moBrB;;AAvloBE;;EAEE,aAAA;EACA,4BAtBiB;AAgnoBrB;;AA7moBE;;EAEE,6BALiB;AAqnoBrB;;AA7moBE;;EAEE,2BAViB;AA0noBrB;;AA7moBE;;EAEE,aAAA;EACA,6BAhBiB;AAgooBrB;;AA7moBE;;EAEE,aAAA;EACA,2BAtBiB;AAsooBrB;;AAnooBE;;EAEE,6BALiB;AA2ooBrB;;AAnooBE;;EAEE,2BAViB;AAgpoBrB;;AAnooBE;;EAEE,aAAA;EACA,6BAhBiB;AAspoBrB;;AAnooBE;;EAEE,aAAA;EACA,2BAtBiB;AA4poBrB;;AAzpoBE;;EAEE,oBALiB;AAiqoBrB;;AAzpoBE;;EAEE,kBAViB;AAsqoBrB;;AAzpoBE;;EAEE,aAAA;EACA,oBAhBiB;AA4qoBrB;;AAzpoBE;;EAEE,aAAA;EACA,kBAtBiB;AAkroBrB;;AAxpoBA,qCAAA;AACA;;EAEE,iBAAA;AA2poBF;;AAxpoBA;;EAEE,cAAA;AA2poBF;;AAxpoBA;;EAEE,gBAAA;EACA,2BAAA;AA2poBF;;AArpoBA,6BAAA;AACA;EACE,aAAA;AAwpoBF;;AArpoBA;EACE,aAAA;AAwpoBF;;AArpoBA;EACE,aAAA;AAwpoBF;;AArpoBA;EACE,aAAA;AAwpoBF;;AArpoBA;EACE,aAAA;AAwpoBF;;AArpoBA;EACE,aAAA;AAwpoBF;;AArpoBA;EACE,aAAA;AAwpoBF;;AAlpoBA;;;EAGE,UAAA;AAqpoBF;;AAlpoBA;;;EAGE,YD5ba;ACilpBf;;AAlpoBA;;;EAGE,aD1agB;AC+jpBlB;;AAlpoBA;;;EAGE,aD/agB;ACokpBlB;;AAlpoBA;;;EAGE,aDpbgB;ACykpBlB;;AAlpoBA;;;EAGE,aDzbgB;AC8kpBlB;;AAlpoBA;;;EAGE,aAAA;AAqpoBF;;AAlpoBA;;;EAGE,eDhea;ACqnpBf;;AAlpoBA;;;EAGE,gBD9cgB;ACmmpBlB;;AAlpoBA;;;EAGE,gBDndgB;ACwmpBlB;;AAlpoBA;;;EAGE,gBDxdgB;AC6mpBlB;;AAlpoBA;;;EAGE,gBD7dgB;ACknpBlB;;AA/ooBA,aAAA;AACA;;EAEE,kBAAA;EACA,MAAA;EACA,QAAA;AAkpoBF;;AA/ooBA,SAAA;AACA;;EAEE,wCAAA;EACA,6BAAA;AAkpoBF;;AA/ooBA,WAAA;AACA;;EAEE,YAAA;AAkpoBF;;AA/ooBA,sEAAA;AACA;EACE,gBAAA;EACA,iBAAA;AAkpoBF","sourcesContent":["/* Host Variables */\n:host {\n  --grid-auto-row-height: 0;\n  --grid-fill-color: var(--ids-layout-grid-color-background);\n  --grid-text-color: var(--ids-layout-grid-color-text);\n  --min-col-width: 0;\n  --max-col-width: 1fr;\n  --min-row-height: 0;\n  --max-row-height: 1fr;\n  --min-row-width: 1fr;\n  --sticky-position: 0;\n}\n\n/* Grid Variables */\n$prefix: 'ids-layout-grid';\n$spacing-unit: 8px;\n$grid-cols: 24;\n$grid-rows: 50;\n\n// Gutters by breakpoint\n$grid-gap-xs: $spacing-unit;     // XS gutters: 8px\n$grid-gap-sm: $spacing-unit * 2; // S gutters: 16px\n$grid-gap-md: $spacing-unit * 2; // M gutters: 16px\n$grid-gap-lg: $spacing-unit * 2; // L gutters: 16px\n$grid-gap-xl: $spacing-unit * 2; // XL gutters: 16px\n$grid-gap-xxl: $spacing-unit * 2; // XXL gutters: 16px\n\n// Margins by breakpoint\n$grid-margin-xs: $spacing-unit * 2; // XS margins: 16px\n$grid-margin-sm: $spacing-unit * 2; // S margins: 16px\n$grid-margin-md: $spacing-unit * 2; // M margins: 16px\n$grid-margin-lg: $spacing-unit * 3; // L margins: 24px\n$grid-margin-xl: $spacing-unit * 3; // XL margins: 24px\n$grid-margin-xxl: $spacing-unit * 3; // XXL margins: 24px\n\n// Default gap (fallback)\n$grid-gap: $grid-gap-sm;\n$grid-padding-xxs: calc($spacing-unit / 2);\n$grid-padding-xs: $spacing-unit;\n$grid-padding-sm: $spacing-unit * 2;\n$grid-padding-md: $spacing-unit * 3;\n$grid-padding-lg: $spacing-unit * 4;\n$grid-padding-xl: $spacing-unit * 5;\n$min-col-width: var(--min-col-width);\n$max-col-width: var(--max-col-width);\n$min-row-height: var(--min-row-height);\n$max-row-height: var(--max-row-height);\n$max-width: var(--max-width);\n\n/* Host and ids-layout-grid Base */\n:host,\n.#{$prefix} {\n  display: grid;\n  /* stylelint-disable-next-line property-no-deprecated */\n  grid-gap: $grid-gap-sm; // Default to SM gutter (16px)\n  justify-content: start;\n  box-sizing: border-box;\n}\n\n:host([hidden]) {\n  display: none;\n}\n\n/* Grid Columms - Base */\n@for $i from 1 through $grid-cols {\n  :host([cols='#{$i}']),\n  .#{$prefix}-cols-#{$i} {\n    width: 100%;\n    grid-template-columns: repeat($i, minmax($min-col-width, $max-col-width));\n  }\n\n  :host(.#{$prefix}) > ::slotted([col-span='#{$i}']),\n  .#{$prefix} > .#{$prefix}-col-span-#{$i} {\n    grid-column: span $i / span $i;\n  }\n\n  :host(.#{$prefix}) > ::slotted([col-start='#{$i}']),\n  .#{$prefix} > .#{$prefix}-col-start-#{$i} {\n    grid-column-start: $i;\n  }\n\n  :host(.#{$prefix}) > ::slotted([col-end='#{$i}']),\n  .#{$prefix} > .#{$prefix}-col-end-#{$i} {\n    grid-column-end: $i;\n  }\n}\n\n/* Grid Rows - Base */\n@for $i from 1 through $grid-rows {\n  :host([rows='#{$i}']),\n  .#{$prefix}-rows-#{$i} {\n    grid-template-rows: repeat($i, minmax(var(--min-row-height), var(--max-row-height)));\n  }\n\n  :host(.#{$prefix}) > ::slotted([row-span='#{$i}']),\n  .#{$prefix} > .#{$prefix}-row-span-#{$i} {\n    grid-row: span $i / span $i;\n  }\n\n  :host(.#{$prefix}) > ::slotted([order='#{$i}']),\n  .#{$prefix} > .#{$prefix}-order-#{$i} {\n    order: $i;\n  }\n\n  :host(.#{$prefix}) > ::slotted([order='-1']),\n  .#{$prefix} > .#{$prefix}-order--1 {\n    order: -1;\n  }\n}\n","@use '../../themes/mixins/ids-core-mixins' as *;\n@use './ids-layout-grid-base' as *;\n@use './ids-layout-grid-responsive' as *;\n\n// ================================================\n// Main\n\n/* Use media queries by default */\n:host(:not([enable-container])),\n.#{$prefix}:not([enable-container]) {\n  @include media-queries;\n}\n\n/* Use container queries if enabled */\n:host([enable-container]),\n.#{$prefix}[enable-container] {\n  container-type: inline-size;\n\n  @include container-queries;\n}\n\n/* Grid Gaps */\n:host([gap='none']),\n.#{$prefix}.#{$prefix}-gap-none {\n  /* stylelint-disable-next-line property-no-deprecated */\n  grid-gap: 0;\n}\n\n:host([gap='sm']),\n.#{$prefix}.#{$prefix}-gap-sm {\n  /* stylelint-disable-next-line property-no-deprecated */\n  grid-gap: $grid-gap-sm;\n}\n\n:host([gap='md']),\n.#{$prefix}.#{$prefix}-gap-md {\n  /* stylelint-disable-next-line property-no-deprecated */\n  grid-gap: $grid-gap-md;\n}\n\n:host([gap='lg']),\n.#{$prefix}.#{$prefix}-gap-lg {\n  /* stylelint-disable-next-line property-no-deprecated */\n  grid-gap: $grid-gap-lg;\n}\n\n:host([gap='xl']),\n.#{$prefix}.#{$prefix}-gap-xl {\n  /* stylelint-disable-next-line property-no-deprecated */\n  grid-gap: $grid-gap-xl;\n}\n\n// ================================================\n// Box Model\n\n/* Grid Margins */\n:host([margin='xs']),\n.#{$prefix}.#{$prefix}-margin-xs {\n  margin: $grid-margin-xs;\n}\n\n:host([margin='sm']),\n.#{$prefix}.#{$prefix}-margin-sm {\n  margin: $grid-margin-sm;\n}\n\n:host([margin='md']),\n.#{$prefix}.#{$prefix}-margin-md {\n  margin: $grid-margin-md;\n}\n\n:host([margin='lg']),\n.#{$prefix}.#{$prefix}-margin-lg {\n  margin: $grid-margin-lg;\n}\n\n:host([margin='xl']),\n.#{$prefix}.#{$prefix}-margin-xl {\n  margin: $grid-margin-xl;\n}\n\n:host([margin='auto']),\n.#{$prefix}.#{$prefix}-margin-auto {\n  margin: auto;\n}\n\n/* Grid Margin Y */\n:host([margin-y='xs']),\n.#{$prefix}.#{$prefix}-margin-y-xs {\n  margin-block: $grid-margin-xs;\n}\n\n:host([margin-y='sm']),\n.#{$prefix}.#{$prefix}-margin-y-sm {\n  margin-block: $grid-margin-sm;\n}\n\n:host([margin-y='md']),\n.#{$prefix}.#{$prefix}-margin-y-md {\n  margin-block: $grid-margin-md;\n}\n\n:host([margin-y='lg']),\n.#{$prefix}.#{$prefix}-margin-y-lg {\n  margin-block: $grid-margin-lg;\n}\n\n:host([margin-y='xl']),\n.#{$prefix}.#{$prefix}-margin-y-xl {\n  margin-block: $grid-margin-xl;\n}\n\n/* Grid Max Width */\n:host([max-width='xs']),\n.#{$prefix}.#{$prefix}-max-width-xs {\n  max-width: $breakpoint-xs;\n}\n\n:host([max-width='sm']),\n.#{$prefix}.#{$prefix}-max-width-sm {\n  max-width: $breakpoint-sm;\n}\n\n:host([max-width='md']),\n.#{$prefix}.#{$prefix}-max-width-md {\n  max-width: $breakpoint-md;\n}\n\n:host([max-width='lg']),\n.#{$prefix}.#{$prefix}-max-width-lg {\n  max-width: $breakpoint-lg;\n}\n\n:host([max-width='xl']),\n.#{$prefix}.#{$prefix}-max-width-xl {\n  max-width: $breakpoint-xl;\n}\n\n:host([max-width='xxl']),\n.#{$prefix}.#{$prefix}-max-width-xxl {\n  max-width: $breakpoint-xxl;\n}\n\n:host([max-width$='px']) {\n  max-width: var(--max-width);\n}\n\n/* Grid Padding */\n:host([padding='xs']),\n::slotted([padding='xs']),\n.#{$prefix}.#{$prefix}-padding-xs {\n  padding: $grid-padding-xs;\n}\n\n:host([padding='sm']),\n::slotted([padding='sm']),\n.#{$prefix}.#{$prefix}-padding-sm {\n  padding: $grid-padding-sm;\n}\n\n:host([padding='md']),\n::slotted([padding='md']),\n.#{$prefix}.#{$prefix}-padding-md {\n  padding: $grid-padding-md;\n}\n\n:host([padding='lg']),\n::slotted([padding='lg']),\n.#{$prefix}.#{$prefix}-padding-lg {\n  padding: $grid-padding-lg;\n}\n\n:host([padding='xl']),\n::slotted([padding='xl']),\n.#{$prefix}.#{$prefix}-padding-xl {\n  padding: $grid-padding-xl;\n}\n\n/* Grid Padding X */\n:host([padding-x='xs']),\n.#{$prefix}.#{$prefix}-padding-x-xs {\n  padding-inline: $grid-padding-xs;\n}\n\n:host([padding-x='sm']),\n.#{$prefix}.#{$prefix}-padding-x-sm {\n  padding-inline: $grid-padding-sm;\n}\n\n:host([padding-x='md']),\n.#{$prefix}.#{$prefix}-padding-x-md {\n  padding-inline: $grid-padding-md;\n}\n\n:host([padding-x='lg']),\n.#{$prefix}.#{$prefix}-padding-x-lg {\n  padding-inline: $grid-padding-lg;\n}\n\n:host([padding-x='xl']),\n.#{$prefix}.#{$prefix}-padding-x-xl {\n  padding-inline: $grid-padding-xl;\n}\n\n/* Grid Padding Y */\n:host([padding-y='xs']),\n.#{$prefix}.#{$prefix}-padding-y-xs {\n  padding-block: $grid-padding-xs;\n}\n\n:host([padding-y='xxs']),\n.#{$prefix}.#{$prefix}-padding-y-xxs {\n  padding-block: $grid-padding-xxs;\n}\n\n:host([padding-y='sm']),\n.#{$prefix}.#{$prefix}-padding-y-sm {\n  padding-block: $grid-padding-sm;\n}\n\n:host([padding-y='md']),\n.#{$prefix}.#{$prefix}-padding-y-md {\n  padding-block: $grid-padding-md;\n}\n\n:host([padding-y='lg']),\n.#{$prefix}.#{$prefix}-padding-y-lg {\n  padding-block: $grid-padding-lg;\n}\n\n:host([padding-y='xl']),\n.#{$prefix}.#{$prefix}-padding-y-xl {\n  padding-block: $grid-padding-xl;\n}\n\n/* Grid Padding Bottom */\n:host([padding-bottom='xxs']),\n.#{$prefix}.#{$prefix}-padding-bottom-xxs {\n  padding-block-end: $grid-padding-xxs;\n}\n\n:host([padding-bottom='xs']),\n.#{$prefix}.#{$prefix}-padding-bottom-xs {\n  padding-block-end: $grid-padding-xs;\n}\n\n:host([padding-bottom='sm']),\n.#{$prefix}.#{$prefix}-padding-bottom-sm {\n  padding-block-end: $grid-padding-sm;\n}\n\n:host([padding-bottom='md']),\n.#{$prefix}.#{$prefix}-padding-bottom-md {\n  padding-block-end: $grid-padding-md;\n}\n\n:host([padding-bottom='lg']),\n.#{$prefix}.#{$prefix}-padding-bottom-lg {\n  padding-block-end: $grid-padding-lg;\n}\n\n:host([padding-bottom='xl']),\n.#{$prefix}.#{$prefix}-padding-bottom-xl {\n  padding-block-end: $grid-padding-xl;\n}\n\n// ================================================\n// Grid Layout\n\n/* Grid - Auto Fit/Fill */\n:host([auto-fit]),\n.#{$prefix}-auto-fit {\n  width: 100%;\n  grid-template-columns: repeat(auto-fit, minmax($min-col-width, $max-col-width));\n}\n\n:host([auto-fill]),\n.#{$prefix}-auto-fill {\n  width: 100%;\n  grid-template-columns: repeat(auto-fill, minmax($min-col-width, $max-col-width));\n}\n\n/* Grid - Auto Columns - TODO - Add settings for grid-auto-columns */\n:host(.#{$prefix}-cols-auto),\n.#{$prefix}-cols-auto {\n  grid-auto-columns: auto;\n}\n\n:host(.#{$prefix}-cols-min),\n.#{$prefix}-cols-min\t{\n  grid-auto-columns: min-content;\n}\n\n:host(.#{$prefix}-cols-max),\n.#{$prefix}-cols-max {\n  grid-auto-columns: max-content;\n}\n\n:host(.#{$prefix}-cols-fr),\n.#{$prefix}-cols-fr {\n  grid-auto-columns: minmax(0, 1fr);\n}\n\n/* Grid Flow */\n:host([flow='row']),\n.#{$prefix}-flow-row {\n  grid-auto-flow: row;\n}\n\n:host([flow='column']),\n.#{$prefix}-flow-col {\n  grid-auto-flow: column;\n}\n\n:host([flow='dense']),\n.#{$prefix}-flow-dense {\n  grid-auto-flow: dense;\n}\n\n:host([flow='row-dense']),\n.#{$prefix}-flow-row-dense {\n  grid-auto-flow: row dense;\n}\n\n:host([flow='column-dense']),\n.#{$prefix}-flow-col-dense {\n  grid-auto-flow: column dense;\n}\n\n/* Grid - Auto Rows - TODO - Add settings for grid-auto-rows */\n:host(.#{$prefix}-auto-rows-auto),\n.#{$prefix}-auto-rows-auto {\n  grid-auto-rows: auto;\n}\n\n:host(.#{$prefix}-auto-rows-min),\n.#{$prefix}-auto-rows-min {\n  grid-auto-rows: min-content;\n}\n\n:host(.#{$prefix}-auto-rows-max),\n.#{$prefix}-auto-rows-max {\n  grid-auto-rows: max-content;\n}\n\n:host(.#{$prefix}-auto-rows-fr),\n.#{$prefix}-auto-rows-fr {\n  grid-auto-rows: minmax(0, 1fr);\n}\n\n:host([row-height]),\n.#{$prefix}-auto-row-height {\n  grid-auto-rows: var(--grid-auto-row-height);\n}\n\n/* Grid - Template Rows */\n:host([template-rows]),\n.#{$prefix}-template-rows {\n  grid-template-rows: var(--grid-template-rows);\n}\n\n/** Align items */\n$align-items-list: start end center stretch;\n\n@each $align-items in $align-items-list {\n  :host([align-items='#{$align-items}']),\n  .#{$prefix}-align-items-#{$align-items} {\n    align-items: $align-items;\n  }\n}\n\n/* Justify Content and Align Content */\n$align-content-list: start center space-between space-around space-evenly end;\n\n@each $align-content in $align-content-list {\n  :host([justify-content='#{$align-content}']),\n  .#{$prefix}-justify-#{$align-content} {\n    justify-content: $align-content;\n  }\n\n  :host([align-content='#{$align-content}']),\n  .#{$prefix}-align-#{$align-content} {\n    align-content: $align-content;\n  }\n\n  ::slotted([justify-content='#{$align-content}']),\n  .#{$prefix} > .#{$prefix}-justify-#{$align-content} {\n    display: grid;\n    justify-content: $align-content;\n  }\n\n  ::slotted([align-content='#{$align-content}']),\n  .#{$prefix} > .#{$prefix}-align-#{$align-content} {\n    display: grid;\n    align-content: $align-content;\n  }\n}\n\n/* Grid Col/Row Span All and Sticky */\n::slotted([col-span='all']),\n.#{$prefix} > .#{$prefix}-col-span-all {\n  grid-column: 1 / -1;\n}\n\n::slotted([row-span='all']),\n.#{$prefix} > .#{$prefix}-row-span-all {\n  grid-row: 1 / -1;\n}\n\n::slotted([sticky]),\n.#{$prefix} > .#{$prefix}-sticky {\n  position: sticky;\n  top: var(--sticky-position);\n}\n\n// ================================================\n// Hide Cells\n\n/* Hide Cell on Breakpoints */\n:host > ::slotted([hide='xs']) {\n  display: none;\n}\n\n:host > ::slotted([hide='sm']) {\n  display: none;\n}\n\n:host > ::slotted([hide='md']) {\n  display: none;\n}\n\n:host > ::slotted([hide='lg']) {\n  display: none;\n}\n\n:host > ::slotted([hide='xl']) {\n  display: none;\n}\n\n:host > ::slotted([hide='xxl']) {\n  display: none;\n}\n\n:host > ::slotted([hide='always']) {\n  display: none;\n}\n\n// ================================================\n// Row and column gap\n\n:host([row-gap='none']),\n::slotted([row-gap='none']),\n.#{$prefix}.#{$prefix}-row-gap-none {\n  row-gap: 0;\n}\n\n:host([row-gap='xs']),\n::slotted([row-gap='xs']),\n.#{$prefix}.#{$prefix}-row-gap-xs {\n  row-gap: $grid-padding-xs;\n}\n\n:host([row-gap='sm']),\n::slotted([row-gap='sm']),\n.#{$prefix}.#{$prefix}-row-gap-sm {\n  row-gap: $grid-padding-sm;\n}\n\n:host([row-gap='md']),\n::slotted([row-gap='md']),\n.#{$prefix}.#{$prefix}-row-gap-md {\n  row-gap: $grid-padding-md;\n}\n\n:host([row-gap='lg']),\n::slotted([row-gap='lg']),\n.#{$prefix}.#{$prefix}-row-gap-lg {\n  row-gap: $grid-padding-lg;\n}\n\n:host([row-gap='xl']),\n::slotted([row-gap='xl']),\n.#{$prefix}.#{$prefix}-row-gap-xl {\n  row-gap: $grid-padding-xl;\n}\n\n:host([col-gap='none']),\n::slotted([col-gap='none']),\n.#{$prefix}.#{$prefix}-col-gap-none {\n  column-gap: 0;\n}\n\n:host([col-gap='xs']),\n::slotted([col-gap='xs']),\n.#{$prefix}.#{$prefix}-col-gap-xs {\n  column-gap: $grid-padding-xs;\n}\n\n:host([col-gap='sm']),\n::slotted([col-gap='sm']),\n.#{$prefix}.#{$prefix}-col-gap-sm {\n  column-gap: $grid-padding-sm;\n}\n\n:host([col-gap='md']),\n::slotted([col-gap='md']),\n.#{$prefix}.#{$prefix}-col-gap-md {\n  column-gap: $grid-padding-md;\n}\n\n:host([col-gap='lg']),\n::slotted([col-gap='lg']),\n.#{$prefix}.#{$prefix}-col-gap-lg {\n  column-gap: $grid-padding-lg;\n}\n\n:host([col-gap='xl']),\n::slotted([col-gap='xl']),\n.#{$prefix}.#{$prefix}-col-gap-xl {\n  column-gap: $grid-padding-xl;\n}\n\n// ================================================\n// Demo Utilities\n\n/* Editable */\n::slotted([editable]) > ids-button,\n.#{$prefix} > .#{$prefix}-cell.editable > ids-button {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n/* Fill */\n::slotted([fill]),\n.#{$prefix} > .#{$prefix}-cell.fill {\n  background-color: var(--grid-fill-color);\n  color: var(--grid-text-color);\n}\n\n/* Height */\n::slotted([height='auto']),\n.#{$prefix} > .#{$prefix}-height-auto {\n  height: auto;\n}\n\n/* When containing an auto-fit data grid cell, fill available height */\n:host(.ids-layout-grid-has-auto-fit-cell) {\n  block-size: 100%;\n  min-block-size: 0;\n}\n","// ================================================\n// Viewport and Container Queries\n@use '../../themes/mixins/ids-core-mixins' as *;\n@use './ids-layout-grid-base' as *;\n\n// Base Media Queries\n@mixin grid-rows($size) {\n  @for $i from 1 through $grid-rows {\n    &[rows-#{$size}='#{$i}'],\n    &.#{$prefix}-rows-#{$size}-#{$i} {\n      grid-template-rows: repeat($i, minmax(0, 1fr));\n    }\n    & > ::slotted([row-span-#{$size}='#{$i}']),\n    &.#{$prefix} > .#{$prefix}-row-span-#{$size}-#{$i} {\n      grid-row: span $i / span $i;\n    }\n    & > ::slotted([order-#{$size}='#{$i}']),\n    &.#{$prefix} > .#{$prefix}-order-#{$size}-#{$i} {\n      order: $i;\n    }\n    & > ::slotted([order-#{$size}='-1']),\n    &.#{$prefix} > .#{$prefix}-order-#{$size}--1 {\n      order: -1;\n    }\n  }\n}\n\n@mixin hide-show($size) {\n  & > ::slotted([hide='#{$size}']) {\n    display: block;\n  }\n}\n\n// XS: 0px+\n@media (width >= 0) {\n  @for $i from 1 through $grid-cols {\n    :host(:not([enable-container])[cols-xs='#{$i}']),\n    .#{$prefix}-cols-xs-#{$i} {\n      width: 100%;\n      grid-template-columns: repeat(#{$i}, minmax($min-col-width, $max-col-width));\n    }\n  }\n\n  @for $i from 1 through $grid-rows {\n    :host([rows-xs='#{$i}']),\n    .#{$prefix}-rows-xs-#{$i} {\n      grid-template-rows: repeat($i, minmax(0, 1fr));\n    }\n  }\n\n  :host([flow-xs=\"row\"]), .#{$prefix}-flow-xs-row { grid-auto-flow: row; }\n  :host([flow-xs=\"column\"]), .#{$prefix}-flow-xs-col { grid-auto-flow: column; }\n  :host([flow-xs=\"dense\"]), .#{$prefix}-flow-xs-dense { grid-auto-flow: dense; }\n  :host([flow-xs=\"row-dense\"]), .#{$prefix}-flow-xs-row-dense { grid-auto-flow: row dense; }\n  :host([flow-xs=\"column-dense\"]), .#{$prefix}-flow-xs-col-dense { grid-auto-flow: column dense; }\n}\n\n// SM: 576px+\n@media (width >= $breakpoint-sm) {\n  @for $i from 1 through $grid-cols {\n    :host(:not([enable-container])[cols-sm='#{$i}']),\n    .#{$prefix}-cols-sm-#{$i} {\n      width: 100%;\n      grid-template-columns: repeat(#{$i}, minmax($min-col-width, $max-col-width));\n    }\n  }\n\n  @for $i from 1 through $grid-rows {\n    :host([rows-sm='#{$i}']),\n    .#{$prefix}-rows-sm-#{$i} {\n      grid-template-rows: repeat($i, minmax(0, 1fr));\n    }\n  }\n  :host([flow-sm=\"row\"]), .#{$prefix}-flow-sm-row { grid-auto-flow: row; }\n  :host([flow-sm=\"column\"]), .#{$prefix}-flow-sm-col { grid-auto-flow: column; }\n  :host([flow-sm=\"dense\"]), .#{$prefix}-flow-sm-dense { grid-auto-flow: dense; }\n  :host([flow-sm=\"row-dense\"]), .#{$prefix}-flow-sm-row-dense { grid-auto-flow: row dense; }\n  :host([flow-sm=\"column-dense\"]), .#{$prefix}-flow-sm-col-dense { grid-auto-flow: column dense; }\n}\n\n// MD: 768px+\n@media (width >= $breakpoint-md) {\n  @for $i from 1 through $grid-cols {\n    :host(:not([enable-container])[cols-md='#{$i}']),\n    .#{$prefix}-cols-md-#{$i} {\n      width: 100%;\n      grid-template-columns: repeat(#{$i}, minmax($min-col-width, $max-col-width));\n    }\n  }\n\n  @for $i from 1 through $grid-rows {\n    :host([rows-md='#{$i}']),\n    .#{$prefix}-rows-md-#{$i} {\n      grid-template-rows: repeat($i, minmax(0, 1fr));\n    }\n  }\n  :host([flow-md=\"row\"]), .#{$prefix}-flow-md-row { grid-auto-flow: row; }\n  :host([flow-md=\"column\"]), .#{$prefix}-flow-md-col { grid-auto-flow: column; }\n  :host([flow-md=\"dense\"]), .#{$prefix}-flow-md-dense { grid-auto-flow: dense; }\n  :host([flow-md=\"row-dense\"]), .#{$prefix}-flow-md-row-dense { grid-auto-flow: row dense; }\n  :host([flow-md=\"column-dense\"]), .#{$prefix}-flow-md-col-dense { grid-auto-flow: column dense; }\n}\n\n// LG: 928px+\n@media (width >= $breakpoint-lg) {\n  @for $i from 1 through $grid-cols {\n    :host(:not([enable-container])[cols-lg='#{$i}']),\n    .#{$prefix}-cols-lg-#{$i} {\n      width: 100%;\n      grid-template-columns: repeat(#{$i}, minmax($min-col-width, $max-col-width));\n    }\n  }\n\n  @for $i from 1 through $grid-rows {\n    :host([rows-lg='#{$i}']),\n    .#{$prefix}-rows-lg-#{$i} {\n      grid-template-rows: repeat($i, minmax(0, 1fr));\n    }\n  }\n  :host([flow-lg=\"row\"]), .#{$prefix}-flow-lg-row { grid-auto-flow: row; }\n  :host([flow-lg=\"column\"]), .#{$prefix}-flow-lg-col { grid-auto-flow: column; }\n  :host([flow-lg=\"dense\"]), .#{$prefix}-flow-lg-dense { grid-auto-flow: dense; }\n  :host([flow-lg=\"row-dense\"]), .#{$prefix}-flow-lg-row-dense { grid-auto-flow: row dense; }\n  :host([flow-lg=\"column-dense\"]), .#{$prefix}-flow-lg-col-dense { grid-auto-flow: column dense; }\n}\n\n// XL: 1184px+\n@media (width >= $breakpoint-xl) {\n  @for $i from 1 through $grid-cols {\n    :host(:not([enable-container])[cols-xl='#{$i}']),\n    .#{$prefix}-cols-xl-#{$i} {\n      width: 100%;\n      grid-template-columns: repeat(#{$i}, minmax($min-col-width, $max-col-width));\n    }\n  }\n\n  @for $i from 1 through $grid-rows {\n    :host([rows-xl='#{$i}']),\n    .#{$prefix}-rows-xl-#{$i} {\n      grid-template-rows: repeat($i, minmax(0, 1fr));\n    }\n  }\n  :host([flow-xl=\"row\"]), .#{$prefix}-flow-xl-row { grid-auto-flow: row; }\n  :host([flow-xl=\"column\"]), .#{$prefix}-flow-xl-col { grid-auto-flow: column; }\n  :host([flow-xl=\"dense\"]), .#{$prefix}-flow-xl-dense { grid-auto-flow: dense; }\n  :host([flow-xl=\"row-dense\"]), .#{$prefix}-flow-xl-row-dense { grid-auto-flow: row dense; }\n  :host([flow-xl=\"column-dense\"]), .#{$prefix}-flow-xl-col-dense { grid-auto-flow: column dense; }\n}\n\n// XXL: 2464px+\n@media (width >= $breakpoint-xxl) {\n  @for $i from 1 through $grid-cols {\n    :host(:not([enable-container])[cols-xxl='#{$i}']),\n    .#{$prefix}-cols-xxl-#{$i} {\n      width: 100%;\n      grid-template-columns: repeat(#{$i}, minmax($min-col-width, $max-col-width));\n    }\n  }\n\n  @for $i from 1 through $grid-rows {\n    :host([rows-xxl='#{$i}']),\n    .#{$prefix}-rows-xxl-#{$i} {\n      grid-template-rows: repeat($i, minmax(0, 1fr));\n    }\n  }\n  :host([flow-xxl=\"row\"]), .#{$prefix}-flow-xxl-row { grid-auto-flow: row; }\n  :host([flow-xxl=\"column\"]), .#{$prefix}-flow-xxl-col { grid-auto-flow: column; }\n  :host([flow-xxl=\"dense\"]), .#{$prefix}-flow-xxl-dense { grid-auto-flow: dense; }\n  :host([flow-xxl=\"row-dense\"]), .#{$prefix}-flow-xxl-row-dense { grid-auto-flow: row dense; }\n  :host([flow-xxl=\"column-dense\"]), .#{$prefix}-flow-xxl-col-dense { grid-auto-flow: column dense; }\n}\n\n// Container queries with cascading min-width\n@container (width >= 0) {\n  @for $i from 1 through $grid-cols {\n    :host([cols-xs='#{$i}']), .#{$prefix}-cols-xs-#{$i} {\n      width: 100%;\n      grid-template-columns: repeat(#{$i}, minmax($min-col-width, $max-col-width));\n    }\n  }\n}\n\n@container (width >= #{$breakpoint-sm}) {\n  @for $i from 1 through $grid-cols {\n    :host([cols-sm='#{$i}']), .#{$prefix}-cols-sm-#{$i} {\n      width: 100%;\n      grid-template-columns: repeat(#{$i}, minmax($min-col-width, $max-col-width));\n    }\n  }\n}\n\n@container (width >= #{$breakpoint-md}) {\n  @for $i from 1 through $grid-cols {\n    :host([cols-md='#{$i}']), .#{$prefix}-cols-md-#{$i} {\n      width: 100%;\n      grid-template-columns: repeat(#{$i}, minmax($min-col-width, $max-col-width));\n    }\n  }\n}\n\n@container (width >= #{$breakpoint-lg}) {\n  @for $i from 1 through $grid-cols {\n    :host([cols-lg='#{$i}']), .#{$prefix}-cols-lg-#{$i} {\n      width: 100%;\n      grid-template-columns: repeat(#{$i}, minmax($min-col-width, $max-col-width));\n    }\n  }\n}\n\n@container (width >= #{$breakpoint-xl}) {\n  @for $i from 1 through $grid-cols {\n    :host([cols-xl='#{$i}']), .#{$prefix}-cols-xl-#{$i} {\n      width: 100%;\n      grid-template-columns: repeat(#{$i}, minmax($min-col-width, $max-col-width));\n    }\n  }\n}\n\n@container (width >= #{$breakpoint-xxl}) {\n  @for $i from 1 through $grid-cols {\n    :host([cols-xxl='#{$i}']), .#{$prefix}-cols-xxl-#{$i} {\n      width: 100%;\n      grid-template-columns: repeat(#{$i}, minmax($min-col-width, $max-col-width));\n    }\n  }\n}\n\n@mixin container-queries {\n  @container (width >= #{$breakpoint-xs}) { @include grid-cols(xs); @include grid-rows(xs); @include hide-show(xs); }\n\n  @container (width >= #{$breakpoint-sm}) { @include grid-cols(sm); @include grid-rows(sm); @include hide-show(sm); }\n\n  @container (width >= #{$breakpoint-md}) { @include grid-cols(md); @include grid-rows(md); @include hide-show(md); }\n\n  @container (width >= #{$breakpoint-lg}) { @include grid-cols(lg); @include grid-rows(lg); @include hide-show(lg); }\n\n  @container (width >= #{$breakpoint-xl}) { @include grid-cols(xl); @include grid-rows(xl); @include hide-show(xl); }\n\n  @container (width >= #{$breakpoint-xxl}) { @include grid-cols(xxl); @include grid-rows(xxl); @include hide-show(xxl); }\n}\n\n@mixin media-queries {\n  @media (width >= $breakpoint-xs) { @include grid-cols(xs); @include grid-rows(xs); @include hide-show(xs); }\n\n  @media (width >= $breakpoint-sm) { @include grid-cols(sm); @include grid-rows(sm); @include hide-show(sm); }\n\n  @media (width >= $breakpoint-md) { @include grid-cols(md); @include grid-rows(md); @include hide-show(md); }\n\n  @media (width >= $breakpoint-lg) { @include grid-cols(lg); @include grid-rows(lg); @include hide-show(lg); }\n\n  @media (width >= $breakpoint-xl) { @include grid-cols(xl); @include grid-rows(xl); @include hide-show(xl); }\n\n  @media (width >= $breakpoint-xxl) { @include grid-cols(xxl); @include grid-rows(xxl); @include hide-show(xxl); }\n}\n\n@mixin grid-cols($size) {\n  @for $i from 1 through $grid-cols {\n    & > ::slotted([col-span-#{$size}='#{$i}']),\n    &.#{$prefix} > .#{$prefix}-col-span-#{$size}-#{$i} {\n      grid-column: span $i / span $i;\n    }\n    & > ::slotted([col-start-#{$size}='#{$i}']),\n    &.#{$prefix} > .#{$prefix}-col-start-#{$size}-#{$i} {\n      grid-column-start: $i;\n    }\n    & > ::slotted([col-end-#{$size}='#{$i}']),\n    &.#{$prefix} > .#{$prefix}-col-end-#{$size}-#{$i} {\n      grid-column-end: $i;\n    }\n  }\n}\n","// Breakpoints - this cant be tokens\n$breakpoint-xxl: 2463px;\n$breakpoint-xl: 1183px;\n$breakpoint-lg: 928px;\n$breakpoint-md: 927px;\n$breakpoint-sm: 767px;\n$breakpoint-xs: 320px;\n\n// Sets Text Antialiasing\n@mixin antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// vendor prefixed transitions for regular attributes (non-vendor prefixed)\n@mixin transition($transitions-list...) {\n  @each $prefix in $prefixes {\n    #{$prefix}transition: $transitions-list;\n  }\n}\n\n// make the text invisible visually but readable by screen readers\n@mixin audible() {\n  /* stylelint-disable-next-line property-no-deprecated */\n  clip: rect(0, 0, 0, 0);\n  color: var(--ids-color-text-default);\n  height: 0;\n  line-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
